
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("2NjcZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3eedeeb153763c97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $iFYlf = parcelRequire("iFYlf");

var $e2ucp = parcelRequire("e2ucp");

var $3mYHL = parcelRequire("3mYHL");

var $xNRJ9 = parcelRequire("xNRJ9");

var $dxCvy = parcelRequire("dxCvy");

var $9NiTW = parcelRequire("9NiTW");

var $4dRjY = parcelRequire("4dRjY");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");

var $74iNv = parcelRequire("74iNv");
const $3eedeeb153763c97$var$ProjectComponents = ()=>{
    const [{ match: match, location: location }] = (0, $doZTA.useRouter)();
    const prefetchResult = (0, $2YP9W.useResource)((0, $xNRJ9.projectsComponentsResource));
    const projectContext = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { projectKey: projectKey } = match.params;
    if ((0, $3mYHL.isProjectArchivedCondition)(projectContext.data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.RedirectToArchivedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iFYlf.default), {
        appNameSuffixForV2Event: "project.components",
        appNameForV3OperationalEvent: "componentsProject"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, projectKey && projectContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2ucp.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74iNv.default), {
            projectContext: projectContext,
            tenantContext: tenantContext,
            prefetchResult: {
                ...prefetchResult
            },
            query: query,
            onQueryChanged: onQueryChanged
        })) : null));
};
var $3eedeeb153763c97$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3eedeeb153763c97$var$ProjectComponents);

});
parcelRegister("iFYlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4f9fac2e290ba9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
const $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d4f9fac2e290ba9$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: $3d4f9fac2e290ba9$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("e2ucp", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d54533b2394391$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67TwH = parcelRequire("67TwH");

var $g0NJu = parcelRequire("g0NJu");

var $3c4nq = parcelRequire("3c4nq");

var $bfhDn = parcelRequire("bfhDn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$85d54533b2394391$export$2e2bcd8739ae039 = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67TwH.default), {
        location: location,
        queryFromUrl: (0, $3c4nq.queryFromUrl),
        queryToUrl: (0, $bfhDn.queryToUrl),
        defaultQuery: (0, $g0NJu.initialQuery)
    }, children);

});
parcelRegister("67TwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e75e9a90d3818a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hJCUd = parcelRequire("hJCUd");

var $8Rkzz = parcelRequire("8Rkzz");

var $ebyGx = parcelRequire("ebyGx");

var $5y0F0 = parcelRequire("5y0F0");

var $6wlPy = parcelRequire("6wlPy");

var $aJXmP = parcelRequire("aJXmP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41e75e9a90d3818a$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))((0, $6wlPy.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJXmP.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};

});
parcelRegister("6wlPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c011c7ab8644dae0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");
const $c011c7ab8644dae0$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c011c7ab8644dae0$export$2e2bcd8739ae039 = $c011c7ab8644dae0$var$fromUrlTransformerFactory;

});

parcelRegister("aJXmP", function(module, exports) {

$parcel$export(module.exports, "AdapterWithState", () => $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $ebyGx = parcelRequire("ebyGx");
class $1acd1d8f1a4e9958$export$2fcc0cb3ae18b63e extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("g0NJu", function(module, exports) {

$parcel$export(module.exports, "initialQuery", () => $5db780a623eea3bd$export$8af7177c92ae79e3);

var $aBKog = parcelRequire("aBKog");

var $8GURO = parcelRequire("8GURO");
const $5db780a623eea3bd$export$8af7177c92ae79e3 = {
    orderField: (0, $8GURO.NAME),
    orderDirection: (0, $aBKog.ASC),
    page: 1,
    filter: ''
};

});
parcelRegister("aBKog", function(module, exports) {

$parcel$export(module.exports, "ASC", () => $3a24a09c42e46583$export$1dee026a19752d6b);
$parcel$export(module.exports, "DESC", () => $3a24a09c42e46583$export$b6abcf7fa1d94f65);
$parcel$export(module.exports, "ORDER_DIRECTION", () => $3a24a09c42e46583$export$543711d9afc9aac1);
const $3a24a09c42e46583$export$1dee026a19752d6b = 'ASC';
const $3a24a09c42e46583$export$b6abcf7fa1d94f65 = 'DESC';
const $3a24a09c42e46583$export$543711d9afc9aac1 = {
    [$3a24a09c42e46583$export$1dee026a19752d6b]: $3a24a09c42e46583$export$1dee026a19752d6b,
    [$3a24a09c42e46583$export$b6abcf7fa1d94f65]: $3a24a09c42e46583$export$b6abcf7fa1d94f65
};

});

parcelRegister("8GURO", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $c276ed843b0e55a5$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $c276ed843b0e55a5$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $c276ed843b0e55a5$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $c276ed843b0e55a5$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELD", () => $c276ed843b0e55a5$export$55c82710eb02082c);
const $c276ed843b0e55a5$export$3c5e605ca7ade9f2 = 'NAME';
const $c276ed843b0e55a5$export$d44826c816b5619b = 'DESCRIPTION';
const $c276ed843b0e55a5$export$73dcda99369fd988 = 'LEAD';
const $c276ed843b0e55a5$export$1c62ab608c48125c = 'ISSUES';
const $c276ed843b0e55a5$export$55c82710eb02082c = {
    [$c276ed843b0e55a5$export$3c5e605ca7ade9f2]: $c276ed843b0e55a5$export$3c5e605ca7ade9f2,
    [$c276ed843b0e55a5$export$d44826c816b5619b]: $c276ed843b0e55a5$export$d44826c816b5619b,
    [$c276ed843b0e55a5$export$73dcda99369fd988]: $c276ed843b0e55a5$export$73dcda99369fd988,
    [$c276ed843b0e55a5$export$1c62ab608c48125c]: $c276ed843b0e55a5$export$1c62ab608c48125c
};

});


parcelRegister("3c4nq", function(module, exports) {

$parcel$export(module.exports, "queryFromUrl", () => $beb26f448099fc13$export$34bcc098502c2587);

var $aBKog = parcelRequire("aBKog");

var $8GURO = parcelRequire("8GURO");
const $beb26f448099fc13$var$getOrderEntity = (target, value, defaults)=>Object.values(target).includes(value) ? value : defaults;
const $beb26f448099fc13$export$dbde9a25ef92ab90 = (field)=>$beb26f448099fc13$var$getOrderEntity((0, $8GURO.ORDER_FIELD), field, (0, $8GURO.ORDER_FIELD).NAME);
const $beb26f448099fc13$export$d13e6a6b186c83d7 = (direction)=>$beb26f448099fc13$var$getOrderEntity((0, $aBKog.ORDER_DIRECTION), direction, (0, $aBKog.ORDER_DIRECTION).DESC);
const $beb26f448099fc13$export$aa86da1aa250e687 = (page)=>typeof Number(page) === 'number' && Number(page) >= 1 ? Number(page) : 1;
const $beb26f448099fc13$export$34bcc098502c2587 = ({ filter: filter, orderDirection: orderDirection, orderField: orderField, page: page })=>({
        filter: filter || '',
        orderDirection: $beb26f448099fc13$export$d13e6a6b186c83d7(orderDirection),
        orderField: $beb26f448099fc13$export$dbde9a25ef92ab90(orderField),
        page: $beb26f448099fc13$export$aa86da1aa250e687(page)
    });

});

parcelRegister("bfhDn", function(module, exports) {

$parcel$export(module.exports, "queryToUrl", () => $01f7c7d5600d6cea$export$2ecaae24d8b0a6a8);
const $01f7c7d5600d6cea$export$2ecaae24d8b0a6a8 = (query)=>{
    if (query) {
        const { filter: filter, orderDirection: orderDirection, orderField: orderField, page: page } = query;
        return {
            filter: filter,
            orderDirection: orderDirection,
            orderField: orderField,
            page: page
        };
    }
    return {};
};

});


parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("74iNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c017b3833b44d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $l02tE = parcelRequire("l02tE");

var $9dbF6 = parcelRequire("9dbF6");

var $62oVl = parcelRequire("62oVl");
const $78c017b3833b44d1$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    });
var $78c017b3833b44d1$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $62oVl.default), {
    ProjectDirectoriesApp: $l02tE.default,
    Updater: $78c017b3833b44d1$var$Updater
});

});
parcelRegister("l02tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9608f7e5c12660dd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $hZHze = parcelRequire("hZHze");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");

var $97Kan = parcelRequire("97Kan");

var $kgxuk = parcelRequire("kgxuk");

var $kZiN0 = parcelRequire("kZiN0");

var $6Hwga = parcelRequire("6Hwga");

var $g0NJu = parcelRequire("g0NJu");

var $lrD6Q = parcelRequire("lrD6Q");

var $9Ge1a = parcelRequire("9Ge1a");

var $hCNeI = parcelRequire("hCNeI");

var $8oe4d = parcelRequire("8oe4d");

var $9UvW4 = parcelRequire("9UvW4");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");

var $5p1gD = parcelRequire("5p1gD");
class $9608f7e5c12660dd$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isAdmin: false,
            prefetchedData: null,
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            query: (0, $g0NJu.initialQuery),
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        const { locale: locale, baseUrl: baseUrl, projectKey: projectKey, projectId: projectId, projectName: projectName, isAdmin: isAdmin, projectType: projectType, prefetchedData: prefetchedData, query: query, onQueryChanged: onQueryChanged } = props;
        const project = {
            id: projectId,
            key: projectKey,
            name: projectName,
            type: projectType
        };
        const analyticsData = {
            projectType: projectType
        };
        this.store = (0, $8oe4d.default)((0, $6Hwga.default));
        this.store.dispatch((0, $hCNeI.set)({
            baseUrl: baseUrl,
            isAdmin: isAdmin,
            locale: locale,
            onQueryChanged: onQueryChanged
        }));
        this.store.dispatch((0, $9UvW4.set)(project));
        this.store.dispatch((0, $9Ge1a.set)(analyticsData));
        this.store.dispatch((0, $2G2i7.setQuery)(query || (0, $g0NJu.initialQuery)));
        if (prefetchedData) this.store.dispatch((0, $lrD6Q.setComponentsPage)(prefetchedData));
        else this.store.dispatch((0, $lrD6Q.getComponentsPageRequest)({
            page: (0, $kYnKh.getCurrentPage)(this.store.getState()),
            initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).VIEW
        }));
    }
    componentDidUpdate() {
        const { query: query } = this.props;
        if (query && query && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(query, (0, $kYnKh.getQuery)(this.store.getState()))) this.store.dispatch((0, $2G2i7.setQuery)(query));
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $kZiN0.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5p1gD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null))));
    }
}

});
parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("kgxuk", function(module, exports) {

$parcel$export(module.exports, "FETCH_COMPONENTS_REASON", () => $89e37105340a0507$export$66a91c2022d4732);
const $89e37105340a0507$export$397e49c56ae84012 = 'VIEW';
const $89e37105340a0507$export$8fe76e5b77038f3e = 'FILTERING';
const $89e37105340a0507$export$75081ca35b4dae45 = 'SORTING';
const $89e37105340a0507$export$ceb692a4f4f3a013 = 'COMPONENT_CREATED';
const $89e37105340a0507$export$fa4ff5560bcaba4d = 'COMPONENT_DELETED';
const $89e37105340a0507$export$78216513f47e03b8 = 'COMPONENT_UPDATED';
const $89e37105340a0507$export$66a91c2022d4732 = {
    VIEW: $89e37105340a0507$export$397e49c56ae84012,
    FILTERING: $89e37105340a0507$export$8fe76e5b77038f3e,
    SORTING: $89e37105340a0507$export$75081ca35b4dae45,
    COMPONENT_CREATED: $89e37105340a0507$export$ceb692a4f4f3a013,
    COMPONENT_DELETED: $89e37105340a0507$export$fa4ff5560bcaba4d,
    COMPONENT_UPDATED: $89e37105340a0507$export$78216513f47e03b8
};

});

parcelRegister("kZiN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b5780a88cbd8ab$export$2e2bcd8739ae039);

var $lrD6Q = parcelRequire("lrD6Q");

var $6PR01 = parcelRequire("6PR01");

var $loinA = parcelRequire("loinA");

var $4VEHE = parcelRequire("4VEHE");

var $1yJX2 = parcelRequire("1yJX2");

var $dfrgZ = parcelRequire("dfrgZ");

var $2uZJv = parcelRequire("2uZJv");

var $d2NYt = parcelRequire("d2NYt");
const $96b5780a88cbd8ab$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $lrD6Q.ADD_COMPONENT_SUCCESS:
            return (0, $loinA.default)(action.payload.name);
        case 0, $lrD6Q.ADD_COMPONENT_FAIL:
            return (0, $6PR01.default)();
        case 0, $lrD6Q.DELETE_COMPONENT_SUCCESS:
            return (0, $1yJX2.default)(action.payload.component.name);
        case 0, $lrD6Q.DELETE_COMPONENT_FAILURE:
            return (0, $4VEHE.default)();
        case 0, $lrD6Q.UPDATE_COMPONENT_SUCCESS:
            return (0, $d2NYt.default)(action.payload.componentName);
        case 0, $lrD6Q.UPDATE_COMPONENT_FAIL:
            return (0, $dfrgZ.default)();
        case 0, $lrD6Q.INITIATE_UPDATE_COMPONENT_FAIL:
            return (0, $2uZJv.default)();
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $96b5780a88cbd8ab$export$2e2bcd8739ae039 = $96b5780a88cbd8ab$var$flagsMapper;

});
parcelRegister("lrD6Q", function(module, exports) {

$parcel$export(module.exports, "ADD_COMPONENT_SUCCESS", () => $47470a3fd45bc8d9$export$c183a38d4b59a6d9);
$parcel$export(module.exports, "addComponentSuccess", () => $47470a3fd45bc8d9$export$4d0d7b371036da7e);
$parcel$export(module.exports, "ADD_COMPONENT_FAIL", () => $47470a3fd45bc8d9$export$4fa38ebaaae89345);
$parcel$export(module.exports, "addComponentFail", () => $47470a3fd45bc8d9$export$cb5b2c24e0a5dde9);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT", () => $47470a3fd45bc8d9$export$1c8d8242dfd2faaa);
$parcel$export(module.exports, "initiateUpdateComponent", () => $47470a3fd45bc8d9$export$a82c94a7a4ba9a48);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT_SUCCESS", () => $47470a3fd45bc8d9$export$65b2950c8245ca00);
$parcel$export(module.exports, "initiateUpdateComponentSuccess", () => $47470a3fd45bc8d9$export$f029600573ab2333);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT_FAIL", () => $47470a3fd45bc8d9$export$7c00c0ce897afa48);
$parcel$export(module.exports, "initiateUpdateComponentFail", () => $47470a3fd45bc8d9$export$1e8dcb553d0c7dcf);
$parcel$export(module.exports, "UPDATE_COMPONENT_REQUEST", () => $47470a3fd45bc8d9$export$b676f3c0288df16a);
$parcel$export(module.exports, "updateComponentRequest", () => $47470a3fd45bc8d9$export$9553a85e2bc20da3);
$parcel$export(module.exports, "PATCH_COMPONENT", () => $47470a3fd45bc8d9$export$76d71ef1b430c044);
$parcel$export(module.exports, "patchComponent", () => $47470a3fd45bc8d9$export$c21b0e7ef80ba29f);
$parcel$export(module.exports, "UPDATE_COMPONENT_SUCCESS", () => $47470a3fd45bc8d9$export$543e05e6a6883af);
$parcel$export(module.exports, "updateComponentSuccess", () => $47470a3fd45bc8d9$export$77f1acf01c0045cd);
$parcel$export(module.exports, "UPDATE_COMPONENT_FAIL", () => $47470a3fd45bc8d9$export$8cd0c0bce936b058);
$parcel$export(module.exports, "updateComponentFail", () => $47470a3fd45bc8d9$export$d24cd5f476018727);
$parcel$export(module.exports, "UPDATE_COMPONENT_VALIDATION_FAIL", () => $47470a3fd45bc8d9$export$6c721d766648f32a);
$parcel$export(module.exports, "updateComponentValidationFail", () => $47470a3fd45bc8d9$export$18bef1cc777a2207);
$parcel$export(module.exports, "GET_COMPONENTS_PAGE_REQUEST", () => $47470a3fd45bc8d9$export$61cc82f1967db37b);
$parcel$export(module.exports, "getComponentsPageRequest", () => $47470a3fd45bc8d9$export$af441cb160ff9e19);
$parcel$export(module.exports, "SET_COMPONENTS_PAGE", () => $47470a3fd45bc8d9$export$e0ab2efe830203fb);
$parcel$export(module.exports, "setComponentsPage", () => $47470a3fd45bc8d9$export$4f58aa0a531045ac);
$parcel$export(module.exports, "DELETE_COMPONENT_SUCCESS", () => $47470a3fd45bc8d9$export$da077ae08c543bd0);
$parcel$export(module.exports, "deleteComponentSuccess", () => $47470a3fd45bc8d9$export$8d34c79dac47f8f3);
$parcel$export(module.exports, "DELETE_COMPONENT_FAILURE", () => $47470a3fd45bc8d9$export$cccbe1054a0c3a89);
$parcel$export(module.exports, "deleteComponentFailure", () => $47470a3fd45bc8d9$export$ac7d0962a47d8bf0);
const $47470a3fd45bc8d9$export$c183a38d4b59a6d9 = 'root.ADD_COMPONENT_SUCCESS';
const $47470a3fd45bc8d9$export$4d0d7b371036da7e = (payload)=>({
        type: $47470a3fd45bc8d9$export$c183a38d4b59a6d9,
        payload: payload
    });
const $47470a3fd45bc8d9$export$4fa38ebaaae89345 = 'root.ADD_COMPONENT_FAIL';
const $47470a3fd45bc8d9$export$cb5b2c24e0a5dde9 = ()=>({
        type: $47470a3fd45bc8d9$export$4fa38ebaaae89345
    });
const $47470a3fd45bc8d9$export$1c8d8242dfd2faaa = 'root.INITIATE_UPDATE_COMPONENT';
const $47470a3fd45bc8d9$export$a82c94a7a4ba9a48 = (payload)=>({
        type: $47470a3fd45bc8d9$export$1c8d8242dfd2faaa,
        payload: payload
    });
const $47470a3fd45bc8d9$export$65b2950c8245ca00 = 'root.INITIATE_UPDATE_COMPONENT_SUCCESS';
const $47470a3fd45bc8d9$export$f029600573ab2333 = (payload)=>({
        type: $47470a3fd45bc8d9$export$65b2950c8245ca00,
        payload: payload
    });
const $47470a3fd45bc8d9$export$7c00c0ce897afa48 = 'root.INITIATE_UPDATE_COMPONENT_FAIL';
const $47470a3fd45bc8d9$export$1e8dcb553d0c7dcf = (payload)=>({
        type: $47470a3fd45bc8d9$export$7c00c0ce897afa48,
        payload: payload
    });
const $47470a3fd45bc8d9$export$b676f3c0288df16a = 'root.UPDATE_COMPONENT_REQUEST';
const $47470a3fd45bc8d9$export$9553a85e2bc20da3 = ()=>({
        type: $47470a3fd45bc8d9$export$b676f3c0288df16a
    });
const $47470a3fd45bc8d9$export$76d71ef1b430c044 = 'root.PATCH_COMPONENT';
const $47470a3fd45bc8d9$export$c21b0e7ef80ba29f = (payload)=>({
        type: $47470a3fd45bc8d9$export$76d71ef1b430c044,
        payload: payload
    });
const $47470a3fd45bc8d9$export$543e05e6a6883af = 'root.UPDATE_COMPONENT_SUCCESS';
const $47470a3fd45bc8d9$export$77f1acf01c0045cd = (payload)=>({
        type: $47470a3fd45bc8d9$export$543e05e6a6883af,
        payload: payload
    });
const $47470a3fd45bc8d9$export$8cd0c0bce936b058 = 'root.UPDATE_COMPONENT_FAIL';
const $47470a3fd45bc8d9$export$d24cd5f476018727 = (payload)=>({
        type: $47470a3fd45bc8d9$export$8cd0c0bce936b058,
        payload: payload
    });
const $47470a3fd45bc8d9$export$6c721d766648f32a = 'root.UPDATE_COMPONENT_VALIDATION_FAIL';
const $47470a3fd45bc8d9$export$18bef1cc777a2207 = (payload)=>({
        type: $47470a3fd45bc8d9$export$6c721d766648f32a,
        payload: payload
    });
const $47470a3fd45bc8d9$export$61cc82f1967db37b = 'components.GET_COMPONENTS_PAGE_REQUEST';
const $47470a3fd45bc8d9$export$af441cb160ff9e19 = (payload)=>({
        type: $47470a3fd45bc8d9$export$61cc82f1967db37b,
        payload: payload
    });
const $47470a3fd45bc8d9$export$e0ab2efe830203fb = 'components.SET_COMPONENTS_PAGE';
const $47470a3fd45bc8d9$export$4f58aa0a531045ac = (payload)=>({
        type: $47470a3fd45bc8d9$export$e0ab2efe830203fb,
        payload: payload
    });
const $47470a3fd45bc8d9$export$da077ae08c543bd0 = 'components.DELETE_COMPONENT_SUCCESS';
const $47470a3fd45bc8d9$export$8d34c79dac47f8f3 = (payload)=>({
        type: $47470a3fd45bc8d9$export$da077ae08c543bd0,
        payload: payload
    });
const $47470a3fd45bc8d9$export$cccbe1054a0c3a89 = 'components.DELETE_COMPONENT_FAILURE';
const $47470a3fd45bc8d9$export$ac7d0962a47d8bf0 = (payload)=>({
        type: $47470a3fd45bc8d9$export$cccbe1054a0c3a89,
        payload: payload
    });

});

parcelRegister("6PR01", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f55bb043069ffe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $58f55bb043069ffe$var$messages = (0, $7VHMR.defineMessages)({
    componentAdditionFailedTitle: {
        "id": "project-components.flags.component-addition-failed-title",
        "defaultMessage": "We couldn't create the component."
    },
    componentAdditionFailedDescription: {
        "id": "project-components.flags.component-addition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$58f55bb043069ffe$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $58f55bb043069ffe$var$messages.componentAdditionFailedTitle,
        description: $58f55bb043069ffe$var$messages.componentAdditionFailedDescription,
        messageId: 'project-directories.components.flags.add.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("loinA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3a8126255cc549$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ca3a8126255cc549$var$messages = (0, $7VHMR.defineMessages)({
    componentAddedTitle: {
        "id": "project-components.flags.component-added-title",
        "defaultMessage": "{name} added"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca3a8126255cc549$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $ca3a8126255cc549$var$messages.componentAddedTitle,
            {
                name: name
            }
        ],
        messageId: 'project-directories.components.flags.add.flag.success',
        messageType: 'transactional'
    });

});

parcelRegister("4VEHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c30bb0396aca08$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $45c30bb0396aca08$var$messages = (0, $7VHMR.defineMessages)({
    componentDeletionFailedTitle: {
        "id": "project-components.flags.component-deletion-failed-title",
        "defaultMessage": "We couldn't delete the component"
    },
    componentDeletionFailedDescription: {
        "id": "project-components.flags.component-deletion-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45c30bb0396aca08$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $45c30bb0396aca08$var$messages.componentDeletionFailedTitle,
        description: $45c30bb0396aca08$var$messages.componentDeletionFailedDescription,
        messageId: 'project-directories.components.flags.delete.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("1yJX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $960508fb487c4bc7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $960508fb487c4bc7$var$messages = (0, $7VHMR.defineMessages)({
    componentDeletedTitle: {
        "id": "project-components.flags.component-deleted-title",
        "defaultMessage": "{name} deleted"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$960508fb487c4bc7$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $960508fb487c4bc7$var$messages.componentDeletedTitle,
            {
                name: name
            }
        ],
        messageId: 'project-directories.components.flags.delete.flag.success',
        messageType: 'transactional'
    });

});

parcelRegister("dfrgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7771d884a1df1683$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7771d884a1df1683$var$messages = (0, $7VHMR.defineMessages)({
    componentEditionFailedTitle: {
        "id": "project-components.flags.component-edition-failed-title",
        "defaultMessage": "We couldn't edit the component"
    },
    componentEditionFailedDescription: {
        "id": "project-components.flags.component-edition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7771d884a1df1683$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $7771d884a1df1683$var$messages.componentEditionFailedTitle,
        description: $7771d884a1df1683$var$messages.componentEditionFailedDescription,
        messageId: 'project-directories.components.flags.update.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("2uZJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ccd54b61f16e8bf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1ccd54b61f16e8bf$var$messages = (0, $7VHMR.defineMessages)({
    componentEditionFailedTitle: {
        "id": "project-components.flags.component-edition-failed-title",
        "defaultMessage": "We couldn't edit the component"
    },
    componentEditionFailedDescription: {
        "id": "project-components.flags.component-edition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1ccd54b61f16e8bf$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $1ccd54b61f16e8bf$var$messages.componentEditionFailedTitle,
        description: $1ccd54b61f16e8bf$var$messages.componentEditionFailedDescription,
        messageId: 'project-directories.components.flags.update.flag.error.initiate-error',
        messageType: 'transactional'
    });

});

parcelRegister("d2NYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $121c75d8d5a6cf5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $121c75d8d5a6cf5a$var$messages = (0, $7VHMR.defineMessages)({
    componentEditedTitle: {
        "id": "project-components.flags.component-edited-title",
        "defaultMessage": "{name} updated"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$121c75d8d5a6cf5a$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $121c75d8d5a6cf5a$var$messages.componentEditedTitle,
            {
                name: name
            }
        ],
        messageId: 'project-directories.components.flags.update.flag.success',
        messageType: 'transactional'
    });

});


parcelRegister("6Hwga", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2442f777144d3e$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $e4vRn = parcelRequire("e4vRn");

var $itShB = parcelRequire("itShB");

var $cIIVG = parcelRequire("cIIVG");

var $jPDeX = parcelRequire("jPDeX");

var $hfw6t = parcelRequire("hfw6t");

var $l81t5 = parcelRequire("l81t5");
var $ae2442f777144d3e$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $hfw6t.retrieveComponents), (0, $e4vRn.default), (0, $l81t5.updateComponent), (0, $l81t5.initiateUpdateComponent), (0, $itShB.successfulDelete), (0, $jPDeX.querySet), (0, $cIIVG.queryPatched));

});
parcelRegister("e4vRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $db8452cad032bdd3$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $kYnKh = parcelRequire("kYnKh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db8452cad032bdd3$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $lrD6Q.ADD_COMPONENT_SUCCESS)).mergeMap(()=>(0, $kVLXA.Observable).of((0, $lrD6Q.getComponentsPageRequest)({
            page: (0, $kYnKh.getCurrentPage)(store.getState()),
            initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).COMPONENT_CREATED
        })));

});
parcelRegister("kYnKh", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $412c164640d61653$export$71eec30d9db46a56);
$parcel$export(module.exports, "getOnQueryChanged", () => $412c164640d61653$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getOrderDirection", () => $412c164640d61653$export$2e04c020ca8711f5);
$parcel$export(module.exports, "getOrderField", () => $412c164640d61653$export$f1954ff3a9ce71ff);
$parcel$export(module.exports, "getFilter", () => $412c164640d61653$export$61ec8404f465cd36);
$parcel$export(module.exports, "getCurrentPage", () => $412c164640d61653$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getOrderBy", () => $412c164640d61653$export$128f09144c413f07);

var $2EuXV = parcelRequire("2EuXV");
const $412c164640d61653$export$71eec30d9db46a56 = (state)=>state.query;
const $412c164640d61653$export$59e4f8ebf6520bf7 = (state)=>state.context.onQueryChanged;
const $412c164640d61653$export$2e04c020ca8711f5 = (state)=>state.query.orderDirection;
const $412c164640d61653$export$f1954ff3a9ce71ff = (state)=>state.query.orderField;
const $412c164640d61653$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $412c164640d61653$export$7945ba8eb1c827e6 = (state)=>state.query.page;
const $412c164640d61653$export$128f09144c413f07 = (state)=>(0, $2EuXV.mapToOrderFetch)($412c164640d61653$export$f1954ff3a9ce71ff(state), $412c164640d61653$export$2e04c020ca8711f5(state));

});
parcelRegister("2EuXV", function(module, exports) {

$parcel$export(module.exports, "mapToOrderFetch", () => $86ae40210e05d826$export$6236a5c184fedc41);

var $aBKog = parcelRequire("aBKog");

var $8GURO = parcelRequire("8GURO");
const $86ae40210e05d826$export$cab2635bfaf51f49 = {
    [(0, $8GURO.NAME)]: 'name',
    [(0, $8GURO.DESCRIPTION)]: 'description',
    [(0, $8GURO.LEAD)]: 'lead',
    [(0, $8GURO.ISSUES)]: 'issueCount'
};
const $86ae40210e05d826$export$6236a5c184fedc41 = (orderField, orderDirection)=>(orderDirection === (0, $aBKog.DESC) ? '-' : '+') + $86ae40210e05d826$export$cab2635bfaf51f49[orderField];

});



parcelRegister("itShB", function(module, exports) {

$parcel$export(module.exports, "successfulDelete", () => $a35c924ce8bf43f3$export$fb40872e7cc28b47);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $k15gu = parcelRequire("k15gu");

var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $3kGkY = parcelRequire("3kGkY");

var $kYnKh = parcelRequire("kYnKh");

var $d8xNe = parcelRequire("d8xNe");
const $a35c924ce8bf43f3$export$fb40872e7cc28b47 = (action$, store)=>action$.ofType((0, $lrD6Q.DELETE_COMPONENT_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const componentsPerPage = (0, $d8xNe.getItemsOnPage)(state);
        const totalComponents = (0, $3kGkY.getTotalItems)(state);
        const currentPage = (0, $kYnKh.getCurrentPage)(state);
        const predictedPage = (0, $k15gu.predictPageToRequestAfterItemDeletion)(componentsPerPage, totalComponents, currentPage);
        return (0, $kVLXA.Observable).of((0, $lrD6Q.getComponentsPageRequest)({
            page: predictedPage,
            initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).COMPONENT_DELETED
        }));
    });

});
parcelRegister("k15gu", function(module, exports) {

$parcel$export(module.exports, "calculateTotalPages", () => $871ef586a0cb0e22$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $871ef586a0cb0e22$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $871ef586a0cb0e22$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $871ef586a0cb0e22$export$407c10b4791d7a16);

const $871ef586a0cb0e22$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $871ef586a0cb0e22$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $871ef586a0cb0e22$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $871ef586a0cb0e22$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $871ef586a0cb0e22$export$407c10b4791d7a16 = (input)=>[
        (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("3kGkY", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $8b5b743d7744872c$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getIds", () => $8b5b743d7744872c$export$24b60fe7179439bc);
$parcel$export(module.exports, "getAris", () => $8b5b743d7744872c$export$edc7a71bded50395);
$parcel$export(module.exports, "getName", () => $8b5b743d7744872c$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getIssueCount", () => $8b5b743d7744872c$export$56d545f19dc75191);
$parcel$export(module.exports, "getLead", () => $8b5b743d7744872c$export$97850e2d25587c0d);
$parcel$export(module.exports, "getDescription", () => $8b5b743d7744872c$export$67580b1c13935958);
$parcel$export(module.exports, "getDefaultAssignee", () => $8b5b743d7744872c$export$725da8bee1e71eb0);
$parcel$export(module.exports, "getComponent", () => $8b5b743d7744872c$export$21a8719ce41a1de2);
$parcel$export(module.exports, "getTotalItems", () => $8b5b743d7744872c$export$cbc4bdd6c02fac4d);
const $8b5b743d7744872c$export$dd1bc94b04021eeb = (state)=>state.components.list.length === 0;
const $8b5b743d7744872c$export$24b60fe7179439bc = (state)=>state.components.list;
const $8b5b743d7744872c$export$edc7a71bded50395 = (state)=>state.components.listAri;
const $8b5b743d7744872c$export$7d9f7e9c1c02b41e = (state, id)=>state.components.byId[id].name;
const $8b5b743d7744872c$export$56d545f19dc75191 = (state, id)=>state.components.byId[id].issueCount;
const $8b5b743d7744872c$export$97850e2d25587c0d = (state, id)=>state.components.byId[id].lead;
const $8b5b743d7744872c$export$67580b1c13935958 = (state, id)=>state.components.byId[id].description;
const $8b5b743d7744872c$export$725da8bee1e71eb0 = (state, id)=>state.components.byId[id].defaultAssignee;
const $8b5b743d7744872c$export$21a8719ce41a1de2 = (state, id)=>state.components.byId[id];
const $8b5b743d7744872c$export$cbc4bdd6c02fac4d = (state)=>state.components.totalItems;

});

parcelRegister("d8xNe", function(module, exports) {

$parcel$export(module.exports, "getItemsOnPage", () => $3a7e9988dfd24a97$export$104aa54211627bc7);
$parcel$export(module.exports, "isLoading", () => $3a7e9988dfd24a97$export$20bb0d907fbbe433);
$parcel$export(module.exports, "getStartAt", () => $3a7e9988dfd24a97$export$d33293070717f977);
$parcel$export(module.exports, "getMaxResults", () => $3a7e9988dfd24a97$export$152d338deb24dc62);
const $3a7e9988dfd24a97$export$104aa54211627bc7 = (state)=>state.ui.page.itemsOnPage;
const $3a7e9988dfd24a97$export$20bb0d907fbbe433 = (state)=>state.ui.page.isLoading;
const $3a7e9988dfd24a97$export$d33293070717f977 = (state, page)=>$3a7e9988dfd24a97$export$104aa54211627bc7(state) * (page - 1);
const $3a7e9988dfd24a97$export$152d338deb24dc62 = (state)=>$3a7e9988dfd24a97$export$104aa54211627bc7(state);

});


parcelRegister("cIIVG", function(module, exports) {

$parcel$export(module.exports, "queryPatched", () => $c88adec70fc37ab4$export$290869333b164745);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hJCUd = parcelRequire("hJCUd");

var $kVLXA = parcelRequire("kVLXA");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");
const $c88adec70fc37ab4$export$290869333b164745 = (action$, store)=>action$.ofType((0, $2G2i7.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $kYnKh.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))(payload, (0, $kYnKh.getQuery)(state)));
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("2G2i7", function(module, exports) {

$parcel$export(module.exports, "SET_QUERY", () => $e428932d24b42069$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $e428932d24b42069$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $e428932d24b42069$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $e428932d24b42069$export$8a4e224aafd3a2bf);
const $e428932d24b42069$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $e428932d24b42069$export$f3b215b0b382f63b = (payload)=>({
        type: $e428932d24b42069$export$11bcea24b35a126f,
        payload: payload
    });
const $e428932d24b42069$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $e428932d24b42069$export$8a4e224aafd3a2bf = (payload)=>({
        type: $e428932d24b42069$export$403065a1ff0b1663,
        payload: payload
    });

});


parcelRegister("jPDeX", function(module, exports) {

$parcel$export(module.exports, "querySet", () => $0fa5cf1c85f17667$export$46c38d4ac3e57dc5);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");
const $0fa5cf1c85f17667$export$46c38d4ac3e57dc5 = (action$, store)=>action$.ofType((0, $2G2i7.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $kYnKh.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("hfw6t", function(module, exports) {

$parcel$export(module.exports, "retrieveComponents", () => $7bb057cdc7d0bcc3$export$228e895d1b5c79dd);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");

var $2cAqw = parcelRequire("2cAqw");

var $lrD6Q = parcelRequire("lrD6Q");

var $6z9Py = parcelRequire("6z9Py");

var $golPT = parcelRequire("golPT");

var $kYnKh = parcelRequire("kYnKh");

var $l1yfo = parcelRequire("l1yfo");

var $90w69 = parcelRequire("90w69");

var $d8xNe = parcelRequire("d8xNe");
const $7bb057cdc7d0bcc3$export$228e895d1b5c79dd = (action$, store)=>{
    const getComponentsRequestAction$ = action$.ofType((0, $lrD6Q.GET_COMPONENTS_PAGE_REQUEST));
    return getComponentsRequestAction$.mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const page = payload.page;
        const baseUrl = (0, $6z9Py.getBaseUrl)(state);
        const projectKey = (0, $golPT.getProjectKey)(state);
        const startAt = (0, $d8xNe.getStartAt)(state, page);
        const maxResults = (0, $d8xNe.getMaxResults)(state);
        const orderBy = (0, $kYnKh.getOrderBy)(state);
        const filter = (0, $kYnKh.getFilter)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $koFzm.famaCatchAndLogFetchError)((0, $l1yfo.requestComponents)(baseUrl, projectKey, startAt, maxResults, orderBy, filter), (0, $2cAqw.PACKAGE_NAME), (0, $gl0PU.toErrorId)('retrieveComponents'), (0, $gl0PU.toErrorMessage)('Error fetching components'))).mergeMap((result)=>// @ts-expect-error - TS2769 - No overload matches this call.
            (0, $kVLXA.Observable).of((0, $lrD6Q.setComponentsPage)(result), (0, $90w69.set)({
                message: ''
            }))).takeUntil(getComponentsRequestAction$).catch(()=>/*
				 * We are not logging the error here because it was already logged inside famaCatchAndLogFetchError call.
				 */ (0, $kVLXA.Observable).of((0, $90w69.set)({
                message: 'Error retrieving components'
            })));
    });
};

});
parcelRegister("koFzm", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $eb8b95f475174133$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $eb8b95f475174133$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $1RLjE = parcelRequire("1RLjE");
const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $jJZqs.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
        (0, $1RLjE.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;

});

parcelRegister("2cAqw", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $c3570c890c9d7e25$export$b8b9d90f9e5bd72b);

var $3XO6n = parcelRequire("3XO6n");
const $c3570c890c9d7e25$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraProjectDirectoriesComponents');

});

parcelRegister("6z9Py", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $0c045fe856c36469$export$f654b28f82155665);
$parcel$export(module.exports, "isAdmin", () => $0c045fe856c36469$export$fc970ed23da99565);
$parcel$export(module.exports, "getLocale", () => $0c045fe856c36469$export$180605366c04f0cd);
const $0c045fe856c36469$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $0c045fe856c36469$export$fc970ed23da99565 = (state)=>state.context.isAdmin;
const $0c045fe856c36469$export$180605366c04f0cd = (state)=>state.context.locale;

});

parcelRegister("golPT", function(module, exports) {

$parcel$export(module.exports, "getProjectKey", () => $6446493ec17a95f2$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $6446493ec17a95f2$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectName", () => $6446493ec17a95f2$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjectType", () => $6446493ec17a95f2$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectDefaultAssignee", () => $6446493ec17a95f2$export$be28a82d4e8d697f);
$parcel$export(module.exports, "getProjectLead", () => $6446493ec17a95f2$export$478e7310480ee1ab);
$parcel$export(module.exports, "getProjectLeadName", () => $6446493ec17a95f2$export$c5b979a08b55628c);
$parcel$export(module.exports, "isComponentAdminContext", () => $6446493ec17a95f2$export$26a3de6cbed85df7);

var $j0xEB = parcelRequire("j0xEB");
const $6446493ec17a95f2$export$3988ae62b71be9a3 = (state)=>state.project;
const $6446493ec17a95f2$export$667f2a0f99c75faa = (state)=>state.project.key;
const $6446493ec17a95f2$export$89040d072f281f85 = (state)=>state.project.id;
const $6446493ec17a95f2$export$2cd058184eb75757 = (state)=>state.project.name;
const $6446493ec17a95f2$export$3dd0da95519c1a33 = (state)=>state.project.type;
const $6446493ec17a95f2$export$be28a82d4e8d697f = (state)=>state.project.defaultAssignee;
const $6446493ec17a95f2$export$478e7310480ee1ab = (state)=>state.project.lead;
const $6446493ec17a95f2$export$c5b979a08b55628c = (state)=>state.project.lead && state.project.lead.displayName;
const $6446493ec17a95f2$export$26a3de6cbed85df7 = ()=>{
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const pathname = (0, $j0xEB.default)() && (0, $j0xEB.default)().pathname || '';
    return pathname.endsWith && pathname.endsWith('/administer-components');
};

});

parcelRegister("l1yfo", function(module, exports) {

$parcel$export(module.exports, "requestComponents", () => $5b80d05b85588877$export$7ec8ef4a312fa6eb);
$parcel$export(module.exports, "getPrefetchedData", () => $5b80d05b85588877$export$191a95ab818c6ef2);
$parcel$export(module.exports, "requestComponent", () => $5b80d05b85588877$export$f20b154a1c4c6494);

var $8xvPa = parcelRequire("8xvPa");

var $lfc7M = parcelRequire("lfc7M");

var $lEFJO = parcelRequire("lEFJO");

var $2EuXV = parcelRequire("2EuXV");

var $6z9Py = parcelRequire("6z9Py");

var $gJHvn = parcelRequire("gJHvn");

var $WCSZZ = parcelRequire("WCSZZ");
const $5b80d05b85588877$export$519b99feca126399 = (baseUrl, projectKey, startAt, maxResults, orderBy, filter)=>{
    const encodedQuery = encodeURIComponent(filter);
    const componentSourceParam = '&componentSource=auto';
    return `${baseUrl}/rest/api/2/project/${projectKey}/component?startAt=${startAt}&maxResults=${maxResults}&orderBy=${orderBy}&query=${encodedQuery}${componentSourceParam}`;
};
const $5b80d05b85588877$export$7ec8ef4a312fa6eb = async (baseUrl, projectKey, startAt = (0, $lfc7M.START_AT), maxResults = (0, $lfc7M.ITEMS_ON_PAGE), orderBy = (0, $lfc7M.ORDER), filter = (0, $lfc7M.FILTER))=>{
    const fullUrl = $5b80d05b85588877$export$519b99feca126399(baseUrl, projectKey, startAt, maxResults, orderBy, filter);
    const response = await fetch(fullUrl, (0, $lEFJO.createOptions)('GET'));
    const json = await response.json();
    if (!response.ok) throw await (0, $8xvPa.getErrorFromResponse)(response, 'Failed to fetch');
    const { values: values, total: total } = json;
    return (0, $WCSZZ.transformComponents)(values, total, baseUrl);
};
const $5b80d05b85588877$export$191a95ab818c6ef2 = (baseUrl, projectKey, query)=>{
    if (query) {
        const { orderDirection: orderDirection, orderField: orderField, filter: filter, page: page } = query;
        const orderBy = (0, $2EuXV.mapToOrderFetch)(orderField, orderDirection);
        const maxResults = (0, $lfc7M.ITEMS_ON_PAGE);
        const startAt = (page - 1) * maxResults;
        return $5b80d05b85588877$export$7ec8ef4a312fa6eb(baseUrl, projectKey, startAt, maxResults, orderBy, filter);
    }
    return $5b80d05b85588877$export$7ec8ef4a312fa6eb(baseUrl, projectKey);
};
const $5b80d05b85588877$export$2756a9db83f319ac = (id)=>`/rest/api/2/component/${id}`;
const $5b80d05b85588877$export$f20b154a1c4c6494 = async (state, id)=>{
    const baseUrl = (0, $6z9Py.getBaseUrl)(state);
    const fullUrl = `${baseUrl}${$5b80d05b85588877$export$2756a9db83f319ac(id)}`;
    const response = await fetch(fullUrl, (0, $lEFJO.createOptions)('GET'));
    const json = await response.json();
    if (response.ok) return {
        id: id,
        component: (0, $WCSZZ.transformComponentObj)(json, baseUrl)
    };
    throw (0, $gJHvn.getErrorFromResultJson)(json, response.status);
};

});
parcelRegister("8xvPa", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $8065287d9cd7a779$export$7780d7826aafbede);

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $8065287d9cd7a779$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $eusud.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $jJZqs.default)(response.status, errorMessage);
};

});

parcelRegister("lfc7M", function(module, exports) {

$parcel$export(module.exports, "ITEMS_ON_PAGE", () => $1a5d2c525b8186bf$export$5364831c6b9eb7a3);
$parcel$export(module.exports, "PAGE", () => $1a5d2c525b8186bf$export$d3d35020fa5b54f0);
$parcel$export(module.exports, "FILTER", () => $1a5d2c525b8186bf$export$c1c49903035a02df);
$parcel$export(module.exports, "START_AT", () => $1a5d2c525b8186bf$export$5a3b37e8556e32de);
$parcel$export(module.exports, "ORDER", () => $1a5d2c525b8186bf$export$11e75bce9f7ea886);

var $fFsPq = parcelRequire("fFsPq");
const $1a5d2c525b8186bf$export$5364831c6b9eb7a3 = 25;
const $1a5d2c525b8186bf$export$d3d35020fa5b54f0 = 1;
const $1a5d2c525b8186bf$export$55c82710eb02082c = (0, $fFsPq.NAME);
const $1a5d2c525b8186bf$export$c1c49903035a02df = '';
const $1a5d2c525b8186bf$export$5a3b37e8556e32de = 0;
const $1a5d2c525b8186bf$export$11e75bce9f7ea886 = `+${(0, $fFsPq.ORDER_FIELDS)[$1a5d2c525b8186bf$export$55c82710eb02082c]}`;

});
parcelRegister("fFsPq", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $7261733a8e91b3da$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $7261733a8e91b3da$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $7261733a8e91b3da$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $7261733a8e91b3da$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELDS", () => $7261733a8e91b3da$export$e6d6c3d190bf100b);
const $7261733a8e91b3da$export$3c5e605ca7ade9f2 = 'NAME';
const $7261733a8e91b3da$export$d44826c816b5619b = 'DESCRIPTION';
const $7261733a8e91b3da$export$73dcda99369fd988 = 'LEAD';
const $7261733a8e91b3da$export$1c62ab608c48125c = 'ISSUES';
const $7261733a8e91b3da$export$e6d6c3d190bf100b = {
    [$7261733a8e91b3da$export$3c5e605ca7ade9f2]: 'name',
    [$7261733a8e91b3da$export$d44826c816b5619b]: 'description',
    [$7261733a8e91b3da$export$73dcda99369fd988]: 'lead',
    [$7261733a8e91b3da$export$1c62ab608c48125c]: 'issueCount'
};

});


parcelRegister("lEFJO", function(module, exports) {

$parcel$export(module.exports, "createOptions", () => $33561caedbca9a6d$export$830e3e7c910fe629);
const $33561caedbca9a6d$export$830e3e7c910fe629 = (method, body)=>{
    const stringifiedBody = body ? JSON.stringify(body) : undefined;
    return {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        method: method,
        body: stringifiedBody
    };
};

});

parcelRegister("gJHvn", function(module, exports) {

$parcel$export(module.exports, "ComponentValidationError", () => $62103a3611ca0393$export$2a0a959ca186c5a2);
$parcel$export(module.exports, "getErrorFromResultJson", () => $62103a3611ca0393$export$f94105122c76865e);

var $jJZqs = parcelRequire("jJZqs");
class $62103a3611ca0393$export$2a0a959ca186c5a2 extends Error {
    constructor(message, errors){
        super(message);
        this.errors = errors || {};
    }
}
const $62103a3611ca0393$export$f94105122c76865e = (resultJson, status)=>{
    const errors = resultJson.errors;
    if (errors && (errors.name || errors.componentLead)) return new $62103a3611ca0393$export$2a0a959ca186c5a2('', {
        name: resultJson.errors.name,
        componentLead: resultJson.errors.componentLead
    });
    const errorMessage = resultJson.errorMessages && resultJson.errorMessages[0];
    return new (0, $jJZqs.default)(status, errorMessage);
};

});

parcelRegister("WCSZZ", function(module, exports) {

$parcel$export(module.exports, "transformComponentObj", () => $cefaff5f214f9f06$export$f505eac0336ab290);
$parcel$export(module.exports, "transformComponents", () => $cefaff5f214f9f06$export$67cf173cea018455);
const $cefaff5f214f9f06$var$transformLead = (user, baseUrl)=>({
        displayName: user.displayName,
        key: user.key,
        active: user.active,
        accountId: user.accountId,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        // from PK - I could not see this code being used anywhere. Hence not updating to new url.
        profileUrl: `${baseUrl}/jira/people/${user.accountId}`
    });
const $cefaff5f214f9f06$export$f505eac0336ab290 = (item, baseUrl)=>{
    const { name: name, description: description, assigneeType: assigneeType, lead: lead, componentBean: componentBean } = item;
    const { ari: ari, metadata: metadata } = componentBean ?? {};
    return {
        ari: ari,
        metadata: metadata,
        name: name,
        description: description,
        issueCount: item.issueCount ? item.issueCount : 0,
        defaultAssignee: assigneeType,
        lead: lead ? $cefaff5f214f9f06$var$transformLead(lead, baseUrl) : undefined
    };
};
const $cefaff5f214f9f06$export$79ccea7e11af4b35 = (item, baseUrl)=>({
        [item.id]: $cefaff5f214f9f06$export$f505eac0336ab290(item, baseUrl)
    });
const $cefaff5f214f9f06$export$67cf173cea018455 = (components, total, baseUrl)=>{
    const list = components.map((i)=>i.id);
    const listAri = components// Typesafe way to filter out undefined values.
    // Theoretically if global components are turned on, we will _only_ get back components with ARIs.
    // But to keep things happy with Typescript we need to handle undefined case as well.
    .flatMap(({ componentBean: componentBean })=>componentBean?.ari ? [
            componentBean?.ari
        ] : []);
    const byId = Object.assign({}, ...components.map((component)=>$cefaff5f214f9f06$export$79ccea7e11af4b35(component, baseUrl)));
    return {
        byId: byId,
        list: list,
        listAri: listAri,
        total: total
    };
};

});


parcelRegister("90w69", function(module, exports) {

$parcel$export(module.exports, "SET", () => $dcc4fa76c5e353a7$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $dcc4fa76c5e353a7$export$adaa4cf7ef1b65be);
// set
const $dcc4fa76c5e353a7$export$5e8f180ef0142226 = 'ui.error.SET';
const $dcc4fa76c5e353a7$export$adaa4cf7ef1b65be = (payload)=>({
        type: $dcc4fa76c5e353a7$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("l81t5", function(module, exports) {

$parcel$export(module.exports, "initiateUpdateComponent", () => $4abe886ae72778ef$export$a82c94a7a4ba9a48);
$parcel$export(module.exports, "updateComponent", () => $4abe886ae72778ef$export$3d375ec46cfe3d13);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $gJHvn = parcelRequire("gJHvn");

var $kYnKh = parcelRequire("kYnKh");

var $l1yfo = parcelRequire("l1yfo");

var $1apDX = parcelRequire("1apDX");

var $aN3Lz = parcelRequire("aN3Lz");
const $4abe886ae72778ef$export$a82c94a7a4ba9a48 = (action$, store)=>{
    const initiateUpdateComponent$ = action$.ofType((0, $lrD6Q.INITIATE_UPDATE_COMPONENT));
    return initiateUpdateComponent$.mergeMap(()=>{
        const id = (0, $aN3Lz.getId)(store.getState());
        return (0, $kVLXA.Observable).fromPromise((0, $l1yfo.requestComponent)(store.getState(), id)).mergeMap((result)=>(0, $kVLXA.Observable).of((0, $lrD6Q.initiateUpdateComponentSuccess)(result))).takeUntil(initiateUpdateComponent$).catch((e)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(e, 'project-components.state.epics.initate.update.component', (0, $9f04abe75161e860$export$1089831196ae0f84));
            return (0, $kVLXA.Observable).of((0, $lrD6Q.initiateUpdateComponentFail)({
                id: id,
                error: e
            }));
        });
    });
};
const $4abe886ae72778ef$export$3d375ec46cfe3d13 = (action$, store)=>action$.ofType((0, $lrD6Q.UPDATE_COMPONENT_REQUEST)).mergeMap(()=>(0, $kVLXA.Observable).fromPromise((0, $1apDX.updateComponent)(store.getState())).mergeMap(()=>(0, $kVLXA.Observable).of((0, $lrD6Q.updateComponentSuccess)({
                componentName: (0, $aN3Lz.getEditedComponentName)(store.getState())
            }), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $lrD6Q.getComponentsPageRequest)({
                page: (0, $kYnKh.getCurrentPage)(store.getState()),
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).COMPONENT_UPDATED
            })))// @ts-expect-error - TS2345 - Argument of type '(error: ComponentRequestError) => Observable<UpdateComponentValidationFailAction> | Observable<UpdateComponentFailAction>' is not assignable to parameter of type '(err: any, caught: Observable<UpdateComponentSuccessAction>) => ObservableInput<UpdateComponentValidationFailAction>'.
        .catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'project-components.state.epics.update', (0, $9f04abe75161e860$export$1089831196ae0f84));
            if (error instanceof (0, $gJHvn.ComponentValidationError)) return (0, $kVLXA.Observable).of((0, $lrD6Q.updateComponentValidationFail)(error));
            return (0, $kVLXA.Observable).of((0, $lrD6Q.updateComponentFail)(error));
        }));

});
const $9f04abe75161e860$export$1089831196ae0f84 = 'directories.components.error';

parcelRegister("1apDX", function(module, exports) {

$parcel$export(module.exports, "updateComponent", () => $dbafe247340db1ad$export$3d375ec46cfe3d13);

var $lEFJO = parcelRequire("lEFJO");

var $6z9Py = parcelRequire("6z9Py");

var $gJHvn = parcelRequire("gJHvn");

var $aN3Lz = parcelRequire("aN3Lz");

var $i9EiJ = parcelRequire("i9EiJ");
const $dbafe247340db1ad$export$d5777c038fb95c3f = (component)=>{
    if (!component) return {};
    const { name: name, lead: lead, defaultAssignee: defaultAssignee, description: description = '' } = component;
    return {
        name: name,
        description: description,
        assigneeType: defaultAssignee,
        leadAccountId: lead && lead.accountId || ''
    };
};
const $dbafe247340db1ad$export$3d375ec46cfe3d13 = async (state)=>{
    const componentId = (0, $aN3Lz.getId)(state);
    const component = (0, $aN3Lz.getEditedComponent)(state);
    const componentDataForRequest = $dbafe247340db1ad$export$d5777c038fb95c3f(component);
    const fullUrl = `${(0, $6z9Py.getBaseUrl)(state)}${(0, $i9EiJ.componentEndpointUrl)(componentId)}`;
    const result = await fetch(fullUrl, (0, $lEFJO.createOptions)('PUT', componentDataForRequest));
    const resultJson = await result.json();
    if (result.ok) return component;
    throw (0, $gJHvn.getErrorFromResultJson)(resultJson, result.status);
};

});
parcelRegister("aN3Lz", function(module, exports) {

$parcel$export(module.exports, "isInitialising", () => $8ee9b5790fe78339$export$afb304c64a235941);
$parcel$export(module.exports, "isEditing", () => $8ee9b5790fe78339$export$6ca2a662afed3e7f);
$parcel$export(module.exports, "saveIsInProgress", () => $8ee9b5790fe78339$export$6d46a811199c63f);
$parcel$export(module.exports, "getId", () => $8ee9b5790fe78339$export$218c8c3169c024d2);
$parcel$export(module.exports, "getEditedComponent", () => $8ee9b5790fe78339$export$6fc6dbafd8663a78);
$parcel$export(module.exports, "getEditedComponentName", () => $8ee9b5790fe78339$export$760bf67a250fa7f1);
$parcel$export(module.exports, "getNameErrorMessage", () => $8ee9b5790fe78339$export$6222164b63cc3ae9);
const $8ee9b5790fe78339$export$afb304c64a235941 = (state, id)=>state.ui.edit.initialiseInProgress && state.ui.edit.id === id;
const $8ee9b5790fe78339$export$6ca2a662afed3e7f = (state)=>!!state.ui.edit.id && !state.ui.edit.initialiseInProgress;
const $8ee9b5790fe78339$export$6d46a811199c63f = (state)=>state.ui.edit.saveIsInProgress;
const $8ee9b5790fe78339$export$218c8c3169c024d2 = (state)=>state.ui.edit.id || '';
const $8ee9b5790fe78339$export$6fc6dbafd8663a78 = (state)=>state.ui.edit.editedComponent;
const $8ee9b5790fe78339$export$760bf67a250fa7f1 = (state)=>state.ui.edit.editedComponent && state.ui.edit.editedComponent.name || '';
const $8ee9b5790fe78339$export$6222164b63cc3ae9 = (state)=>state.ui.edit.nameErrorMessage;
const $8ee9b5790fe78339$export$8802ac508ab8d49a = (state)=>state.ui.edit.leadErrorMessage;

});

parcelRegister("i9EiJ", function(module, exports) {

$parcel$export(module.exports, "componentEndpointUrl", () => $e915729cea430193$export$e933405cdc2c0965);
const $e915729cea430193$export$e933405cdc2c0965 = (componentId)=>{
    const componentUrl = componentId ? `/${componentId}` : '';
    return `/rest/api/2/component${componentUrl}`;
};

});




parcelRegister("9Ge1a", function(module, exports) {

$parcel$export(module.exports, "SET", () => $2a0b249d5773b4e4$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $2a0b249d5773b4e4$export$adaa4cf7ef1b65be);
const $2a0b249d5773b4e4$export$5e8f180ef0142226 = 'analytics.SET';
const $2a0b249d5773b4e4$export$adaa4cf7ef1b65be = (payload)=>({
        type: $2a0b249d5773b4e4$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("hCNeI", function(module, exports) {

$parcel$export(module.exports, "SET", () => $3dbc1a97e7e15957$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $3dbc1a97e7e15957$export$adaa4cf7ef1b65be);
const $3dbc1a97e7e15957$export$5e8f180ef0142226 = 'context.SET';
const $3dbc1a97e7e15957$export$adaa4cf7ef1b65be = (payload)=>({
        type: $3dbc1a97e7e15957$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("8oe4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8df5db2c90d2607$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $1en2q = parcelRequire("1en2q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8df5db2c90d2607$export$2e2bcd8739ae039 = (rootEpic, initialState, middlewares = [])=>(0, $F2Mxm.default)({
        appName: 'Project components',
        rootReducer: $1en2q.default,
        initialState: initialState,
        rootEpic: rootEpic,
        middlewares: middlewares
    });

});
parcelRegister("1en2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9cf040ddc6b7a98$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $gx49E = parcelRequire("gx49E");

var $lAE7m = parcelRequire("lAE7m");

var $egFQ1 = parcelRequire("egFQ1");

var $9f4Hs = parcelRequire("9f4Hs");

var $9gzso = parcelRequire("9gzso");

var $WRvJC = parcelRequire("WRvJC");
const $f9cf040ddc6b7a98$var$combinedReducer = (0, $3f2cs.combineReducers)({
    components: $lAE7m.default,
    project: $9f4Hs.default,
    ui: $WRvJC.default,
    context: $egFQ1.default,
    analyticsData: $gx49E.default,
    query: $9gzso.default
});
var $f9cf040ddc6b7a98$export$2e2bcd8739ae039 = $f9cf040ddc6b7a98$var$combinedReducer;

});
parcelRegister("gx49E", function(module, exports) {

$parcel$export(module.exports, "default", () => $c514f83fdfa7528e$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9Ge1a = parcelRequire("9Ge1a");
const $c514f83fdfa7528e$export$d4c72bab9d6cc13a = {
    projectType: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c514f83fdfa7528e$export$2e2bcd8739ae039 = (state = $c514f83fdfa7528e$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9Ge1a.SET:
            return (0, $7uUwQ.freeze)(action.payload);
        default:
            return state;
    }
};

});

parcelRegister("lAE7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f684181db5da942$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $lrD6Q = parcelRequire("lrD6Q");
const $7f684181db5da942$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    byId: {},
    list: [],
    listAri: [],
    totalItems: 0
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7f684181db5da942$export$2e2bcd8739ae039 = (state = $7f684181db5da942$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $lrD6Q.SET_COMPONENTS_PAGE:
            return (0, $7uUwQ.assign)(state, {
                byId: action.payload.byId,
                list: action.payload.list,
                listAri: action.payload.listAri,
                totalItems: action.payload.total
            });
        case 0, $lrD6Q.PATCH_COMPONENT:
            {
                const componentId = action.payload.id;
                const originalComponent = (0, $7uUwQ.getIn)(state.byId, [
                    componentId
                ]);
                const patchedComponent = (0, $7uUwQ.assign)({}, originalComponent, action.payload.component);
                return (0, $7uUwQ.freeze)({
                    ...state,
                    byId: (0, $7uUwQ.assoc)(state.byId, componentId, patchedComponent)
                });
            }
        default:
            return state;
    }
};

});

parcelRegister("egFQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4552d882ea464e$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $lzeFL = parcelRequire("lzeFL");

var $hCNeI = parcelRequire("hCNeI");
const $1b4552d882ea464e$export$d4c72bab9d6cc13a = Object.freeze({
    baseUrl: '',
    isAdmin: false,
    locale: (0, $lzeFL.defaultLocale),
    onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b4552d882ea464e$export$2e2bcd8739ae039 = (state = $1b4552d882ea464e$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $hCNeI.SET:
            return Object.freeze(action.payload);
        default:
            return state;
    }
};

});

parcelRegister("9f4Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45f5dcfe0148d90$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $2vSU6 = parcelRequire("2vSU6");

var $9UvW4 = parcelRequire("9UvW4");
const $a45f5dcfe0148d90$export$d4c72bab9d6cc13a = {
    key: '',
    id: -1,
    name: '',
    type: (0, $2vSU6.CORE_PROJECT)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a45f5dcfe0148d90$export$2e2bcd8739ae039 = (state = $a45f5dcfe0148d90$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9UvW4.SET:
            return (0, $7uUwQ.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("9UvW4", function(module, exports) {

$parcel$export(module.exports, "SET", () => $554a7a95dc6cdb6a$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $554a7a95dc6cdb6a$export$adaa4cf7ef1b65be);
const $554a7a95dc6cdb6a$export$5e8f180ef0142226 = 'project.SET';
const $554a7a95dc6cdb6a$export$adaa4cf7ef1b65be = (payload)=>({
        type: $554a7a95dc6cdb6a$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("9gzso", function(module, exports) {

$parcel$export(module.exports, "default", () => $c642762510c64108$export$2e2bcd8739ae039);

var $g0NJu = parcelRequire("g0NJu");

var $2G2i7 = parcelRequire("2G2i7");
const $c642762510c64108$export$d4c72bab9d6cc13a = (0, $g0NJu.initialQuery);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c642762510c64108$export$2e2bcd8739ae039 = (state = $c642762510c64108$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $2G2i7.SET_QUERY:
            return action.payload;
        case 0, $2G2i7.PATCH_QUERY:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("WRvJC", function(module, exports) {

$parcel$export(module.exports, "default", () => $776290407b5cac2c$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $2zFjT = parcelRequire("2zFjT");

var $90SUa = parcelRequire("90SUa");

var $2gV4g = parcelRequire("2gV4g");

var $lszLu = parcelRequire("lszLu");

var $xaONt = parcelRequire("xaONt");
const $776290407b5cac2c$export$d4c72bab9d6cc13a = {
    add: (0, $2zFjT.initialState),
    edit: (0, $2gV4g.initialState),
    delete: (0, $90SUa.initialState),
    error: (0, $lszLu.initialState),
    page: (0, $xaONt.initialState)
};
const $776290407b5cac2c$var$combinedReducer = (0, $3f2cs.combineReducers)({
    add: $2zFjT.default,
    edit: $2gV4g.default,
    delete: (0, $90SUa.default),
    error: $lszLu.default,
    page: $xaONt.default
});
var $776290407b5cac2c$export$2e2bcd8739ae039 = $776290407b5cac2c$var$combinedReducer;

});
parcelRegister("2zFjT", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $545f3527f28923fa$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $545f3527f28923fa$export$2e2bcd8739ae039);

var $lrD6Q = parcelRequire("lrD6Q");

var $j4QfZ = parcelRequire("j4QfZ");
const $545f3527f28923fa$export$d4c72bab9d6cc13a = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$545f3527f28923fa$export$2e2bcd8739ae039 = (state = $545f3527f28923fa$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $j4QfZ.INITIATE:
            return {
                isOpen: true
            };
        case 0, $lrD6Q.ADD_COMPONENT_SUCCESS:
        case 0, $j4QfZ.CANCEL:
            return {
                isOpen: false
            };
        default:
            return state;
    }
};

});
parcelRegister("j4QfZ", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $cb1f0d743bac7e7d$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $cb1f0d743bac7e7d$export$b14c4413e822aa8d);
$parcel$export(module.exports, "CANCEL", () => $cb1f0d743bac7e7d$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $cb1f0d743bac7e7d$export$70b61ad426ddbe54);
// initiate
const $cb1f0d743bac7e7d$export$643daa42aa3148d5 = 'ui.add.INITIATE';
const $cb1f0d743bac7e7d$export$b14c4413e822aa8d = ()=>({
        type: $cb1f0d743bac7e7d$export$643daa42aa3148d5
    });
const $cb1f0d743bac7e7d$export$2b10f4b30fb65583 = 'ui.add.CANCEL';
const $cb1f0d743bac7e7d$export$70b61ad426ddbe54 = ()=>({
        type: $cb1f0d743bac7e7d$export$2b10f4b30fb65583
    });

});


parcelRegister("90SUa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $3d436c043bb1c252$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $3d436c043bb1c252$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $fr1K2 = parcelRequire("fr1K2");

var $hqTkp = parcelRequire("hqTkp");

var $lrD6Q = parcelRequire("lrD6Q");

var $314fd = parcelRequire("314fd");
const $3d436c043bb1c252$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    componentsBeingDeleted: [],
    spinner: {}
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d436c043bb1c252$export$2e2bcd8739ae039 = (state = $3d436c043bb1c252$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $314fd.DELETE_COMPONENT_STARTED:
            return (0, $7uUwQ.freeze)({
                ...state,
                spinner: {
                    ...state.spinner,
                    [action.payload.id]: true
                },
                componentsBeingDeleted: [
                    ...state.componentsBeingDeleted,
                    action.payload.id
                ]
            });
        case 0, $314fd.DELETE_COMPONENT_DIALOG_DISPLAYED:
            return (0, $7uUwQ.freeze)({
                ...state,
                spinner: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.spinner, action.payload.id)
            });
        case 0, $lrD6Q.DELETE_COMPONENT_FAILURE:
            {
                const componentsBeingDeleted = action.payload.isDialogOpen ? state.componentsBeingDeleted : (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(state.componentsBeingDeleted, action.payload.id);
                return (0, $7uUwQ.assign)(state, {
                    spinner: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.spinner, action.payload.id),
                    componentsBeingDeleted: componentsBeingDeleted
                });
            }
        case 0, $314fd.DELETE_COMPONENT_CANCEL:
        case 0, $lrD6Q.DELETE_COMPONENT_SUCCESS:
            return (0, $7uUwQ.freeze)({
                ...state,
                componentsBeingDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(state.componentsBeingDeleted, action.payload.id),
                spinner: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.spinner, action.payload.id)
            });
        default:
            return state;
    }
};

});
parcelRegister("314fd", function(module, exports) {

$parcel$export(module.exports, "DELETE_COMPONENT_STARTED", () => $945f7c8e9e8db1da$export$1f324f2a5e0c1e6f);
$parcel$export(module.exports, "deleteComponentStarted", () => $945f7c8e9e8db1da$export$a37e7704966d1adf);
$parcel$export(module.exports, "DELETE_COMPONENT_DIALOG_DISPLAYED", () => $945f7c8e9e8db1da$export$9bfb374019bf36dd);
$parcel$export(module.exports, "deleteComponentDialogDisplayed", () => $945f7c8e9e8db1da$export$e3156991de922d9c);
$parcel$export(module.exports, "DELETE_COMPONENT_CANCEL", () => $945f7c8e9e8db1da$export$1aeaef53ac9bbd05);
$parcel$export(module.exports, "deleteComponentCancel", () => $945f7c8e9e8db1da$export$3a48db21ea62cc77);
const $945f7c8e9e8db1da$export$1f324f2a5e0c1e6f = 'ui.delete.DELETE_COMPONENT_STARTED';
const $945f7c8e9e8db1da$export$a37e7704966d1adf = (payload)=>({
        type: $945f7c8e9e8db1da$export$1f324f2a5e0c1e6f,
        payload: payload
    });
const $945f7c8e9e8db1da$export$9bfb374019bf36dd = 'ui.delete.DELETE_COMPONENT_DIALOG_DISPLAYED';
const $945f7c8e9e8db1da$export$e3156991de922d9c = (payload)=>({
        type: $945f7c8e9e8db1da$export$9bfb374019bf36dd,
        payload: payload
    });
const $945f7c8e9e8db1da$export$1aeaef53ac9bbd05 = 'ui.delete.DELETE_COMPONENT_CANCEL';
const $945f7c8e9e8db1da$export$3a48db21ea62cc77 = (payload)=>({
        type: $945f7c8e9e8db1da$export$1aeaef53ac9bbd05,
        payload: payload
    });

});


parcelRegister("2gV4g", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $726f1b6583b01435$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $726f1b6583b01435$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $lrD6Q = parcelRequire("lrD6Q");

var $aSIZh = parcelRequire("aSIZh");
const $726f1b6583b01435$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    saveIsInProgress: false,
    initialiseInProgress: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$726f1b6583b01435$export$2e2bcd8739ae039 = (state = $726f1b6583b01435$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $lrD6Q.INITIATE_UPDATE_COMPONENT:
            return (0, $7uUwQ.freeze)({
                initialiseInProgress: true,
                id: action.payload.id,
                saveIsInProgress: false
            });
        case 0, $lrD6Q.INITIATE_UPDATE_COMPONENT_SUCCESS:
            return (0, $7uUwQ.assign)(state, {
                initialiseInProgress: false,
                id: action.payload.id,
                editedComponent: action.payload.component,
                saveIsInProgress: false
            });
        case 0, $lrD6Q.INITIATE_UPDATE_COMPONENT_FAIL:
            return (0, $7uUwQ.assign)(state, {
                initialiseInProgress: false,
                id: undefined,
                editedComponent: false,
                saveIsInProgress: false
            });
        case 0, $aSIZh.UPDATE_EDITED_COMPONENT:
            return (0, $7uUwQ.assign)(state, {
                editedComponent: action.payload.component
            });
        case 0, $aSIZh.CANCEL:
            return (0, $7uUwQ.assign)(state, {
                id: undefined,
                editedComponent: undefined,
                saveIsInProgress: false
            });
        case 0, $lrD6Q.UPDATE_COMPONENT_REQUEST:
            return (0, $7uUwQ.assign)(state, {
                saveIsInProgress: true,
                nameErrorMessage: undefined,
                leadErrorMessage: undefined
            });
        case 0, $lrD6Q.UPDATE_COMPONENT_SUCCESS:
            return (0, $7uUwQ.assign)(state, {
                saveIsInProgress: false,
                id: undefined,
                editedComponent: undefined
            });
        case 0, $lrD6Q.UPDATE_COMPONENT_VALIDATION_FAIL:
            return (0, $7uUwQ.assign)(state, {
                nameErrorMessage: action.payload.errors.name,
                leadErrorMessage: action.payload.errors.componentLead,
                saveIsInProgress: false
            });
        case 0, $lrD6Q.UPDATE_COMPONENT_FAIL:
            return (0, $7uUwQ.assign)(state, {
                saveIsInProgress: false
            });
        default:
            return state;
    }
};

});
parcelRegister("aSIZh", function(module, exports) {

$parcel$export(module.exports, "UPDATE_EDITED_COMPONENT", () => $6723c106af898bd4$export$3e160f16eaac1ba0);
$parcel$export(module.exports, "updateEditedComponent", () => $6723c106af898bd4$export$5e01f454419fe080);
$parcel$export(module.exports, "CANCEL", () => $6723c106af898bd4$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $6723c106af898bd4$export$70b61ad426ddbe54);
const $6723c106af898bd4$export$3e160f16eaac1ba0 = 'ui.edit.UPDATE_EDITED_COMPONENT';
const $6723c106af898bd4$export$5e01f454419fe080 = (component)=>({
        type: $6723c106af898bd4$export$3e160f16eaac1ba0,
        payload: {
            component: component
        }
    });
const $6723c106af898bd4$export$2b10f4b30fb65583 = 'ui.edit.CANCEL';
const $6723c106af898bd4$export$70b61ad426ddbe54 = ()=>({
        type: $6723c106af898bd4$export$2b10f4b30fb65583
    });

});


parcelRegister("lszLu", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d2a4f41708c65354$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $d2a4f41708c65354$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $90w69 = parcelRequire("90w69");
const $d2a4f41708c65354$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    message: undefined
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d2a4f41708c65354$export$2e2bcd8739ae039 = (state = $d2a4f41708c65354$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $90w69.SET:
            return (0, $7uUwQ.freeze)({
                message: action.payload.message
            });
        default:
            return state;
    }
};

});

parcelRegister("xaONt", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1970bdfbd4da7dfa$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $1970bdfbd4da7dfa$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $lfc7M = parcelRequire("lfc7M");

var $lrD6Q = parcelRequire("lrD6Q");

var $90w69 = parcelRequire("90w69");
const $1970bdfbd4da7dfa$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    isLoading: false,
    itemsOnPage: (0, $lfc7M.ITEMS_ON_PAGE),
    currentPage: (0, $lfc7M.PAGE)
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1970bdfbd4da7dfa$export$2e2bcd8739ae039 = (state = $1970bdfbd4da7dfa$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $lrD6Q.GET_COMPONENTS_PAGE_REQUEST:
            return (0, $7uUwQ.assign)(state, {
                isLoading: true,
                currentPage: action.payload.page
            });
        case 0, $90w69.SET:
            return (0, $7uUwQ.assign)(state, {
                isLoading: false
            });
        case 0, $lrD6Q.SET_COMPONENTS_PAGE:
            return (0, $7uUwQ.assign)(state, {
                isLoading: false
            });
        default:
            return state;
    }
};

});




parcelRegister("5p1gD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86ac3a393d57cdc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $h3TXK = parcelRequire("h3TXK");

var $vOSKs = parcelRequire("vOSKs");
const $c86ac3a393d57cdc$var$containerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300'
});
class $c86ac3a393d57cdc$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c86ac3a393d57cdc$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h3TXK.ContentWithGlobalComponentsProperty), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vOSKs.default), null));
    }
}

});
parcelRegister("h3TXK", function(module, exports) {

$parcel$export(module.exports, "ContentWithGlobalComponentsProperty", () => $e26bd35433320843$export$6822792b9dbc0ad0);

var $bC2fB = parcelRequire("bC2fB");

var $kgxuk = parcelRequire("kgxuk");

var $ldTif = parcelRequire("ldTif");

var $lrD6Q = parcelRequire("lrD6Q");

var $62PJu = parcelRequire("62PJu");

var $6z9Py = parcelRequire("6z9Py");

var $golPT = parcelRequire("golPT");

var $j4QfZ = parcelRequire("j4QfZ");

var $d8xNe = parcelRequire("d8xNe");

var $j8XGj = parcelRequire("j8XGj");

var $f0ahH = parcelRequire("f0ahH");
const $e26bd35433320843$var$mapStateToProps = (state)=>({
        status: (0, $j8XGj.getStatus)(state),
        editable: (0, $6z9Py.isAdmin)(state),
        analyticsData: (0, $62PJu.get)(state),
        baseUrl: (0, $6z9Py.getBaseUrl)(state),
        projectKey: (0, $golPT.getProjectKey)(state),
        projectName: (0, $golPT.getProjectName)(state),
        projectType: (0, $golPT.getProjectType)(state),
        isAdminContext: (0, $golPT.isComponentAdminContext)(),
        // Toggles to `true` inherently when our `refreshComponents` function is
        // invoked. Resolves to `false` when asynchronous actions are finished.
        isLoading: (0, $d8xNe.isLoading)(state)
    });
const $e26bd35433320843$var$mapDispatchToProps = {
    onAddComponent: (0, $j4QfZ.initiate)
};
const $e26bd35433320843$var$mapDispatchToPropsGlobalComponentsProperty = (dispatch)=>({
        onAddComponent: ()=>{
            dispatch((0, $j4QfZ.initiate)());
        },
        // Refresh cached components when toggling between Compass and Jira components..
        refreshComponents: ()=>{
            dispatch((0, $lrD6Q.getComponentsPageRequest)({
                page: 0,
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).VIEW
            }));
        }
    });
var $e26bd35433320843$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($e26bd35433320843$var$mapStateToProps, $e26bd35433320843$var$mapDispatchToProps)((0, $f0ahH.default));
const $e26bd35433320843$export$6822792b9dbc0ad0 = (0, $bC2fB.connect)($e26bd35433320843$var$mapStateToProps, $e26bd35433320843$var$mapDispatchToPropsGlobalComponentsProperty)((0, $ldTif.withGlobalComponentsProperty)((0, $f0ahH.default)));

});
parcelRegister("ldTif", function(module, exports) {

$parcel$export(module.exports, "withGlobalComponentsProperty", () => $93f66bea6be0b03e$export$8fb23a61064dd4a6);

var $5uXOq = parcelRequire("5uXOq");

var $5zSbY = parcelRequire("5zSbY");

var $hFon0 = parcelRequire("hFon0");

var $3GsiP = parcelRequire("3GsiP");

var $7CMCs = parcelRequire("7CMCs");

var $pa9q9 = parcelRequire("pa9q9");

var $5oFIy = parcelRequire("5oFIy");

var $kNZL3 = parcelRequire("kNZL3");

var $82Ni4 = parcelRequire("82Ni4");
const $93f66bea6be0b03e$export$8fb23a61064dd4a6 = (WrappedComponent)=>(props)=>{
        const { projectKey: projectKey, refreshComponents: refreshComponents } = props;
        const { enabled: enabled, loading: loading, error: error, setProperty: setProperty } = (0, $hFon0.useGlobalComponentsProperty)(projectKey);
        const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
        const provisionStatus = (0, $3GsiP.useCompassProvisionStatus)();
        const { startPollingBootstrapSyncStatus: startPollingBootstrapSyncStatus, stopPollingBootstrapSyncStatus: stopPollingBootstrapSyncStatus, isSyncInProgress: isSyncInProgress } = (0, $kNZL3.useGetBootstrapSyncStatus)();
        const { loading: permissionsLoading, hasCompassPermissions: hasCompassPermissions } = (0, $5zSbY.useGetCompassPermissions)();
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && enabled === undefined && error) showFlag({
                type: 'error',
                title: (0, $82Ni4.default).errorFetching,
                messageId: 'project-directories.components.common.services.with-global-components-property.show-flag.error.error-fetching',
                messageType: 'transactional'
            });
        }, [
            showFlag,
            loading,
            error,
            enabled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (provisionStatus === 'error') showFlag({
                type: 'error',
                title: (0, $82Ni4.default).errorProvisioning,
                messageId: 'project-directories.components.common.services.with-global-components-property.show-flag.error.error-provisioning',
                messageType: 'transactional'
            });
        }, [
            showFlag,
            provisionStatus
        ]);
        const toggleProperty = (0, $5uXOq.useCallback)((newValue)=>{
            setProperty(newValue).then(()=>{
                if (newValue) startPollingBootstrapSyncStatus();
                else stopPollingBootstrapSyncStatus();
                refreshComponents();
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $82Ni4.default).errorToggling,
                    messageId: 'project-directories.components.common.services.with-global-components-property.show-flag.error.error-toggling',
                    messageType: 'transactional'
                });
            });
        }, [
            refreshComponents,
            setProperty,
            showFlag,
            startPollingBootstrapSyncStatus,
            stopPollingBootstrapSyncStatus
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !loading && provisionStatus !== 'loading' && provisionStatus !== 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                isCompassProvisioned: provisionStatus === 'provisioned',
                globalComponentsEnabled: enabled
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "compass-lodestone",
            id: "globalComponentsPropertyHOC",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            globalComponentsProperty: {
                enabled: enabled,
                hasCompassPermissions: hasCompassPermissions,
                loading: loading || isSyncInProgress || permissionsLoading,
                setProperty: toggleProperty
            }
        })));
    };

});
parcelRegister("5zSbY", function(module, exports) {

$parcel$export(module.exports, "useGetCompassPermissions", () => $2c7dcc3b0c5efcc7$export$31f6fe789b504709);

var $5uXOq = parcelRequire("5uXOq");

var $7oOMy = parcelRequire("7oOMy");
function $2c7dcc3b0c5efcc7$export$31f6fe789b504709() {
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [hasCompassPermissions, setHasCompassPermissions] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        (0, $7oOMy.getCompassPermissions)() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((result)=>{
            if (result.statusCode) setHasCompassPermissions(result.statusCode === 200);
            else setHasCompassPermissions(!!result.entitlements);
        }).catch((e)=>setError(e)).finally(()=>setLoading(false));
    }, []);
    return {
        loading: loading,
        hasCompassPermissions: hasCompassPermissions,
        error: error
    };
}

});
parcelRegister("7oOMy", function(module, exports) {

$parcel$export(module.exports, "getCompassPermissions", () => $61d3d55d3d0986b6$export$a60fbb9830f913a6);

var $eusud = parcelRequire("eusud");
const $61d3d55d3d0986b6$var$url = '/gateway/api/compass/v1/entitlements';
const $61d3d55d3d0986b6$export$a60fbb9830f913a6 = async ()=>{
    try {
        return await (0, $eusud.performPostRequest)($61d3d55d3d0986b6$var$url, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entitlements: []
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403) return error;
        throw error;
    }
};

});


parcelRegister("hFon0", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $e88d764a116eddca$export$a070f388fcd93df0);

var $5uXOq = parcelRequire("5uXOq");

var $do78Z = parcelRequire("do78Z");

var $feQhf = parcelRequire("feQhf");
function $e88d764a116eddca$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [enabled, setEnabled] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $5uXOq.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $5uXOq.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $feQhf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $feQhf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $do78Z.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("do78Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b15e5e3de311da0$export$2e2bcd8739ae039);

var $c3jsi = parcelRequire("c3jsi");

var $1AJVB = parcelRequire("1AJVB");
var $2b15e5e3de311da0$export$2e2bcd8739ae039 = (0, $c3jsi.default)((0, $1AJVB.props));

});
parcelRegister("c3jsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdca2a0bd8756d7$export$2e2bcd8739ae039);

var $8Op28 = parcelRequire("8Op28");
const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $8Op28.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $ccdca2a0bd8756d7$var$pNothing,
        update: $ccdca2a0bd8756d7$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $ccdca2a0bd8756d7$var$pNothing
    };
};

});
parcelRegister("8Op28", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3e46065a4b1d2500$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $3e46065a4b1d2500$export$2e2bcd8739ae039);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");

var $2YZCu = parcelRequire("2YZCu");


var $1NZBJ = parcelRequire("1NZBJ");
const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $1NZBJ.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, $bSSG7.createLocalStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        else storage = (0, $eNf8a.createSessionStorageProvider)((0, $1NZBJ.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $2YZCu.default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $1NZBJ.default).scopes.current !== (0, $1NZBJ.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3e46065a4b1d2500$var$cacheMap = {};
const $3e46065a4b1d2500$var$getCache = async (props)=>{
    await (0, $1NZBJ.scopeGuard)().catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
    return $3e46065a4b1d2500$var$cacheMap[cacheKey];
};
const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
    Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
};
var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;

});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';



parcelRegister("1AJVB", function(module, exports) {

$parcel$export(module.exports, "props", () => $68c0e7b1e3ad3adb$export$8128bb6492cf3de7);

const $68c0e7b1e3ad3adb$var$MAX_RESULTS = 10;
const $68c0e7b1e3ad3adb$var$CACHE_SIZE = $68c0e7b1e3ad3adb$var$MAX_RESULTS * 2;
const $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY = 'components';
const $68c0e7b1e3ad3adb$export$8128bb6492cf3de7 = {
    size: $68c0e7b1e3ad3adb$var$CACHE_SIZE,
    cacheKey: $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
};

});


parcelRegister("feQhf", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $f3ade48088ec15c3$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $f3ade48088ec15c3$export$71702a5b14caff65);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $f3ade48088ec15c3$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $f3ade48088ec15c3$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $f3ade48088ec15c3$var$getProjectId = async (projectKey)=>{
    const project = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $f3ade48088ec15c3$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $eusud.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $f3ade48088ec15c3$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $eusud.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("3GsiP", function(module, exports) {

$parcel$export(module.exports, "hasCompassBeenProvisioned", () => $322bab86217036c5$export$f5f769750906cf9c);
$parcel$export(module.exports, "useCompassProvisionStatus", () => $322bab86217036c5$export$aa74b72c625075d2);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $koeKL = parcelRequire("koeKL");
const $322bab86217036c5$export$d76f7cdcb363ecda = 'compass';
const $322bab86217036c5$var$logErrorAndFireAnalytics = (errorMessage)=>{
    const { packageName: packageName, locationId: locationId, message: message, error: error } = errorMessage;
    (0, $2YZCu.default).safeErrorWithoutCustomerData(`${packageName}.${locationId}`, message, error);
    (0, $jcw0u.default)({
        meta: {
            id: locationId,
            packageName: packageName
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $322bab86217036c5$var$doOnError = (error)=>{
    $322bab86217036c5$var$logErrorAndFireAnalytics({
        packageName: 'jiraSoftwareCompassCrossFlowTouchPoint',
        locationId: 'services.license-information.has-compass-been-provisioned',
        message: 'Could not fetch license information.',
        error: error
    });
};
const $322bab86217036c5$var$getLicenseInformation = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/xflow/${cloudId}/license-information`);
const $322bab86217036c5$export$f5f769750906cf9c = async (cloudId)=>{
    try {
        const data = await $322bab86217036c5$var$getLicenseInformation(cloudId);
        return data?.products?.[$322bab86217036c5$export$d76f7cdcb363ecda]?.state === 'ACTIVE';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        $322bab86217036c5$var$doOnError(err);
        throw err;
    }
};
const $322bab86217036c5$export$aa74b72c625075d2 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    (0, $5uXOq.useEffect)(()=>{
        const provisionedCheck = async ()=>{
            if (await $322bab86217036c5$export$f5f769750906cf9c(cloudId)) setStatus('provisioned');
            else setStatus('not-provisioned');
        };
        provisionedCheck().catch(()=>{
            setStatus('error');
        });
    }, [
        cloudId
    ]);
    return status;
};

});

parcelRegister("kNZL3", function(module, exports) {

$parcel$export(module.exports, "useGetBootstrapSyncStatus", () => $3b44e808f67b76d6$export$8810d87873b64f44);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $ldpCA = parcelRequire("ldpCA");
const $3b44e808f67b76d6$var$REQUEST_TIMEOUT = 2000;
const $3b44e808f67b76d6$var$bootstrapSyncUrl = '/rest/internal/1.0/component/sync/compass/status';
const $3b44e808f67b76d6$export$8810d87873b64f44 = (pollMax = 10)=>{
    const [error, setError] = (0, $5uXOq.useState)();
    const [bootstrapSyncStatus, setBootstrapSyncStatus] = (0, $5uXOq.useState)(undefined);
    const [isSyncInProgress, setIsSyncInProgress] = (0, $5uXOq.useState)(false);
    const timerRef = (0, $5uXOq.useRef)();
    const pollCount = (0, $5uXOq.useRef)(0);
    const resetRequest = (0, $5uXOq.useCallback)(()=>{
        setIsSyncInProgress(false);
        clearTimeout(timerRef.current);
        pollCount.current = 0;
    }, []);
    const handleError = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (err)=>{
        setError(err);
        resetRequest();
        setBootstrapSyncStatus((0, $ldpCA.requestStatus).ENDED);
        (0, $jcw0u.default)({
            meta: {
                id: 'useGetBootstrapSyncStatus',
                packageName: 'jiraProjectDirectoriesComponents',
                teamName: 'compass-lodestone'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        resetRequest
    ]);
    const invokeRequest = (0, $5uXOq.useCallback)(async ()=>(0, $eusud.performGetRequestWithRetry)($3b44e808f67b76d6$var$bootstrapSyncUrl, {
            retryAttempts: 3
        }), []);
    const startPollingBootstrapSyncStatus = (0, $5uXOq.useCallback)(()=>{
        const reinitiatePoll = (status)=>{
            if (!bootstrapSyncStatus || bootstrapSyncStatus !== (0, $ldpCA.requestStatus).COMPLETED || bootstrapSyncStatus !== (0, $ldpCA.requestStatus).ENDED) {
                setBootstrapSyncStatus(status);
                pollCount.current += 1;
                timerRef.current = setTimeout(startPollingBootstrapSyncStatus, $3b44e808f67b76d6$var$REQUEST_TIMEOUT);
            } else clearTimeout(timerRef.current);
        };
        setIsSyncInProgress(true);
        invokeRequest().then((data)=>{
            if (pollCount.current === pollMax) throw new Error('Polling attempts reached');
            // If Compass is not provisioned on a site, the sync status endpoint returns a 200 with no content.
            if (!data) {
                setBootstrapSyncStatus((0, $ldpCA.requestStatus).ENDED);
                resetRequest();
                return;
            }
            const { state: syncState } = data;
            switch(syncState){
                case (0, $ldpCA.requestStatus).COMPLETED:
                    setBootstrapSyncStatus((0, $ldpCA.requestStatus).COMPLETED);
                    resetRequest();
                    break;
                case (0, $ldpCA.requestStatus).IN_PROGESS:
                    reinitiatePoll((0, $ldpCA.requestStatus).IN_PROGESS);
                    break;
                case (0, $ldpCA.requestStatus).NOT_INITIATED:
                    reinitiatePoll((0, $ldpCA.requestStatus).NOT_INITIATED);
                    break;
                default:
                    setBootstrapSyncStatus((0, $ldpCA.requestStatus).ENDED);
                    resetRequest();
                    break;
            }
        }).catch((err)=>{
            handleError(err);
        });
    }, [
        invokeRequest,
        bootstrapSyncStatus,
        pollMax,
        resetRequest,
        handleError
    ]);
    const stopPollingBootstrapSyncStatus = (0, $5uXOq.useCallback)(()=>{
        setBootstrapSyncStatus((0, $ldpCA.requestStatus).ENDED);
        resetRequest();
    }, [
        resetRequest
    ]);
    return {
        error: error,
        isSyncInProgress: isSyncInProgress,
        bootstrapSyncStatus: bootstrapSyncStatus,
        startPollingBootstrapSyncStatus: startPollingBootstrapSyncStatus,
        stopPollingBootstrapSyncStatus: stopPollingBootstrapSyncStatus
    };
};

});
parcelRegister("ldpCA", function(module, exports) {

$parcel$export(module.exports, "requestStatus", () => $c4c75f613326520f$export$b623c9d52fb562b0);
const $c4c75f613326520f$export$b623c9d52fb562b0 = {
    ENDED: 'ENDED',
    COMPLETED: 'COMPLETED',
    IN_PROGESS: 'IN_PROGRESS',
    NOT_INITIATED: 'NOT_INITIATED'
};

});


parcelRegister("82Ni4", function(module, exports) {

$parcel$export(module.exports, "default", () => $02af150d092514cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02af150d092514cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorToggling: {
        "id": "project-directories.components.common.services.with-global-components-property.error-toggling",
        "defaultMessage": "Error updating Global Components Property"
    },
    errorFetching: {
        "id": "project-directories.components.common.services.with-global-components-property.error-fetching",
        "defaultMessage": "Error fetching Global Components Property"
    },
    errorProvisioning: {
        "id": "project-directories.components.common.services.with-global-components-property.error-provisioning",
        "defaultMessage": "Error fetching Compass provisioning state"
    }
});

});


parcelRegister("62PJu", function(module, exports) {

$parcel$export(module.exports, "get", () => $0d4505e1ee2af321$export$3988ae62b71be9a3);
const $0d4505e1ee2af321$export$3988ae62b71be9a3 = (state)=>state.analyticsData;

});

parcelRegister("j8XGj", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $3554e48a3ea0c931$export$b70265791d2079d4);

var $3kGkY = parcelRequire("3kGkY");

var $kYnKh = parcelRequire("kYnKh");

var $hKBBJ = parcelRequire("hKBBJ");

var $d8xNe = parcelRequire("d8xNe");
const $3554e48a3ea0c931$export$b70265791d2079d4 = (state)=>{
    if ((0, $hKBBJ.getError)(state).message) return 'error';
    if ((0, $d8xNe.isLoading)(state)) return 'has-components';
    const isFilterEmpty = (0, $kYnKh.getFilter)(state) === '';
    return (0, $3kGkY.isEmpty)(state) && isFilterEmpty ? 'empty' : 'has-components';
};

});
parcelRegister("hKBBJ", function(module, exports) {

$parcel$export(module.exports, "getError", () => $042322f228188a50$export$e1599abf47b5b568);
const $042322f228188a50$export$e1599abf47b5b568 = (state)=>state.ui.error;

});


parcelRegister("f0ahH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f3bfae9e4e78c9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ldJSL = parcelRequire("ldJSL");

var $luBm6 = parcelRequire("luBm6");

var $jS4lj = parcelRequire("jS4lj");

var $e0tCO = parcelRequire("e0tCO");

var $gEFwt = parcelRequire("gEFwt");

var $cS37j = parcelRequire("cS37j");

var $2vSU6 = parcelRequire("2vSU6");

var $7XYc4 = parcelRequire("7XYc4");

var $id7K0 = parcelRequire("id7K0");

var $1asmd = parcelRequire("1asmd");

var $koVbs = parcelRequire("koVbs");

var $az4zD = parcelRequire("az4zD");

var $3HwlS = parcelRequire("3HwlS");

var $d3xtk = parcelRequire("d3xtk");

var $5aax0 = parcelRequire("5aax0");

var $73b2Z = parcelRequire("73b2Z");

var $kuWs9 = parcelRequire("kuWs9");

var $3vJCP = parcelRequire("3vJCP");

var $4mxqk = parcelRequire("4mxqk");

var $hv2Tu = parcelRequire("hv2Tu");

var $1zkys = parcelRequire("1zkys");

var $fP6zk = parcelRequire("fP6zk");

var $dAIrW = parcelRequire("dAIrW");

var $e5SJp = parcelRequire("e5SJp");

var $84sfP = parcelRequire("84sfP");

var $eBSZq = parcelRequire("eBSZq");

var $7h5i5 = parcelRequire("7h5i5");
function $31f3bfae9e4e78c9$var$AppViewOld(props) {
    const { onAddComponent: onAddComponent, status: status, editable: editable, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, projectType: projectType, intl: { formatMessage: formatMessage }, isAdminContext: isAdminContext, isLoading: isLoading, globalComponentsProperty: globalComponentsProperty = {
        loading: false,
        enabled: false,
        hasCompassPermissions: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setProperty: ()=>{}
    } } = props;
    const isProjectTypeJsw = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null);
    let content = null;
    let searchBar = null;
    let actions = isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fP6zk.WrappedGlobalComponentsToggleButton), {
        globalComponentsProperty: {
            loading: globalComponentsProperty.loading,
            enabled: globalComponentsProperty.enabled,
            setProperty: globalComponentsProperty.setProperty
        },
        isEditable: editable
    }) : null;
    let createComponentButton = null;
    const statusWithLoading = isLoading || globalComponentsProperty.loading ? 'loading' : status;
    switch(statusWithLoading){
        case 'loading':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAIrW.LoadingState), null);
            break;
        case 'empty':
            if (globalComponentsProperty.enabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3xtk.CompassEmptyState), {
                projectKey: projectKey
            });
            else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mxqk.default), {
                projectType: projectType
            });
            break;
        case 'has-components':
            if (editable) createComponentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vJCP.default), {
                testId: "project-directories.components.content.create-component-button",
                loading: globalComponentsProperty.loading,
                globalComponentsEnabled: globalComponentsProperty.enabled,
                oldOnAddComponent: onAddComponent,
                projectKey: projectKey
            });
             // check if a user has access to compass, if not show request access state
            if (globalComponentsProperty.enabled) {
                if (!globalComponentsProperty.hasCompassPermissions) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kuWs9.RequestAccessState), null);
                else // FF on - Compass components
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $73b2Z.default), {
                    testId: "project-directories.components.content.compass-components-table",
                    projectKey: projectKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e5SJp.default), null));
            } else {
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84sfP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e5SJp.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aax0.CompassTableCrossflowTouchPointWithEC), null));
                searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1zkys.default), null);
            }
            actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31f3bfae9e4e78c9$var$ActionsWrapper, null, isProjectTypeJsw && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fP6zk.WrappedGlobalComponentsToggleButton), {
                globalComponentsProperty: {
                    loading: globalComponentsProperty.loading,
                    enabled: globalComponentsProperty.enabled,
                    setProperty: globalComponentsProperty.setProperty
                },
                isEditable: editable
            }), createComponentButton);
            break;
        case 'error':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hv2Tu.default), null);
            break;
        default:
            break;
    }
    const pageContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "project-directories.components.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        breadcrumbs: breadcrumbs,
        actions: actions,
        bottomBar: isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBSZq.HeaderBottombarContent), {
            isGlobalComponentsEnabled: globalComponentsProperty.enabled,
            searchBar: searchBar,
            formatMessage: formatMessage
        }) : searchBar
    }, formatMessage((0, $7h5i5.messages).caption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $7h5i5.messages).caption)
    }), content);
    return isAdminContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0tCO.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectType: projectType
    }, pageContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, pageContent);
}
function $31f3bfae9e4e78c9$var$AppViewNew(props) {
    const { onAddComponent: onAddComponent, status: status, editable: editable, projectKey: projectKey, projectType: projectType, isLoading: isLoading, globalComponentsProperty: globalComponentsProperty = {
        loading: false,
        enabled: false,
        hasCompassPermissions: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setProperty: ()=>{}
    } } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isProjectTypeJsw = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    let content = null;
    let searchBar = null;
    let createComponentButton = null;
    const toggleButton = isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fP6zk.WrappedGlobalComponentsToggleButton), {
        globalComponentsProperty: {
            loading: globalComponentsProperty.loading,
            enabled: globalComponentsProperty.enabled,
            setProperty: globalComponentsProperty.setProperty
        },
        isEditable: editable
    }) : null;
    let actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, toggleButton);
    const statusWithLoading = isLoading || globalComponentsProperty.loading ? 'loading' : status;
    switch(statusWithLoading){
        case 'loading':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAIrW.LoadingState), null);
            break;
        case 'empty':
            if (globalComponentsProperty.enabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d3xtk.CompassEmptyState), {
                projectKey: projectKey
            });
            else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mxqk.default), {
                projectType: projectType
            });
            break;
        case 'has-components':
            if (editable) createComponentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vJCP.default), {
                testId: "project-directories.components.content.create-component-button",
                loading: globalComponentsProperty.loading,
                globalComponentsEnabled: globalComponentsProperty.enabled,
                oldOnAddComponent: onAddComponent,
                projectKey: projectKey
            });
             // check if a user has access to compass, if not show request access state
            if (globalComponentsProperty.enabled) {
                if (!globalComponentsProperty.hasCompassPermissions) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kuWs9.RequestAccessState), null);
                else // FF on - Compass components
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $73b2Z.default), {
                    testId: "project-directories.components.content.compass-components-table",
                    projectKey: projectKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e5SJp.default), null));
            } else {
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84sfP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e5SJp.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5aax0.CompassTableCrossflowTouchPointWithEC), null));
                searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1zkys.default), {
                    ariaLabel: formatMessage((0, $7h5i5.messages).filterInputLabel)
                });
            }
            actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, toggleButton, createComponentButton);
            break;
        case 'error':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hv2Tu.default), null);
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testId": "project-directories.components.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1asmd.PageTopBar), {
        actions: actions,
        bottomBar: isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBSZq.HeaderBottombarContent), {
            isGlobalComponentsEnabled: globalComponentsProperty.enabled,
            searchBar: searchBar,
            formatMessage: formatMessage
        })) : searchBar
    }), content);
}
const $31f3bfae9e4e78c9$var$AppView = (0, $7XYc4.componentWithCondition)((0, $3HwlS.getWillShowNav4), $31f3bfae9e4e78c9$var$AppViewNew, (0, $az4zD.injectIntlV2)($31f3bfae9e4e78c9$var$AppViewOld));
var $31f3bfae9e4e78c9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $31f3bfae9e4e78c9$var$AppView;
const $31f3bfae9e4e78c9$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_8mocu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e0tCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $67a65658db3ebd27$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $7Xr7M = parcelRequire("7Xr7M");
var $67a65658db3ebd27$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $7Xr7M.default));

});
parcelRegister("7Xr7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c779f1fa7b01b6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $c2D8L = parcelRequire("c2D8L");

var $81ps3 = parcelRequire("81ps3");

var $9zgyl = parcelRequire("9zgyl");
const $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) || projectType === (0, $2vSU6.CUSTOMER_SERVICE_PROJECT) && (0, $4R6GH.fg)('jcs_project_type_m3')) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            href: (0, $81ps3.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $9zgyl.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $14c779f1fa7b01b6$export$2e2bcd8739ae039 = $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb;

});
parcelRegister("9zgyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e487ef6161e77fc4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e487ef6161e77fc4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});



parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("1asmd", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $a509d50a7a06aca2$export$7e5801dc91bf1819);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

const $a509d50a7a06aca2$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$90c4434a1e138106),
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStylesOld2,
            (0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStyles,
            wrapAtMd ? $a509d50a7a06aca2$var$wrapAtMdStyle : $a509d50a7a06aca2$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$1742330ac6a668f0),
        xcss: [
            $a509d50a7a06aca2$var$actionsBoxStyles,
            wrapAtMd && $a509d50a7a06aca2$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $a509d50a7a06aca2$export$7e5801dc91bf1819 = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a509d50a7a06aca2$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), props);
const $a509d50a7a06aca2$var$noWrapStyle = (0, $8CUq3.xcss)({
    flexWrap: 'nowrap'
});
const $a509d50a7a06aca2$var$wrapAtMdStyle = (0, $8CUq3.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $h9kUS.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $a509d50a7a06aca2$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$wrapperStylesOld2 = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$actionsBoxAtMdStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    [(0, $h9kUS.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $a509d50a7a06aca2$var$actionsBoxStyles = (0, $8CUq3.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $2fd65ab7d0fa0d2a$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $2fd65ab7d0fa0d2a$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("d3xtk", function(module, exports) {

$parcel$export(module.exports, "CompassEmptyState", () => $83dc3e82d3916647$export$c3891d38ba06b32e);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $7CMCs = parcelRequire("7CMCs");

var $hqBSi = parcelRequire("hqBSi");

var $3Ehv7 = parcelRequire("3Ehv7");

var $dAIrW = parcelRequire("dAIrW");

var $an4sI = parcelRequire("an4sI");

var $8PL6W = parcelRequire("8PL6W");
const $83dc3e82d3916647$var$TEST_ID = 'project-directories.components.compass-empty-state.empty';
const $83dc3e82d3916647$export$c3891d38ba06b32e = ({ projectKey: projectKey })=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const [crossFlowComplete, setCrossFlowComplete] = (0, $5uXOq.useState)(false);
    let componentsTableEmptyState;
    const { count: count, loading: loading, error: error } = (0, $3Ehv7.useCountCompassComponents)({
        skip: !(licensedProducts && licensedProducts.compass || crossFlowComplete)
    });
    // Render empty state if tenant has Compass, OR
    // We've completed cross flow. Licensed products won't be updated until page reload.
    if (licensedProducts && licensedProducts.compass || crossFlowComplete) {
        if (loading) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAIrW.LoadingState), null);
        else if (error) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PL6W.ComponentsTableEmptyState), {
            testId: $83dc3e82d3916647$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            displayMode: "unknown"
        });
        else if (!count) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PL6W.ComponentsTableEmptyState), {
            testId: $83dc3e82d3916647$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            displayMode: "no-components"
        });
        else componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PL6W.ComponentsTableEmptyState), {
            testId: $83dc3e82d3916647$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            componentCount: count,
            displayMode: "no-linked-components"
        });
    } else componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $an4sI.default), {
        origin: "project-pages.project-directories.components.view.empty",
        onCrossFlowComplete: ()=>setCrossFlowComplete(true)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "compassEmptyState",
        sendToPrivacyUnsafeSplunk: true
    }, componentsTableEmptyState);
};

});
parcelRegister("3Ehv7", function(module, exports) {

$parcel$export(module.exports, "useCountCompassComponents", () => $f2a39db69fd8ff43$export$31d633df2827a840);

var $5pk0Q = parcelRequire("5pk0Q");

var $koeKL = parcelRequire("koeKL");

var $cYSLf = parcelRequire("cYSLf");
const $f2a39db69fd8ff43$export$31d633df2827a840 = (props)=>{
    const { skip: skip = false } = props ?? {};
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: data, loading: loading, error: error } = (0, $5pk0Q.useFetchQuery)((0, $cYSLf.COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY), {
        cloudId: cloudId,
        query: {
            fieldFilters: [
                {
                    name: 'state',
                    filter: {
                        in: [
                            'ACTIVE'
                        ]
                    }
                }
            ],
            sort: []
        }
    }, {
        fetchPolicy: 'network-only',
        skip: skip
    });
    const count = data?.compass?.searchComponents?.__typename === 'CompassSearchComponentConnection' ? data?.compass?.searchComponents?.totalCount : null;
    return {
        count: count,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5pk0Q", function(module, exports) {

$parcel$export(module.exports, "useFetchQuery", () => $cfa72d88fe779077$export$e0fe68859e28ee42);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");
// sounced from https://github.com/apollographql/apollo-client/blob/main/src/react/hooks/utils/useDeepMemo.ts
const $cfa72d88fe779077$var$useDeepMemo = (memoFn, key)=>{
    const ref = (0, $5uXOq.useRef)();
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return ref.current.value;
};
const $cfa72d88fe779077$export$e0fe68859e28ee42 = (query, vars, opts)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [result, setResult] = (0, $5uXOq.useState)({
        data: null,
        error: null,
        loading: true
    });
    const { data: data, error: error, loading: loading } = result;
    const prevVariables = (0, $5uXOq.useRef)();
    const fetch = (variables, options)=>{
        const { fetchPolicy: fetchPolicy = 'network-only', skip: skip = false } = options || {};
        if (skip || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevVariables.current, variables)) return;
        prevVariables.current = variables;
        // Don't trigger re-render if it's intial render
        if (!(loading === true && data == null && error === null)) setResult({
            error: null,
            loading: true,
            data: null
        });
        (0, $8Uumt.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy
        }).toPromise().then((d)=>{
            setResult({
                error: null,
                loading: false,
                // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'null'.
                data: d
            });
        }).catch((e)=>{
            setResult({
                data: null,
                loading: false,
                error: e
            });
        });
    };
    const memo = {
        vars: vars,
        opts: opts
    };
    $cfa72d88fe779077$var$useDeepMemo(()=>{
        fetch(vars, opts);
    }, memo);
    const nullableData = data == null ? null : data;
    return {
        data: nullableData,
        error: error,
        loading: loading
    };
};

});

parcelRegister("cYSLf", function(module, exports) {

$parcel$export(module.exports, "COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY", () => $f17eb6532b8cf7f1$export$e0e019aad11e83aa);

var $5Q9jf = parcelRequire("5Q9jf");
const $f17eb6532b8cf7f1$export$e0e019aad11e83aa = (0, $5Q9jf.default);

});
parcelRegister("5Q9jf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e46cd407eaa3b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35c66d1fe3da80e6066fb994a448a5b8>>
 * @relayHash 889293ef5047c9583bb7e73bf9000cdd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425
const $a3e46cd407eaa3b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "concreteType": "CompassCatalogQueryApi",
            "kind": "LinkedField",
            "name": "compass",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "searchComponents",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ],
                            "type": "CompassSearchComponentConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlCountCompassComponentsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlCountCompassComponentsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425",
            "metadata": {},
            "name": "gqlCountCompassComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a3e46cd407eaa3b4$var$node.hash = "db6ce5954b3b32b77dc71734e9b9557b";
var $a3e46cd407eaa3b4$export$2e2bcd8739ae039 = $a3e46cd407eaa3b4$var$node;

});



parcelRegister("dAIrW", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $2b8af53d9b4e3136$export$62aa48085237e36f);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $eZJjh = parcelRequire("eZJjh");
function $2b8af53d9b4e3136$export$62aa48085237e36f() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "project-directories.components.content.components-spinner"
    }));
}

});

parcelRegister("an4sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ced9af1c20464bb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hbou1 = parcelRequire("hbou1");

var $6pvrS = parcelRequire("6pvrS");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ced9af1c20464bb$var$CrossFlowTouchPointWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});
class $7ced9af1c20464bb$var$CompassCrossFlow extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isCompassLicensed: false
        };
    }
    render() {
        const { isCompassLicensed: isCompassLicensed, origin: origin, onCrossFlowComplete: onCrossFlowComplete } = this.props;
        return !isCompassLicensed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pvrS.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ced9af1c20464bb$var$CrossFlowTouchPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hbou1.default), {
            origin: origin,
            eventSource: "jiraComponentsSection",
            onCrossFlowComplete: onCrossFlowComplete
        })));
    }
}
var $7ced9af1c20464bb$export$2e2bcd8739ae039 = $7ced9af1c20464bb$var$CompassCrossFlow;

});
parcelRegister("hbou1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f9c31e75234441e$export$2e2bcd8739ae039);

var $iGUhI = parcelRequire("iGUhI");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $8Uumt = parcelRequire("8Uumt");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $6f1mg = parcelRequire("6f1mg");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");

var $3JT92 = parcelRequire("3JT92");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $8zOmE = parcelRequire("8zOmE");

var $9OXo1 = parcelRequire("9OXo1");

var $cmVQ7 = parcelRequire("cmVQ7");

var $2tT7R = parcelRequire("2tT7R");

var $j5YhT = parcelRequire("j5YhT");

var $dAfqg = parcelRequire("dAfqg");

var $6zT3P = parcelRequire("6zT3P");


var $3GsiP = parcelRequire("3GsiP");

var $ljkmy = parcelRequire("ljkmy");

var $4ngBf = parcelRequire("4ngBf");

var $61CXq = parcelRequire("61CXq");
const $8f9c31e75234441e$var$NewCrossFlowTouchPoint = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { enabled: enabled, onTry: onTry, onLearnMore: onLearnMore } = props;
    if (enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f9c31e75234441e$var$ContentWrapper, {
        "data-testid": "compass-cross-flow.ui.empty-state-not-provisioned"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6f1mg.CompassLogo), {
        appearance: "brand",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f9c31e75234441e$var$TouchPointMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large",
        as: "h2"
    }, formatMessage((0, $61CXq.default).headLine))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f9c31e75234441e$var$TouchPointMessageDescriptionWrapper, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $61CXq.default).callToActionIssueTermRefresh : (0, $61CXq.default).callToAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onTry
    }, formatMessage((0, $61CXq.default).engageMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: onLearnMore,
        href: (0, $c7f5227e1f4d5143$export$ae684c7694b92c83),
        target: "_blank"
    }, formatMessage((0, $61CXq.default).learnMoreMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6zT3P.CrossflowImage), null));
    return null;
};
/**
 * Basic crossflow touch point that shows a static message and a button to try Compass.
 */ const $8f9c31e75234441e$var$DefaultCrossFlowTouchPoint = (props)=>{
    const { origin: origin, eventSource: eventSource, onCrossFlowComplete: onCrossFlowComplete } = props;
    const crossFlow = (0, $bHpB9.useCrossFlow)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { fireInteractedUIEvent: fireInteractedUIEvent, fireViewedUIEvent: fireViewedUIEvent } = (0, $cmVQ7.useFireCrossFlowAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!crossFlow.isEnabled) (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraCompassCrossFlow'
            }
        });
        else fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'tryCompassBanner'
        }, {
            recommendedProductIds: [
                (0, $jWY5k.Targets).COMPASS
            ],
            source: eventSource
        });
    }, [
        crossFlow,
        eventSource,
        fireViewedUIEvent
    ]);
    const onTry = (0, $5uXOq.useCallback)(async (event, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryCompassButton'
        }, {
            targetProductId: (0, $jWY5k.Targets).COMPASS,
            recommendedProductIds: [
                (0, $jWY5k.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointTry');
        if (crossFlow.isEnabled) {
            await crossFlow.api.open({
                journey: (0, $bHpB9.Journeys).GET_STARTED,
                targetProduct: (0, $jWY5k.Targets).COMPASS,
                sourceComponent: 'jira-compass-cross-flow-try',
                sourceContext: 'jira'
            }); // Refresh the Compass Crossflow Touchpoint once Compass is provisioned
            const result = await (0, $3GsiP.hasCompassBeenProvisioned)(cloudId);
            if (result) {
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandComplete', {
                    hasCompassProvisioned: result,
                    origin: origin
                });
                onCrossFlowComplete?.();
            } else (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandIncomplete', {
                hasCompassProvisioned: result,
                origin: origin
            });
        }
    }, [
        cloudId,
        crossFlow,
        origin,
        fireInteractedUIEvent,
        onCrossFlowComplete
    ]);
    const onLearnMore = (0, $5uXOq.useCallback)(async (event, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMoreCompassButton'
        }, {
            targetProductId: (0, $jWY5k.Targets).COMPASS,
            recommendedProductIds: [
                (0, $jWY5k.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointLearnMore');
    }, [
        fireInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: "compass-lodestone",
        id: "crossFlowTouchPoint",
        packageName: "jiraCompassCrossFlowTouchPoint",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "jiraCompassCrossFlowTouchPoint"
    }), $8f9c31e75234441e$var$NewCrossFlowTouchPoint({
        enabled: crossFlow.isEnabled,
        onTry: onTry,
        onLearnMore: onLearnMore
    }));
};
/**
 * This crossflow touch point advertises Compass capabilities using repository data associated with current Jira project pulled from Team Work Graph.
 */ const $8f9c31e75234441e$var$AutoCatalogViaTeamWorkGraphCrossFlowTouchPoint = (props)=>{
    const { origin: origin, eventSource: eventSource, onCrossFlowComplete: onCrossFlowComplete } = props;
    const crossFlow = (0, $bHpB9.useCrossFlow)();
    const { fireInteractedUIEvent: fireInteractedUIEvent, fireViewedUIEvent: fireViewedUIEvent } = (0, $cmVQ7.useFireCrossFlowAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const isStagingOrDev = (0, $2tT7R.useIsStagingOrDevOrLocal)();
    const providerId = isStagingOrDev ? 'com.github.integration.staging' : 'com.github.integration.production';
    const projectContext = (0, $dAfqg.useProjectContext)();
    const projectId = projectContext.data?.projectId;
    if (!projectId) throw new Error('Provisioning did not return projectId');
    const jiraProjectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId.toString()
    }).toString();
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $iGUhI.default), {
        projectId: jiraProjectAri,
        first: 20
    });
    const repositories = data?.graphStore?.projectAssociatedRepo?.edges?.map((edge)=>edge?.node)?.filter((repo)=>repo?.__typename === 'DevOpsRepository') || [];
    const filteredRepositories = providerId ? repositories.filter((repo)=>repo?.__typename === 'DevOpsRepository' && repo?.providerId === providerId && repo?.name !== null) : repositories;
    (0, $5uXOq.useEffect)(()=>{
        if (!crossFlow.isEnabled) (0, $jcw0u.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraCompassCrossFlow'
            }
        });
        else fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'tryCompassBanner'
        }, {
            recommendedProductIds: [
                (0, $jWY5k.Targets).COMPASS
            ],
            source: eventSource
        }, {
            autoCatalogingViaTwg: true
        });
    }, [
        crossFlow,
        eventSource,
        fireViewedUIEvent
    ]);
    const onTry = (0, $5uXOq.useCallback)(async (_, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryCompassButton'
        }, {
            targetProductId: (0, $jWY5k.Targets).COMPASS,
            recommendedProductIds: [
                (0, $jWY5k.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        }, {
            autoCatalogingViaTwg: true
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointTry');
        if (crossFlow.isEnabled) {
            await crossFlow.api.open({
                journey: (0, $bHpB9.Journeys).GET_STARTED,
                targetProduct: (0, $jWY5k.Targets).COMPASS,
                sourceComponent: 'jira-compass-cross-flow-try',
                sourceContext: 'jira',
                extraAnalyticsAttributes: {
                    autoCatalogingViaTwg: true
                }
            }); // Refresh the Compass Crossflow Touchpoint once Compass is provisioned
            const result = await (0, $3GsiP.hasCompassBeenProvisioned)(cloudId);
            if (result) {
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandComplete', {
                    hasCompassProvisioned: result,
                    origin: origin,
                    autoCatalogingViaTwg: true
                });
                onCrossFlowComplete?.();
            } else (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandIncomplete', {
                hasCompassProvisioned: result,
                origin: origin,
                autoCatalogingViaTwg: true
            });
        }
    }, [
        cloudId,
        crossFlow,
        origin,
        fireInteractedUIEvent,
        onCrossFlowComplete
    ]);
    if (filteredRepositories.length <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f9c31e75234441e$var$DefaultCrossFlowTouchPoint, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "compass-cross-flow.ui.new-empty-state-not-provisioned",
        paddingBlock: "space.400",
        paddingBlockStart: "space.100",
        xcss: (0, $3JT92.cx)($8f9c31e75234441e$var$containerStyle.root)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        templateColumns: "1fr 2fr",
        gap: "space.400",
        alignContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ngBf.default), {
        onTry: onTry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljkmy.ConnectedRepositoryList), {
        filteredRepositories: filteredRepositories
    })));
};
const $8f9c31e75234441e$var$CrossFlowTouchPoint = (props)=>{
    if ((0, $4R6GH.fg)('compass_software_collections_empty_state')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f9c31e75234441e$var$AutoCatalogViaTeamWorkGraphCrossFlowTouchPoint, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f9c31e75234441e$var$DefaultCrossFlowTouchPoint, props);
};
var $8f9c31e75234441e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8f9c31e75234441e$var$CrossFlowTouchPoint;
const $8f9c31e75234441e$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _1bsbj2pb _syaz1gjq _19pk1epz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f9c31e75234441e$var$TouchPointMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1wq8 _ca0qv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f9c31e75234441e$var$TouchPointMessageDescriptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _ca0qv47k _u5f3idpf _n3tdv47k _19bvidpf",
            __cmplp.className
        ])
    });
});
const $8f9c31e75234441e$var$containerStyle = {
    root: "_p12f1fra"
};

});
parcelRegister("iGUhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b105ff96c14e90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<073e7d3aac053da8af5c93c8a297b31b>>
 * @relayHash a1232aab5ef9e6659ae067c93a9169aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 076209f08f2315ef3dc68a6106e497924279b6f13378b7488e91c34481458fd4
const $87b105ff96c14e90$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiConnectedRepositoryListQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                            "kind": "LinkedField",
                            "name": "projectAssociatedRepo",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "DevOpsRepository"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiConnectedRepositoryListQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                            "kind": "LinkedField",
                            "name": "projectAssociatedRepo",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "DevOpsRepository"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "076209f08f2315ef3dc68a6106e497924279b6f13378b7488e91c34481458fd4",
            "metadata": {},
            "name": "uiConnectedRepositoryListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$87b105ff96c14e90$var$node.hash = "1bf7812285ed8ed625f26394df73556d";
var $87b105ff96c14e90$export$2e2bcd8739ae039 = $87b105ff96c14e90$var$node;

});

parcelRegister("6f1mg", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", () => $2252ec49561667bf$export$eb7d748e4f9c9676);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $2252ec49561667bf$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const $2252ec49561667bf$export$eb7d748e4f9c9676 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2252ec49561667bf$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6zT3P", function(module, exports) {

$parcel$export(module.exports, "CrossflowImage", () => $eeb5b5b3d3cc8416$export$d0aa3e19f62b822f);

var $5uXOq = parcelRequire("5uXOq");

var $azJAI = parcelRequire("azJAI");
const $eeb5b5b3d3cc8416$export$d0aa3e19f62b822f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azJAI.default), {
        alt: "Jira Crossflow",
        width: 457,
        height: 285
    });

});
parcelRegister("azJAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb83f35c4311ea9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $fqo5e = parcelRequire("fqo5e");
const $acb83f35c4311ea9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fqo5e)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fqo5e))
});
var $acb83f35c4311ea9$export$2e2bcd8739ae039 = $acb83f35c4311ea9$var$Illustration;
// for advanced use only
const $acb83f35c4311ea9$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("fqo5e", function(module, exports) {
module.exports = new URL("ui-jsw-compass-crossflow.0545e2c1.svg", import.meta.url).toString();

});



const $c7f5227e1f4d5143$export$ae684c7694b92c83 = 'https://www.atlassian.com/software/compass';

parcelRegister("ljkmy", function(module, exports) {

$parcel$export(module.exports, "ConnectedRepositoryList", () => $8389bc03b01f9b02$export$fe586af18a4bb85b);

var $5uXOq = parcelRequire("5uXOq");

var $bgrar = parcelRequire("bgrar");

var $eQsHE = parcelRequire("eQsHE");
const $8389bc03b01f9b02$export$fe586af18a4bb85b = ({ filteredRepositories: filteredRepositories })=>{
    if (!filteredRepositories.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        gap: "space.300",
        alignItems: "center",
        templateColumns: "1fr 1fr"
    }, filteredRepositories.slice(0, 6).map((repo, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eQsHE.default), {
            key: repo.name,
            repositoryName: repo.name,
            cardVisualConfigurationIndex: idx
        })));
};

});
parcelRegister("eQsHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3a808645634398$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $jAy2o = parcelRequire("jAy2o");

var $c781K = parcelRequire("c781K");

var $1f9bV = parcelRequire("1f9bV");

var $9e98Z = parcelRequire("9e98Z");

var $4ONFy = parcelRequire("4ONFy");

var $l1N8i = parcelRequire("l1N8i");

var $cKfU7 = parcelRequire("cKfU7");

var $dZbEw = parcelRequire("dZbEw");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $42CjB = parcelRequire("42CjB");

var $eBwIo = parcelRequire("eBwIo");

var $koVbs = parcelRequire("koVbs");

var $joPoo = parcelRequire("joPoo");

var $4YHAp = parcelRequire("4YHAp");
function $3f3a808645634398$var$isIconType(raw) {
    return raw in (0, $joPoo.default);
}
const $3f3a808645634398$var$toComponentType = (raw)=>$3f3a808645634398$var$isIconType(raw) ? raw : 'OTHER';
const $3f3a808645634398$var$styles = {
    cardStyles: "_2rkopd34 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _1bto1l2s _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj _1ul9124j",
    containerStyle: "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _4t3i1osq",
    unpressableButton: "_2rkoiti9 _syaz1gjq _1e0c116y _bfhkm7j4 _2lx2vrvc _1n261q9c _u5f3pxbi _19bvu2gc _ca0q1b66 _n3td1b66",
    iconBox: "_19bvv77o _u5f31b66 _ca0qv77o _n3tdv77o",
    inlineTooltip: "_2rkoglpi _bfhkvuon _16qs1cd0 _syaz1fxt _c71l1mjv _p12f1mjv _1q51u2gc _85i5u2gc _bozgutpp _y4tiutpp",
    informationIcon: "_ca0qze3t _n3tdze3t",
    buttonStyle: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    completedActions: "_19bv1ejb"
};
const $3f3a808645634398$var$CustomTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btzsC.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $3f3a808645634398$var$styles.inlineTooltip,
            className
        ]),
        ref: ref,
        placement: "top"
    }, children);
});
function $3f3a808645634398$var$CompassRepositoryCard(props) {
    const testId = 'project-directories.components.view.compass-repository-card';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configuration = [
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ONFy))), {
                    label: formatMessage((0, $4YHAp.messages).componentReadiness)
                }),
                message: formatMessage((0, $4YHAp.messages).componentReadiness)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                        label: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                        label: formatMessage((0, $4YHAp.messages).repositoryAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).repositoryAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: formatMessage((0, $4YHAp.messages).descriptionAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).descriptionAdded)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ONFy))), {
                    label: formatMessage((0, $4YHAp.messages).devOpsHealth)
                }),
                message: formatMessage((0, $4YHAp.messages).devOpsHealth)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                        label: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                        label: formatMessage((0, $4YHAp.messages).repositoryAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).repositoryAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).pullRequestCycleTime)
                    }),
                    message: formatMessage((0, $4YHAp.messages).pullRequestCycleTime)
                },
                {
                    message: formatMessage((0, $4YHAp.messages).plusOne)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ONFy))), {
                    label: formatMessage((0, $4YHAp.messages).softwareQuality)
                }),
                message: formatMessage((0, $4YHAp.messages).softwareQuality)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                        label: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).buildSuccessRate)
                    }),
                    message: formatMessage((0, $4YHAp.messages).buildSuccessRate)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).openBugs)
                    }),
                    message: formatMessage((0, $4YHAp.messages).openBugs)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).qualityGateConditions)
                    }),
                    message: formatMessage((0, $4YHAp.messages).qualityGateConditions)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ONFy))), {
                    label: formatMessage((0, $4YHAp.messages).openJiraIssues)
                }),
                message: formatMessage((0, $4YHAp.messages).openJiraIssues)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).openBugs)
                    }),
                    message: formatMessage((0, $4YHAp.messages).openBugs)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                        label: formatMessage((0, $4YHAp.messages).projectAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).projectAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                        label: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ONFy))), {
                    label: formatMessage((0, $4YHAp.messages).securityMetrics)
                }),
                message: formatMessage((0, $4YHAp.messages).securityMetrics)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).openCriticalSeverityVulnerabilities)
                    }),
                    message: formatMessage((0, $4YHAp.messages).openCriticalSeverityVulnerabilities)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cKfU7))), {
                        label: formatMessage((0, $4YHAp.messages).openHighSeverityVulnerabilities)
                    }),
                    message: formatMessage((0, $4YHAp.messages).openHighSeverityVulnerabilities)
                },
                {
                    message: formatMessage((0, $4YHAp.messages).plusThree)
                }
            ]
        },
        {
            componentType: 'OTHER',
            scorecard: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ONFy))), {
                    label: formatMessage((0, $4YHAp.messages).componentReadiness)
                }),
                message: formatMessage((0, $4YHAp.messages).componentReadiness)
            },
            completedActions: [
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                        label: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).ownerTeamAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                        label: formatMessage((0, $4YHAp.messages).repositoryAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).repositoryAdded)
                },
                {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: formatMessage((0, $4YHAp.messages).descriptionAdded)
                    }),
                    message: formatMessage((0, $4YHAp.messages).descriptionAdded)
                }
            ]
        }
    ];
    const { repositoryName: repositoryName, cardVisualConfigurationIndex: cardVisualConfigurationIndex } = props;
    const visualConfigIndex = (cardVisualConfigurationIndex ?? 0) % configuration.length;
    const visualConfig = configuration[visualConfigIndex];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $3f3a808645634398$var$styles.cardStyles,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        xcss: $3f3a808645634398$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBwIo.ComponentTypeIcon), {
        type: $3f3a808645634398$var$toComponentType(visualConfig.componentType ?? 'OTHER'),
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, repositoryName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        xcss: $3f3a808645634398$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f3a808645634398$var$styles.iconBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
        label: formatMessage((0, $4YHAp.messages).owner)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        as: "p",
        align: "start"
    }, formatMessage((0, $4YHAp.messages).owner))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        xcss: $3f3a808645634398$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f3a808645634398$var$styles.iconBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jAy2o))), {
        label: formatMessage((0, $4YHAp.messages).workItems)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        as: "p",
        align: "start"
    }, formatMessage((0, $4YHAp.messages).workItems))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        xcss: $3f3a808645634398$var$styles.containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f3a808645634398$var$styles.iconBox
    }, visualConfig.scorecard.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        as: "p",
        align: "start"
    }, visualConfig.scorecard.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        component: $3f3a808645634398$var$CustomTooltip,
        content: formatMessage((0, $4YHAp.messages).scorecardInfo)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            testId: `${testId}.scorecard-tooltip`,
            ...tooltipProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9e98Z))),
            label: formatMessage((0, $4YHAp.messages).scorecardInfo),
            appearance: "subtle",
            spacing: "compact"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        wrap: "wrap",
        gap: "space.100",
        xcss: $3f3a808645634398$var$styles.completedActions
    }, visualConfig.completedActions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            key: index,
            xcss: $3f3a808645634398$var$styles.unpressableButton,
            space: "space.050"
        }, action.icon ? action.icon : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            as: "p",
            align: "start"
        }, action.message)))));
}
var $3f3a808645634398$export$2e2bcd8739ae039 = $3f3a808645634398$var$CompassRepositoryCard;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("9e98Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b7c83a53e38e447$var$_react = $6b7c83a53e38e447$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6b7c83a53e38e447$var$_baseNew = $6b7c83a53e38e447$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6b7c83a53e38e447$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b7c83a53e38e447$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $6b7c83a53e38e447$var$_react.default.createElement($6b7c83a53e38e447$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$6b7c83a53e38e447$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $6b7c83a53e38e447$var$_default = module.exports.default = $6b7c83a53e38e447$var$InformationCircleIcon;

});

parcelRegister("4ONFy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d879bb1bedf9deed9d11ee66de42aeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38225c2fcfbe42cc$var$_react = $38225c2fcfbe42cc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $38225c2fcfbe42cc$var$_baseNew = $38225c2fcfbe42cc$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $38225c2fcfbe42cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Scorecard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Scorecard in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38225c2fcfbe42cc$var$ScorecardIcon = (props)=>/*#__PURE__*/ $38225c2fcfbe42cc$var$_react.default.createElement($38225c2fcfbe42cc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0 0 13V16a8 8 0 1 1 8-8h-1.5A6.5 6.5 0 0 0 8 1.5m4.326 3.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zm-1.889 8.548a6.52 6.52 0 0 0 3.59-3.59l1.391.562A8.03 8.03 0 0 1 11 15.418z" clip-rule="evenodd"/>`
    }, props));
$38225c2fcfbe42cc$var$ScorecardIcon.displayName = 'ScorecardIcon';
var $38225c2fcfbe42cc$var$_default = module.exports.default = $38225c2fcfbe42cc$var$ScorecardIcon;

});

parcelRegister("cKfU7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5c7894403de42aa021c7c1fb5d93f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94761e21311354b3$var$_react = $94761e21311354b3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $94761e21311354b3$var$_baseNew = $94761e21311354b3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $94761e21311354b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pulse".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: work health in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94761e21311354b3$var$PulseIcon = (props)=>/*#__PURE__*/ $94761e21311354b3$var$_react.default.createElement($94761e21311354b3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 1a.75.75 0 0 1 .722.548l2.778 9.92 1.028-3.67a.75.75 0 0 1 .722-.548H16v1.5h-3.931l-1.597 5.702a.75.75 0 0 1-1.444 0L6.25 4.532l-1.028 3.67a.75.75 0 0 1-.722.548H0v-1.5h3.931l1.597-5.702A.75.75 0 0 1 6.25 1" clip-rule="evenodd"/>`
    }, props));
$94761e21311354b3$var$PulseIcon.displayName = 'PulseIcon';
var $94761e21311354b3$var$_default = module.exports.default = $94761e21311354b3$var$PulseIcon;

});

parcelRegister("eBwIo", function(module, exports) {

$parcel$export(module.exports, "ComponentTypeIcon", () => $bf35123508037109$export$cac930aaf0e7232e);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $joPoo = parcelRequire("joPoo");

var $C0ZIU = parcelRequire("C0ZIU");
const $bf35123508037109$export$cac930aaf0e7232e = (props)=>{
    const { type: providedType, testId: testId, size: size = 'medium' } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const type = !providedType.startsWith('ari:cloud:compass') ? providedType : 'OTHER';
    const componentType = (0, $joPoo.default)[type] ?? (0, $joPoo.default).OTHER;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(componentType.name)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $C0ZIU.ComponentIconBackground), {
        testId: testId,
        type: type,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: formatMessage(componentType.name),
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
        glyph: componentType.icon
    })));
};

});
parcelRegister("joPoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $add3fce0a4614519$export$2e2bcd8739ae039);
// We had to disable the rule, because the "fill" and "stroke" attributes of the svg wanted a token, and there's no token for white
/**
 * This file contains the component types metadata that will need to be used throughout the Compass Frontend.
 * Actual field definitions and its options are fetched using a GraphQL query from the Compass Catalog.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $gRKkP = parcelRequire("gRKkP");
const $add3fce0a4614519$export$bace2d8ac2cf2caa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z",
        fill: "#fff"
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$add3fce0a4614519$export$2e2bcd8739ae039 = {
    SERVICE: {
        id: 'SERVICE',
        name: (0, $gRKkP.default).service,
        color: (isDarkMode)=>isDarkMode ? '#8F7EE7' : '#6554C0',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z",
                fill: "#fff"
            }))
    },
    LIBRARY: {
        id: 'LIBRARY',
        name: (0, $gRKkP.default).library,
        color: (isDarkMode)=>isDarkMode ? '#F5CD47' : '#FF8B00',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z",
                fill: "#fff"
            }))
    },
    APPLICATION: {
        id: 'APPLICATION',
        name: (0, $gRKkP.default).application,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#36B37E',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z",
                fill: "#fff"
            }))
    },
    CAPABILITY: {
        id: 'CAPABILITY',
        name: (0, $gRKkP.default).capability,
        color: (isDarkMode)=>isDarkMode ? '#738496' : '#344563',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-4-inside-4_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "24",
                height: "24",
                rx: "3",
                fill: "#44546F"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.7048 6.76169C10.7048 7.47703 11.2847 8.05693 12 8.05693C12.7154 8.05693 13.2953 7.47703 13.2953 6.76169C13.2953 6.04635 12.7154 5.46646 12 5.46646C11.2847 5.46646 10.7048 6.04635 10.7048 6.76169ZM11.2 9.54498C10.9878 9.48411 10.7856 9.39963 10.5965 9.29457L9.2954 10.5975C9.52591 11.013 9.65718 11.4911 9.65718 12C9.65718 13.599 8.36093 14.8952 6.76194 14.8952C5.16294 14.8952 3.8667 13.599 3.8667 12C3.8667 10.401 5.16294 9.10474 6.76194 9.10474C7.27055 9.10474 7.74854 9.23589 8.16392 9.46622L9.46569 8.1626C9.23572 7.74747 9.1048 7.26987 9.1048 6.76169C9.1048 5.1627 10.401 3.86646 12 3.86646C13.599 3.86646 14.8953 5.1627 14.8953 6.76169C14.8953 7.27051 14.764 7.74867 14.5335 8.16417L15.8358 9.46641C16.2512 9.23596 16.7293 9.10474 17.2381 9.10474C18.8371 9.10474 20.1333 10.401 20.1333 12C20.1333 13.599 18.8371 14.8952 17.2381 14.8952C15.6391 14.8952 14.3429 13.599 14.3429 12C14.3429 11.4913 14.4741 11.0132 14.7044 10.5978L13.402 9.29543C13.2133 9.4001 13.0116 9.48429 12.8 9.545V14.455C14.0099 14.8021 14.8953 15.9168 14.8953 17.2383C14.8953 18.8373 13.599 20.1335 12 20.1335C10.401 20.1335 9.1048 18.8373 9.1048 17.2383C9.1048 15.9168 9.99013 14.8021 11.2 14.455V9.54498ZM11.9931 15.943C11.281 15.9467 10.7048 16.5252 10.7048 17.2383C10.7048 17.9536 11.2847 18.5335 12 18.5335C12.7154 18.5335 13.2953 17.9536 13.2953 17.2383C13.2953 16.5252 12.7191 15.9467 12.0069 15.943C12.0046 15.9431 12.0023 15.9431 12 15.9431C11.9977 15.9431 11.9954 15.9431 11.9931 15.943ZM5.4667 12C5.4667 12.7153 6.0466 13.2952 6.76194 13.2952C7.47728 13.2952 8.05718 12.7153 8.05718 12C8.05718 11.2846 7.47728 10.7047 6.76194 10.7047C6.0466 10.7047 5.4667 11.2846 5.4667 12ZM15.9429 12C15.9429 12.7153 16.5228 13.2952 17.2381 13.2952C17.9534 13.2952 18.5333 12.7153 18.5333 12C18.5333 11.2846 17.9534 10.7047 17.2381 10.7047C16.5228 10.7047 15.9429 11.2846 15.9429 12Z",
                fill: "white"
            }))
    },
    CLOUD_RESOURCE: {
        id: 'CLOUD_RESOURCE',
        name: (0, $gRKkP.default).cloudResource,
        color: (isDarkMode)=>isDarkMode ? '#8F7EE7' : '#6554C0',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    DATA_PIPELINE: {
        id: 'DATA_PIPELINE',
        name: (0, $gRKkP.default).dataPipeline,
        color: (isDarkMode)=>isDarkMode ? '#E2483D' : '#FF5630',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                stroke: "#fff",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                stroke: "#fff",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    MACHINE_LEARNING_MODEL: {
        id: 'MACHINE_LEARNING_MODEL',
        name: (0, $gRKkP.default).machineLearningModel,
        color: (isDarkMode)=>isDarkMode ? '#E2483D' : '#FF5630',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M4.61222 7.89078L18.8696 16.1906",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M4.85273 16.2901L19.0688 7.95921",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "none",
                d: "M11.7317 20.2989L11.7317 3.24756",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "#FF5630",
                d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    TEMPLATE: {
        id: 'TEMPLATE',
        name: (0, $gRKkP.default).template,
        color: (isDarkMode)=>isDarkMode ? '#42B2D7' : '#00B8DA',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-1-outside-1_2331_289998",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "2.99998",
                width: "18",
                height: "18",
                fill: "black"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                fill: "white",
                x: "3",
                y: "2.99998",
                width: "18",
                height: "18"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M14.464 11.4051L18.853 11.405C18.8862 11.405 18.9131 11.432 18.9131 11.4652L18.9131 13.5996C18.9131 13.6328 18.8862 13.6597 18.853 13.6597L14.464 13.6597C14.4307 13.6597 14.4038 13.6328 14.4038 13.5996L14.4038 11.4652C14.4038 11.432 14.4307 11.4051 14.464 11.4051Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M8.74316 17.8442L8.74317 6.15577C8.74317 5.63419 8.74317 5.3734 8.5922 5.20279C8.57599 5.18447 8.55868 5.16716 8.54036 5.15096C8.36975 4.99998 8.10896 4.99998 7.58738 4.99998C7.0658 4.99999 6.80501 4.99999 6.63439 5.15096C6.61608 5.16717 6.59877 5.18448 6.58256 5.2028C6.43159 5.37341 6.43159 5.6342 6.43159 6.15578L6.43159 17.8442C6.43159 18.3658 6.43159 18.6266 6.58256 18.7972C6.59877 18.8155 6.61608 18.8328 6.6344 18.849C6.805 19 7.06579 19 7.58735 19C8.10894 19 8.36973 19 8.54035 18.849C8.55866 18.8328 8.57598 18.8155 8.59219 18.7972C8.74316 18.6266 8.74316 18.3658 8.74316 17.8442Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M9.89457 6.35349C9.4795 6.35349 9.14302 6.68998 9.14302 7.10505C9.14303 7.52012 9.47951 7.8566 9.89458 7.8566L9.89457 6.35349ZM16.0626 7.10502L16.0626 6.35347L16.0626 7.10502ZM16.8141 7.85657L16.0626 7.85657L16.0626 7.85657L16.8141 7.85657ZM16.0626 10.3539C16.0626 10.7689 16.399 11.1054 16.8141 11.1054C17.2292 11.1054 17.5657 10.7689 17.5657 10.3539L16.0626 10.3539ZM3.99996 6.4679C3.58489 6.46792 3.24843 6.80442 3.24845 7.21949C3.24847 7.63456 3.58497 7.97103 4.00004 7.97101L3.99996 6.4679ZM4.94361 7.97096C5.35868 7.97094 5.69515 7.63444 5.69513 7.21937C5.69511 6.80429 5.35861 6.46783 4.94354 6.46785L4.94361 7.97096ZM9.89458 7.8566L16.0626 7.85658L16.0626 6.35347L9.89457 6.35349L9.89458 7.8566ZM16.0626 7.85657L16.0626 10.3539L17.5657 10.3539L17.5657 7.85657L16.0626 7.85657ZM16.0626 7.85658L16.0626 7.85657L17.5657 7.85657C17.5657 7.02643 16.8927 6.35347 16.0626 6.35347L16.0626 7.85658ZM4.00004 7.97101L4.94361 7.97096L4.94354 6.46785L3.99996 6.4679L4.00004 7.97101ZM18.853 11.405L18.853 9.90194L18.853 11.405ZM14.464 11.4051L14.464 12.9082L14.464 11.4051ZM14.4038 11.4652L12.9007 11.4652L12.9007 11.4652L14.4038 11.4652ZM14.4038 13.5996L15.9069 13.5996L15.9069 13.5996L14.4038 13.5996ZM14.464 13.6597L14.464 15.1628L14.464 15.1628L14.464 13.6597ZM18.853 13.6597L18.853 12.1566L18.853 12.1566L18.853 13.6597ZM18.9131 13.5996L20.4163 13.5996L20.4163 13.5996L18.9131 13.5996ZM18.9131 11.4652L17.41 11.4652L17.41 11.4652L18.9131 11.4652ZM8.74317 6.15577L7.24006 6.15577L7.24006 6.15577L8.74317 6.15577ZM8.74316 17.8442L10.2463 17.8442L10.2463 17.8442L8.74316 17.8442ZM6.43159 17.8442L7.9347 17.8442L7.9347 17.8442L6.43159 17.8442ZM6.43159 6.15578L4.92848 6.15578L4.92848 6.15578L6.43159 6.15578ZM6.58256 5.2028L7.70823 6.19889L7.70825 6.19887L6.58256 5.2028ZM7.58738 4.99998L7.58738 6.50309L7.58738 4.99998ZM6.63439 5.15096L5.6383 4.02529L5.63829 4.0253L6.63439 5.15096ZM8.5922 5.20279L7.46651 6.19887L7.46653 6.19888L8.5922 5.20279ZM8.54036 5.15096L7.54427 6.27663L7.5443 6.27665L8.54036 5.15096ZM7.58735 19L7.58732 20.5031L7.58735 19ZM6.6344 18.849L5.6383 19.9747L5.6383 19.9747L6.6344 18.849ZM6.58256 18.7972L7.70824 17.8011L7.70824 17.8011L6.58256 18.7972ZM8.54035 18.849L9.53642 19.9747L9.53642 19.9747L8.54035 18.849ZM8.59219 18.7972L7.46652 17.8011L7.46652 17.8011L8.59219 18.7972ZM18.853 9.90194L14.4639 9.90195L14.464 12.9082L18.853 12.9081L18.853 9.90194ZM12.9007 11.4652L12.9007 13.5996L15.9069 13.5996L15.9069 11.4652L12.9007 11.4652ZM14.464 15.1628L18.853 15.1628L18.853 12.1566L14.4639 12.1566L14.464 15.1628ZM20.4163 13.5996L20.4163 11.4652L17.41 11.4652L17.41 13.5996L20.4163 13.5996ZM18.853 15.1628C19.7163 15.1628 20.4163 14.463 20.4163 13.5996L17.41 13.5996C17.41 12.8026 18.0561 12.1566 18.853 12.1566L18.853 15.1628ZM12.9007 13.5996C12.9007 14.4629 13.6006 15.1628 14.464 15.1628L14.4639 12.1566C15.2609 12.1566 15.9069 12.8027 15.9069 13.5996L12.9007 13.5996ZM14.4639 9.90195C13.6006 9.90196 12.9007 10.6018 12.9007 11.4652L15.9069 11.4652C15.9069 12.2621 15.2609 12.9082 14.464 12.9082L14.4639 9.90195ZM18.853 12.9081C18.0561 12.9082 17.41 12.2621 17.41 11.4652L20.4163 11.4652C20.4163 10.6018 19.7164 9.90193 18.853 9.90194L18.853 12.9081ZM7.24006 6.15577L7.24006 17.8442L10.2463 17.8442L10.2463 6.15577L7.24006 6.15577ZM7.9347 17.8442L7.93469 6.15578L4.92848 6.15578L4.92848 17.8442L7.9347 17.8442ZM7.93469 6.15578C7.93469 6.0202 7.93478 5.92531 7.93664 5.84611C7.93752 5.80852 7.93868 5.78111 7.9399 5.76104C7.94112 5.74089 7.94214 5.73268 7.94207 5.73321C7.942 5.73377 7.94027 5.74781 7.93493 5.77157C7.9295 5.79569 7.91973 5.83268 7.90261 5.8783C7.88522 5.92465 7.86087 5.97828 7.82715 6.0354C7.79317 6.09297 7.75326 6.148 7.70823 6.19889L5.45689 4.20671C5.09945 4.61065 4.99651 5.05936 4.95885 5.36214C4.92575 5.6282 4.92848 5.93394 4.92848 6.15578L7.93469 6.15578ZM7.58737 3.49688C7.36553 3.49688 7.05979 3.49415 6.79374 3.52725C6.49095 3.56491 6.04224 3.66785 5.6383 4.02529L7.63049 6.27663C7.5796 6.32166 7.52457 6.36157 7.467 6.39555C7.40988 6.42927 7.35625 6.45362 7.30991 6.47101C7.26428 6.48813 7.22729 6.4979 7.20318 6.50333C7.17941 6.50867 7.16537 6.5104 7.16481 6.51047C7.16428 6.51054 7.17249 6.50952 7.19265 6.5083C7.21272 6.50708 7.24013 6.50592 7.27772 6.50504C7.35691 6.50318 7.45181 6.50309 7.58738 6.50309L7.58737 3.49688ZM7.70825 6.19887C7.68392 6.22636 7.65795 6.25233 7.6305 6.27662L5.63829 4.0253C5.57421 4.08201 5.51362 4.1426 5.45688 4.20672L7.70825 6.19887ZM10.2463 6.15577C10.2463 5.93393 10.249 5.62819 10.2159 5.36214C10.1782 5.05935 10.0753 4.61064 9.71786 4.2067L7.46653 6.19888C7.42149 6.14799 7.38159 6.09296 7.3476 6.03539C7.31388 5.97827 7.28953 5.92464 7.27215 5.87829C7.25503 5.83267 7.24525 5.79568 7.23983 5.77156C7.23448 5.74779 7.23275 5.73375 7.23268 5.7332C7.23262 5.73267 7.23364 5.74088 7.23486 5.76103C7.23608 5.7811 7.23723 5.80851 7.23812 5.8461C7.23998 5.9253 7.24006 6.02019 7.24006 6.15577L10.2463 6.15577ZM7.58738 6.50309C7.72296 6.50309 7.81786 6.50318 7.89705 6.50504C7.93464 6.50592 7.96205 6.50708 7.98212 6.50829C8.00227 6.50952 8.01048 6.51053 8.00995 6.51047C8.0094 6.5104 7.99536 6.50867 7.97159 6.50332C7.94747 6.4979 7.91049 6.48812 7.86486 6.471C7.81852 6.45362 7.76489 6.42927 7.70776 6.39555C7.65019 6.36157 7.59516 6.32166 7.54427 6.27663L9.53645 4.02528C9.1325 3.66784 8.6838 3.5649 8.38101 3.52724C8.11495 3.49415 7.80921 3.49688 7.58737 3.49688L7.58738 6.50309ZM9.71788 4.20671C9.66115 4.1426 9.60055 4.08201 9.53643 4.02526L7.5443 6.27665C7.5168 6.25232 7.49083 6.22634 7.46651 6.19887L9.71788 4.20671ZM7.58738 17.4969C7.4518 17.4969 7.35691 17.4968 7.27772 17.4949C7.24013 17.494 7.21272 17.4929 7.19265 17.4917C7.1725 17.4904 7.16429 17.4894 7.16482 17.4895C7.16538 17.4896 7.17942 17.4913 7.20318 17.4966C7.2273 17.5021 7.26428 17.5118 7.30991 17.529C7.35625 17.5463 7.40988 17.5707 7.46701 17.6044C7.52458 17.6384 7.5796 17.6783 7.63049 17.7233L5.6383 19.9747C6.04224 20.3321 6.49093 20.435 6.79371 20.4727C7.05976 20.5058 7.36549 20.5031 7.58732 20.5031L7.58738 17.4969ZM4.92848 17.8442C4.92848 18.066 4.92576 18.3718 4.95885 18.6378C4.99651 18.9406 5.09944 19.3893 5.45687 19.7932L7.70824 17.8011C7.75327 17.852 7.79318 17.907 7.82716 17.9646C7.86088 18.0217 7.88523 18.0753 7.90261 18.1217C7.91973 18.1673 7.92951 18.2043 7.93493 18.2284C7.94027 18.2522 7.942 18.2662 7.94207 18.2668C7.94214 18.2673 7.94112 18.2591 7.9399 18.2389C7.93868 18.2189 7.93752 18.1915 7.93664 18.1539C7.93478 18.0747 7.9347 17.9798 7.9347 17.8442L4.92848 17.8442ZM7.63049 17.7233C7.65797 17.7477 7.68394 17.7736 7.70824 17.8011L5.45687 19.7932C5.51359 19.8573 5.57418 19.9179 5.6383 19.9747L7.63049 17.7233ZM7.58732 20.5031C7.80917 20.5031 8.11491 20.5058 8.38097 20.4727C8.68375 20.4351 9.13246 20.3322 9.53642 19.9747L7.54428 17.7233C7.59517 17.6783 7.65019 17.6384 7.70776 17.6044C7.76489 17.5707 7.81852 17.5464 7.86486 17.529C7.91049 17.5119 7.94748 17.5021 7.97159 17.4967C7.99536 17.4913 8.0094 17.4896 8.00996 17.4895C8.01048 17.4894 8.00227 17.4905 7.98212 17.4917C7.96205 17.4929 7.93464 17.4941 7.89705 17.4949C7.81785 17.4968 7.72296 17.4969 7.58738 17.4969L7.58732 20.5031ZM7.24006 17.8442C7.24006 17.9798 7.23997 18.0747 7.23811 18.1539C7.23723 18.1915 7.23607 18.2189 7.23485 18.2389C7.23363 18.2591 7.23261 18.2673 7.23268 18.2668C7.23275 18.2662 7.23448 18.2522 7.23982 18.2284C7.24525 18.2043 7.25502 18.1673 7.27214 18.1217C7.28953 18.0753 7.31388 18.0217 7.3476 17.9646C7.38158 17.907 7.42149 17.852 7.46652 17.8011L9.71786 19.7933C10.0753 19.3893 10.1782 18.9406 10.2159 18.6378C10.249 18.3718 10.2463 18.066 10.2463 17.8442L7.24006 17.8442ZM9.53642 19.9747C9.60052 19.918 9.66111 19.8574 9.71786 19.7933L7.46652 17.8011C7.49084 17.7736 7.51681 17.7476 7.54427 17.7233L9.53642 19.9747Z",
                fill: "white",
                mask: "url(#path-1-outside-1_2331_289998)"
            }))
    },
    UI_ELEMENT: {
        id: 'UI_ELEMENT',
        name: (0, $gRKkP.default).uiElement,
        color: (isDarkMode)=>isDarkMode ? '#F5CD47' : '#FF8B00',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-1-inside-1_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                x: "2.83353",
                y: "13.6489",
                width: "6.97358",
                height: "7.36887",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                fill: "none",
                x: "2.83353",
                y: "13.6489",
                width: "6.97358",
                height: "7.36887",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-1-inside-1_1403_23012)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-2-inside-2_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                x: "2.83353",
                y: "3.01807",
                width: "18.5455",
                height: "8.59702",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                fill: "none",
                x: "2.83353",
                y: "3.01807",
                width: "18.5455",
                height: "8.59702",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-2-inside-2_1403_23012)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-3-inside-3_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                x: "11.5089",
                y: "13.6489",
                width: "9.87006",
                height: "7.36887",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                fill: "none",
                x: "11.5089",
                y: "13.6489",
                width: "9.87006",
                height: "7.36887",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-3-inside-3_1403_23012)"
            }))
    },
    WEBSITE: {
        id: 'WEBSITE',
        name: (0, $gRKkP.default).website,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#36B37E',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-5-inside-5_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "24",
                height: "24",
                rx: "3",
                fill: "#22A06B"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 18.375C12.8372 18.375 13.6662 18.2101 14.4396 17.8897C15.2131 17.5694 15.9158 17.0998 16.5078 16.5078C17.0998 15.9158 17.5694 15.2131 17.8897 14.4396C18.2101 13.6662 18.375 12.8372 18.375 12C18.375 11.1628 18.2101 10.3338 17.8897 9.56039C17.5694 8.78694 17.0998 8.08417 16.5078 7.49219C15.9158 6.90022 15.2131 6.43064 14.4396 6.11027C13.6662 5.78989 12.8372 5.625 12 5.625C10.3092 5.625 8.68774 6.29665 7.49219 7.49219C6.29665 8.68774 5.625 10.3092 5.625 12C5.625 13.6908 6.29665 15.3123 7.49219 16.5078C8.68774 17.7033 10.3092 18.375 12 18.375ZM11.3625 17.0554C10.1302 16.9017 8.99657 16.303 8.17476 15.372C7.35294 14.441 6.8996 13.2418 6.9 12C6.9 11.6047 6.951 11.2286 7.03387 10.8589L10.0875 13.9125V14.55C10.0875 15.2513 10.6613 15.825 11.3625 15.825V17.0554ZM15.7612 15.4361C15.6804 15.1785 15.5192 14.9535 15.3012 14.7941C15.0833 14.6346 14.82 14.5491 14.55 14.55H13.9125V12.6375C13.9125 12.2869 13.6256 12 13.275 12H9.45V10.725H10.725C11.0756 10.725 11.3625 10.4381 11.3625 10.0875V8.8125H12.6375C13.3387 8.8125 13.9125 8.23875 13.9125 7.5375V7.27612C15.7804 8.03475 17.1 9.86437 17.1 12C17.1 13.326 16.59 14.5309 15.7612 15.4361Z",
                fill: "white"
            }))
    },
    DATASET: {
        id: 'DATASET',
        name: (0, $gRKkP.default).dataset,
        color: (isDarkMode)=>isDarkMode ? '#DA62AC' : '#CD519D',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M3 0H21C22.7 0 24 1.3 24 3V21C24 22.7 22.7 24 21 24H3C1.3 24 0 22.7 0 21V3C0 1.3 1.3 0 3 0Z",
                fill: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 6.5V17.5H17.5V6.5H6.5ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 10.75H5V9.25H18V10.75Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 14.75H5V13.25H18V14.75Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.75 5L12.75 18L11.25 18L11.25 5L12.75 5Z",
                fill: "currentColor"
            }))
    },
    DATA_PRODUCT: {
        id: 'DATA_PRODUCT',
        name: (0, $gRKkP.default).dataProduct,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#2ABB7F',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M0 21V3c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3Z",
                fill: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.1 5a.9.9 0 0 1 .9-.9h4v1.8H5.9V9H4.1V5ZM19 4.1a.9.9 0 0 1 .9.9v4h-1.8V5.9H15V4.1h4ZM19.9 19a.9.9 0 0 1-.9.9h-4v-1.8h3.1V15h1.8v4ZM5 19.9a.9.9 0 0 1-.9-.9v-4h1.8v3.1H9v1.8H5Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M11 8h2v2h-2V8ZM8 11h2v2H8v-2ZM11 14h2v2h-2v-2ZM14 11h2v2h-2v-2Z",
                fill: "currentColor"
            }))
    },
    DASHBOARD: {
        id: 'DASHBOARD',
        name: (0, $gRKkP.default).dashboard,
        color: (isDarkMode)=>isDarkMode ? '#8777D9' : '#8777D9',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M0 21V3c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3Z",
                fill: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.5 17.5h13v-11h-13v11ZM4 18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4 9.25h8v1.5H4v-1.5ZM12 13.25h8v1.5h-8v-1.5Z",
                fill: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.75 6v13h-1.5V6h1.5Z",
                fill: "currentColor"
            }))
    },
    OTHER: {
        id: 'OTHER',
        name: (0, $gRKkP.default).other,
        color: (isDarkMode)=>isDarkMode ? '#388BFF' : '#0065FF',
        icon: $add3fce0a4614519$export$bace2d8ac2cf2caa
    }
};

});
parcelRegister("gRKkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0c958982fd98df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d0c958982fd98df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    service: {
        "id": "compass-common.common.component-types-metadata.service",
        "defaultMessage": "Service"
    },
    library: {
        "id": "compass-common.common.component-types-metadata.library",
        "defaultMessage": "Library"
    },
    application: {
        "id": "compass-common.common.component-types-metadata.application",
        "defaultMessage": "Application"
    },
    other: {
        "id": "compass-common.common.component-types-metadata.other",
        "defaultMessage": "Other"
    },
    capability: {
        "id": "compass-common.common.component-types-metadata.capability",
        "defaultMessage": "Capability"
    },
    cloudResource: {
        "id": "compass-common.common.component-types-metadata.cloud-resource",
        "defaultMessage": "Cloud resource"
    },
    dataPipeline: {
        "id": "compass-common.common.component-types-metadata.data-pipeline",
        "defaultMessage": "Data pipeline"
    },
    machineLearningModel: {
        "id": "compass-common.common.component-types-metadata.machine-learning-model",
        "defaultMessage": "Machine learning model"
    },
    template: {
        "id": "compass-common.common.component-types-metadata.template",
        "defaultMessage": "Template"
    },
    uiElement: {
        "id": "compass-common.common.component-types-metadata.ui-element",
        "defaultMessage": "UI element"
    },
    website: {
        "id": "compass-common.common.component-types-metadata.website",
        "defaultMessage": "Website"
    },
    dataset: {
        "id": "compass-common.common.component-types-metadata.dataset",
        "defaultMessage": "Dataset"
    },
    dataProduct: {
        "id": "compass-common.common.component-types-metadata.data-product",
        "defaultMessage": "Data product"
    },
    dashboard: {
        "id": "compass-common.common.component-types-metadata.dashboard",
        "defaultMessage": "Dashboard"
    }
});

});


parcelRegister("C0ZIU", function(module, exports) {

$parcel$export(module.exports, "ComponentIconBackground", () => $7ade982c8b486a8c$export$2f11e092dd014dd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5owSH = parcelRequire("5owSH");

var $hxoiH = parcelRequire("hxoiH");

var $joPoo = parcelRequire("joPoo");
function $7ade982c8b486a8c$export$2f11e092dd014dd4(props) {
    const { type: type, size: size = 'medium', testId: testId, children: children } = props;
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ade982c8b486a8c$var$IconBackground, {
        "data-testid": testId,
        size: size,
        color: (0, $joPoo.default)[type].color(isDarkMode)
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ade982c8b486a8c$var$IconBackground = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ke0o0q": (0, $lD23V.default)((0, $5owSH.sizes)[__cmplp.size]),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb4cet _4t3i4cet _bfhk1cj8 _1p3rwubq _f2puwubq _1lvewubq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("4YHAp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0f29486cac146f97$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0f29486cac146f97$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    owner: {
        "id": "compass-repository-card.owner",
        "defaultMessage": "Owner"
    },
    workItems: {
        "id": "compass-repository-card.work-items",
        "defaultMessage": "Work items"
    },
    scorecardInfo: {
        "id": "compass-repository-card.scorecard-info",
        "defaultMessage": "Use this scorecard in Compass to ensure component details are ready for development teams to reference in the catalog."
    },
    componentReadiness: {
        "id": "compass-repository-card.component-readiness",
        "defaultMessage": "Component readiness"
    },
    ownerTeamAdded: {
        "id": "compass-repository-card.owner-team-added",
        "defaultMessage": "Owner team added"
    },
    repositoryAdded: {
        "id": "compass-repository-card.repository-added",
        "defaultMessage": "Repository added"
    },
    descriptionAdded: {
        "id": "compass-repository-card.description-added",
        "defaultMessage": "Description added"
    },
    buildSuccessRate: {
        "id": "compass-repository-card.build-success-rate",
        "defaultMessage": "Build success rate"
    },
    pullRequestCycleTime: {
        "id": "compass-repository-card.pull-request-cycle-time",
        "defaultMessage": "Pull request cycle time"
    },
    projectAdded: {
        "id": "compass-repository-card.project-added",
        "defaultMessage": "Project added"
    },
    securityMetrics: {
        "id": "compass-repository-card.security-metrics",
        "defaultMessage": "Security metrics"
    },
    softwareQuality: {
        "id": "compass-repository-card.software-quality",
        "defaultMessage": "Software quality"
    },
    openJiraIssues: {
        "id": "compass-repository-card.open-jira-issues",
        "defaultMessage": "Open Jira issues"
    },
    devOpsHealth: {
        "id": "compass-repository-card.devops-health",
        "defaultMessage": "DevOps health"
    },
    openBugs: {
        "id": "compass-repository-card.open-bugs",
        "defaultMessage": "Open bugs"
    },
    qualityGateConditions: {
        "id": "compass-repository-card.quality-gate-conditions",
        "defaultMessage": "Quality gate conditions"
    },
    openCriticalSeverityVulnerabilities: {
        "id": "compass-repository-card.open-critical-severity-vulnerabilities",
        "defaultMessage": "Open critical severity vulnerabilities"
    },
    openHighSeverityVulnerabilities: {
        "id": "compass-repository-card.open-high-severity-vulnerabilities",
        "defaultMessage": "Open high severity vulnerabilities"
    },
    plusOne: {
        "id": "compass-repository-card.plus-one",
        "defaultMessage": "+1"
    },
    plusThree: {
        "id": "compass-repository-card.plus-three",
        "defaultMessage": "+3"
    }
});

});



parcelRegister("4ngBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $03dabcaf2838ade8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $eCeGD = parcelRequire("eCeGD");

var $l1N8i = parcelRequire("l1N8i");

var $dIHEn = parcelRequire("dIHEn");
var $6f1mg = parcelRequire("6f1mg");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $5nbLn = parcelRequire("5nbLn");
var $2lrGK = parcelRequire("2lrGK");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $g8Ctp = parcelRequire("g8Ctp");

var $jOgIm = parcelRequire("jOgIm");
const $03dabcaf2838ade8$var$styles = {
    root: "_p12fxilx"
};
function $03dabcaf2838ade8$var$AutoCatalogEmptyStateLeftPanel(props) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onTry: onTry } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        alignInline: "start",
        xcss: $03dabcaf2838ade8$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8Ctp.NavLogo), {
        href: "https://www.atlassian.com/software/compass/",
        label: formatMessage((0, $jOgIm.default).compass),
        logo: (0, $4R6GH.fg)('platform-team25-app-icon-tiles') ? (0, $2lrGK.CompassLogo) : (0, $6f1mg.CompassLogo),
        icon: (0, $4R6GH.fg)('platform-team25-app-icon-tiles') ? (0, $5nbLn.CompassIcon) : (0, $dIHEn.CompassIcon)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h3"
    }, formatMessage((0, $jOgIm.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.150"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $jOgIm.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onTry
    }, formatMessage((0, $jOgIm.default).createYourCatalogButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest",
        size: "small",
        testId: "compass-cross-flow.ui.auto-catalog-empt-state-left-panel.auto-catalog-empty-state-left-panel-legal-disclaimer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $jOgIm.default).legalDisclaimer,
        values: {
            boldText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, formatMessage((0, $jOgIm.default).boldText)),
            atlassianCustomerAgreementLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
                target: "_blank"
            }, formatMessage((0, $jOgIm.default).atlassianCustomerAgreementLink)),
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                target: "_blank"
            }, formatMessage((0, $jOgIm.default).privacyPolicyLink))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage((0, $jOgIm.default).createYourCatalogButtonTip))));
}
var $03dabcaf2838ade8$export$2e2bcd8739ae039 = $03dabcaf2838ade8$var$AutoCatalogEmptyStateLeftPanel;

});
parcelRegister("dIHEn", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $85c2cd6f52fb90ed$export$f7857fe64d7161d9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $85c2cd6f52fb90ed$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $85c2cd6f52fb90ed$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $85c2cd6f52fb90ed$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5nbLn", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $e82fb65f5281281d$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::47230916c8ace4e66464ab0a154a2cc3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e82fb65f5281281d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $e82fb65f5281281d$export$f7857fe64d7161d9({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $e82fb65f5281281d$var$svg,
        size: size,
        appearance: appearance,
        label: label || 'Compass',
        testId: testId
    });
}

});

parcelRegister("2lrGK", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", () => $fe662f017eb43f02$export$eb7d748e4f9c9676);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a2afaaa2e1d6067f90b9e279655ffaa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fe662f017eb43f02$var$svg = `<svg width="95" viewBox="0 0 95 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
    <path fill="var(--ds-text, #292a2e)" d="M90.83 17.15q-.9 0-1.6-.25a2.84 2.84 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.03.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.1-.24-1.64-.78t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25.65.25 1.05.7.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.89.23t-.36.6q0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-7.8-.01q-.9 0-1.6-.25a2.84 2.84 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.03.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25.65.25 1.05.7.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.89.23t-.36.6q0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-8.99-.04a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M62.5 19.86V9.36h1.89v1.28h.1q.14-.29.4-.61t.69-.54 1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.07v4.07zm3.61-4.28q.57 0 .95-.31t.57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.56 0-.94.29t-.58.83q-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3M49.8 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-9.25 1.51q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
function $fe662f017eb43f02$export$eb7d748e4f9c9676({ label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $fe662f017eb43f02$var$svg,
        label: label || 'Compass',
        testId: testId
    });
}

});

parcelRegister("jOgIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d878a4213389ff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d4d878a4213389ff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    compass: {
        "id": "compass.components-left-panel.header",
        "defaultMessage": "Compass"
    },
    title: {
        "id": "compass.components-left-panel.title",
        "defaultMessage": "Create a catalog of your repositories linked in Jira and measure the health and performance of it for free"
    },
    description: {
        "id": "compass.components-left-panel.description",
        "defaultMessage": "Catalog these components and use them to track performance, health, and identify dependencies. Link issues to components \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    },
    createYourCatalogButton: {
        "id": "compass.components-left-panel.create-your-catalog.button",
        "defaultMessage": "Create your catalog in Compass"
    },
    createYourCatalogButtonTip: {
        "id": "compass.components-left-panel.create-your-catalog.buttonTip",
        "defaultMessage": "You will provision another product but it's on the free plan"
    },
    legalDisclaimer: {
        "id": "compass.components-left-panel.create-your-catalog.legal-disclaimer",
        "defaultMessage": "{boldText}, you agree to the {atlassianCustomerAgreementLink} and {privacyPolicyLink}, and that Atlassian will collect, use and process data from the Github for Jira app you have installed across your Atlassian products in accordance with the {atlassianCustomerAgreementLink} and {privacyPolicyLink}."
    },
    boldText: {
        "id": "compass.components-left-panel.create-your-catalog.legal-disclaimer-bold-text-part",
        "defaultMessage": "By clicking Create your catalog in Compass"
    },
    atlassianCustomerAgreementLink: {
        "id": "compass.components-left-panel.create-your-catalog.atlassian-customer-agreement-link",
        "defaultMessage": "Atlassian Customer Agreement"
    },
    privacyPolicyLink: {
        "id": "compass.components-left-panel.create-your-catalog.privacy-policy-link",
        "defaultMessage": "Privacy Policy"
    }
});

});


parcelRegister("61CXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e84ab741feb1741$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9e84ab741feb1741$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    callToAction: {
        "id": "compass-cross-flow.call-to-action",
        "defaultMessage": "Create a comprehensive catalog of software components in Compass, then link them to issues \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    },
    engageMessage: {
        "id": "compass-cross-flow.engage-message",
        "defaultMessage": "Try Compass free"
    },
    headLine: {
        "id": "compass-cross-flow.head-line",
        "defaultMessage": "A new way to work on software components "
    },
    learnMoreMessage: {
        "id": "compass-cross-flow.learn-more-message",
        "defaultMessage": "Learn more about Compass"
    },
    callToActionIssueTermRefresh: {
        "id": "compass-cross-flow.call-to-action-issue-term-refresh",
        "defaultMessage": "Create a comprehensive catalog of software components in Compass, then link them to work items \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    }
});

});



parcelRegister("8PL6W", function(module, exports) {

$parcel$export(module.exports, "ComponentsTableEmptyState", () => $0f94ddf7c78c42e6$export$bbd499cf012bf709);
/* components-table-empty-state.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ldJSL = parcelRequire("ldJSL");

var $1GGwS = parcelRequire("1GGwS");

var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $3vJCP = parcelRequire("3vJCP");

var $dnzwM = parcelRequire("dnzwM");

var $9k0WK = parcelRequire("9k0WK");
const $0f94ddf7c78c42e6$var$ISSUES_URL = (projectKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    encodeURI(`${window.location.origin}/browse/${projectKey}/issues`);
function $0f94ddf7c78c42e6$export$bbd499cf012bf709({ loading: loading, projectKey: projectKey, testId: testId, componentCount: componentCount, displayMode: displayMode }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createButtonTestId = testId && `${testId}-create-button`; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'compassComponentsTableEmptyStateLearnMore');
    };
    const EmptyState = displayMode === 'no-linked-components' ? (0, $dnzwM.EmptyStateImage) : (0, $dnzwM.EmptyStateBlocks);
    const primaryAction = displayMode === 'no-linked-components' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        appearance: "primary",
        href: $0f94ddf7c78c42e6$var$ISSUES_URL(projectKey)
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9k0WK.default).gotoIssuesIssueTermRefresh : (0, $9k0WK.default).gotoIssues)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vJCP.default), {
        testId: createButtonTestId,
        loading: loading,
        oldOnAddComponent: ()=>{},
        projectKey: projectKey,
        globalComponentsEnabled: true,
        verbose: true
    });
    let heading;
    let body;
    switch(displayMode){
        case 'no-components':
            heading = (0, $9k0WK.default).noComponentsHeading;
            body = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9k0WK.default).noComponentsBodyIssueTermRefresh : (0, $9k0WK.default).noComponentsBody;
            break;
        case 'no-linked-components':
            heading = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9k0WK.default).noLinkedComponentsHeadingIssueTermRefresh : (0, $9k0WK.default).noLinkedComponentsHeading;
            body = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9k0WK.default).noLinkedComponentsBodyIssueTermRefresh : (0, $9k0WK.default).noLinkedComponentsBody;
            break;
        case 'unknown':
            heading = (0, $9k0WK.default).heading;
            body = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9k0WK.default).noComponentsBodyIssueTermRefresh : (0, $9k0WK.default).noComponentsBody;
            break;
        default:
            heading = (0, $9k0WK.default).heading;
            body = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9k0WK.default).noComponentsBodyIssueTermRefresh : (0, $9k0WK.default).noComponentsBody;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "componentsTableEmptyState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        eventName: "viewed componentsTableEmptyState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f94ddf7c78c42e6$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.400",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EmptyState, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f94ddf7c78c42e6$var$Heading, null, formatMessage(heading, {
        componentCount: componentCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f94ddf7c78c42e6$var$Body, null, formatMessage(body, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.200",
        alignItems: "center"
    }, primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
        articleId: "6frUzedhV1M0c05JhXMvK0",
        appearance: "link",
        spacing: "none",
        onClick: onClickLearnMore,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/link-issues-to-compass-components/",
            onClick: onClickLearnMore,
            target: "_blank"
        }, formatMessage((0, $9k0WK.default).learnMore))
    }, formatMessage((0, $9k0WK.default).learnMore))))))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f94ddf7c78c42e6$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1epz _2hwx1wug _otyr1epz _18u01wug _1bsbbhyd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f94ddf7c78c42e6$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f94ddf7c78c42e6$var$Body = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1ejb _1bsbr5sb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3vJCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $40ffdb73b3440bca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $3sGLB = parcelRequire("3sGLB");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $eHSyU = parcelRequire("eHSyU");
const $40ffdb73b3440bca$var$COMPASS_CREATE_COMPONENT_URL = (projectKey)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const projectLink = encodeURI(`${window.location.origin}/browse/${projectKey}`);
    return `/compass/home?showCreateComponentModal=true&projectLink=${projectLink}`;
};
function $40ffdb73b3440bca$export$2e2bcd8739ae039({ testId: testId, loading: loading, globalComponentsEnabled: globalComponentsEnabled = false, oldOnAddComponent: oldOnAddComponent, projectKey: projectKey, verbose: verbose = false }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (globalComponentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        testId: testId,
        href: $40ffdb73b3440bca$var$COMPASS_CREATE_COMPONENT_URL(projectKey),
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "primary",
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createCompassComponent');
        },
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($3sGLB)))
    }, formatMessage(verbose ? (0, $eHSyU.default).addCompassComponent : (0, $eHSyU.default).addComponent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "createComponentButton",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isLoading: loading,
        testId: testId,
        appearance: "primary",
        onClick: oldOnAddComponent
    }, formatMessage((0, $eHSyU.default).addComponent)));
}

});
parcelRegister("eHSyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29002853a1b4bdf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b29002853a1b4bdf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addComponent: {
        "id": "project-components.create-component-button.trigger",
        "defaultMessage": "Create component"
    },
    addCompassComponent: {
        "id": "project-components.create-compass-component-button.trigger",
        "defaultMessage": "Create Compass component"
    }
});

});


parcelRegister("dnzwM", function(module, exports) {

$parcel$export(module.exports, "EmptyStateBlocks", () => $69d91d7703b45ce7$export$58b6dcfb3ce70686);
$parcel$export(module.exports, "EmptyStateImage", () => $69d91d7703b45ce7$export$a7907bb86a15af4e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7rzXh = parcelRequire("7rzXh");

var $cJrmx = parcelRequire("cJrmx");
const $69d91d7703b45ce7$export$58b6dcfb3ce70686 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7rzXh))),
        alt: "",
        width: 171.25
    });
const $69d91d7703b45ce7$var$imageTopMarginStyles = null;
const $69d91d7703b45ce7$export$a7907bb86a15af4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cJrmx))),
        alt: "",
        width: 336,
        className: (0, $bwpsq.default)([
            "_19pkpxbi"
        ])
    });

});
parcelRegister("7rzXh", function(module, exports) {
module.exports = new URL("empty-state-blocks.4f8f7da7.svg", import.meta.url).toString();

});

parcelRegister("cJrmx", function(module, exports) {
module.exports = new URL("issues-highlight.37797bd0.svg", import.meta.url).toString();

});


parcelRegister("9k0WK", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2af344bf8d2bcf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aa2af344bf8d2bcf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "compass-common.components-table-empty-state.heading",
        "defaultMessage": "No Compass components are linked to your project"
    },
    noComponentsHeading: {
        "id": "compass-common.components-table-empty-state.no-components-heading",
        "defaultMessage": "You don't have any software components in Compass"
    },
    noLinkedComponentsHeading: {
        "id": "compass-common.components-table-empty-state.no-linked-components-heading",
        "defaultMessage": "{componentCount, plural, one {You have # software component in Compass, but it is not linked to an issue} other {You have # software components in Compass, but none are linked to issues}}"
    },
    body: {
        "id": "compass-common.components-table-empty-state.body",
        "defaultMessage": "Create a component in Compass, then add it to an issue's <b>Components</b> field. The component and its related information will appear here."
    },
    noComponentsBody: {
        "id": "compass-common.components-table-empty-state.no-components-body",
        "defaultMessage": "Issues can be linked to Compass software components, so you can track and manage the work on your software architecture."
    },
    noLinkedComponentsBody: {
        "id": "compass-common.components-table-empty-state.no-linked-components-body",
        "defaultMessage": "Add a component to an issue\u2019s <b>Components</b> field. Both will appear here, so you can track the work on your software architecture."
    },
    gotoIssues: {
        "id": "compass-common.components-table-empty-state.goto-issues",
        "defaultMessage": "Go to issues"
    },
    learnMore: {
        "id": "compass-common.components-table-empty-state.learn-more",
        "defaultMessage": "Learn more"
    },
    noLinkedComponentsHeadingIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.no-linked-components-heading-issue-term-refresh",
        "defaultMessage": "{componentCount, plural, one {You have # software component in Compass, but it is not linked to a work item} other {You have # software components in Compass, but none are linked to work items}}"
    },
    bodyIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.body-issue-term-refresh",
        "defaultMessage": "Create a component in Compass, then add it to the <b>Components</b> field in a work item. The component and its related information will appear here."
    },
    noComponentsBodyIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.no-components-body-issue-term-refresh",
        "defaultMessage": "Work items can be linked to Compass software components, so you can track and manage the work on your software architecture."
    },
    noLinkedComponentsBodyIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.no-linked-components-body-issue-term-refresh",
        "defaultMessage": "Add a component to the <b>Components</b> field in a work item. Both will appear here, so you can track the work on your software architecture."
    },
    gotoIssuesIssueTermRefresh: {
        "id": "compass-common.components-table-empty-state.goto-issues-issue-term-refresh",
        "defaultMessage": "Go to work items"
    }
});

});



parcelRegister("5aax0", function(module, exports) {

$parcel$export(module.exports, "CompassTableCrossflowTouchPointWithEC", () => $53cf94edc35da7ec$export$6d86b5ae49a52ead);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $gVLkC = parcelRequire("gVLkC");

var $HObzK = parcelRequire("HObzK");

var $6pvrS = parcelRequire("6pvrS");

var $71ynZ = parcelRequire("71ynZ");

var $kIgFD = parcelRequire("kIgFD");
const $53cf94edc35da7ec$var$CompassTableCrossflowTouchPoint = (props)=>{
    const { isCompassLicensed: isCompassLicensed, origin: origin } = props;
    const [{ hasBeenDismissed: hasBeenDismissed }, { dismiss: dismiss }] = (0, $kIgFD.useTouchPointDismissed)();
    const [{ hasBeenViewed: hasSpotlightBeenViewed }] = (0, $71ynZ.useCompassComponentsSpotlightViewed)();
    const onDismiss = (0, $5uXOq.useCallback)(async ()=>{
        dismiss();
    }, [
        dismiss
    ]);
    // Conditions for when we should render the touch point.
    const shouldRender = (0, $5uXOq.useMemo)(()=>{
        if (isCompassLicensed) // Don't render the touch point if Compass is already provisioned.
        return false;
        if (!hasSpotlightBeenViewed) // Don't render the touch point until user has dismissed our first spotlight.
        return false;
        // Don't render the touch point if a user has already dismissed it.
        return !hasBeenDismissed;
    }, [
        isCompassLicensed,
        hasSpotlightBeenViewed,
        hasBeenDismissed
    ]);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pvrS.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $HObzK.AsyncCompassTableCrossFlowTouchPoint), {
        origin: origin,
        onDismiss: onDismiss
    }))) : null;
};
const $53cf94edc35da7ec$export$6d86b5ae49a52ead = (0, $gVLkC.withCompassEntitlementCheck)($53cf94edc35da7ec$var$CompassTableCrossflowTouchPoint, 'project-pages.project-directories.components.view.table');

});
parcelRegister("gVLkC", function(module, exports) {

$parcel$export(module.exports, "withCompassEntitlementCheck", () => $182410da9c37f261$export$f091708323f34577);

var $5uXOq = parcelRequire("5uXOq");

var $hqBSi = parcelRequire("hqBSi");

var $9OXo1 = parcelRequire("9OXo1");
const $182410da9c37f261$var$isCompassInLicensedProducts = (licensedProducts)=>licensedProducts && licensedProducts.compass || false;
const $182410da9c37f261$export$4cfb87fbb2c1c13f = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const memoisedData = (0, $5uXOq.useMemo)(()=>$182410da9c37f261$var$isCompassInLicensedProducts(licensedProducts), [
        licensedProducts
    ]);
    return {
        isCompassLicensed: memoisedData
    };
};
function $182410da9c37f261$export$f091708323f34577(WrappedComponent, origin) {
    // eslint-disable-next-line jira/react/no-class-components
    return class extends (0, $5uXOq.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { licensedProducts: licensedProducts } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    isCompassLicensed: $182410da9c37f261$var$isCompassInLicensedProducts(licensedProducts),
                    origin: origin,
                    ...this.props
                })));
        }
    };
}

});

parcelRegister("HObzK", function(module, exports) {

$parcel$export(module.exports, "AsyncCompassTableCrossFlowTouchPoint", () => $200f5da9c7cc4e04$export$a46027b03a0a578b);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $b0O7F = parcelRequire("b0O7F");
const $200f5da9c7cc4e04$var$entryPointParams = {};
const $200f5da9c7cc4e04$export$a46027b03a0a578b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $b0O7F.asyncCompassTableCrossFlowTouchPoint), $200f5da9c7cc4e04$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.compass.table-cross-flow",
        packageName: "jiraCompassCrossFlow",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $200f5da9c7cc4e04$export$2e2bcd8739ae039 = $200f5da9c7cc4e04$export$a46027b03a0a578b;

});
parcelRegister("b0O7F", function(module, exports) {

$parcel$export(module.exports, "asyncCompassTableCrossFlowTouchPoint", () => $05ac785f8208f740$export$674e2f56ee41c337);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $05ac785f8208f740$export$674e2f56ee41c337 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("iNq9J")).then((module)=>module.AsyncCompassTableCrossFlow), {
        moduleId: "95c02303"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iNq9J", function(module, exports) {

let $daf1179add653ec2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $daf1179add653ec2$var$load("hp1Pp").then(()=>parcelRequire('iCgP0'));

});



parcelRegister("71ynZ", function(module, exports) {

$parcel$export(module.exports, "useCompassComponentsSpotlightViewed", () => $0ce966484154e1e9$export$3c55ae3693c7bfe9);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $90yGq = parcelRequire("90yGq");
const $0ce966484154e1e9$var$COMPASS_COMPONENTS_NAMESPACE = 'compass-components';
function $0ce966484154e1e9$export$3c55ae3693c7bfe9() {
    const accountId = (0, $90yGq.useAccountId)();
    const storageKey = `spotlight-viewed-${accountId}`;
    const storage = (0, $5uXOq.useMemo)(()=>(0, $bSSG7.createLocalStorageProvider)($0ce966484154e1e9$var$COMPASS_COMPONENTS_NAMESPACE), []);
    const [hasBeenViewed, setHasBeenViewed] = (0, $5uXOq.useState)(storage.get(storageKey));
    const hide = (0, $5uXOq.useCallback)(()=>{
        setHasBeenViewed(true);
        storage.set(storageKey, true);
    }, [
        setHasBeenViewed,
        storage,
        storageKey
    ]);
    const reset = (0, $5uXOq.useCallback)(()=>{
        setHasBeenViewed(false);
        storage.remove(storageKey);
    }, [
        setHasBeenViewed,
        storage,
        storageKey
    ]);
    return [
        {
            hasBeenViewed: hasBeenViewed
        },
        {
            hide: hide,
            reset: reset
        }
    ];
}

});

parcelRegister("kIgFD", function(module, exports) {

$parcel$export(module.exports, "useTouchPointDismissed", () => $4d2bcdbf4773d776$export$36756169aeb33eb4);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $90yGq = parcelRequire("90yGq");
const $4d2bcdbf4773d776$var$COMPASS_COMPONENTS_NAMESPACE = 'compass-components';
function $4d2bcdbf4773d776$export$36756169aeb33eb4() {
    const accountId = (0, $90yGq.useAccountId)();
    const storageKey = `table-crossflow-dismissed-${accountId}`;
    const storage = (0, $5uXOq.useMemo)(()=>(0, $bSSG7.createLocalStorageProvider)($4d2bcdbf4773d776$var$COMPASS_COMPONENTS_NAMESPACE), []);
    const [hasBeenDismissed, setHasBeenDismissed] = (0, $5uXOq.useState)(storage.get(storageKey));
    const dismiss = (0, $5uXOq.useCallback)(()=>{
        setHasBeenDismissed(true);
        storage.set(storageKey, true);
    }, [
        setHasBeenDismissed,
        storage,
        storageKey
    ]);
    const reset = (0, $5uXOq.useCallback)(()=>{
        setHasBeenDismissed(false);
        storage.remove(storageKey);
    }, [
        setHasBeenDismissed,
        storage,
        storageKey
    ]);
    return [
        {
            hasBeenDismissed: hasBeenDismissed
        },
        {
            dismiss: dismiss,
            reset: reset
        }
    ];
}

});


parcelRegister("73b2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $55730727ddb1b3ad$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $3kGkY = parcelRequire("3kGkY");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");

var $d8xNe = parcelRequire("d8xNe");

var $45aZl = parcelRequire("45aZl");

const $55730727ddb1b3ad$var$mapStateToProps = (state)=>({
        isPageLoading: (0, $d8xNe.isLoading)(state),
        // Ordered list of IDs returned from backend. Needed for rendering sorted order.
        componentIds: (0, $3kGkY.getIds)(state),
        // Used to quickly fire search query.
        componentAris: (0, $3kGkY.getAris)(state),
        // Needed to retrieve component by ARI and render.
        componentsById: state.components.byId,
        componentCount: (0, $3kGkY.getTotalItems)(state),
        orderField: (0, $kYnKh.getOrderField)(state),
        orderDirection: (0, $kYnKh.getOrderDirection)(state)
    });
const $55730727ddb1b3ad$var$mapDispatchToProps = (dispatch)=>({
        onSort: ({ key: key, sortOrder: sortOrder })=>{
            dispatch((0, $2G2i7.patchQuery)({
                orderDirection: sortOrder,
                orderField: key,
                page: 1
            }));
            dispatch((0, $lrD6Q.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).SORTING
            }));
        }
    });
var $55730727ddb1b3ad$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($55730727ddb1b3ad$var$mapStateToProps, $55730727ddb1b3ad$var$mapDispatchToProps)((0, $45aZl.default));

});
parcelRegister("45aZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e5dc133111f4ef$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $dHbUn = parcelRequire("dHbUn");

var $l1N8i = parcelRequire("l1N8i");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $axhu5 = parcelRequire("axhu5");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $l8ruj = parcelRequire("l8ruj");

var $fFsPq = parcelRequire("fFsPq");

var $lKaBM = parcelRequire("lKaBM");

var $3YwGL = parcelRequire("3YwGL");

var $cWjmM = parcelRequire("cWjmM");

var $RN6ng = parcelRequire("RN6ng");

var $8D2Ck = parcelRequire("8D2Ck");

var $lawRn = parcelRequire("lawRn");

var $fl4OQ = parcelRequire("fl4OQ");

var $6sHQY = parcelRequire("6sHQY");

var $1yNuo = parcelRequire("1yNuo");

var $b8bgB = parcelRequire("b8bgB");
const $23e5dc133111f4ef$var$useGetTeams = (components, siteId)=>{
    const [teamInfo, setTeamInfo] = (0, $5uXOq.useState)({});
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (components.length === 0) {
            setTeamInfo({});
            return;
        }
        const ownerIds = Array.from(new Set(components.map((component)=>component?.ownerId).filter(Boolean).map((0, $axhu5.getIdFromAri))));
        if (ownerIds.length === 0) {
            setTeamInfo({});
            return;
        }
        (0, $lKaBM.getTeams)(ownerIds, siteId).then((result)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const teamsByAri = Object.fromEntries(result.teams.map((team)=>[
                    team.id,
                    team
                ]));
            setTeamInfo(teamsByAri);
        }).catch((e)=>setError(e));
    }, [
        components,
        siteId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            meta: {
                id: 'useGetTeams',
                packageName: 'jiraProjectDirectoriesComponents',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    return {
        teamInfo: teamInfo,
        error: error
    };
};
function $23e5dc133111f4ef$export$2e2bcd8739ae039(props) {
    const { testId: testId, projectKey: projectKey, isPageLoading: isPageLoading, componentIds: componentIds, componentsById: componentsById, componentAris: componentAris, componentCount: componentCount, orderField: orderField, orderDirection: orderDirection, onSort: onSort, children: children } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const siteId = (0, $koeKL.useCloudId)();
    const { components: compassComponents, loading: compassComponentsLoading, error: compassComponentsError } = (0, $3YwGL.useGetCompassComponents)(componentAris);
    const loading = (0, $5uXOq.useMemo)(()=>compassComponentsLoading || isPageLoading, [
        compassComponentsLoading,
        isPageLoading
    ]); // Merged list of components in Jira that also exist in Compass.
    // This list is also sorted correctly via Jira.
    const mergedComponents = (0, $5uXOq.useMemo)(()=>{
        if (loading || compassComponents.length === 0) return [];
         // We reduce by `componentIds` as these are in correct sort order from server already.
        return componentIds.reduce((acc, componentId)=>{
            // Get the full Jira component from `componentsById`. We need the ARI and issue count.
            const jiraComponent = componentsById[componentId]; // Find a matching component that exists in Compass with the same ARI.
            const compassComponent = compassComponents.find((curCompassComponent)=>curCompassComponent.id === jiraComponent.ari); // Component exists in compass, we can render it.
            if (compassComponent) acc.push({
                ...compassComponent,
                issueCount: jiraComponent.issueCount
            });
            return acc;
        }, []);
    }, [
        loading,
        componentIds,
        componentsById,
        compassComponents
    ]);
    const { teamInfo: teamInfo } = $23e5dc133111f4ef$var$useGetTeams(mergedComponents, siteId);
    const head = (0, $5uXOq.useMemo)(()=>({
            cells: [
                {
                    key: (0, $fFsPq.NAME),
                    content: formatMessage((0, $b8bgB.default).componentHeader),
                    width: 25,
                    isSortable: true
                },
                {
                    key: 'owner-team',
                    content: formatMessage((0, $b8bgB.default).ownerTeamHeader),
                    width: 25,
                    isSortable: false
                },
                {
                    key: 'repository',
                    content: formatMessage((0, $b8bgB.default).repositoryHeader),
                    width: 18,
                    isSortable: false
                },
                {
                    key: 'dependencies',
                    content: formatMessage((0, $b8bgB.default).dependenciesHeader),
                    width: 12,
                    isSortable: false
                },
                {
                    key: 'scorecard',
                    content: formatMessage((0, $b8bgB.default).scorecardHeader),
                    width: 12,
                    isSortable: false
                },
                {
                    key: (0, $fFsPq.ISSUES),
                    content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $b8bgB.default).issuesHeaderIssueTermRefresh : (0, $b8bgB.default).issuesHeader),
                    width: 8,
                    isSortable: true
                }
            ]
        }), [
        formatMessage
    ]);
    const rows = mergedComponents.map((component, idx)=>{
        const ownerId = (0, $axhu5.getIdFromAri)(component?.ownerId ?? '');
        return $23e5dc133111f4ef$var$compassComponentToRow({
            ...component,
            ownerName: teamInfo[ownerId]?.displayName ?? null
        }, projectKey, // Sorting is handled by API.
        orderDirection === 'DESC' ? -(idx + 1) : idx + 1);
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'learnMoreAboutLinkingIssuesToCompassLink');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage((0, $b8bgB.default).componentCount, {
        componentCount: componentCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "right-start",
        messageId: "project-directories.components.compass-table.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.200",
                xcss: $23e5dc133111f4ef$var$tableHeaderStyles
            }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $b8bgB.default).componentInfoIssueTermRefresh : (0, $b8bgB.default).componentInfo, {
                // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                bold: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("strong", null, text),
                link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                        articleId: "6frUzedhV1M0c05JhXMvK0",
                        appearance: "link",
                        spacing: "none",
                        onClick: onClickLearnMore,
                        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                            href: "https://support.atlassian.com/jira-software-cloud/docs/link-issues-to-compass-components/",
                            target: "_blank",
                            appearance: "link",
                            spacing: "none",
                            onClick: onClickLearnMore
                        }, text)
                    }, text)
            })),
        trigger: (triggerProps)=>{
            if ((0, $4R6GH.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))),
                label: "",
                spacing: "compact",
                appearance: "subtle",
                testId: "project-directories.components.compass-table.add",
                onClick: ()=>setIsOpen(!isOpen),
                ...triggerProps
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                spacing: "compact",
                appearance: "subtle-link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                    spacing: "spacious",
                    label: ""
                }),
                testId: "project-directories.components.compass-table.add",
                onClick: ()=>setIsOpen(!isOpen),
                ...triggerProps
            });
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23e5dc133111f4ef$var$TableWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
        isFixedSize: true,
        loadingSpinnerSize: "large",
        head: head,
        rows: rows,
        isLoading: loading,
        sortKey: orderField,
        sortOrder: orderDirection,
        onSort: (data, analyticsEvent)=>{
            onSort?.(data);
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'compassComponentsTableSorted', {
                key: data.key,
                sortOrder: data.sortOrder
            });
        },
        emptyView: compassComponentsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1yNuo.ComponentsTableErrorState), null) : undefined
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "compassComponentsTable",
        sendToPrivacyUnsafeSplunk: true
    }, content), !compassComponentsError && children);
}
function $23e5dc133111f4ef$var$compassComponentToRow(component, projectKey, key) {
    const componentId = (0, $axhu5.getIdFromAri)(component.id);
    const ownerId = component.ownerId ? (0, $axhu5.getIdFromAri)(component?.ownerId ?? '') : undefined;
    return {
        cells: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWjmM.default), {
                    componentId: componentId,
                    name: component.name,
                    description: component.description,
                    typeId: component.typeId,
                    isArchived: component.state === 'ARCHIVED'
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lawRn.default), {
                    ownerName: component.ownerName,
                    ownerId: ownerId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl4OQ.RepositoryCell), {
                    repositoryLinks: component.links
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $RN6ng.default), {
                    componentId: componentId,
                    inwardRelationships: component.inwardRelationships,
                    outwardRelationships: component.outwardRelationships
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sHQY.default // Use full component ARI to make scorecards query.
                ), {
                    componentId: component.id,
                    scorecardScores: component.scorecardScores
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8D2Ck.default), {
                    projectKey: projectKey,
                    componentName: component.name,
                    issueCount: component.issueCount
                }),
                key: key
            }
        ]
    };
}
const $23e5dc133111f4ef$var$tableHeaderStyles = (0, $8CUq3.xcss)({
    width: '417px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23e5dc133111f4ef$var$TableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bve4zgxb _f96p1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dk72m.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hiWL0.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlnvO.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50Tma.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDBI6.default), {
                isLoading: isLoading,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hcItm")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = null;
const $3b29b0d00cd7b5c6$var$tableStyles = null;
const $3b29b0d00cd7b5c6$var$bodyBorder = null;
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $3b29b0d00cd7b5c6$var$captionStyles = null;
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = null;
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0852c529eaab7231$var$fixedHeightStyles = null;
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $0852c529eaab7231$var$emptyViewContainerStyles = null;
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggqAE.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $1g0dL.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$var$fixedSizeTruncateStyles = null;
const $11c3ea74eda01ab8$var$overflowTruncateStyles = null;
const $11c3ea74eda01ab8$var$truncationWidthStyles = null;
const $11c3ea74eda01ab8$var$cellStyles = null;
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ba9cb59faf06ce7f$var$rowStyles = null;
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = null;
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = null;
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lLAKY.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = null;
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$contentsContainerStyles = null;
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$spinnerContainerStyles = null;
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48301faf1109874f$var$containerStyles = null;
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $48301faf1109874f$var$spinnerBackdropStyles = null;
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $48301faf1109874f$var$spinnerContainerStyles = null;
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});



parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");



var $9GQPi = parcelRequire("9GQPi");
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = null;
const $e002e0403dc403bb$var$headStyles = null;
const $e002e0403dc403bb$var$overflowTruncateStyles = null;
const $e002e0403dc403bb$var$truncationWidthStyles = null;
const $e002e0403dc403bb$var$fixedSizeTruncateStyles = null;
const $e002e0403dc403bb$var$cellStyles = null;
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = null;
const $e002e0403dc403bb$var$headCellBaseStylesOld = null;
const $e002e0403dc403bb$var$onClickStyles = null;
const $e002e0403dc403bb$var$baseStyles = null;
const $e002e0403dc403bb$var$ascendingStyles = null;
const $e002e0403dc403bb$var$descendingStyles = null;
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
                onClick: onClick,
                xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "small",
                            color: "color.text.subtle",
                            weight: "bold",
                            maxLines: 1,
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("hcItm", function(module, exports) {

let $c8660dfa442bff40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8660dfa442bff40$var$load("76n7a"),
    $c8660dfa442bff40$var$load("l253H"),
    $c8660dfa442bff40$var$load("etJKP")
]).then(()=>parcelRequire('4THp8'));

});


parcelRegister("axhu5", function(module, exports) {

$parcel$export(module.exports, "getColorForProgress", () => $f2241e7f80843dca$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $f2241e7f80843dca$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $f2241e7f80843dca$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $f2241e7f80843dca$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $f2241e7f80843dca$export$79640a85913af5aa);


var $5COzG = parcelRequire("5COzG");
const $f2241e7f80843dca$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $f2241e7f80843dca$var$COLOR_RANGES = [
    {
        start: $f2241e7f80843dca$export$aa91e30498abc411.FAILING,
        end: $f2241e7f80843dca$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $829f609a65d26a98$exports).R300
    },
    {
        start: $f2241e7f80843dca$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $f2241e7f80843dca$export$aa91e30498abc411.PASSING - 1,
        color: (0, $829f609a65d26a98$exports).Y300
    },
    {
        start: $f2241e7f80843dca$export$aa91e30498abc411.PASSING,
        end: $f2241e7f80843dca$export$aa91e30498abc411.PASSING,
        color: (0, $829f609a65d26a98$exports).G300
    }
];
const $f2241e7f80843dca$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $f2241e7f80843dca$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $829f609a65d26a98$exports).R300;
};
const $f2241e7f80843dca$export$921f23fa0f13f23e = 90;
const $f2241e7f80843dca$export$69a1d9a35c04a358 = 50;
const $f2241e7f80843dca$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $f2241e7f80843dca$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $f2241e7f80843dca$export$69a1d9a35c04a358 && totalScore < $f2241e7f80843dca$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $f2241e7f80843dca$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $5COzG.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $5COzG.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $5COzG.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $5COzG.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $f2241e7f80843dca$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $f2241e7f80843dca$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
parcelRegister("5COzG", function(module, exports) {

$parcel$export(module.exports, "default", () => $97482220323f4986$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $97482220323f4986$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});

});


parcelRegister("lKaBM", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $9a7c5b02ac312e5c$export$5a622455e94bac3);

var $eusud = parcelRequire("eusud");

const $9a7c5b02ac312e5c$var$TEAMS_BULK_REST_API_URL_V4 = '/gateway/api/v4/teams/withMembers/bulk';
const $9a7c5b02ac312e5c$export$5a622455e94bac3 = async (teamIds, siteId)=>(0, $eusud.performPostRequest)($9a7c5b02ac312e5c$var$TEAMS_BULK_REST_API_URL_V4, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            teamIds: teamIds,
            siteId: siteId
        })
    });

});

parcelRegister("3YwGL", function(module, exports) {

$parcel$export(module.exports, "useGetCompassComponents", () => $4630dd4039a20af9$export$79b1cb1316dc1cf9);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $5pk0Q = parcelRequire("5pk0Q");

var $koeKL = parcelRequire("koeKL");

var $lfc7M = parcelRequire("lfc7M");

var $hktLw = parcelRequire("hktLw");
const $4630dd4039a20af9$export$79b1cb1316dc1cf9 = (componentAris)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: data, loading: loading, error: error } = (0, $5pk0Q.useFetchQuery)((0, $hktLw.SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY), {
        cloudId: cloudId,
        query: {
            first: (0, $lfc7M.ITEMS_ON_PAGE),
            fieldFilters: [
                {
                    name: 'entityId',
                    filter: {
                        in: componentAris
                    }
                }
            ]
        }
    }, {
        fetchPolicy: 'network-only'
    });
    const components = (0, $5uXOq.useMemo)(()=>{
        if (data?.compass?.searchComponents?.__typename !== 'CompassSearchComponentConnection') return [];
        return data?.compass?.searchComponents.nodes?.map($4630dd4039a20af9$var$mapNodeToComponent).filter((component)=>component != null) ?? [];
    }, [
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && error) (0, $jcw0u.default)({
            meta: {
                id: 'useGetCompassComponents',
                packageName: 'jiraProjectDirectoriesComponents',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        loading,
        error
    ]);
    return {
        components: components,
        loading: loading,
        error: error
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4630dd4039a20af9$var$mapNodeToComponent(node) {
    if (!node || !node.component || node.__typename !== 'CompassSearchComponentResult') return null;
    const { component: component } = node;
    let inwardRelationships;
    let outwardRelationships;
    if (component.inwardRelationships.__typename !== 'CompassRelationshipConnection') inwardRelationships = {
        nodes: [],
        pageInfo: {
            hasNextPage: false
        },
        error: component.inwardRelationships.message
    };
    else inwardRelationships = component.inwardRelationships;
    if (component.outwardRelationships.__typename !== 'CompassRelationshipConnection') outwardRelationships = {
        nodes: [],
        pageInfo: {
            hasNextPage: false
        },
        error: component.outwardRelationships.message
    };
    else outwardRelationships = component.outwardRelationships;
    const repositoryLinks = component.links?.reduce((acc, cur)=>{
        if (cur.type === 'REPOSITORY') acc.push(cur);
        return acc;
    }, []) ?? [];
    return {
        id: component.id,
        name: component.name,
        description: component.description,
        typeId: component.typeId,
        ownerId: component.ownerId,
        links: repositoryLinks,
        link: node.link,
        state: component.state,
        scorecardScores: component.scorecardScores,
        inwardRelationships: inwardRelationships,
        outwardRelationships: outwardRelationships
    };
}

});
parcelRegister("hktLw", function(module, exports) {

$parcel$export(module.exports, "SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY", () => $45cc5c7a66791e07$export$bd252c97cab4a3b6);

var $4P1qD = parcelRequire("4P1qD");
const $45cc5c7a66791e07$export$bd252c97cab4a3b6 = (0, $4P1qD.default);

});
parcelRegister("4P1qD", function(module, exports) {

$parcel$export(module.exports, "default", () => $433937ab76786fa5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca58d674586260c252dd9c7a3486b4b7>>
 * @relayHash 98e8fb0777fab7eb66d33463c9f0871f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4ef783417e74213eaa4dc96b67b877132fc6ae850fda499d9ecc3d414b345479
const $433937ab76786fa5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "typeId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "ownerId"
    }, v6 = {
        "types": [
            "DEPENDS_ON"
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    }, v10 = [
        {
            "concreteType": "CompassCatalogQueryApi",
            "kind": "LinkedField",
            "name": "compass",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "searchComponents",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "CompassSearchComponentResult",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        },
                                        {
                                            "concreteType": "CompassComponent",
                                            "kind": "LinkedField",
                                            "name": "component",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "state"
                                                },
                                                {
                                                    "concreteType": "CompassLink",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": true,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CompassScorecardScore",
                                                    "kind": "LinkedField",
                                                    "name": "scorecardScores",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalScore"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "maxTotalScore"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "inwardRelationships",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "query",
                                                            "value": {
                                                                "direction": "INWARD",
                                                                "filters": v6 /*: any*/ ,
                                                                "first": 5
                                                            }
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CompassRelationship",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CompassComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "startNode",
                                                                            "plural": false,
                                                                            "selections": v7 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "CompassRelationshipConnection"
                                                        },
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "relationships(query:{\"direction\":\"INWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                                                },
                                                {
                                                    "alias": "outwardRelationships",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "query",
                                                            "value": {
                                                                "direction": "OUTWARD",
                                                                "filters": v6 /*: any*/ ,
                                                                "first": 5
                                                            }
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CompassRelationship",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CompassComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "endNode",
                                                                            "plural": false,
                                                                            "selections": v7 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "CompassRelationshipConnection"
                                                        },
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "relationships(query:{\"direction\":\"OUTWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CompassSearchComponentConnection"
                        },
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "id": "4ef783417e74213eaa4dc96b67b877132fc6ae850fda499d9ecc3d414b345479",
            "metadata": {},
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$433937ab76786fa5$var$node.hash = "8a9b9fd2ce363a346ece1981d9c0fc18";
var $433937ab76786fa5$export$2e2bcd8739ae039 = $433937ab76786fa5$var$node;

});



parcelRegister("cWjmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6222413fa2bb3ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");

var $3bDjY = parcelRequire("3bDjY");

var $eBwIo = parcelRequire("eBwIo");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $d5WIT = parcelRequire("d5WIT");
function $f6222413fa2bb3ab$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, name: name, description: description, typeId: typeId, isArchived: isArchived } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: description ?? name
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...tooltipProps,
            testId: "project-directories.components.compass-table.cells.component.link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInline: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBwIo.ComponentTypeIcon), {
                type: typeId
            })),
            iconAfter: isArchived ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInlineStart: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, formatMessage((0, $d5WIT.default).archived))) : undefined,
            appearance: "link",
            spacing: "none",
            href: `/compass/component/${componentId}`,
            target: "_blank",
            onClick: (_, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'compassComponentLink');
            }
        }, name));
}

});
parcelRegister("d5WIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3255ce40b7c8754$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f3255ce40b7c8754$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    archived: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.component.archived",
        "defaultMessage": "Archived"
    }
});

});


parcelRegister("RN6ng", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d1e69f0f4d0b3a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $6fKa9 = parcelRequire("6fKa9");

var $kcDEu = parcelRequire("kcDEu");
const $2d1e69f0f4d0b3a2$var$messages = (0, $7VHMR.defineMessages)({
    noDependencies: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-dependencies",
        "defaultMessage": "No dependencies"
    },
    viewDependencies: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.view-dependencies",
        "defaultMessage": "View dependencies"
    }
});
function $2d1e69f0f4d0b3a2$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, inwardRelationships: inwardRelationships, outwardRelationships: outwardRelationships } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (inwardRelationships.nodes.length === 0 && outwardRelationships.nodes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6fKa9.SubtleText), null, formatMessage($2d1e69f0f4d0b3a2$var$messages.noDependencies));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        messageId: "project-directories.components.compass-table.cells.dependencies.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kcDEu.default), {
                testId: "project-directories.components.compass-table.cells.dependencies.popup-wrapper",
                componentId: componentId,
                dependsOn: outwardRelationships,
                dependedOnBy: inwardRelationships
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                appearance: "link",
                spacing: "none",
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewDependenciesButton');
                    setIsOpen(!isOpen);
                }
            }, formatMessage($2d1e69f0f4d0b3a2$var$messages.viewDependencies))
    });
}

});
parcelRegister("6fKa9", function(module, exports) {

$parcel$export(module.exports, "SubtleText", () => $74a0bf9827938a32$export$474d9b539a9b2a24);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $74a0bf9827938a32$export$474d9b539a9b2a24 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kcDEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd13c3517ccd3ce1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $9Xmvg = parcelRequire("9Xmvg");

var $eZJjh = parcelRequire("eZJjh");

var $axhu5 = parcelRequire("axhu5");

var $koeKL = parcelRequire("koeKL");

var $lKaBM = parcelRequire("lKaBM");

var $lPPAO = parcelRequire("lPPAO");
function $bd13c3517ccd3ce1$export$2e2bcd8739ae039(props) {
    const { testId: testId, componentId: componentId, dependsOn: dependsOn, dependedOnBy: dependedOnBy } = props;
    const [teamNamesById, setTeamNamesById] = (0, $5uXOq.useState)({});
    const [teamsLoading, setTeamsLoading] = (0, $5uXOq.useState)(true);
    const siteId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        const uniqueOwnerIds = Array.from(new Set([
            ...dependsOn.nodes.flatMap((node)=>node.endNode.ownerId ? [
                    (0, $axhu5.getIdFromAri)(node.endNode.ownerId)
                ] : []),
            ...dependedOnBy.nodes.flatMap((node)=>node.startNode.ownerId ? [
                    (0, $axhu5.getIdFromAri)(node.startNode.ownerId)
                ] : [])
        ]));
        if (uniqueOwnerIds.length > 0) (0, $lKaBM.getTeams)(uniqueOwnerIds, siteId).then((teams)=>{
            setTeamNamesById(teams.teams.reduce((acc, curTeam)=>Object.assign(acc, {
                    [curTeam.id]: curTeam.displayName
                }), {}));
        }).catch(()=>setTeamNamesById({})).finally(()=>setTeamsLoading(false));
        else setTeamsLoading(false);
    }, [
        dependsOn,
        dependedOnBy,
        siteId
    ]);
    if (teamsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$ContentWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$ContentWrapper, {
        "data-testid": testId
    }, dependsOn.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, "Depends on")), dependsOn.nodes.map((node, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lPPAO.default), {
            key: idx,
            node: {
                ...node.endNode
            },
            ownerName: teamNamesById[(0, $axhu5.getIdFromAri)(node.endNode.ownerId ?? '')]
        })), dependsOn.pageInfo.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$ViewMoreLink, {
        componentId: componentId
    })), dependedOnBy.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, "Depended on by")), dependedOnBy.nodes.map((node, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lPPAO.default), {
            key: idx,
            node: {
                ...node.startNode
            },
            ownerName: teamNamesById[(0, $axhu5.getIdFromAri)(node.startNode.ownerId ?? '')]
        })), dependedOnBy.pageInfo.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$ViewMoreLink, {
        componentId: componentId
    })));
}
const $bd13c3517ccd3ce1$var$ViewMoreLink = ({ componentId: componentId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd13c3517ccd3ce1$var$Link, {
        href: `/compass/component/${componentId}/dependencies`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, "View more ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Xmvg))), {
        label: "",
        LEGACY_size: "small"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd13c3517ccd3ce1$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $bd13c3517ccd3ce1$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrutpp _ngc01fxt",
            __cmplp.className
        ])
    });
});
const $bd13c3517ccd3ce1$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbk5xz _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $bd13c3517ccd3ce1$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1ns9 _4cvr1h6o _24rc1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lPPAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a4e9cda859b02$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $joPoo = parcelRequire("joPoo");

var $axhu5 = parcelRequire("axhu5");

var $eBwIo = parcelRequire("eBwIo");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $2lDCM = parcelRequire("2lDCM");
function $306a4e9cda859b02$var$isIconType(raw) {
    return raw in (0, $joPoo.default);
}
const $306a4e9cda859b02$var$toComponentType = (raw)=>$306a4e9cda859b02$var$isIconType(raw) ? raw : 'OTHER';
function $306a4e9cda859b02$export$2e2bcd8739ae039(props) {
    const { node: node, ownerName: ownerName } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const componentId = (0, $5uXOq.useMemo)(()=>(0, $axhu5.getIdFromAri)(node.id), [
        node.id
    ]);
    const ownedBy = (0, $5uXOq.useMemo)(()=>{
        const componentNameComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $306a4e9cda859b02$var$iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBwIo.ComponentTypeIcon), {
            type: $306a4e9cda859b02$var$toComponentType(node.typeId),
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($306a4e9cda859b02$var$Text, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            spacing: "none",
            href: `/compass/component/${componentId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (_, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dependencyComponentLink');
            }
        }, node.name)), "\xa0");
        if ((ownerName?.length ?? 0) > 0) {
            const ownerId = (0, $axhu5.getIdFromAri)(node.ownerId ?? '');
            const teamNameComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                href: `/compass/people/team/${ownerId}`,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dependencyOwnerLink');
                }
            }, ownerName));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $2lDCM.default).ownedBy, {
                text: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($306a4e9cda859b02$var$Text, null, chunks),
                componentName: componentNameComponent,
                teamName: teamNameComponent
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $2lDCM.default).noOwner, {
            text: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($306a4e9cda859b02$var$Text, null, chunks),
            componentName: componentNameComponent
        }));
    }, [
        node.ownerId,
        ownerName,
        componentId,
        node.name,
        node.typeId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($306a4e9cda859b02$var$Row, {
        "data-testid": "project-directories.components.compass-table.cells.dependencies.popup-content.depency-row.row"
    }, ownedBy);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $306a4e9cda859b02$var$Row = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _4cvr1h6o _1bsbk5xz _4t3i1ylp _otyru2gc _bfhk11bn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $306a4e9cda859b02$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l",
            __cmplp.className
        ])
    });
});
const $306a4e9cda859b02$var$iconWrapper = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});

});
parcelRegister("2lDCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $78dcb5ae259728b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $78dcb5ae259728b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ownedBy: {
        "id": "project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.owner-new",
        "defaultMessage": "{componentName} <text>owned by</text> {teamName}"
    },
    noOwner: {
        "id": "project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.no-owner-new",
        "defaultMessage": "{componentName} <text>No owner</text>"
    }
});

});




parcelRegister("8D2Ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3eaa4e1d35d99c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $cIy4l = parcelRequire("cIy4l");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $6fKa9 = parcelRequire("6fKa9");
const $6e3eaa4e1d35d99c$var$messages = (0, $7VHMR.defineMessages)({
    noIssues: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-issues",
        "defaultMessage": "No issues"
    },
    issueCount: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.issue-count",
        "defaultMessage": "{issueCount, plural, one {# issue} other {# issues}}"
    }
});
function $6e3eaa4e1d35d99c$export$2e2bcd8739ae039(props) {
    const { projectKey: projectKey, componentName: componentName, issueCount: issueCount } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issuesUrl = (0, $5uXOq.useMemo)(()=>{
        const jql = `project = ${(0, $cIy4l.toQuotedString)(projectKey)} AND component = ${(0, $cIy4l.toQuotedString)(componentName)}`;
        return (0, $cIy4l.createIssuesUrl)(jql);
    }, [
        projectKey,
        componentName
    ]);
    const link = (0, $4R6GH.fg)('replace-anchor-with-link__morphinecake') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        "data-testid": "project-directories.components.compass-table.cells.issues.link",
        href: issuesUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage($6e3eaa4e1d35d99c$var$messages.issueCount, {
        issueCount: issueCount
    })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        "data-testid": "project-directories.components.compass-table.cells.issues.link",
        href: issuesUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage($6e3eaa4e1d35d99c$var$messages.issueCount, {
        issueCount: issueCount
    }));
    return issueCount > 0 ? link : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6fKa9.SubtleText), null, formatMessage($6e3eaa4e1d35d99c$var$messages.noIssues));
}

});
parcelRegister("cIy4l", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $ae91325110cc96a6$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $ae91325110cc96a6$export$c623a4b2d8c439ab);
const $ae91325110cc96a6$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $ae91325110cc96a6$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $ae91325110cc96a6$var$ENCODE_MAP[character] || character;
};
const $ae91325110cc96a6$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $ae91325110cc96a6$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $ae91325110cc96a6$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("lawRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $41671db7178b4d49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $6fKa9 = parcelRequire("6fKa9");
const $41671db7178b4d49$var$messages = (0, $7VHMR.defineMessages)({
    noOwner: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-owner",
        "defaultMessage": "No owner"
    }
});
function $41671db7178b4d49$export$2e2bcd8739ae039(props) {
    const { ownerName: ownerName, ownerId: ownerId } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return ownerId && ownerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "project-directories.components.compass-table.cells.owner.link",
        appearance: "link",
        spacing: "none",
        href: `/compass/people/team/${ownerId}`,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'ownerLink');
        }
    }, ownerName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6fKa9.SubtleText), null, formatMessage($41671db7178b4d49$var$messages.noOwner));
}

});

parcelRegister("fl4OQ", function(module, exports) {

$parcel$export(module.exports, "RepositoryCell", () => $7c3d43b93b3f423a$export$b9085fe6b12a0b7b);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dn5wJ = parcelRequire("dn5wJ");
var $buvhv = parcelRequire("buvhv");

var $0Tx5e = parcelRequire("0Tx5e");

var $bay8L = parcelRequire("bay8L");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6fKa9 = parcelRequire("6fKa9");

var $lTmOb = parcelRequire("lTmOb");

var $3SeWl = parcelRequire("3SeWl");
const $7c3d43b93b3f423a$var$RE_BITBUCKET_REPOSITORY = /^https?:\/\/bitbucket\.org\//;
const $7c3d43b93b3f423a$export$ed662bf1621eb175 = 1;
function $7c3d43b93b3f423a$export$b9085fe6b12a0b7b({ repositoryLinks: repositoryLinks }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const bubbledRepositoryLinks = (0, $5uXOq.useMemo)(()=>$7c3d43b93b3f423a$export$37c5febb87944530(repositoryLinks), [
        repositoryLinks
    ]);
    if (bubbledRepositoryLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6fKa9.SubtleText), null, formatMessage((0, $lTmOb.default).noRepository));
    const displayedRepositoryLinks = bubbledRepositoryLinks.slice(0, $7c3d43b93b3f423a$export$ed662bf1621eb175);
    const remainingRepositoryLinks = bubbledRepositoryLinks.slice($7c3d43b93b3f423a$export$ed662bf1621eb175);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bay8L.SmartCardProviderMigration), null, displayedRepositoryLinks.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c3d43b93b3f423a$var$LinkContainer, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0Tx5e.CardSSR), {
            testId: "project-directories.components.compass-table.cells.repository.smart-link",
            url: link.url,
            appearance: "inline",
            placeholder: link.name || link.url,
            ui: {
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                clickableContainer: true
            },
            onClick: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'repositoryLink');
            },
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $dn5wJ.CardAction).ChangeStatusAction
                ]
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buvhv.default), {
            text: link.name,
            maxLines: 1,
            hideIcon: true
        })), index === displayedRepositoryLinks.length - 1 && remainingRepositoryLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3SeWl.default), {
            repositories: remainingRepositoryLinks
        }))));
}
function $7c3d43b93b3f423a$export$af662343bda1b144(links) {
    return links.filter((link)=>link.type === 'REPOSITORY');
}
function $7c3d43b93b3f423a$export$37c5febb87944530(repositoryLinks, sort = true) {
    const bitbucketLinks = repositoryLinks.filter((link)=>$7c3d43b93b3f423a$var$RE_BITBUCKET_REPOSITORY.test(link.url));
    const remainingLinks = repositoryLinks.filter((link)=>!$7c3d43b93b3f423a$var$RE_BITBUCKET_REPOSITORY.test(link.url));
    if (sort) {
        const comparator = (a, b)=>{
            if (!!a.name && !b.name) return -1;
            if (!a.name && !!b.name) return 1;
            return (a.name || a.url).localeCompare(b.name || b.url);
        };
        bitbucketLinks.sort(comparator);
        remainingLinks.sort(comparator);
    }
    remainingLinks.unshift(...bitbucketLinks);
    return remainingLinks;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c3d43b93b3f423a$var$LinkContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _116e116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (!(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action')) {
        if (hideRetry && props.retry) delete props.retry;
    }
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        ...(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? {
            hideRetry: hideRetry
        } : undefined,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});



parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("kDhrr")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("9sP91")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $kDhrr = parcelRequire("kDhrr");

var $kp8aU = parcelRequire("kp8aU");

var $9sP91 = parcelRequire("9sP91");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $kxcRq = parcelRequire("kxcRq");

var $9sP91 = parcelRequire("9sP91");

var $9tslm = parcelRequire("9tslm");

var $4ZXUA = parcelRequire("4ZXUA");

var $7IZqM = parcelRequire("7IZqM");

var $bWpL0 = parcelRequire("bWpL0");

var $aWyvu = parcelRequire("aWyvu");

var $3dV67 = parcelRequire("3dV67");

var $cJxXG = parcelRequire("cJxXG");

var $77cM6 = parcelRequire("77cM6");

var $k39kU = parcelRequire("k39kU");
const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: {
        component: (0, $9sP91.default),
        props: {
            icon: (0, $8dVIb.IconType).Component
        }
    },
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        }
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        }
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        }
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        }
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        }
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        }
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        }
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $aWyvu.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $77cM6.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        }
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        }
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        }
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $9tslm.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $3dV67.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $3dV67.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        }
    }
};
const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AppliedToComponentsCount:
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return $3c92d860530d8c8b$var$toBadgeProps(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return $3c92d860530d8c8b$var$toTextProps(data);
        case (0, $8dVIb.ElementName).Title:
            return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
        case (0, $8dVIb.ElementName).LinkIcon:
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v2')) return $3c92d860530d8c8b$var$toLinkIconProps(data, context.type);
            return typeof data === 'object' ? data : undefined;
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
    if ((0, $VSDnB.fg)('platform-linking-additional-flexible-element-props')) return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $3c92d860530d8c8b$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkIconProps = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $kxcRq.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    /**
	 * @deprecated remove when cleaning up FG platform_bandicoots-smart-card-disable-aria
	 */ more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $c53851cced73411d$export$6a4545d6b336c401);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("jP3VI"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("2zelF"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("3vtQf")))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("hIRd2"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("3vtQf")))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("kcbfF"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("gVXQp")))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("9bx9i")))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("aO5d7"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("ckyDP")))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("5mR3i")))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>(parcelRequire("k8THN"))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("fBf2G")),
            large: ()=>(parcelRequire("kee99"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("lslfp")),
            large: ()=>(parcelRequire("8yVZ6"))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("4nfzo")),
            large: ()=>(parcelRequire("5e2oM"))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("lyNGw")),
            large: ()=>(parcelRequire("7pYnQ"))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("bnA29")),
            large: ()=>(parcelRequire("cEK5F"))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("kwONT")),
            large: ()=>(parcelRequire("eFVyZ"))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("9Auxh")),
            large: ()=>(parcelRequire("b1syu"))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("hpac9")),
            large: ()=>(parcelRequire("e4niJ"))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("5nTq3")),
            large: ()=>(parcelRequire("5FD7P"))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("818b0")),
            large: ()=>(parcelRequire("7rpmm"))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("lnlq4")),
            large: ()=>(parcelRequire("1bqc1"))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("hSsH1")),
            large: ()=>(parcelRequire("4ggae"))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("4sBeG"))),
            large: ()=>(parcelRequire("faNHh"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("bPjbr"))),
            large: ()=>(parcelRequire("7Cfy8"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("6qWjs"))),
            large: ()=>(parcelRequire("lhK2t"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("ezu4w"))),
            large: ()=>(parcelRequire("Zl279"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("iAkpb"))),
            large: ()=>(parcelRequire("jfHd4"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("jnURg"))),
            large: ()=>(parcelRequire("h6mSM"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("gAdQO"))),
            large: ()=>(parcelRequire("2Nnnn"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("6ClRv"))),
            large: ()=>(parcelRequire("af9Ay"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("1ni2E"))),
            large: ()=>(parcelRequire("JuWWj"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("kQSMP"))),
            large: ()=>(parcelRequire("3Umjx"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("kvhCa"))),
            large: ()=>(parcelRequire("bpMfi"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dvo9I"))),
            large: ()=>(parcelRequire("3unVm"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("ercGv"))),
            large: ()=>(parcelRequire("kEBpI"))
        },
        // Confluence icons
        [(0, $8dVIb.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("4Atwu"))),
            large: ()=>Promise.resolve((parcelRequire("8lQ8Y")))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $8dVIb.IconType).Attachment]: {
            default: ()=>(parcelRequire("b2QJV"))
        },
        [(0, $8dVIb.IconType).CheckItem]: {
            default: ()=>(parcelRequire("hTMzv"))
        },
        [(0, $8dVIb.IconType).Component]: {
            default: ()=>(parcelRequire("i5LI7"))
        },
        [(0, $8dVIb.IconType).Comment]: {
            default: ()=>(parcelRequire("28C0M"))
        },
        [(0, $8dVIb.IconType).View]: {
            default: ()=>(parcelRequire("5ewzx"))
        },
        [(0, $8dVIb.IconType).React]: {
            default: ()=>(parcelRequire("8NR13"))
        },
        [(0, $8dVIb.IconType).Vote]: {
            default: ()=>(parcelRequire("acQVl"))
        },
        [(0, $8dVIb.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("eXA0t"))
        },
        [(0, $8dVIb.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("9kf9T"))
        },
        [(0, $8dVIb.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("jiNtU"))
        },
        [(0, $8dVIb.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("eL0Ys"))
        },
        [(0, $8dVIb.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("aX5mo"))
        },
        [(0, $8dVIb.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("fIUai"))
        },
        [(0, $8dVIb.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("9EtBf"))
        },
        [(0, $8dVIb.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("1t6AM"))
        },
        [(0, $8dVIb.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("d3Riz"))
        },
        [(0, $8dVIb.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("34KmU"))
        },
        [(0, $8dVIb.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("99TdN"))
        },
        [(0, $8dVIb.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("lWPoA"))
        },
        [(0, $8dVIb.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("4hqZ5")))
        },
        [(0, $8dVIb.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("89ySK"))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);
const $c53851cced73411d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $lwV66 = parcelRequire("lwV66");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($duwKf))), (0, (/*@__PURE__*/$parcel$interopDefault($lwV66)))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("lwV66", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $040b7f7dd846f7fd$var$_react = $040b7f7dd846f7fd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $040b7f7dd846f7fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $040b7f7dd846f7fd$var$Document24Icon = (props)=>/*#__PURE__*/ $040b7f7dd846f7fd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$040b7f7dd846f7fd$var$Document24Icon.displayName = 'Document24Icon';
var $040b7f7dd846f7fd$var$_default = module.exports.default = $040b7f7dd846f7fd$var$Document24Icon;

});

parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});



parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});



parcelRegister("jP3VI", function(module, exports) {

let $e6e5d427a0d38fe7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6e5d427a0d38fe7$var$load("aQTX9").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("2zelF", function(module, exports) {

let $1de9faf58c0c87e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1de9faf58c0c87e3$var$load("3T2eQ").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("hIRd2", function(module, exports) {

let $ce6fd2014e57e430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ce6fd2014e57e430$var$load("ffQaD"),
    $ce6fd2014e57e430$var$load("kvRbA"),
    $ce6fd2014e57e430$var$load("ldrEN")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("kcbfF", function(module, exports) {

let $eb3da7fce14b245c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb3da7fce14b245c$var$load("jZklo").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("aO5d7", function(module, exports) {

let $7de29da141eece0c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7de29da141eece0c$var$load("bHxrz").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("k8THN", function(module, exports) {

let $ea9fc3e9dd344518$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea9fc3e9dd344518$var$load("46xqb").then(()=>parcelRequire('a8hd9'));

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("fBf2G", function(module, exports) {

let $b5b5fad0121b0aed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b5b5fad0121b0aed$var$load("kRL9H").then(()=>parcelRequire('8njZH'));

});

parcelRegister("kee99", function(module, exports) {

let $eba016aa82a444ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eba016aa82a444ac$var$load("5soZa").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("lslfp", function(module, exports) {

let $f9ecb1cf63d607e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f9ecb1cf63d607e6$var$load("ece3U").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("8yVZ6", function(module, exports) {

let $63be7a3a4598be7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $63be7a3a4598be7a$var$load("1HQ0J").then(()=>parcelRequire('dGYEZ'));

});

parcelRegister("4nfzo", function(module, exports) {

let $32f5634727f32f4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32f5634727f32f4e$var$load("2xhmB").then(()=>parcelRequire('96Idm'));

});

parcelRegister("5e2oM", function(module, exports) {

let $3ce01edc74408d8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ce01edc74408d8e$var$load("8hyuR").then(()=>parcelRequire('RiK2l'));

});

parcelRegister("lyNGw", function(module, exports) {

let $fb235055aa698154$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb235055aa698154$var$load("4Hcjo").then(()=>parcelRequire('3KifV'));

});

parcelRegister("7pYnQ", function(module, exports) {

let $5669b5249fdb6af1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5669b5249fdb6af1$var$load("yxx4T").then(()=>parcelRequire('iBOon'));

});

parcelRegister("bnA29", function(module, exports) {

let $848dcb3f06f2141b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $848dcb3f06f2141b$var$load("gyqsg").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("cEK5F", function(module, exports) {

let $936cf90f8e3e2f60$var$load = (parcelRequire("28QjX"))(4);
module.exports = $936cf90f8e3e2f60$var$load("eI2NM").then(()=>parcelRequire('jdlqN'));

});

parcelRegister("kwONT", function(module, exports) {

let $ef1e345b5057ffb4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef1e345b5057ffb4$var$load("lbzkh").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("eFVyZ", function(module, exports) {

let $aaf18be27d7ddeca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aaf18be27d7ddeca$var$load("1toGC").then(()=>parcelRequire('c70Lr'));

});

parcelRegister("9Auxh", function(module, exports) {

let $6faf29a3253d3b39$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6faf29a3253d3b39$var$load("5yV3B").then(()=>parcelRequire('F35X1'));

});

parcelRegister("b1syu", function(module, exports) {

let $8065f0354f624b50$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8065f0354f624b50$var$load("d0F9x").then(()=>parcelRequire('2osAJ'));

});

parcelRegister("hpac9", function(module, exports) {

let $cabcadf6ae2e1f42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cabcadf6ae2e1f42$var$load("7cJNA").then(()=>parcelRequire('eABwY'));

});

parcelRegister("e4niJ", function(module, exports) {

let $a3e383822d90894c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3e383822d90894c$var$load("cuyPa").then(()=>parcelRequire('7zjHG'));

});

parcelRegister("5nTq3", function(module, exports) {

let $3eba16db4c5c1d72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3eba16db4c5c1d72$var$load("53hH3").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("5FD7P", function(module, exports) {

let $420f218bbefec4c3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $420f218bbefec4c3$var$load("5Eq1b").then(()=>parcelRequire('cHwqN'));

});

parcelRegister("818b0", function(module, exports) {

let $5d64c263665334a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d64c263665334a2$var$load("jCvJI").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("7rpmm", function(module, exports) {

let $56aeb9ea10df1bd3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56aeb9ea10df1bd3$var$load("jvPYJ").then(()=>parcelRequire('2sfBf'));

});

parcelRegister("lnlq4", function(module, exports) {

let $f8fc5c6b4e705851$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8fc5c6b4e705851$var$load("hu0uQ").then(()=>parcelRequire('5m93C'));

});

parcelRegister("1bqc1", function(module, exports) {

let $0dcb22e00a0d6271$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dcb22e00a0d6271$var$load("h5pFP").then(()=>parcelRequire('2tm8x'));

});

parcelRegister("hSsH1", function(module, exports) {

let $d03dbc9f90006243$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d03dbc9f90006243$var$load("b1qY8").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("4ggae", function(module, exports) {

let $31a531e2d90f4446$var$load = (parcelRequire("28QjX"))(4);
module.exports = $31a531e2d90f4446$var$load("8c61R").then(()=>parcelRequire('iABw2'));

});

parcelRegister("faNHh", function(module, exports) {

let $b0be56fcbb908172$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0be56fcbb908172$var$load("cdi9t").then(()=>parcelRequire('l04jD'));

});

parcelRegister("7Cfy8", function(module, exports) {

let $58b824d1a2ea9c13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $58b824d1a2ea9c13$var$load("fsbZm").then(()=>parcelRequire('52A0r'));

});

parcelRegister("lhK2t", function(module, exports) {

let $f7eee5dccd5a384d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7eee5dccd5a384d$var$load("jDEKQ").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("Zl279", function(module, exports) {

let $0b86035afefa8641$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b86035afefa8641$var$load("exonR").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("jfHd4", function(module, exports) {

let $e040ef9611e0e60c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e040ef9611e0e60c$var$load("gDjNE").then(()=>parcelRequire('41M8N'));

});

parcelRegister("h6mSM", function(module, exports) {

let $c734bf2e0d63df94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c734bf2e0d63df94$var$load("ljL6x").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("2Nnnn", function(module, exports) {

let $20924a5914a94fa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $20924a5914a94fa0$var$load("dJFy4").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("af9Ay", function(module, exports) {

let $7752be2f3d740436$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7752be2f3d740436$var$load("4f6Qg").then(()=>parcelRequire('529Ow'));

});

parcelRegister("JuWWj", function(module, exports) {

let $088c3609920e6766$var$load = (parcelRequire("28QjX"))(4);
module.exports = $088c3609920e6766$var$load("5b7z5").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("3Umjx", function(module, exports) {

let $2d87e92c7a44ae09$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d87e92c7a44ae09$var$load("75rqy").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("bpMfi", function(module, exports) {

let $84f77414cd4cb748$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84f77414cd4cb748$var$load("jxvAw").then(()=>parcelRequire('21nCU'));

});

parcelRegister("3unVm", function(module, exports) {

let $28a6bb471d98579f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28a6bb471d98579f$var$load("3L0Vc").then(()=>parcelRequire('93zHH'));

});

parcelRegister("kEBpI", function(module, exports) {

let $f09490ac2941d78c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f09490ac2941d78c$var$load("koGHi").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});


parcelRegister("8lQ8Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $40d9c5b900864dd9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $25dv3 = parcelRequire("25dv3");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $40d9c5b900864dd9$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25dv3.default), {
        label: label,
        testId: testId
    });
};
$40d9c5b900864dd9$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $40d9c5b900864dd9$export$2e2bcd8739ae039 = $40d9c5b900864dd9$var$PageLiveDoc24Icon;

});
parcelRegister("25dv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b5ea63b1e20da2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $23b5ea63b1e20da2$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$23b5ea63b1e20da2$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$23b5ea63b1e20da2$export$2e2bcd8739ae039 = $23b5ea63b1e20da2$var$PageLiveDoc24Icon;

});


parcelRegister("b2QJV", function(module, exports) {

let $80a8ca9d9079b9ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80a8ca9d9079b9ba$var$load("bHtk9").then(()=>parcelRequire('eZ9Cp'));

});

parcelRegister("hTMzv", function(module, exports) {

let $d07d400d364d97f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d07d400d364d97f5$var$load("10YFK").then(()=>parcelRequire('f5h6d'));

});

parcelRegister("i5LI7", function(module, exports) {

let $d2bdb3fa3cba1265$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2bdb3fa3cba1265$var$load("eHHfh").then(()=>parcelRequire('biU84'));

});

parcelRegister("28C0M", function(module, exports) {

let $18e9d06c8bb828e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18e9d06c8bb828e0$var$load("aA0tq").then(()=>parcelRequire('729P0'));

});

parcelRegister("5ewzx", function(module, exports) {

let $3cf786b2f3106989$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cf786b2f3106989$var$load("f0D0P").then(()=>parcelRequire('6N55R'));

});

parcelRegister("8NR13", function(module, exports) {

let $668c0634cfa76a7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $668c0634cfa76a7f$var$load("fTI2h").then(()=>parcelRequire('3xPiH'));

});

parcelRegister("acQVl", function(module, exports) {

let $76e413f697d051f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $76e413f697d051f0$var$load("b6xhe").then(()=>parcelRequire('9j532'));

});

parcelRegister("eXA0t", function(module, exports) {

let $ae42818d45a34fe6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae42818d45a34fe6$var$load("4b20x").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("9kf9T", function(module, exports) {

let $6ca1bd775537e485$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ca1bd775537e485$var$load("bhhPH").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("jiNtU", function(module, exports) {

let $e0d614c1b037b486$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0d614c1b037b486$var$load("jTNTf").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("eL0Ys", function(module, exports) {

let $abe635e95dbbcf20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $abe635e95dbbcf20$var$load("1bW9w").then(()=>parcelRequire('Le10t'));

});

parcelRegister("aX5mo", function(module, exports) {

let $7f93927a0d8f10f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f93927a0d8f10f8$var$load("dqho9").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("fIUai", function(module, exports) {

let $b726884848bc31ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b726884848bc31ae$var$load("j82pJ").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("9EtBf", function(module, exports) {

let $706ecf612af6f4c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $706ecf612af6f4c0$var$load("a0E5q").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("1t6AM", function(module, exports) {

let $111d9cf2449fdb30$var$load = (parcelRequire("28QjX"))(4);
module.exports = $111d9cf2449fdb30$var$load("4E7mO").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("d3Riz", function(module, exports) {

let $9824e629a9213344$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9824e629a9213344$var$load("kel8g").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("34KmU", function(module, exports) {

let $23d5b6a342ab0291$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23d5b6a342ab0291$var$load("98SE2").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("99TdN", function(module, exports) {

let $6aafca294ba4066d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6aafca294ba4066d$var$load("ffQaD"),
    $6aafca294ba4066d$var$load("kvRbA"),
    $6aafca294ba4066d$var$load("lMeFU")
]).then(()=>parcelRequire('2CRmv'));

});

parcelRegister("lWPoA", function(module, exports) {

let $ffa6e1d54a154aa3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffa6e1d54a154aa3$var$load("1AaKL").then(()=>parcelRequire('2ciBJ'));

});

parcelRegister("89ySK", function(module, exports) {

let $5efa38d08ffa18a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5efa38d08ffa18a2$var$load("6wTPq").then(()=>parcelRequire('2lRM4'));

});


parcelRegister("9sP91", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e693987bf1cd254$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7IZqM = parcelRequire("7IZqM");
const $5e693987bf1cd254$var$AppliedToComponentsCount = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $7zaVw.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7IZqM.default), {
        icon: (0, $8dVIb.IconType).Component,
        label: label,
        ...props
    });
};
var $5e693987bf1cd254$export$2e2bcd8739ae039 = $5e693987bf1cd254$var$AppliedToComponentsCount;

});
parcelRegister("7IZqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9f19acb0d3ec1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
const $aab9f19acb0d3ec1$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $aab9f19acb0d3ec1$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $aab9f19acb0d3ec1$var$badgeStyles = null;
const $aab9f19acb0d3ec1$var$iconStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $aab9f19acb0d3ec1$var$labelStylesOld = null;
const $aab9f19acb0d3ec1$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        className: (0, $bwpsq.default)([
            $aab9f19acb0d3ec1$var$styles.container,
            $aab9f19acb0d3ec1$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                xcss: $aab9f19acb0d3ec1$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $aab9f19acb0d3ec1$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(Badge);
const $aab9f19acb0d3ec1$var$BadgeRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($aab9f19acb0d3ec1$var$BadgeRefreshNew);
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8dcr7 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
const $aab9f19acb0d3ec1$var$Badge = (props)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeRefreshNewWithOverrideCss, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($aab9f19acb0d3ec1$var$BadgeCompiledNew, {
        ...props
    });
};
var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;

});
parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");

var $dVpJZ = parcelRequire("dVpJZ");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    const item = (0, $kxcRq.getLazyIcons)()[icon];
    if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVpJZ.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $8dVIb.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'small' : 'xsmall'
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $29YN9.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'small' : 'xsmall'
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
parcelRegister("e1vlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df3c19aa4679ee0a$export$2e2bcd8739ae039);

var $4Atwu = parcelRequire("4Atwu");

var $8lQ8Y = parcelRequire("8lQ8Y");

var $50H21 = parcelRequire("50H21");
const $df3c19aa4679ee0a$var$LiveDocumentIconWithColor = (0, $50H21.renderIconPerSize)((0, $4Atwu.default), (0, $8lQ8Y.default));
$df3c19aa4679ee0a$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $df3c19aa4679ee0a$export$2e2bcd8739ae039 = $df3c19aa4679ee0a$var$LiveDocumentIconWithColor;

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$styles = {
    roundImg: "_2rko14q2"
};
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $bwpsq.default)([
                appearance === 'round' && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && $951590e808a48e01$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $880176eb12ae8419$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("3dubP", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $9f9aac8ddfd1f0ad$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("9tslm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2a1e857857107e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");
const $bf2a1e857857107e$var$badgeStylesOld = null;
const $bf2a1e857857107e$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $bf2a1e857857107e$var$AtlaskitBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
            children: value
        })
    });
};
var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;

});

parcelRegister("4ZXUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e655d051c837701$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $1e655d051c837701$var$MAX_COUNT = 4;
const $1e655d051c837701$var$styles = null;
const $1e655d051c837701$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $1e655d051c837701$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1e655d051c837701$var$stylesMap[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;

});

parcelRegister("bWpL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a4f7878d6976fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66a4f7878d6976fe$var$stylesOld = null;
const $66a4f7878d6976fe$var$styles = null;
const $66a4f7878d6976fe$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $66a4f7878d6976fe$var$DateTime = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props')) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: content
    });
};
var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;

});

parcelRegister("aWyvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c193b1fc074556$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
const $d6c193b1fc074556$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $d6c193b1fc074556$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $d6c193b1fc074556$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium, appearance)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            appearance: appearance
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $d6c193b1fc074556$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square' })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId, size, (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? appearance : undefined) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        icon
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $d6c193b1fc074556$var$styles.container,
            $d6c193b1fc074556$var$positionStyleMap[position],
            render && $d6c193b1fc074556$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $d6c193b1fc074556$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;

});

parcelRegister("3dV67", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60bb11df77d728a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
const $b60bb11df77d728a$var$containerStyles = null;
const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
    if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
    if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $b60bb11df77d728a$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $b60bb11df77d728a$var$baseAnchorStyle = null;
const $b60bb11df77d728a$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $b60bb11df77d728a$var$anchorConstantsStyles = null;
const $b60bb11df77d728a$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $b60bb11df77d728a$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $b60bb11df77d728a$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $b60bb11df77d728a$var$linkStyleSizeMap[size],
            $b60bb11df77d728a$var$anchorLineClampMap[$b60bb11df77d728a$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $b60bb11df77d728a$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 1 && $b60bb11df77d728a$var$anchorLinkLineHeight1Map[size],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 2 && $b60bb11df77d728a$var$anchorLinkLineHeight2Map[size],
            $b60bb11df77d728a$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId)
    });
};
var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;

});

parcelRegister("cJxXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9c30eaf441ad65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");
const $af9c30eaf441ad65$var$stylesOld = null;
const $af9c30eaf441ad65$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $af9c30eaf441ad65$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
        appearance: appearance,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;

});
parcelRegister("a4DH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ceba18caf6f022$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $cLKee = parcelRequire("cLKee");

var $dMzTJ = parcelRequire("dMzTJ");

var $j6VJk = parcelRequire("j6VJk");

var $1s0lY = parcelRequire("1s0lY");

var $kf01E = parcelRequire("kf01E");

var $4Dg4o = parcelRequire("4Dg4o");
const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $1s0lY.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $1s0lY.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Dg4o.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j6VJk.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kf01E.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, $cLKee.default)($27ceba18caf6f022$var$LozengeAction);

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kYwnb = parcelRequire("kYwnb");

var $051X7 = parcelRequire("051X7");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = (0, $VSDnB.fg)('smart_links_noun_support') ? !!(details && details.data || (0, $kYwnb.isEntityPresent)(details)) : !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("cLKee", function(module, exports) {

$parcel$export(module.exports, "default", () => $061d6f2e0c766414$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: props?.appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;

});

parcelRegister("dMzTJ", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$618660b8f2aa87e2);
const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("j6VJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");
const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
const $ee1a9d5bb42f1de9$var$contentStyles = null;
const $ee1a9d5bb42f1de9$var$linkStyles = null;
const $ee1a9d5bb42f1de9$var$textStylesBase = null;
const $ee1a9d5bb42f1de9$var$dropdownItemGroupStyles = null;
const $ee1a9d5bb42f1de9$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("1s0lY", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $47c640bee30204cc$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $47c640bee30204cc$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("kf01E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0af43cfe2e114d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $hgsSZ = parcelRequire("hgsSZ");
const $9a0af43cfe2e114d$var$dropdownItemGroupStyles = null;
const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $hgsSZ.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;

});
parcelRegister("hgsSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $419e60cbfb62c454$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");
const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: appearance,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;

});


parcelRegister("4Dg4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa61527cd4f792e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $c8Oei = parcelRequire("c8Oei");

var $h5UrH = parcelRequire("h5UrH");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $afa61527cd4f792e$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $afa61527cd4f792e$var$triggerLozengeStyles = null;
const $afa61527cd4f792e$var$triggerButtonStyles = null;
const $afa61527cd4f792e$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
            appearance: appearance,
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        as: "span",
                        xcss: $afa61527cd4f792e$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
const $afa61527cd4f792e$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const [isPressing, setIsPressing] = (0, $5uXOq.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $5uXOq.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $5uXOq.useState)(undefined);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $5uXOq.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $5uXOq.useCallback)(()=>setIsPressing(false), []);
    (0, $5uXOq.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $DEWI6.cx)($afa61527cd4f792e$var$styles.lozengeContainer, (isOpen || isPressing) && $afa61527cd4f792e$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                appearance: appearance,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                    className: (0, $bwpsq.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            as: "span",
                            xcss: $afa61527cd4f792e$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $afa61527cd4f792e$export$2e2bcd8739ae039 = (0, $h5UrH.withFeatureFlaggedComponent)($afa61527cd4f792e$var$LozengeActionTriggerOld, $afa61527cd4f792e$var$LozengeActionTrigger, ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2'));

});
parcelRegister("h5UrH", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlaggedComponent", () => $080bc03d046ff7bd$export$55dba0d8ccf3da86);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $080bc03d046ff7bd$export$55dba0d8ccf3da86 = (ComponentOld, ComponentNext, featureFlagFn)=>{
    return (props)=>{
        // copied from packages/editor/editor-common/src/utils/withFeatureFlaggedComponent.tsx
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return featureFlagFn() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentNext, {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentOld, {
            ...props
        });
    };
};

});




parcelRegister("77cM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a723b9f793426daa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l5Xsv = parcelRequire("l5Xsv");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $a723b9f793426daa$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $a723b9f793426daa$var$Media = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l5Xsv.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;

});

parcelRegister("k39kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $af078338fe34f0f5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $af078338fe34f0f5$var$baseStyleOld = null;
const $af078338fe34f0f5$var$baseStyle = null;
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $af078338fe34f0f5$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const newContent = hideFormat && content ? content : (0, $fpDmE.getFormattedMessage)(message) || content;
    const oldContent = (0, $fpDmE.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color && (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? color : undefined,
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $VSDnB.fg)('platform-linking-additional-flexible-element-props') ? newContent : oldContent
    });
};
var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;

});


parcelRegister("kDhrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5972a7cc25546c87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $77cM6 = parcelRequire("77cM6");
const $5972a7cc25546c87$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $77cM6.default), {
        ...rest,
        ...data
    });
};
var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;

});

parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $673e9555bded0d05$var$snippetBaseStyleOld = null;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});


parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $66554651c27d9387$var$stylesOld = null;
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Zm9O.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $f30ba994fabdf720$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if ($f30ba994fabdf720$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
        ...props,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $b8eaafd3e75b73f4$var$actionGroupStylesOld = null;
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$safariStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                testId: "smart-element-group-actions",
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                className: (0, $bwpsq.default)([
                    size === (0, $8dVIb.SmartLinkSize).XLarge && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_c71lxy5q",
                    size === (0, $8dVIb.SmartLinkSize).XLarge && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_c71lviql",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;

});
parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$BaseBlockStylesOld = null;
const $96a6d91fb5d77548$var$baseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $96a6d91fb5d77548$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapsStylesOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $96a6d91fb5d77548$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});

parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$baseStyleBySizeOld = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyleOld = null;
const $ed56962f49dee3a8$var$baseStyles = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ed56962f49dee3a8$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $8dVIb.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySizeOld[size],
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            isHorizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ]),
        children: (0, $akF1x.renderChildren)(children, size)
    });
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Left,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStylesOld[size],
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $61dcf60a0013442f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;

});

parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cElbi.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;

});
parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDhrr.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kp8aU.default), {
            maxLines: snippetMaxLines,
            content: text
        })
    });
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});

parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tgi5.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adeuB.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHeMs.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});

parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $VSDnB = parcelRequire("VSDnB");

var $aRS1S = parcelRequire("aRS1S");
const $ea67ef8b17402f34$var$AISummaryCSSStyles = null;
const $ea67ef8b17402f34$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $270fc2c4bbd80c91$var$listStyles = null;
const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});


parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $obtkX.default), {
        ...props,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.Provider), {
                ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kBKwT.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8Sqt.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $8z1HA.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});





parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $s2ak7 = parcelRequire("s2ak7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b695424587865b74$var$ignoreContainerPaddingStylesOld = null;
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $b695424587865b74$export$1af10e3728e3a644(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $s2ak7.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("erAKX")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $erAKX = parcelRequire("erAKX");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $3dubP = parcelRequire("3dubP");

var $fpDmE = parcelRequire("fpDmE");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmall = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $b3ee32ab04698fad$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $b3ee32ab04698fad$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $b3ee32ab04698fad$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $5uXOq.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $8dVIb.SmartLinkSize).Large || size === (0, $8dVIb.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $krXdA.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                appearance: $b3ee32ab04698fad$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $b3ee32ab04698fad$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                appearance: $b3ee32ab04698fad$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss = (0, $3dubP.withOverrideCss)($b3ee32ab04698fad$var$ActionButtonRefreshNew);
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $b3ee32ab04698fad$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $VSDnB.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($b3ee32ab04698fad$var$ActionButtonNew, {
        ...props
    });
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});

parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $345d01659b23eb38$var$stackItemIconStylesOld = null;
const $345d01659b23eb38$var$stackItemIconStylesCompiled = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});

parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5PILj.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $222d00bebc6cbf68$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $222d00bebc6cbf68$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.button, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: (0, $3JT92.cx)(!(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$stylesOld.content, (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $222d00bebc6cbf68$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});



parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).delete
        }),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).edit
        }),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("lyOhH")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("kQ6Ua")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("lyOhH", function(module, exports) {

let $fb23c76bc86d7ec6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fb23c76bc86d7ec6$var$load("ffQaD"),
    $fb23c76bc86d7ec6$var$load("kvRbA"),
    $fb23c76bc86d7ec6$var$load("3SzZM")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("kQ6Ua", function(module, exports) {

let $f2be052be792008d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f2be052be792008d$var$load("ffQaD"),
    $f2be052be792008d$var$load("kvRbA"),
    $f2be052be792008d$var$load("jZ50W")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("erAKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a9f0a1fef78487$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");
const $12a9f0a1fef78487$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $12a9f0a1fef78487$var$UnresolvedAction = ({ testId: testId = 'unresolved-action' })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $8dVIb.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $12a9f0a1fef78487$var$styles.message,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $12a9f0a1fef78487$var$styles.button,
        children: message
    }) : message;
};
var $12a9f0a1fef78487$export$2e2bcd8739ae039 = $12a9f0a1fef78487$var$UnresolvedAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RbANO.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1r4gF.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $dS3PR = parcelRequire("dS3PR");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("9O9YP")));
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7zaVw.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $e5vwM.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnPiq.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $a203465a8c9e0684$var$styles = null;
const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("9O9YP", function(module, exports) {

let $72408668de532ebc$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72408668de532ebc$var$load("kNFvF"),
    $72408668de532ebc$var$load("ffQaD"),
    $72408668de532ebc$var$load("kvRbA"),
    $72408668de532ebc$var$load("47Kh6")
]).then(()=>parcelRequire('1Rjyb'));

});


parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3ivMk")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $7zaVw.messages).related_links_view_related_links : (0, $7zaVw.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k98Kd.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hyKRO = parcelRequire("hyKRO");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::460873555b00dc694a7c27133071dd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::359c101bebeaae075dd3e3e9a50caec7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});



parcelRegister("3ivMk", function(module, exports) {

let $266bb40faa8f7fb6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $266bb40faa8f7fb6$var$load("hHAog").then(()=>parcelRequire('14MtF'));

});



parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $aBTst = parcelRequire("aBTst");
const $e384e6334b5a98a7$var$containerStyles = null;
const $e384e6334b5a98a7$var$errorStyles = null;
const $e384e6334b5a98a7$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $e384e6334b5a98a7$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aBTst.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $e384e6334b5a98a7$var$styles.errorContentStyles,
                children: [
                    message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e384e6334b5a98a7$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});





parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});


parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $erAKX = parcelRequire("erAKX");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    const context = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? (0, $Nh1XU.useFlexibleUiContext)() : {};
    const showRetry = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? !hideRetry && Boolean(context?.actions?.[(0, $8dVIb.InternalActionName).UnresolvedAction]) : false;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $erAKX.default), {
                    testId: testId
                })
            }),
            !(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') && descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});

parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e2967317da51f9f7$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {
                overrideIcon: icon,
                position: position,
                size: size
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Vertical,
                width: (0, $8dVIb.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulp1b66"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1BfaB.default), {
                direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
                align: (0, $8dVIb.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});

parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fpDmE.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});


parcelRegister("0Tx5e", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $e2bd3eca15e522b1$export$7b5e1b7f9a325b6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $daJ0i = parcelRequire("daJ0i");

var $fzJZi = parcelRequire("fzJZi");

var $hBQOn = parcelRequire("hBQOn");

var $i41Ob = parcelRequire("i41Ob");
const $e2bd3eca15e522b1$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $5uXOq.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const cardProps = {
        ...props,
        id: id
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: (0, $fzJZi.context),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            FallbackComponent: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                    ...cardProps
                }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hBQOn.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("hBQOn", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $ad2753aa52acbfd4$export$7598f5d7c597dd32);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $lGoTE = parcelRequire("lGoTE");

var $1VPdD = parcelRequire("1VPdD");

var $fgpl1 = parcelRequire("fgpl1");

var $7HAq8 = parcelRequire("7HAq8");

var $kxcRq = parcelRequire("kxcRq");

var $jCOVt = parcelRequire("jCOVt");

var $g2eZ6 = parcelRequire("g2eZ6");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $8Buf6 = parcelRequire("8Buf6");

var $7RcXv = parcelRequire("7RcXv");

var $9fYWd = parcelRequire("9fYWd");

var $7oGL1 = parcelRequire("7oGL1");
function $ad2753aa52acbfd4$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error } = (0, $lGoTE.useSmartLink)(id, url);
    const definitionId = (0, $fgpl1.getDefinitionId)(state.details);
    const extensionKey = (0, $fgpl1.getExtensionKey)(state.details);
    const resourceType = (0, $fgpl1.getResourceType)(state.details);
    const services = (0, $fgpl1.getServices)(state.details);
    let isFlexibleUi = (0, $5uXOq.useMemo)(()=>(0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined), [
        children,
        ui
    ]);
    const actionOptions = (0, $jCOVt.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $5uXOq.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $kxcRq.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $8dVIb.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $fgpl1.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isModifierKeyPressed` be true.
            const target = isModifierKeyPressed ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        id,
        url,
        state.details,
        appearance,
        definitionId,
        onClick,
        isFlexibleUi,
        createAnalyticsEvent,
        fireEvent
    ]);
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $5uXOq.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $5uXOq.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $5uXOq.useEffect)(()=>{
        $5vDFA.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $5vDFA.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $5vDFA.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fgpl1.isFinalState)(state.status)) {
            (0, $1VPdD.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1VPdD.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $5uXOq.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fYWd.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7oGL1.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'block':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Buf6.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions
            });
        case 'embed':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7RcXv.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus
            });
    }
}
const $ad2753aa52acbfd4$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $91tw3.isFlexibleUiCard)(props.children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? props?.ui : undefined) ? (0, $8dVIb.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HAq8.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5igsJ.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ad2753aa52acbfd4$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("lGoTE", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $7e143fdfadf9b6c5$export$9f4e486b1dc3e700);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $3CATS = parcelRequire("3CATS");

var $eYswX = parcelRequire("eYswX");

var $khbkQ = parcelRequire("khbkQ");

var $hjhAz = parcelRequire("hjhAz");
function $7e143fdfadf9b6c5$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $hjhAz.useSmartCardState)(url);
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const actions = (0, $3CATS.useSmartCardActions)(id, url);
    const config = (0, $eYswX.useSmartLinkConfig)();
    const renderers = (0, $khbkQ.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $5uXOq.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error
    };
}

});
parcelRegister("3CATS", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $36916caf65c178ae$export$f7c340395f31e832);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");

var $fmdet = parcelRequire("fmdet");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $fgpl1 = parcelRequire("fgpl1");

var $iPVbQ = parcelRequire("iPVbQ");

var $f22ja = parcelRequire("f22ja");
const $36916caf65c178ae$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $f22ja.default)();
    const invokeClientAction = (0, $iPVbQ.default)({});
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $5uXOq.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $8dVIb.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $5uXOq.useCallback)((metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $5uXOq.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $5uXOq.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $5uXOq.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $fgpl1.getDefinitionId)(details);
        if (definitionId) (0, $fgpl1.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $5uXOq.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $5uXOq.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $fgpl1.getDefinitionId)(details);
        const extensionKey = (0, $fgpl1.getExtensionKey)(details);
        const services = (0, $fgpl1.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $fmdet.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1VPdD.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1VPdD.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $5uXOq.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("fmdet", function(module, exports) {

$parcel$export(module.exports, "auth", () => $5f3c60ac520535bf$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("fHui9")).AuthError);

var $fHui9 = parcelRequire("fHui9");

var $2sGCH = parcelRequire("2sGCH");
function $5f3c60ac520535bf$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $2sGCH.isOfTypeAuthError)(errorType)) reject(new (0, $fHui9.AuthError)(data.message, errorType));
                    else reject(new (0, $fHui9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $fHui9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("fHui9", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $39436ca0ebc2906b$export$145273558d58e0ac);
class $39436ca0ebc2906b$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("2sGCH", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $4689bea2fc57183c$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $4689bea2fc57183c$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("fgpl1", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $8cbc55b0be5f7abb$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $8cbc55b0be5f7abb$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $8cbc55b0be5f7abb$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $8cbc55b0be5f7abb$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $8cbc55b0be5f7abb$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $8cbc55b0be5f7abb$export$3f9446bb21b945a0);

var $iCv9y = parcelRequire("iCv9y");
const $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $iCv9y.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $8cbc55b0be5f7abb$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $8cbc55b0be5f7abb$export$218d96312e385949 = (details)=>details?.meta?.key;
const $8cbc55b0be5f7abb$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $8cbc55b0be5f7abb$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $8cbc55b0be5f7abb$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $8cbc55b0be5f7abb$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $8cbc55b0be5f7abb$export$ac5d414b1ebfab5a = (details)=>details && $8cbc55b0be5f7abb$export$cd41ae544cfc2a65(details) && $8cbc55b0be5f7abb$export$795910f5f15a9633(details);
const $8cbc55b0be5f7abb$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $8cbc55b0be5f7abb$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $8cbc55b0be5f7abb$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $8cbc55b0be5f7abb$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $8cbc55b0be5f7abb$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $8cbc55b0be5f7abb$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $8cbc55b0be5f7abb$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $8cbc55b0be5f7abb$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("iCv9y", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $28ad1893a5a5e6d3$export$c81497d3681f24f4);
const $28ad1893a5a5e6d3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("eYswX", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $2387d938a9c268b4$export$5d10838c1e539409);

var $051X7 = parcelRequire("051X7");
const $2387d938a9c268b4$export$5d10838c1e539409 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});

parcelRegister("khbkQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $53b108afa53560ee$export$c3514c024fefef57);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $53b108afa53560ee$export$c3514c024fefef57 = ()=>{
    const context = (0, $051X7.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $5uXOq.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("jCOVt", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $aaa9fcf770cffa90$export$2ae4cf79c720146a);
const $aaa9fcf770cffa90$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $VSDnB = parcelRequire("VSDnB");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");

var $VSDnB = parcelRequire("VSDnB");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $VSDnB.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("8Buf6", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $4d626c57887b3576$export$d18ccd25c0d2c6b0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $6TU5j = parcelRequire("6TU5j");

var $7xFN9 = parcelRequire("7xFN9");

var $gfnFT = parcelRequire("gfnFT");

var $bMldO = parcelRequire("bMldO");

var $1ENCM = parcelRequire("1ENCM");

var $kQeqP = parcelRequire("kQeqP");

var $7wrOH = parcelRequire("7wrOH");

var $kc7yu = parcelRequire("kc7yu");

var $1PV7p = parcelRequire("1PV7p");
const $4d626c57887b3576$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $gfnFT.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $6TU5j.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            });
        case 'resolved':
            if ((0, $VSDnB.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $7xFN9.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PV7p.default), {
                    ...blockCardProps,
                    onAuthorize: handleAuthorize
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PV7p.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQeqP.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7wrOH.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ENCM.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("6TU5j", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $f8634558e6ab3b89$export$f93c47f1b2b3f55b);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $f8634558e6ab3b89$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("7xFN9", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $6c86d4fba49dfc79$export$a019611f39785186);
const $6c86d4fba49dfc79$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("gfnFT", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $616acbd6c6da9a6a$export$9759a67e215c4598);
const $616acbd6c6da9a6a$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $7f29852863f1f016$var$baseWrapperStylesNew = null;
const $7f29852863f1f016$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStylesNew = null;
const $7f29852863f1f016$var$truncateStylesOld = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});



parcelRegister("1ENCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e31a40ad40a157$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $7zaVw = parcelRequire("7zaVw");

var $k39kU = parcelRequire("k39kU");

var $bd45l = parcelRequire("bd45l");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e31a40ad40a157$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $5uXOq.useMemo)(()=>props.onAuthorize ? [
            (0, $bd45l.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $7zaVw.messages).could_not_load_link
                }
            })
        ]
    });
};
var $c5e31a40ad40a157$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($c5e31a40ad40a157$var$ErroredView);

});
parcelRegister("bd45l", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $93e1b738cef17b2e$export$c527d977b53f7537);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $93e1b738cef17b2e$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $8dVIb.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("3Mvli", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25c51e88598659e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");
var $5HrTg = parcelRequire("5HrTg");
var $hYQw7 = parcelRequire("hYQw7");
var $buvhv = parcelRequire("buvhv");

var $82kHN = parcelRequire("82kHN");
const $d25c51e88598659e$var$customBlockStylesOld = null;
const $d25c51e88598659e$var$customBlockStyles = null;
const $d25c51e88598659e$var$titleBlockCssOld = null;
const $d25c51e88598659e$var$titleBlockCss = null;
const $d25c51e88598659e$var$footerBlockCssOld = null;
const $d25c51e88598659e$var$footerBlockCss = null;
const $d25c51e88598659e$var$footerBlockSafariStyles = null;
const $d25c51e88598659e$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $82kHN.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...(0, $82kHN.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                status: cardState.status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9 _2yhz14q2" : "_zulp1f3t _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                status: cardState.status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt" : "_4cvr1y6m"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ...(0, $82kHN.PreviewBlockOptions),
                status: cardState.status
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HrTg.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                status: cardState.status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb" : "_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj",
                    safari && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d25c51e88598659e$export$2e2bcd8739ae039 = $d25c51e88598659e$var$UnresolvedView;

});
parcelRegister("9fYWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $063c59fdd9d80513$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $anB5s = parcelRequire("anB5s");

var $f22ja = parcelRequire("f22ja");

var $lJP2b = parcelRequire("lJP2b");

var $1Vuck = parcelRequire("1Vuck");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $063c59fdd9d80513$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $anB5s.useAISummaryConfig)();
    const resolve = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $5uXOq.useMemo)(()=>(0, $1Vuck.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        details,
        fireEvent,
        id,
        onAuthorize,
        origin,
        renderers,
        actionOptions,
        resolve,
        status,
        url
    ]);
    const retry = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? undefined : (0, $1Vuck.getRetryOptions)(url, status, details, onAuthorize);
    const { title: title } = context || {};
    (0, $5uXOq.useEffect)(()=>{
        switch(status){
            case (0, $8dVIb.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $8dVIb.SmartLinkStatus).Errored:
            case (0, $8dVIb.SmartLinkStatus).Fallback:
            case (0, $8dVIb.SmartLinkStatus).Forbidden:
            case (0, $8dVIb.SmartLinkStatus).NotFound:
            case (0, $8dVIb.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleUiOptionContext).Provider, {
        value: ui,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Nh1XU.FlexibleUiContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJP2b.default), {
                testId: testId,
                ...ui,
                onClick: onClick,
                retry: retry,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                status: status,
                children: children
            })
        })
    });
};
var $063c59fdd9d80513$export$2e2bcd8739ae039 = $063c59fdd9d80513$var$FlexibleCard;

});
parcelRegister("lJP2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $399db9c8fe523a70$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $7ZRiH = parcelRequire("7ZRiH");

var $91tw3 = parcelRequire("91tw3");

var $buvhv = parcelRequire("buvhv");

var $jwrXN = parcelRequire("jwrXN");

var $4mRkk = parcelRequire("4mRkk");
const $399db9c8fe523a70$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $7ZRiH.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
            if ((0, $91tw3.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $8dVIb.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $8dVIb.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $399db9c8fe523a70$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick, removeBlockRestriction)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child)) {
            if ((0, $91tw3.isFlexibleUiTitleBlock)(child)) {
                if ((0, $91tw3.isStyleCacheProvider)(child)) return $399db9c8fe523a70$var$updateChildrenTitleBlock(child, {
                    onClick: onClick,
                    retry: retry,
                    containerSize: containerSize,
                    status: status,
                    theme: containerTheme
                });
                else {
                    const { size: blockSize } = child.props;
                    const size = blockSize || containerSize;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        onClick: // @ts-expect-error
                        onClick,
                        size: size,
                        status: status,
                        theme: containerTheme,
                        ...(0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? undefined : {
                            retry: retry
                        }
                    });
                }
            }
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $91tw3.isStyleCacheProvider)(child)) return $399db9c8fe523a70$var$updateChildrenBlock(child, size, status);
            // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                size: size,
                status: status
            });
        }
        if ((0, $VSDnB.fg)('platform-linking-flexible-card-openness')) {
            if (removeBlockRestriction) return child;
        }
    });
};
const $399db9c8fe523a70$var$updateChildrenBlock = (node, size, status)=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiBlock)(child)) // @ts-expect-error
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            size: size,
            status: status
        });
        return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
        children: updatedChildren
    });
};
const $399db9c8fe523a70$var$updateChildrenTitleBlock = (node, { containerSize: containerSize, ...props })=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) && (0, $91tw3.isFlexibleUiTitleBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                ...props,
                size: size
            });
        } else return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
        children: updatedChildren
    });
};
const $399db9c8fe523a70$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return undefined;
    if (node.type === (0, $buvhv.default)) return node;
    if ((0, $91tw3.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $399db9c8fe523a70$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $399db9c8fe523a70$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>$399db9c8fe523a70$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(block)) return block.props;
};
const $399db9c8fe523a70$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $399db9c8fe523a70$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mRkk.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
const $399db9c8fe523a70$var$baseStyleCommon = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$backgroundStyleOld = null;
const $399db9c8fe523a70$var$backgroundStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$elevationStylesOld = null;
const $399db9c8fe523a70$var$elevationStyles = null;
const $399db9c8fe523a70$var$clickableContainerStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$gapStyleMapOld = {
    xlarge: "_zulp1jvo",
    large: "_zulph3jc",
    medium: "_zulp1qos",
    small: "_zulpfzsm"
};
const $399db9c8fe523a70$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $399db9c8fe523a70$var$getPadding = (size)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $399db9c8fe523a70$var$getGap = (size)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$previewOnLeftStyleMapOld = {
    xlarge: "_19bv15sf _y5vk1k92",
    large: "_19bvf557 _y5vk1j6v",
    medium: "_19bvqox2 _y5vk1kwk",
    small: "_19bv1ltm _y5vk6mu8"
};
const $399db9c8fe523a70$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $399db9c8fe523a70$var$previewOnRightStyleMapOld = {
    xlarge: "_u5f315sf _1yob1k92",
    large: "_u5f3f557 _1yob1j6v",
    medium: "_u5f3qox2 _1yob1kwk",
    small: "_u5f31ltm _1yob6mu8"
};
const $399db9c8fe523a70$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $399db9c8fe523a70$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $8dVIb.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $8dVIb.SmartLinkTheme).Link })=>{
    (0, $gKZoD.di)((0, $jwrXN.default));
    const padding = hidePadding ? (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : $399db9c8fe523a70$var$getPadding(size);
    const gap = $399db9c8fe523a70$var$getGap(size);
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $399db9c8fe523a70$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $399db9c8fe523a70$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $399db9c8fe523a70$var$previewOnLeftStyleMap[size],
            previewOnRight && $399db9c8fe523a70$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $lD23V.default)(padding),
            "--_73mooq": (0, $lD23V.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $lD23V.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null,
            $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $399db9c8fe523a70$var$gapStyleMapOld[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $399db9c8fe523a70$var$previewOnLeftStyleMapOld[size],
            previewOnRight && $399db9c8fe523a70$var$previewOnRightStyleMapOld[size],
            !hideElevation && "_19ith6cr _2rkopd34 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $lD23V.default)(padding),
            "--_73mooq": (0, $lD23V.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $lD23V.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null,
            $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jwrXN.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $399db9c8fe523a70$export$2e2bcd8739ae039 = $399db9c8fe523a70$var$Container;

});
parcelRegister("7ZRiH", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $767677c9fc81205d$export$783c1bf8fee63f80);
const $767677c9fc81205d$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("jwrXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $93868de8e0c8126a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $hHEfn = parcelRequire("hHEfn");
const $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $93868de8e0c8126a$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $5uXOq.useState)(true);
    const mouseStopTimer = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $5uXOq.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $8dVIb.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            children: children
        })
    });
};
var $93868de8e0c8126a$export$2e2bcd8739ae039 = $93868de8e0c8126a$var$HoverCardControl;

});
parcelRegister("hHEfn", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $2eeb1383fcc12911$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $2eeb1383fcc12911$export$f1f63acbe6ed8fb0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $cb25w = parcelRequire("cb25w");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $7HAq8 = parcelRequire("7HAq8");

var $5igsJ = parcelRequire("5igsJ");

var $kySOC = parcelRequire("kySOC");
const $2eeb1383fcc12911$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gKZoD.di)((0, $kySOC.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: (0, $8dVIb.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $kySOC.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $5uXOq.useCallback)((error, info)=>{
        (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HAq8.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kySOC.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext = (0, $cb25w.default)()($2eeb1383fcc12911$var$HoverCardWithErrorBoundary);
const $2eeb1383fcc12911$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $2eeb1383fcc12911$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($2eeb1383fcc12911$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("kySOC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $3e0a0fbe111efeba$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $3e0a0fbe111efeba$export$e2173dafa6a751bb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $3CATS = parcelRequire("3CATS");

var $khbkQ = parcelRequire("khbkQ");

var $hjhAz = parcelRequire("hjhAz");

var $5igsJ = parcelRequire("5igsJ");

var $jpjv9 = parcelRequire("jpjv9");

var $fqj3r = parcelRequire("fqj3r");

var $hZqF4 = parcelRequire("hZqF4");
const $3e0a0fbe111efeba$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $3e0a0fbe111efeba$var$FADE_IN_DELAY = 500;
const $3e0a0fbe111efeba$var$FADE_OUT_DELAY = 300;
const $3e0a0fbe111efeba$var$RESOLVE_DELAY = 100;
const $3e0a0fbe111efeba$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $hZqF4.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId, showLabel: showLabel = true })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $3e0a0fbe111efeba$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const fadeOutTimeoutId = (0, $5uXOq.useRef)();
    const fadeInTimeoutId = (0, $5uXOq.useRef)();
    const resolveTimeOutId = (0, $5uXOq.useRef)();
    const mousePos = (0, $5uXOq.useRef)();
    const popupOffset = (0, $5uXOq.useRef)();
    const parentSpan = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderers = (0, $khbkQ.useSmartLinkRenderers)();
    const linkState = (0, $hjhAz.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $3CATS.useSmartCardActions)(id, url);
    const setMousePosition = (0, $5uXOq.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $hZqF4.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $hZqF4.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $5uXOq.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $3e0a0fbe111efeba$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $5uXOq.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $3e0a0fbe111efeba$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $5uXOq.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $5uXOq.useCallback)((actionId)=>{
        if (actionId === (0, $8dVIb.ActionName).PreviewAction || actionId === (0, $8dVIb.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $5uXOq.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $5uXOq.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5igsJ.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            id: id,
            source: $3e0a0fbe111efeba$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqj3r.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $5uXOq.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": "hover-card-trigger-wrapper",
                ...!(0, $VSDnB.fg)('platform_bandicoots-smart-card-disable-aria') ? {
                    'aria-label': showLabel ? formatMessage((0, $7zaVw.messages).more_information_about_this_work_item) : undefined
                } : {},
                ...(0, $VSDnB.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        formatMessage,
        showLabel
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $jpjv9.default)
    });
};

});
parcelRegister("jpjv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3866955ba7de81$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $0f3866955ba7de81$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $0f3866955ba7de81$export$2e2bcd8739ae039 = $0f3866955ba7de81$var$CustomPopupContainer;

});

parcelRegister("fqj3r", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $d84d865bf5e6c05a$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $d84d865bf5e6c05a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $051X7 = parcelRequire("051X7");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $fgpl1 = parcelRequire("fgpl1");

var $hjhAz = parcelRequire("hjhAz");

var $kxcRq = parcelRequire("kxcRq");

var $cnaAy = parcelRequire("cnaAy");

var $g2eZ6 = parcelRequire("g2eZ6");

var $hZqF4 = parcelRequire("hZqF4");

var $8RJLv = parcelRequire("8RJLv");

var $fF5L8 = parcelRequire("fF5L8");

var $KTqu4 = parcelRequire("KTqu4");

var $6klQO = parcelRequire("6klQO");

var $g3aqq = parcelRequire("g3aqq");

var $f6jZ5 = parcelRequire("f6jZ5");
const $d84d865bf5e6c05a$export$34883cbaea18402d = 'smart-links-hover-preview';
const $d84d865bf5e6c05a$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const extensionKey = (0, $5uXOq.useMemo)(()=>(0, $fgpl1.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $hjhAz.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $5uXOq.useMemo)(()=>(0, $fgpl1.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $cnaAy.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $fgpl1.getServices)(linkState.details);
    const statusRef = (0, $5uXOq.useRef)(linkStatus);
    const fireEventRef = (0, $5uXOq.useRef)(fireEvent);
    const definitionIdRef = (0, $5uXOq.useRef)(definitionId);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $kxcRq.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $8RJLv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $8dVIb.SmartLinkSize).Large,
        position: (0, $8dVIb.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const flexibleCardProps = {
        appearance: (0, $8dVIb.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: (0, $hZqF4.flexibleUiOptions),
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g3aqq.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f6jZ5.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KTqu4.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6klQO.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fF5L8.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $d84d865bf5e6c05a$export$2e2bcd8739ae039 = $d84d865bf5e6c05a$var$HoverCardContent;

});
parcelRegister("hZqF4", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $c1c4917a58eea345$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $c1c4917a58eea345$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $c1c4917a58eea345$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $c1c4917a58eea345$export$e7cae8c75d768024);

var $k5uoT = parcelRequire("k5uoT");

var $8dVIb = parcelRequire("8dVIb");
const $c1c4917a58eea345$export$8245b0eaabf3440c = (0, $k5uoT.layers).modal();
const $c1c4917a58eea345$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    size: (0, $8dVIb.SmartLinkSize).Medium,
    zIndex: $c1c4917a58eea345$export$8245b0eaabf3440c + 1
};
const $c1c4917a58eea345$export$a0a37c997fbcd678 = 24;
const $c1c4917a58eea345$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("8RJLv", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $575ef03a4633fd6f$export$8548546c0aa631e6);

var $FcDCF = parcelRequire("FcDCF");

var $8dVIb = parcelRequire("8dVIb");

var $6N2TY = parcelRequire("6N2TY");
const $575ef03a4633fd6f$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $FcDCF.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $8dVIb.ElementName).AuthorGroup,
            (0, $8dVIb.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn,
                    (0, $8dVIb.ElementName).SubscriberCount,
                    (0, $8dVIb.ElementName).State
                ],
                subtitle: [
                    (0, $8dVIb.ElementName).SourceBranch,
                    (0, $8dVIb.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $8dVIb.ElementName).LatestCommit,
                    (0, $8dVIb.ElementName).CollaboratorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $6N2TY.extractOwnedBy)(data) ? (0, $8dVIb.ElementName).OwnedByGroup : (0, $8dVIb.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $8dVIb.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount,
                    (0, $8dVIb.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $8dVIb.ElementName).AssignedToGroup,
                        (0, $8dVIb.ElementName).State,
                        (0, $8dVIb.ElementName).StoryPoints,
                        (0, $8dVIb.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).CollaboratorGroup,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ],
                secondary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount,
                    (0, $8dVIb.ElementName).AttachmentCount,
                    (0, $8dVIb.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $8dVIb.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).State,
                    (0, $8dVIb.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).SentOn
                ],
                tertiary: [
                    (0, $8dVIb.ElementName).ReactCount,
                    (0, $8dVIb.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $8dVIb.ElementName).AuthorGroup,
                    (0, $8dVIb.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix = [
    (0, $8dVIb.ElementName).AssignedToGroup,
    (0, $8dVIb.ElementName).OwnedByGroup,
    (0, $8dVIb.ElementName).AuthorGroup
];
const $575ef03a4633fd6f$var$toElementItem = (name)=>{
    const showNamePrefix = $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $575ef03a4633fd6f$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $8dVIb.ElementName)).map($575ef03a4633fd6f$var$toElementItem);
};
const $575ef03a4633fd6f$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $575ef03a4633fd6f$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $575ef03a4633fd6f$var$toElementItems(metadata.subtitle),
        primary: $575ef03a4633fd6f$var$toElementItems(primary),
        secondary: $575ef03a4633fd6f$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("6N2TY", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $e8afc48bfc3821d9$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $e8afc48bfc3821d9$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $e8afc48bfc3821d9$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $e8afc48bfc3821d9$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $e8afc48bfc3821d9$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $e8afc48bfc3821d9$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $e8afc48bfc3821d9$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $e8afc48bfc3821d9$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $e8afc48bfc3821d9$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $e8afc48bfc3821d9$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $e8afc48bfc3821d9$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $e8afc48bfc3821d9$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $e8afc48bfc3821d9$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $e8afc48bfc3821d9$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $e8afc48bfc3821d9$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $e8afc48bfc3821d9$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $e8afc48bfc3821d9$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $e8afc48bfc3821d9$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $e8afc48bfc3821d9$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $e8afc48bfc3821d9$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $e8afc48bfc3821d9$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $e8afc48bfc3821d9$export$bdcea84d1550eb9d);

var $lnY7t = parcelRequire("lnY7t");
var $4MmCl = parcelRequire("4MmCl");
var $eV8m9 = parcelRequire("eV8m9");
var $g9Blp = parcelRequire("g9Blp");
const $e8afc48bfc3821d9$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $e8afc48bfc3821d9$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $e8afc48bfc3821d9$export$b68822b76d5d51d5 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:commentCount');
const $e8afc48bfc3821d9$export$4356c594f5c138d6 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $e8afc48bfc3821d9$export$ac56bd7a37249b48 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'endTime');
const $e8afc48bfc3821d9$export$e57334ce4738e29d = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:viewCount');
const $e8afc48bfc3821d9$export$44130aa92252501 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:reactCount');
const $e8afc48bfc3821d9$export$c8bef3d5e550a3a = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:voteCount');
const $e8afc48bfc3821d9$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $eV8m9.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $e8afc48bfc3821d9$export$5546969a505305 = (data)=>{
    const person = (0, $lnY7t.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $e8afc48bfc3821d9$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $lnY7t.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $e8afc48bfc3821d9$export$69b10d653f96288b = (data)=>{
    const persons = (0, $4MmCl.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $e8afc48bfc3821d9$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $g9Blp.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $e8afc48bfc3821d9$export$43e54589935a1ff = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:programmingLanguage');
const $e8afc48bfc3821d9$export$949ac6a8325b3fdb = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeSource']);
const $e8afc48bfc3821d9$export$8bd03a7beb5badf1 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subscriberCount');
const $e8afc48bfc3821d9$export$65362ff78a97fd8 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:attachmentCount');
const $e8afc48bfc3821d9$export$29b0ac5d2f9890cf = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeDestination']);
const $e8afc48bfc3821d9$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $e8afc48bfc3821d9$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $e8afc48bfc3821d9$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $e8afc48bfc3821d9$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $e8afc48bfc3821d9$export$cc4028b2878d0675 = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $e8afc48bfc3821d9$export$b592ddecae70b61d = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'dateSent');
};
const $e8afc48bfc3821d9$export$bdcea84d1550eb9d = (data)=>{
    return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("lnY7t", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $0ac42ccaa7f6f983$export$38a0979ebf273662);

var $aj6Xc = parcelRequire("aj6Xc");
const $0ac42ccaa7f6f983$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $aj6Xc.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("eV8m9", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $2d658438ec8722e8$export$19ee667f3f7a6ec3);

var $aj6Xc = parcelRequire("aj6Xc");
const $2d658438ec8722e8$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $aj6Xc.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $aj6Xc.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("fF5L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ba3ed6dc9291b3$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $67sXJ = parcelRequire("67sXJ");

var $fqj3r = parcelRequire("fqj3r");
const $35ba3ed6dc9291b3$var$NEW_CARD_WIDTH_REM = 25;
const $35ba3ed6dc9291b3$var$HoverCardContainerStyle = null;
const $35ba3ed6dc9291b3$var$popupContainerStyles = null;
const $35ba3ed6dc9291b3$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $67sXJ.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    const [showPrism, setShowPrism] = (0, $5uXOq.useState)(status === 'loading');
    (0, $5uXOq.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $fqj3r.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $67sXJ.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $35ba3ed6dc9291b3$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($35ba3ed6dc9291b3$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $35ba3ed6dc9291b3$export$2e2bcd8739ae039 = $35ba3ed6dc9291b3$var$ContentContainer;

});
parcelRegister("67sXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1d831891587499$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");

var $c1bPW = parcelRequire("c1bPW");

var $DuPPR = parcelRequire("DuPPR");
const $8c1d831891587499$var$contentStyles = null;
const $8c1d831891587499$var$contentStylesPrismVisible = null;
const $8c1d831891587499$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $8c1d831891587499$var$popupContainerStyles = null;
const $8c1d831891587499$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c1bPW.default), {
        palette: (0, $DuPPR.AI_BORDER_PALETTE)[colorMode] ?? (0, $DuPPR.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $bwpsq.default)([
            $8c1d831891587499$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $8c1d831891587499$export$2e2bcd8739ae039 = $8c1d831891587499$var$AIPrism;

});
parcelRegister("c1bPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1652d4d52e4f5cc8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iI2az = parcelRequire("iI2az");
const $1652d4d52e4f5cc8$var$borderContainerStyles = null;
const $1652d4d52e4f5cc8$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1652d4d52e4f5cc8$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI2az.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI2az.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1652d4d52e4f5cc8$export$2e2bcd8739ae039 = $1652d4d52e4f5cc8$var$AIGlowingBorder;

});
parcelRegister("iI2az", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f1273dcfb74565$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
let $e2f1273dcfb74565$var$namespaceUUID = 0;
const $e2f1273dcfb74565$var$svgStyles = null;
const $e2f1273dcfb74565$var$blurredStyles = null;
const $e2f1273dcfb74565$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $e2f1273dcfb74565$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $5uXOq.useRef)(null);
    const namespaceId = (0, $5uXOq.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $e2f1273dcfb74565$var$namespaceUUID;
        $e2f1273dcfb74565$var$namespaceUUID += 1;
    }
    (0, $5uXOq.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $e2f1273dcfb74565$export$2e2bcd8739ae039 = $e2f1273dcfb74565$var$AnimatedSvgContainer;

});


parcelRegister("DuPPR", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $82894915d9bf39bf$export$23b7b83c7063ccfe);
const $82894915d9bf39bf$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $82894915d9bf39bf$export$23b7b83c7063ccfe = {
    dark: {
        blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue800,
        teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal500,
        yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue600,
        teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal300,
        yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("KTqu4", function(module, exports) {

$parcel$export(module.exports, "default", () => $73fc988205a4fd73$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $eCNt3 = parcelRequire("eCNt3");

var $7zaVw = parcelRequire("7zaVw");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");
var $hYQw7 = parcelRequire("hYQw7");
const $73fc988205a4fd73$var$titleBlockStylesOld = null;
const $73fc988205a4fd73$var$titleBlockStyles = null;
const $73fc988205a4fd73$var$mainTextStylesOld = null;
const $73fc988205a4fd73$var$mainTextStyles = null;
const $73fc988205a4fd73$var$connectButtonStylesOld = null;
const $73fc988205a4fd73$var$connectButtonStyles = null;
const $73fc988205a4fd73$var$basePreviewStylesOld = null;
const $73fc988205a4fd73$var$basePreviewStyles = null;
const $73fc988205a4fd73$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const data = cardState.details?.data;
    const meta = cardState.details?.meta;
    const product = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(cardState.details)?.text ?? '' : (0, $f24gj.extractProvider)(data)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
        children: (0, $eCNt3.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $8PVtF.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    const ButtonComponent = (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ignoreContainerPadding: true,
                testId: testId,
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_13lipd34 _qrwqpd34 _otyru2gc" : "_13lipd34 _qrwqpd34 _otyrcxkx"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-title`,
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _k48p1pd9 _19pku2gc" : "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-content`,
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o" : "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                status: (0, $8dVIb.SmartLinkStatus).Forbidden,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _19pku2gc" : "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $73fc988205a4fd73$export$2e2bcd8739ae039 = $73fc988205a4fd73$var$HoverCardForbiddenView;

});
parcelRegister("8PVtF", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $be4c51ebaefcf3e8$export$846c1540a86749e6);

var $7zaVw = parcelRequire("7zaVw");

var $fzJZi = parcelRequire("fzJZi");

var $fKHgZ = parcelRequire("fKHgZ");

var $eCNt3 = parcelRequire("eCNt3");
const $be4c51ebaefcf3e8$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $eCNt3.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $7zaVw.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $7zaVw.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $fKHgZ.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $7zaVw.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $fKHgZ.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $7zaVw.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("fKHgZ", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $d51c8d84b1e7f98f$export$59f8830fb5467e35);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7zaVw = parcelRequire("7zaVw");
const $d51c8d84b1e7f98f$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $7zaVw.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("eCNt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aafc83cfd7b46ae$export$2e2bcd8739ae039);
const $4aafc83cfd7b46ae$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $4aafc83cfd7b46ae$export$2e2bcd8739ae039 = $4aafc83cfd7b46ae$var$extractHostname;

});



parcelRegister("6klQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $338ebad02f36b2c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $9fYWd = parcelRequire("9fYWd");

var $fh9qw = parcelRequire("fh9qw");
var $85ffk = parcelRequire("85ffk");
var $1qDIM = parcelRequire("1qDIM");
var $gg6Qm = parcelRequire("gg6Qm");
var $1JaZ4 = parcelRequire("1JaZ4");
var $buvhv = parcelRequire("buvhv");

var $8RJLv = parcelRequire("8RJLv");

var $k9g4I = parcelRequire("k9g4I");
const $338ebad02f36b2c8$var$hiddenSnippetStyles = null;
const $338ebad02f36b2c8$var$metadataBlockCssOld = null;
/**
 * Moved from HoverCardContent.tsx due to CompiledCSS migration.
 */ const $338ebad02f36b2c8$var$titleBlockStyleOld = null;
const $338ebad02f36b2c8$var$titleBlockStyles = null;
const $338ebad02f36b2c8$var$snippetBlockCss = null;
const $338ebad02f36b2c8$var$actionBlockCss = null;
const $338ebad02f36b2c8$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1VPdD.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1VPdD.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $8dVIb.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $5uXOq.useMemo)(()=>{
        return (0, $8RJLv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(0);
    const snippetBlockRef = (0, $5uXOq.useRef)(null);
    const onSnippetRender = (0, $5uXOq.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $k9g4I.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {
        status: (0, $8dVIb.SmartLinkStatus).Resolved,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...titleBlockProps,
                metadataPosition: (0, $8dVIb.SmartLinkPosition).Top,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9" : "_zulpu2gc _quenui7n _oebj1txw _x7z0u2gc _1ljqu2gc _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $8dVIb.SmartLinkSize).Medium,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_zulpidpf _2aco1o8v _fmt31ohn _yklxcxkx _w3mucxkx _ia0l11wp _3tmpcxkx"
                ])
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1qDIM.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet,
                status: (0, $8dVIb.SmartLinkStatus).Resolved
            }) : snippet,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fh9qw.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $85ffk.default), {})
        ]
    });
};
var $338ebad02f36b2c8$export$2e2bcd8739ae039 = $338ebad02f36b2c8$var$HoverCardResolvedView;

});
parcelRegister("k9g4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0493145b01898e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $jELGn = parcelRequire("jELGn");

var $hYQw7 = parcelRequire("hYQw7");
const $eb0493145b01898e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $5uXOq.useRef)(false);
    const previewBlockRef = (0, $5uXOq.useRef)(null);
    const [showPreview, setShowPreview] = (0, $5uXOq.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)({});
    const data = response?.data;
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $5uXOq.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "var(--ds-space-100, 8px)" : '0.5rem',
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $5uXOq.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $5uXOq.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return showPreview && (0, $jELGn.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
    return showPreview && data && (0, $jELGn.default)(data) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $eb0493145b01898e$export$2e2bcd8739ae039 = $eb0493145b01898e$var$ImagePreview;

});
parcelRegister("jELGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b57ea7b1c4bc68$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $c3b57ea7b1c4bc68$export$a79836076066b8b6);

var $kYwnb = parcelRequire("kYwnb");
var $5nDnb = parcelRequire("5nDnb");

var $8dVIb = parcelRequire("8dVIb");
const $c3b57ea7b1c4bc68$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $5nDnb.extractImage)(data);
    return url ? {
        type: (0, $8dVIb.MediaType).Image,
        url: url
    } : undefined;
};
var $c3b57ea7b1c4bc68$export$2e2bcd8739ae039 = $c3b57ea7b1c4bc68$var$extractPreview;
const $c3b57ea7b1c4bc68$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const entity = (0, $kYwnb.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        if (!url) {
            const provider = (0, $kYwnb.extractEntityProvider)(response);
            url = provider?.image;
        }
        return url ? {
            type: (0, $8dVIb.MediaType).Image,
            url: url
        } : undefined;
    }
    return $c3b57ea7b1c4bc68$var$extractPreview(response.data);
};

});
parcelRegister("5nDnb", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $bf7a10bb5159fbbd$export$4c753a1297cb9805);

var $7OmtM = parcelRequire("7OmtM");
const $bf7a10bb5159fbbd$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $7OmtM.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $7OmtM.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("g3aqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9278993db7419c13$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dghu0 = parcelRequire("dghu0");

var $bubxq = parcelRequire("bubxq");

var $gU02S = parcelRequire("gU02S");

var $aWyvu = parcelRequire("aWyvu");

var $hZqF4 = parcelRequire("hZqF4");
const $9278993db7419c13$var$loadingViewContainer = null;
const $9278993db7419c13$var$skeletonContainer = null;
const $9278993db7419c13$var$titleStyle = null;
const $9278993db7419c13$var$titleBlockStyles = null;
const $9278993db7419c13$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $hZqF4.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $bwpsq.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aWyvu.default), {
                            render: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $bwpsq.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gU02S.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $9278993db7419c13$export$2e2bcd8739ae039 = $9278993db7419c13$var$HoverCardLoadingView;

});

parcelRegister("f6jZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7ebd359d5a8e698$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $3CATS = parcelRequire("3CATS");

var $fgpl1 = parcelRequire("fgpl1");

var $3PAn6 = parcelRequire("3PAn6");

var $9fYWd = parcelRequire("9fYWd");

var $dghu0 = parcelRequire("dghu0");

var $bubxq = parcelRequire("bubxq");

var $eqoQu = parcelRequire("eqoQu");
const $e7ebd359d5a8e698$var$connectButtonStylesOld = null;
const $e7ebd359d5a8e698$var$connectButtonStyles = null;
const $e7ebd359d5a8e698$var$titleBlockStylesOld = null;
const $e7ebd359d5a8e698$var$titleBlockStyles = null;
const $e7ebd359d5a8e698$var$mainTextStylesOld = null;
const $e7ebd359d5a8e698$var$mainTextStyles = null;
const $e7ebd359d5a8e698$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const data = cardState.details?.data;
    const providerName = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(cardState.details)?.text : (0, $f24gj.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $3CATS.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $8dVIb.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $8dVIb.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dghu0.default), {
                testId: `${testId}-title`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9" : "_zulp5l1i _bpsp1wq8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eqoQu.LinkIcon), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-content`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _19pku2gc" : "_11c8dcr7 _19pkcxkx"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dghu0.default), {
                testId: `${testId}-button`,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_1bahesu3 _19pku2gc" : "_1bahesu3 _19pkcxkx"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bubxq.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $e7ebd359d5a8e698$export$2e2bcd8739ae039 = $e7ebd359d5a8e698$var$HoverCardUnauthorisedView;

});
parcelRegister("3PAn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8897e3cb423b2de$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $a8897e3cb423b2de$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $7zaVw.messages).learn_more_about_connecting_account : (0, $7zaVw.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
                href: isProductIntegrationSupported ? (0, $8dVIb.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $8dVIb.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...learnMoreMessage
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: isProductIntegrationSupported ? (0, $8dVIb.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $8dVIb.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                "data-testid": `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    textDecoration: 'underline'
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $a8897e3cb423b2de$export$2e2bcd8739ae039 = $a8897e3cb423b2de$var$UnauthorisedViewContent;

});






parcelRegister("4mRkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aaf352da1fa338$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4URMI = parcelRequire("4URMI");
const $22aaf352da1fa338$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $22aaf352da1fa338$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $22aaf352da1fa338$export$2e2bcd8739ae039 = $22aaf352da1fa338$var$LayeredLink;

});


parcelRegister("1Vuck", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $567a4b851e4bc65e$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $567a4b851e4bc65e$export$f3d3482baaff4bf6);

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");
var $kYwnb = parcelRequire("kYwnb");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $2zcFi = parcelRequire("2zcFi");

var $jELGn = parcelRequire("jELGn");

var $dybmx = parcelRequire("dybmx");

var $jq5Nf = parcelRequire("jq5Nf");

var $7zaVw = parcelRequire("7zaVw");

var $kxcRq = parcelRequire("kxcRq");

var $aOsut = parcelRequire("aOsut");
const $567a4b851e4bc65e$export$e68aec76e359e401 = (params)=>{
    const { response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return {
                title: url,
                url: url
            };
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return (0, $2zcFi.default)(params);
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            const actions = (0, $VSDnB.fg)('platform-linking-flexible-card-unresolved-action') ? {
                [(0, $8dVIb.InternalActionName).UnresolvedAction]: $567a4b851e4bc65e$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
            } : undefined;
            if ((0, $VSDnB.fg)('smart_links_noun_support')) {
                if ((0, $kYwnb.isEntityPresent)(response)) return {
                    url: url,
                    title: url,
                    linkIcon: (0, $dybmx.extractErrorIcon)(response, status),
                    preview: (0, $jELGn.extractSmartLinkPreviewImage)(response),
                    provider: (0, $jq5Nf.extractSmartLinkProviderIcon)(response),
                    actions: actions
                };
            }
            return {
                url: url,
                title: url,
                linkIcon: (0, $dybmx.extractErrorIcon)(response, status),
                preview: (0, $jELGn.default)(response?.data),
                provider: (0, $jq5Nf.default)(response?.data),
                actions: actions
            };
    }
};
const $567a4b851e4bc65e$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $567a4b851e4bc65e$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const data = response && response.data || (0, $aOsut.getEmptyJsonLd)();
    const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(response) : (0, $f24gj.extractProvider)(data);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            const access = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $567a4b851e4bc65e$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $7zaVw.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $kxcRq.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $7zaVw.messages).connect_link_account_card_name,
                onClick: (0, $kxcRq.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $8dVIb.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $7zaVw.messages).cannot_find_link
            };
    }
};

});
parcelRegister("2zcFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $da041debbb7991f6$export$2e2bcd8739ae039);

var $hWyvy = parcelRequire("hWyvy");
var $8Tcl1 = parcelRequire("8Tcl1");
var $ccpJ1 = parcelRequire("ccpJ1");
var $8UXrm = parcelRequire("8UXrm");
var $4MmCl = parcelRequire("4MmCl");
var $eV8m9 = parcelRequire("eV8m9");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $FcDCF = parcelRequire("FcDCF");

var $VSDnB = parcelRequire("VSDnB");

var $jnrSW = parcelRequire("jnrSW");

var $d4sEp = parcelRequire("d4sEp");

var $9LwFA = parcelRequire("9LwFA");

var $jELGn = parcelRequire("jELGn");

var $bWsp1 = parcelRequire("bWsp1");

var $djFaY = parcelRequire("djFaY");

var $dybmx = parcelRequire("dybmx");

var $jq5Nf = parcelRequire("jq5Nf");

var $iGAv4 = parcelRequire("iGAv4");

var $6N2TY = parcelRequire("6N2TY");
const $da041debbb7991f6$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkUrl)(response) : (0, $8UXrm.extractLink)(data);
    return {
        actions: (0, $d4sEp.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $6N2TY.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $6N2TY.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $6N2TY.extractAttachmentCount)(data),
        authorGroup: (0, $4MmCl.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $eV8m9.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $9LwFA.extractPersonsUpdatedBy)(data),
        commentCount: (0, $6N2TY.extractCommentCount)(data),
        viewCount: (0, $6N2TY.extractViewCount)(data),
        reactCount: (0, $6N2TY.extractReactCount)(data),
        voteCount: (0, $6N2TY.extractVoteCount)(data),
        checklistProgress: (0, $6N2TY.extractChecklistProgress)(data),
        createdBy: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkCreatedBy)(response) : (0, $6N2TY.extractCreatedBy)(data),
        ownedBy: (0, $6N2TY.extractOwnedBy)(data),
        assignedTo: (0, $6N2TY.extractAssignedTo)(data),
        createdOn: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkCreatedOn)(response) : (0, $8Tcl1.extractDateCreated)(data),
        dueOn: (0, $6N2TY.extractDueOn)(data),
        latestCommit: (0, $iGAv4.extractLatestCommit)(data),
        linkIcon: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dybmx.extractSmartLinkIcon)(response) : (0, $dybmx.extractLinkIcon)(response, renderers),
        location: (0, $6N2TY.extractLocation)(data),
        modifiedBy: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkModifiedBy)(response) : (0, $6N2TY.extractModifiedBy)(data),
        modifiedOn: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkModifiedOn)(response) : (0, $ccpJ1.extractDateUpdated)(data),
        preview: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $jELGn.extractSmartLinkPreviewImage)(response) : (0, $jELGn.default)(data),
        priority: (0, $bWsp1.default)(data),
        provider: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $jq5Nf.extractSmartLinkProviderIcon)(response) : (0, $jq5Nf.default)(data),
        programmingLanguage: (0, $6N2TY.extractProgrammingLanguage)(data),
        readTime: (0, $6N2TY.extractReadTime)(data),
        sentOn: (0, $6N2TY.extractSentOn)(data),
        snippet: (0, $jnrSW.extractSummary)(data) || undefined,
        sourceBranch: (0, $6N2TY.extractSourceBranch)(data),
        state: (0, $djFaY.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $6N2TY.extractSubscriberCount)(data),
        subTasksProgress: (0, $6N2TY.extractSubTasksProgress)(data),
        storyPoints: (0, $6N2TY.extractStoryPoints)(data),
        targetBranch: (0, $6N2TY.extractTargetBranch)(data),
        title: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkTitle)(response) || url : (0, $iPUv2.extractTitle)(data) || url,
        url: url,
        ari: (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkAri)(response) : (0, $hWyvy.extractAri)(data),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(data)
        }
    };
};
var $da041debbb7991f6$export$2e2bcd8739ae039 = $da041debbb7991f6$var$extractFlexibleUiContext;

});
parcelRegister("jnrSW", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $82a2487542e3dcba$export$db5a8500f6b6286e);
const $82a2487542e3dcba$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("d4sEp", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $c3cafd9d828d6c09$export$abe8d0ca1daa1755);

var $8dVIb = parcelRequire("8dVIb");

var $4ma4m = parcelRequire("4ma4m");

var $f5eJz = parcelRequire("f5eJz");

var $kh3Vl = parcelRequire("kh3Vl");

var $gIJxe = parcelRequire("gIJxe");

var $4DFf8 = parcelRequire("4DFf8");

var $joFPX = parcelRequire("joFPX");

var $ljBcB = parcelRequire("ljBcB");
const $c3cafd9d828d6c09$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $8dVIb.ActionName).CopyLinkAction]: (0, $kh3Vl.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $8dVIb.ActionName).DownloadAction]: (0, $gIJxe.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $8dVIb.ActionName).FollowAction]: (0, $4DFf8.default)(response, actionOptions, id),
        [(0, $8dVIb.ActionName).PreviewAction]: (0, $joFPX.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $8dVIb.ActionName).AutomationAction]: (0, $f5eJz.extractAutomationAction)(response),
        [(0, $8dVIb.InternalActionName).AISummaryAction]: (0, $4ma4m.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $8dVIb.InternalActionName).ViewRelatedLinksAction]: (0, $ljBcB.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4ma4m", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $8cdc7ca64eb62313$export$e7f7a50a8b8932df);

var $evnkj = parcelRequire("evnkj");

var $cnaAy = parcelRequire("cnaAy");

var $dn5wJ = parcelRequire("dn5wJ");
const $8cdc7ca64eb62313$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).AISummaryAction, actionOptions) || !(0, $cnaAy.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("evnkj", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $6626d2f2bee6ec27$export$2487b058456cca75);
const $6626d2f2bee6ec27$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("f5eJz", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $ca59c43d6a564063$export$f913cc6abf3ec084);

var $8dVIb = parcelRequire("8dVIb");
const $ca59c43d6a564063$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $8dVIb.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("kh3Vl", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $156b119eb968da41$export$31ddd5c40039ce53);

var $ewRjE = parcelRequire("ewRjE");
const $156b119eb968da41$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $ewRjE.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ewRjE", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $f95950db90c61c64$export$5ec86886067a062d);

var $8UXrm = parcelRequire("8UXrm");

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");
const $f95950db90c61c64$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $8UXrm.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $8dVIb.ActionName).CopyLinkAction,
        definitionId: (0, $fgpl1.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fgpl1.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fgpl1.getResourceType)(response)
    };
};

});


parcelRegister("gIJxe", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $02d459bef4b0b3b6$export$f6c386869a352b1f);

var $gOP67 = parcelRequire("gOP67");
const $02d459bef4b0b3b6$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $gOP67.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("gOP67", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $8cd6513c4477faeb$export$ea97cd34c2ca86de);

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $kxcRq = parcelRequire("kxcRq");

var $evnkj = parcelRequire("evnkj");

var $5U430 = parcelRequire("5U430");

var $e2ZVS = parcelRequire("e2ZVS");
const $8cd6513c4477faeb$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $5U430.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $e2ZVS.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $kxcRq.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $8dVIb.ActionName).DownloadAction,
            definitionId: (0, $fgpl1.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $fgpl1.getExtensionKey)(response),
            id: id,
            resourceType: (0, $fgpl1.getResourceType)(response)
        };
    }
};

});
parcelRegister("5U430", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $76a260c3f7e7678d$export$8f031784a3a03b23);
const $76a260c3f7e7678d$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("e2ZVS", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $ef91c3db80f281ff$export$9682e3ac9d184e95);
const $ef91c3db80f281ff$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("4DFf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a99662467a25c4e$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");
var $FcDCF = parcelRequire("FcDCF");

var $T540Y = parcelRequire("T540Y");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $dn5wJ = parcelRequire("dn5wJ");

var $j4IjY = parcelRequire("j4IjY");
const $5a99662467a25c4e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $fgpl1.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $j4IjY.default)(data);
    const type = (0, $FcDCF.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $T540Y.SmartLinkActionType).FollowEntityAction || actionName === (0, $T540Y.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $8UXrm.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $T540Y.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $5a99662467a25c4e$export$2e2bcd8739ae039 = $5a99662467a25c4e$var$extractFollowAction;

});
parcelRegister("j4IjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $491a605bed171307$export$2e2bcd8739ae039);
const $491a605bed171307$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $491a605bed171307$export$2e2bcd8739ae039 = $491a605bed171307$var$extractServerAction;

});


parcelRegister("joFPX", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $67a9503b149a9ddf$export$9f0d9100b079448);

var $k1bRY = parcelRequire("k1bRY");
const $67a9503b149a9ddf$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $k1bRY.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("k1bRY", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $ae749ffcba0ba676$export$caf83f49e52ac0bb);

var $8UXrm = parcelRequire("8UXrm");
var $k9B19 = parcelRequire("k9B19");
var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");
var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $2Fcti = parcelRequire("2Fcti");

var $hYF5d = parcelRequire("hYF5d");

var $V4gq9 = parcelRequire("V4gq9");

var $dybmx = parcelRequire("dybmx");

var $gOP67 = parcelRequire("gOP67");

var $eBrh9 = parcelRequire("eBrh9");
const $ae749ffcba0ba676$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $k9B19.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $8UXrm.extractLink)(data);
        const extensionKey = (0, $fgpl1.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $2Fcti.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $gOP67.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $eBrh9.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
                    isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
                    linkIcon: (0, $dybmx.extractLinkIcon)(response),
                    providerName: (0, $f24gj.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: src,
                    title: (0, $iPUv2.extractTitle)(data),
                    url: url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $8dVIb.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("2Fcti", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2555d47e7922f4ad$export$7859f96cd8cff034);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");
const $2555d47e7922f4ad$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2555d47e7922f4ad$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("9RmOY"));
    (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).render(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Modal.default, {
            ...props,
            iframeName: $2555d47e7922f4ad$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("9RmOY", function(module, exports) {

let $72dac41cf87d8065$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72dac41cf87d8065$var$load("ffQaD"),
    $72dac41cf87d8065$var$load("kvRbA"),
    $72dac41cf87d8065$var$load("lJvDT")
]).then(()=>parcelRequire('amcti'));

});


parcelRegister("hYF5d", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $693566d688a51b19$export$38d755f52cdf4acb);

var $dvNbb = parcelRequire("dvNbb");
const $693566d688a51b19$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $dvNbb.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("dvNbb", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $9b14bed6babdc545$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $9b14bed6babdc545$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $9b14bed6babdc545$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $9b14bed6babdc545$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $9b14bed6babdc545$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $9b14bed6babdc545$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $9b14bed6babdc545$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $9b14bed6babdc545$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $9b14bed6babdc545$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $9b14bed6babdc545$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $9b14bed6babdc545$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $9b14bed6babdc545$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $9b14bed6babdc545$export$fe44ce30fd8d131b);
const $9b14bed6babdc545$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9b14bed6babdc545$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9b14bed6babdc545$export$84a73a0383f58180 = 'JiraTask';
const $9b14bed6babdc545$export$c6c83963a9378a67 = 'JiraSubTask';
const $9b14bed6babdc545$export$58af3c426c111a6d = 'JiraStory';
const $9b14bed6babdc545$export$ac9898a63417219e = 'JiraBug';
const $9b14bed6babdc545$export$54db5e3fb12e39cd = 'JiraEpic';
const $9b14bed6babdc545$export$2f54a5a217202c85 = 'JiraIncident';
const $9b14bed6babdc545$export$d097371052bfc411 = 'JiraServiceRequest';
const $9b14bed6babdc545$export$efd9452ad16c6676 = 'JiraChange';
const $9b14bed6babdc545$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9b14bed6babdc545$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $9b14bed6babdc545$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});


parcelRegister("V4gq9", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $635b28bc2d55c0b7$export$4f3ffbb500daac5a);
const $635b28bc2d55c0b7$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("dybmx", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $d7af83be96aed150$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $d7af83be96aed150$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $d7af83be96aed150$export$35040aed9264b11c);

var $kYwnb = parcelRequire("kYwnb");

var $8dVIb = parcelRequire("8dVIb");

var $9fbCf = parcelRequire("9fbCf");

var $5ZCMp = parcelRequire("5ZCMp");

var $jq5Nf = parcelRequire("jq5Nf");
const $d7af83be96aed150$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $9fbCf.default)(data, renderers);
    return {
        ...(0, $5ZCMp.default)(data),
        render: render
    };
};
const $d7af83be96aed150$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $jq5Nf.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $8dVIb.IconType).Forbidden
            };
        case (0, $8dVIb.SmartLinkStatus).NotFound:
            return {
                icon: (0, $8dVIb.IconType).Error
            };
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $8dVIb.IconType).Default
            };
    }
};
const $d7af83be96aed150$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityIcon)(response);
    return $d7af83be96aed150$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("9fbCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc79bd445a96437$export$2e2bcd8739ae039);
const $3cc79bd445a96437$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $3cc79bd445a96437$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $3cc79bd445a96437$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $3cc79bd445a96437$export$2e2bcd8739ae039 = $3cc79bd445a96437$var$extractIconRenderer;

});

parcelRegister("5ZCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f6ae1c2ef653082$export$2e2bcd8739ae039);

var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");

var $3TBiE = parcelRequire("3TBiE");

var $4DoyP = parcelRequire("4DoyP");

var $a4RsY = parcelRequire("a4RsY");

var $dvNbb = parcelRequire("dvNbb");

var $1gwFB = parcelRequire("1gwFB");

var $liAf6 = parcelRequire("liAf6");

var $cKwAC = parcelRequire("cKwAC");

var $jq5Nf = parcelRequire("jq5Nf");

var $iWNKM = parcelRequire("iWNKM");
const $4f6ae1c2ef653082$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $a4RsY.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $4f6ae1c2ef653082$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0] : type;
};
const $4f6ae1c2ef653082$var$isJiraProvider = (provider)=>provider === (0, $dvNbb.JIRA_GENERATOR_ID);
function $4f6ae1c2ef653082$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $liAf6.default)(fileFormat);
    const documentTypeIcon = $4f6ae1c2ef653082$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $1gwFB.default)(type, label, providerId);
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $4f6ae1c2ef653082$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $8dVIb.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $8dVIb.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $8dVIb.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $8dVIb.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $8dVIb.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $8dVIb.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $8dVIb.IconType).Task,
                label: taskLabel
            };
            if ($4f6ae1c2ef653082$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $4f6ae1c2ef653082$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $cKwAC.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $4f6ae1c2ef653082$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $iPUv2.extractTitle)(data);
    const type = $4f6ae1c2ef653082$var$extractType(data);
    const urlIcon = (0, $iWNKM.default)(data.icon, label);
    const providerIcon = (0, $jq5Nf.default)(data);
    return $4f6ae1c2ef653082$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $4f6ae1c2ef653082$export$2e2bcd8739ae039 = $4f6ae1c2ef653082$var$extractJsonldDataIcon;

});
parcelRegister("3TBiE", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $99be71cd5a3b0274$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $99be71cd5a3b0274$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("4DoyP", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4);
const $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("a4RsY", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $81dd8ddf907a1532$export$ed3fd59180514d27);

var $cuw1y = parcelRequire("cuw1y");
const $81dd8ddf907a1532$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("1gwFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8e24b11256d3ae$export$2e2bcd8739ae039);

var $f24gj = parcelRequire("f24gj");

var $8dVIb = parcelRequire("8dVIb");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $2f8e24b11256d3ae$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $8dVIb.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $f24gj.isConfluenceGenerator)(providerId)) return {
                icon: (0, $8dVIb.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $8dVIb.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $8dVIb.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $2f8e24b11256d3ae$export$2e2bcd8739ae039 = $2f8e24b11256d3ae$var$extractDocumentTypeIcon;

});

parcelRegister("cKwAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a727b28b60947e$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $97a727b28b60947e$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $8dVIb.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $8dVIb.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $8dVIb.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $8dVIb.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $8dVIb.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $8dVIb.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $8dVIb.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $8dVIb.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $8dVIb.IconType).Task,
                label: label
            };
    }
};
var $97a727b28b60947e$export$2e2bcd8739ae039 = $97a727b28b60947e$var$extractJiraTaskIcon;

});

parcelRegister("jq5Nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e0775b3750bf70$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $87e0775b3750bf70$export$5def189f04eea025);

var $kYwnb = parcelRequire("kYwnb");
var $iPUv2 = parcelRequire("iPUv2");

var $8dVIb = parcelRequire("8dVIb");

var $dvNbb = parcelRequire("dvNbb");

var $iWNKM = parcelRequire("iWNKM");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $87e0775b3750bf70$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $iPUv2.extractTitle)(data);
    if (provider === (0, $dvNbb.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $8dVIb.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $dvNbb.JIRA_GENERATOR_ID)) return {
        icon: (0, $8dVIb.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $iWNKM.default)(icon, label);
};
var $87e0775b3750bf70$export$2e2bcd8739ae039 = $87e0775b3750bf70$var$extractProviderIcon;
const $87e0775b3750bf70$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const provider = (0, $kYwnb.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $dvNbb.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $8dVIb.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $dvNbb.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $8dVIb.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $kYwnb.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $87e0775b3750bf70$var$extractProviderIcon(response.data);
};

});
parcelRegister("iWNKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8418e6f5863288f0$export$2e2bcd8739ae039);

var $cuw1y = parcelRequire("cuw1y");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $8418e6f5863288f0$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $cuw1y.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $8418e6f5863288f0$export$2e2bcd8739ae039 = $8418e6f5863288f0$var$extractUrlIcon;

});




parcelRegister("eBrh9", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $d2874e5e099b8c6e$export$88c5813cfbbe4e4c);

var $8UXrm = parcelRequire("8UXrm");

var $dn5wJ = parcelRequire("dn5wJ");

var $fgpl1 = parcelRequire("fgpl1");

var $kxcRq = parcelRequire("kxcRq");

var $evnkj = parcelRequire("evnkj");

var $5U430 = parcelRequire("5U430");
const $d2874e5e099b8c6e$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $8UXrm.extractLink)(data);
    const viewActionExists = (0, $5U430.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $kxcRq.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $fgpl1.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $fgpl1.getExtensionKey)(response),
        id: id,
        resourceType: (0, $fgpl1.getResourceType)(response)
    };
};

});



parcelRegister("ljBcB", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $a600a657ec97b3e1$export$debae7424a0231b9);

var $hWyvy = parcelRequire("hWyvy");
const $a600a657ec97b3e1$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hWyvy.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("9LwFA", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $4c9ea88664552b6e$export$216e4f6aa7c169b8);

var $o6TQ1 = parcelRequire("o6TQ1");
var $aj6Xc = parcelRequire("aj6Xc");
const $4c9ea88664552b6e$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $o6TQ1.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $aj6Xc.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("o6TQ1", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $e9d0787cbe8b8bff$export$6281d080d62a0719);

var $aj6Xc = parcelRequire("aj6Xc");
const $e9d0787cbe8b8bff$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $aj6Xc.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $aj6Xc.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("bWsp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $92024e0264c50850$export$2e2bcd8739ae039);

var $cuw1y = parcelRequire("cuw1y");

var $8dVIb = parcelRequire("8dVIb");
const $92024e0264c50850$var$priorityMapper = {
    blocker: (0, $8dVIb.IconType).PriorityBlocker,
    critical: (0, $8dVIb.IconType).PriorityCritical,
    high: (0, $8dVIb.IconType).PriorityHigh,
    highest: (0, $8dVIb.IconType).PriorityHighest,
    low: (0, $8dVIb.IconType).PriorityLow,
    lowest: (0, $8dVIb.IconType).PriorityLowest,
    major: (0, $8dVIb.IconType).PriorityMajor,
    medium: (0, $8dVIb.IconType).PriorityMedium,
    minor: (0, $8dVIb.IconType).PriorityMinor,
    trivial: (0, $8dVIb.IconType).PriorityTrivial,
    undefined: (0, $8dVIb.IconType).PriorityUndefined
};
const $92024e0264c50850$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $92024e0264c50850$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $92024e0264c50850$export$2e2bcd8739ae039 = $92024e0264c50850$var$extractPriority;

});

parcelRegister("djFaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c680025bc04d725$export$2e2bcd8739ae039);

var $8UXrm = parcelRequire("8UXrm");

var $fgpl1 = parcelRequire("fgpl1");

var $evnkj = parcelRequire("evnkj");

var $dn5wJ = parcelRequire("dn5wJ");

var $k1bRY = parcelRequire("k1bRY");

var $eL1Oa = parcelRequire("eL1Oa");

var $j4IjY = parcelRequire("j4IjY");
const $9c680025bc04d725$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $9c680025bc04d725$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $fgpl1.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $j4IjY.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $8UXrm.extractLink)(data);
    const invokePreviewAction = response ? (0, $k1bRY.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $9c680025bc04d725$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $eL1Oa.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $evnkj.canShowAction)((0, $dn5wJ.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $9c680025bc04d725$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $9c680025bc04d725$export$2e2bcd8739ae039 = $9c680025bc04d725$var$extractState;

});
parcelRegister("eL1Oa", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $00b49e71ec2a1469$export$e5da155556a77bca);

var $FcDCF = parcelRequire("FcDCF");

var $hJJo2 = parcelRequire("hJJo2");

var $8KYrd = parcelRequire("8KYrd");

var $1fxuS = parcelRequire("1fxuS");

var $a4RsY = parcelRequire("a4RsY");
const $00b49e71ec2a1469$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $FcDCF.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $8KYrd.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $1fxuS.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $00b49e71ec2a1469$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $hJJo2.extractState)(jsonLd);
    }
};
const $00b49e71ec2a1469$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $a4RsY.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("hJJo2", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $23353713d30390cb$export$5e4074cbce6574c7);

var $5Sb4A = parcelRequire("5Sb4A");
// Maps accent color short names to their corresponding background and text colors
const $23353713d30390cb$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $23353713d30390cb$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $5Sb4A.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $5Sb4A.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $23353713d30390cb$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("5Sb4A", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $0823e05e6f9f26fe$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $0823e05e6f9f26fe$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $0823e05e6f9f26fe$export$772610da74ddbc07);
const $0823e05e6f9f26fe$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $0823e05e6f9f26fe$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $0823e05e6f9f26fe$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $0823e05e6f9f26fe$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $0823e05e6f9f26fe$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("8KYrd", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $6e0524caff97ae26$export$962a8da34cf78a4f);

var $5Sb4A = parcelRequire("5Sb4A");
const $6e0524caff97ae26$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($6e0524caff97ae26$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $6e0524caff97ae26$var$extractTagItem(tag);
    }
};
const $6e0524caff97ae26$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $5Sb4A.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("1fxuS", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $4b88cdff9f070a4a$export$7698df1946deda72);
const $4b88cdff9f070a4a$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("iGAv4", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $0e72a17e0fb58d4d$export$f222392162cff0d8);
const $0e72a17e0fb58d4d$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("82kHN", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $315bbe8c3c3dac23$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $315bbe8c3c3dac23$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $315bbe8c3c3dac23$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $315bbe8c3c3dac23$export$9671929f11bd4ad8);

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $6N2TY = parcelRequire("6N2TY");

var $fgpl1 = parcelRequire("fgpl1");
const $315bbe8c3c3dac23$var$baseTopMetadata = [
    {
        name: (0, $8dVIb.ElementName).ModifiedOn
    },
    {
        name: (0, $8dVIb.ElementName).AttachmentCount
    },
    {
        name: (0, $8dVIb.ElementName).SubscriberCount
    },
    {
        name: (0, $8dVIb.ElementName).VoteCount
    },
    {
        name: (0, $8dVIb.ElementName).DueOn
    },
    {
        name: (0, $8dVIb.ElementName).ReadTime
    }
];
const $315bbe8c3c3dac23$var$baseBottomMetaData = [
    {
        name: (0, $8dVIb.ElementName).ReactCount
    },
    {
        name: (0, $8dVIb.ElementName).CommentCount
    },
    {
        name: (0, $8dVIb.ElementName).ViewCount
    },
    {
        name: (0, $8dVIb.ElementName).Priority
    },
    {
        name: (0, $8dVIb.ElementName).SubTasksProgress
    },
    {
        name: (0, $8dVIb.ElementName).ChecklistProgress
    }
];
const $315bbe8c3c3dac23$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $fgpl1.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $8dVIb.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $8dVIb.ElementName).AuthorGroup
        },
        {
            name: (0, $8dVIb.ElementName).CreatedBy
        },
        ...$315bbe8c3c3dac23$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $315bbe8c3c3dac23$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $8dVIb.ElementName).LatestCommit
                    },
                    {
                        name: (0, $8dVIb.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            if ((0, $VSDnB.fg)('expandable_smart_links_for_scorecards_v2')) return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $6N2TY.extractOwnedBy)(data) ? [
                    {
                        name: (0, $8dVIb.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).OwnedBy
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).AppliedToComponentsCount
                    },
                    ...$315bbe8c3c3dac23$var$baseBottomMetaData
                ]
            };
            else return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $6N2TY.extractOwnedBy)(data) ? [
                    {
                        name: (0, $8dVIb.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).OwnedBy
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = !!data['atlassian:ownedBy'] ?? false;
            let topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).AuthorGroup
                },
                {
                    name: (0, $8dVIb.ElementName).CreatedBy
                },
                {
                    name: (0, $8dVIb.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).AssignedToGroup
                },
                {
                    name: (0, $8dVIb.ElementName).AssignedTo
                },
                {
                    name: (0, $8dVIb.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan && (0, $VSDnB.fg)('smart_links_for_plans_platform')) topMetadata = [
                {
                    name: (0, $8dVIb.ElementName).OwnedByGroup
                },
                {
                    name: (0, $8dVIb.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).StoryPoints
                    },
                    {
                        name: (0, $8dVIb.ElementName).Priority
                    },
                    {
                        name: (0, $8dVIb.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $8dVIb.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).ReactCount
                    },
                    {
                        name: (0, $8dVIb.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $8dVIb.ElementName).CollaboratorGroup
                    },
                    ...$315bbe8c3c3dac23$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $315bbe8c3c3dac23$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true
};
const $315bbe8c3c3dac23$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $8dVIb.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $8dVIb.SmartLinkSize).Large
};
const $315bbe8c3c3dac23$export$9671929f11bd4ad8 = {
    placement: (0, $8dVIb.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("1dEUF", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $f3e0678ba71181d8$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f3e0678ba71181d8$var$flexibleBlockCardStyle = null;
const $f3e0678ba71181d8$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("kQeqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ee13c9f8fe006$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $bwyQI = parcelRequire("bwyQI");

var $3G2gB = parcelRequire("3G2gB");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8PVtF = parcelRequire("8PVtF");

var $eCNt3 = parcelRequire("eCNt3");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $aOsut = parcelRequire("aOsut");

var $k39kU = parcelRequire("k39kU");

var $jgxl3 = parcelRequire("jgxl3");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $9b3ee13c9f8fe006$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $9b3ee13c9f8fe006$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intl = (0, $koVbs.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
    const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(details?.data);
    const providerName = provider?.text || '';
    const messageContext = (0, $5uXOq.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
            children: (0, $eCNt3.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $5uXOq.useMemo)(()=>{
        return (0, $8PVtF.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $5uXOq.useMemo)(()=>{
        const descriptor = (0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $jgxl3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $jgxl3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt"
                ])
            })
        ]
    });
};
var $9b3ee13c9f8fe006$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($9b3ee13c9f8fe006$var$ForbiddenView);

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});

parcelRegister("cL21r", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $4b469267e6199ae7$export$d14c2a6dee946f52);

var $7zaVw = parcelRequire("7zaVw");
const $4b469267e6199ae7$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $7zaVw.messages)) return (0, $7zaVw.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("jgxl3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $4f0bf32284a5caf2$export$59f8830fb5467e35);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $4f0bf32284a5caf2$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $8dVIb.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("7wrOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d316574b181170a3$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $bwyQI = parcelRequire("bwyQI");

var $3G2gB = parcelRequire("3G2gB");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $k39kU = parcelRequire("k39kU");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $d316574b181170a3$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d316574b181170a3$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $koVbs.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $5uXOq.useMemo)(()=>{
        const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(details?.data);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $5uXOq.useMemo)(()=>intl.formatMessage((0, $7zaVw.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $5uXOq.useMemo)(()=>({
            descriptor: (0, $7zaVw.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Mvli.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k39kU.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt"
                ])
            })
        ]
    });
};
var $d316574b181170a3$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($d316574b181170a3$var$NotFoundView);

});

parcelRegister("kc7yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b1742d0d340851$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $9fYWd = parcelRequire("9fYWd");

var $ietxm = parcelRequire("ietxm");
var $gg6Qm = parcelRequire("gg6Qm");
var $hYQw7 = parcelRequire("hYQw7");
var $1JaZ4 = parcelRequire("1JaZ4");
var $buvhv = parcelRequire("buvhv");

var $82kHN = parcelRequire("82kHN");

var $1dEUF = parcelRequire("1dEUF");
const $49b1742d0d340851$var$titleBlockCssOld = null;
const $49b1742d0d340851$var$titleBlockCss = null;
const $49b1742d0d340851$var$footerBlockCssOld = null;
const $49b1742d0d340851$var$footerBlockCss = null;
const $49b1742d0d340851$var$footerBlockSafariStyles = null;
const $49b1742d0d340851$var$metadataBlockCssOld = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $49b1742d0d340851$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $5uXOq.useState)(false);
    const { safari: safari = false } = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>(0, $b6uPu.browser)(), []) : {};
    (0, $5uXOq.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $82kHN.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $5uXOq.useMemo)(()=>[
            {
                name: (0, $8dVIb.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $8dVIb.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $8dVIb.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const status = cardState.status;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fYWd.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: (0, $82kHN.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $buvhv.default), {
                ...(0, $82kHN.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $8dVIb.ElementName).Location
                    }
                ],
                metadataPosition: (0, $8dVIb.SmartLinkPosition).Top,
                status: status,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9 _2yhz14q2" : "_zulpcxkx _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: topMetadata,
                maxLines: 1,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_wwyvidpf _1sxbcxkx _i8d01j6v"
                ])
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1JaZ4.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gg6Qm.default), {
                primary: bottomMetadata,
                maxLines: 1,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_wwyvidpf _1sxbcxkx _i8d01j6v"
                ])
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYQw7.default), {
                ...(0, $82kHN.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                },
                status: (0, $8dVIb.SmartLinkStatus).Resolved
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ietxm.default), {
                actions: footerActions,
                status: (0, $8dVIb.SmartLinkStatus).Resolved,
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb" : "_4t3i1k8s _g0eioxwj _1qryoxwj _sxbroxwj _1gyioxwj",
                    safari && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $49b1742d0d340851$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($49b1742d0d340851$var$ResolvedView);

});

parcelRegister("1PV7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $163450cca1677688$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $fgpl1 = parcelRequire("fgpl1");

var $3PAn6 = parcelRequire("3PAn6");

var $1CwNu = parcelRequire("1CwNu");

var $3Mvli = parcelRequire("3Mvli");

var $1dEUF = parcelRequire("1dEUF");
const $163450cca1677688$var$contentStylesOld = null;
const $163450cca1677688$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $163450cca1677688$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const data = cardState.details?.data;
    const providerName = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(cardState.details)?.text : (0, $f24gj.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>onAuthorize ? [
            (0, $1CwNu.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Mvli.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $bwpsq.default)([
                (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _syaz1fxt _19pku2gc" : "_11c8dcr7 _syaz131l _19pkcxkx"
            ]),
            children: content
        })
    });
};
var $163450cca1677688$export$2e2bcd8739ae039 = (0, $1dEUF.withFlexibleUIBlockCardStyle)($163450cca1677688$var$UnauthorisedView);

});
parcelRegister("1CwNu", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $712c9d89e4ab58d6$export$34cef2b72294bd84);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $712c9d89e4ab58d6$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $8dVIb.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("7RcXv", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $ab3d9e42a13cc11c$export$6789d7ecdc77631b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $8PVtF = parcelRequire("8PVtF");

var $lNtMX = parcelRequire("lNtMX");

var $ctwhA = parcelRequire("ctwhA");

var $fgpl1 = parcelRequire("fgpl1");

var $6TU5j = parcelRequire("6TU5j");

var $aOsut = parcelRequire("aOsut");

var $7xFN9 = parcelRequire("7xFN9");

var $kc7yu = parcelRequire("kc7yu");

var $ir8YW = parcelRequire("ir8YW");

var $iJqW5 = parcelRequire("iJqW5");

var $39ESV = parcelRequire("39ESV");

var $5VvNe = parcelRequire("5VvNe");

var $d0weD = parcelRequire("d0weD");

var $4WY3L = parcelRequire("4WY3L");
const $ab3d9e42a13cc11c$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $fgpl1.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $fgpl1.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $6TU5j.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            });
        case 'resolved':
            const resolvedViewProps = (0, $lNtMX.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $VSDnB.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $7xFN9.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                    const unauthViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WY3L.default), {
                        context: unauthViewProps.context,
                        extensionKey: extensionKey,
                        frameStyle: frameStyle,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        inheritDimensions: inheritDimensions,
                        isSelected: isSelected,
                        onAuthorize: handleAuthorize,
                        onClick: handleFrameClick,
                        testId: testId,
                        url: unauthViewProps.link
                    });
                }
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0weD.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $ctwhA.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ir8YW.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc7yu.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WY3L.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d0weD.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39ESV.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $lNtMX.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5VvNe.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iJqW5.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("lNtMX", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $0b9efe0d16e320ac$export$d6cf81ca6e68bcc3);

var $8UXrm = parcelRequire("8UXrm");
var $k9B19 = parcelRequire("k9B19");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $FcDCF = parcelRequire("FcDCF");

var $VSDnB = parcelRequire("VSDnB");

var $aOsut = parcelRequire("aOsut");

var $ejTRu = parcelRequire("ejTRu");

var $hYF5d = parcelRequire("hYF5d");

var $V4gq9 = parcelRequire("V4gq9");
const $0b9efe0d16e320ac$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $k9B19.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
const $0b9efe0d16e320ac$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $aOsut.getEmptyJsonLd)();
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return {
        link: (0, $dhQ1x.extractSmartLinkUrl)(response) || '',
        title: (0, $dhQ1x.extractSmartLinkTitle)(response),
        context: (0, $ejTRu.extractSmartLinkContext)(response),
        preview: (0, $dhQ1x.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
        isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
    return {
        link: (0, $8UXrm.extractLink)(jsonLd) || '',
        title: (0, $iPUv2.extractTitle)(jsonLd),
        context: (0, $ejTRu.generateContext)(jsonLd),
        preview: $0b9efe0d16e320ac$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $V4gq9.extractIsTrusted)(meta),
        isSupportTheming: (0, $hYF5d.extractIsSupportTheming)(meta),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
};

});
parcelRegister("ejTRu", function(module, exports) {

$parcel$export(module.exports, "generateContext", () => $a8e47739da07a172$export$8dcb07487061d3c1);
$parcel$export(module.exports, "extractSmartLinkContext", () => $a8e47739da07a172$export$6ec4b6b24dec9156);

var $kYwnb = parcelRequire("kYwnb");
var $f24gj = parcelRequire("f24gj");
var $cuw1y = parcelRequire("cuw1y");

var $3TBiE = parcelRequire("3TBiE");

var $8PVtF = parcelRequire("8PVtF");
function $a8e47739da07a172$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $f24gj.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $cuw1y.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $f24gj.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $a8e47739da07a172$export$6ec4b6b24dec9156(response) {
    if ((0, $kYwnb.isEntityPresent)(response)) return (0, $kYwnb.extractEntityProvider)(response);
    return $a8e47739da07a172$export$8dcb07487061d3c1(response?.data);
}

});


parcelRegister("ctwhA", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $240edc2fd862d8a6$export$68e1703c529dc7e0);

var $kYwnb = parcelRequire("kYwnb");
var $8UXrm = parcelRequire("8UXrm");
var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");
var $iPUv2 = parcelRequire("iPUv2");
var $FcDCF = parcelRequire("FcDCF");

var $VSDnB = parcelRequire("VSDnB");

var $2Gj5n = parcelRequire("2Gj5n");

var $eL1Oa = parcelRequire("eL1Oa");

var $8Kv84 = parcelRequire("8Kv84");

var $6tk3N = parcelRequire("6tk3N");

var $dvNbb = parcelRequire("dvNbb");
const $240edc2fd862d8a6$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $f24gj.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $dvNbb.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $dvNbb.JIRA_GENERATOR_ID)) return (0, $2Gj5n.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $2Gj5n.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $240edc2fd862d8a6$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $kYwnb.isEntityPresent)(response)) {
        const provider = (0, $kYwnb.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more nouns
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $240edc2fd862d8a6$var$extractInlineIcon(response?.data, showLabel);
};
const $240edc2fd862d8a6$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data;
    if ((0, $VSDnB.fg)('smart_links_noun_support')) return {
        link: (0, $dhQ1x.extractSmartLinkUrl)(response),
        title: (0, $dhQ1x.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $240edc2fd862d8a6$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more nouns we can incorporate these fields
        lozenge: (0, $eL1Oa.extractLozenge)(jsonLd),
        titleTextColor: (0, $8Kv84.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $6tk3N.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
    return {
        link: (0, $8UXrm.extractLink)(jsonLd),
        title: (0, $iPUv2.extractTitle)(jsonLd, removeTextHighlightingFromTitle),
        lozenge: (0, $eL1Oa.extractLozenge)(jsonLd),
        icon: $240edc2fd862d8a6$var$extractInlineIcon(jsonLd, showLabel),
        titleTextColor: (0, $8Kv84.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $6tk3N.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $FcDCF.extractType)(jsonLd)
        }
    };
};

});
parcelRegister("2Gj5n", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $b9f947e5dca4cb3d$export$64bdf1f5e49e8626);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4sBeG = parcelRequire("4sBeG");

var $ezu4w = parcelRequire("ezu4w");

var $bPjbr = parcelRequire("bPjbr");

var $6qWjs = parcelRequire("6qWjs");

var $ercGv = parcelRequire("ercGv");

var $ckyDP = parcelRequire("ckyDP");

var $f24gj = parcelRequire("f24gj");
var $iPUv2 = parcelRequire("iPUv2");
var $cuw1y = parcelRequire("cuw1y");

var $kxcRq = parcelRequire("kxcRq");

var $a4RsY = parcelRequire("a4RsY");

var $6mmu7 = parcelRequire("6mmu7");

var $eeWf5 = parcelRequire("eeWf5");

var $i6XYa = parcelRequire("i6XYa");

var $3TBiE = parcelRequire("3TBiE");

var $4DoyP = parcelRequire("4DoyP");
const $b9f947e5dca4cb3d$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $iPUv2.extractTitle)(jsonLd),
        provider: (0, $f24gj.extractProvider)(jsonLd),
        fileFormat: (0, $6mmu7.extractFileFormat)(jsonLd),
        taskType: (0, $a4RsY.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $cuw1y.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0];
        return $b9f947e5dca4cb3d$var$extractIconByType(highestPriorityType, opts);
    } else return $b9f947e5dca4cb3d$var$extractIconByType(type, opts);
};
function $b9f947e5dca4cb3d$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bPjbr.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6qWjs.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4sBeG.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ezu4w.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $i6XYa.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $b9f947e5dca4cb3d$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $b9f947e5dca4cb3d$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $kxcRq.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $b9f947e5dca4cb3d$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $eeWf5.extractIconFromDocument)(type, opts);
        default:
            return $b9f947e5dca4cb3d$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("4sBeG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6b6e63637c1c2754$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd5a8d264ca7a1e79e3d50d476094729>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4iPF3 = parcelRequire("4iPF3");

var $VSDnB = parcelRequire("VSDnB");

var $9ORcR = parcelRequire("9ORcR");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6b6e63637c1c2754$var$Branch16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ORcR.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9ORcR.default), {
        label: label,
        testId: testId
    });
};
$6b6e63637c1c2754$var$Branch16Icon.displayName = 'Branch16Icon';
var $6b6e63637c1c2754$export$2e2bcd8739ae039 = $6b6e63637c1c2754$var$Branch16Icon;

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9ORcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1801d86c423f8469$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::371b0d35eca629b3ebb5e933140aedc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $1801d86c423f8469$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$1801d86c423f8469$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1801d86c423f8469$export$2e2bcd8739ae039 = $1801d86c423f8469$var$Branch16Icon;

});


parcelRegister("ezu4w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f0dda3514063910b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2e0cf5105bbbaa2e318211c53ac326e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $jSlaY = parcelRequire("jSlaY");

var $VSDnB = parcelRequire("VSDnB");

var $RsLsu = parcelRequire("RsLsu");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f0dda3514063910b$var$Code16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jSlaY))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RsLsu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RsLsu.default), {
        label: label,
        testId: testId
    });
};
$f0dda3514063910b$var$Code16Icon.displayName = 'Code16Icon';
var $f0dda3514063910b$export$2e2bcd8739ae039 = $f0dda3514063910b$var$Code16Icon;

});
parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("RsLsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffae1b83b5704dc$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a17b0b5d454f4262ba3195f959601cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $7ffae1b83b5704dc$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7ffae1b83b5704dc$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ffae1b83b5704dc$export$2e2bcd8739ae039 = $7ffae1b83b5704dc$var$Code16Icon;

});


parcelRegister("bPjbr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f3351ecfbe1e828a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96efea4cb290db7d8f614246fd62e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $bFklq = parcelRequire("bFklq");

var $VSDnB = parcelRequire("VSDnB");

var $a0LEu = parcelRequire("a0LEu");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f3351ecfbe1e828a$var$Commit16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFklq))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a0LEu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a0LEu.default), {
        label: label,
        testId: testId
    });
};
$f3351ecfbe1e828a$var$Commit16Icon.displayName = 'Commit16Icon';
var $f3351ecfbe1e828a$export$2e2bcd8739ae039 = $f3351ecfbe1e828a$var$Commit16Icon;

});
parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("a0LEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $87782212607829d3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50d5a3bab2c708a6de1c7dc72e3a297a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $87782212607829d3$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$87782212607829d3$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$87782212607829d3$export$2e2bcd8739ae039 = $87782212607829d3$var$Commit16Icon;

});


parcelRegister("6qWjs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1636b9971be53c9b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::499dedcb1e659dc62cb0d811acc9f742>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $hXgVM = parcelRequire("hXgVM");

var $VSDnB = parcelRequire("VSDnB");

var $9VouT = parcelRequire("9VouT");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $1636b9971be53c9b$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hXgVM))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VouT.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VouT.default), {
        label: label,
        testId: testId
    });
};
$1636b9971be53c9b$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $1636b9971be53c9b$export$2e2bcd8739ae039 = $1636b9971be53c9b$var$PullRequest16Icon;

});
parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("9VouT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0bea366084931a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f46cc1f5eba58da93be626b062afbd6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $1a0bea366084931a$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$1a0bea366084931a$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1a0bea366084931a$export$2e2bcd8739ae039 = $1a0bea366084931a$var$PullRequest16Icon;

});


parcelRegister("ercGv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95e8963209f4e129$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb120ef54d45ebd04018c195938778f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4xPlE = parcelRequire("4xPlE");

var $VSDnB = parcelRequire("VSDnB");

var $2BNVE = parcelRequire("2BNVE");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95e8963209f4e129$var$Task16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
        label: label,
        testId: testId
    });
};
$95e8963209f4e129$var$Task16Icon.displayName = 'Task16Icon';
var $95e8963209f4e129$export$2e2bcd8739ae039 = $95e8963209f4e129$var$Task16Icon;

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("2BNVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ed5bdbe4530df8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $95ed5bdbe4530df8$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$95ed5bdbe4530df8$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$95ed5bdbe4530df8$export$2e2bcd8739ae039 = $95ed5bdbe4530df8$var$Task16Icon;

});


parcelRegister("6mmu7", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $086b33d374843724$export$f2d65f02f6888b60);
const $086b33d374843724$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("eeWf5", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $43bc73545f7cdfda$export$25c24c7f577936d3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5mR3i = parcelRequire("5mR3i");

var $f24gj = parcelRequire("f24gj");

var $dVpJZ = parcelRequire("dVpJZ");

var $gVXQp = parcelRequire("gVXQp");

var $3vtQf = parcelRequire("3vtQf");

var $9bx9i = parcelRequire("9bx9i");

var $e1vlu = parcelRequire("e1vlu");

var $94rku = parcelRequire("94rku");

var $kxcRq = parcelRequire("kxcRq");

var $3TBiE = parcelRequire("3TBiE");
const $43bc73545f7cdfda$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $43bc73545f7cdfda$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $43bc73545f7cdfda$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $3TBiE.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $43bc73545f7cdfda$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $kxcRq.getIconForFileType)(opts.fileFormat);
};
const $43bc73545f7cdfda$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dVpJZ.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $43bc73545f7cdfda$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVXQp.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9bx9i.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5mR3i))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94rku.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $43bc73545f7cdfda$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $f24gj.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e1vlu.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3vtQf.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("5mR3i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e8828e45bde362b$var$_react = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3e8828e45bde362b$var$_file = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("1NlXW")));

var $3e8828e45bde362b$var$_documentFilled = $3e8828e45bde362b$var$_interopRequireDefault((parcelRequire("53J27")));
function $3e8828e45bde362b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e8828e45bde362b$var$FileIcon = (props)=>/*#__PURE__*/ $3e8828e45bde362b$var$_react.default.createElement($3e8828e45bde362b$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $3e8828e45bde362b$var$_documentFilled.default
    }, props));
$3e8828e45bde362b$var$FileIcon.Name = 'FileIconMigration';
var $3e8828e45bde362b$var$_default = module.exports.default = $3e8828e45bde362b$var$FileIcon;

});
parcelRegister("1NlXW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14eb6801df53e470$var$_react = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $14eb6801df53e470$var$_baseNew = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $14eb6801df53e470$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14eb6801df53e470$var$FileIcon = (props)=>/*#__PURE__*/ $14eb6801df53e470$var$_react.default.createElement($14eb6801df53e470$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$14eb6801df53e470$var$FileIcon.displayName = 'FileIcon';
var $14eb6801df53e470$var$_default = module.exports.default = $14eb6801df53e470$var$FileIcon;

});

parcelRegister("53J27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3af02a3bc9667b59$var$_react = $3af02a3bc9667b59$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3af02a3bc9667b59$var$_file = $3af02a3bc9667b59$var$_interopRequireDefault((parcelRequire("1NlXW")));
function $3af02a3bc9667b59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3af02a3bc9667b59$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $3af02a3bc9667b59$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $3af02a3bc9667b59$var$_file.default
    }));
$3af02a3bc9667b59$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $3af02a3bc9667b59$var$_default = module.exports.default = $3af02a3bc9667b59$var$DocumentFilledIcon;

});


parcelRegister("gVXQp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a29a66c0c086b650$export$2e2bcd8739ae039);

var $h7zk4 = parcelRequire("h7zk4");

var $es8mD = parcelRequire("es8mD");

var $fDskX = parcelRequire("fDskX");

var $50H21 = parcelRequire("50H21");
const $a29a66c0c086b650$var$ChartBarIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($fDskX))), 'purpleBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($h7zk4))), (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))));
$a29a66c0c086b650$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $a29a66c0c086b650$export$2e2bcd8739ae039 = $a29a66c0c086b650$var$ChartBarIconWithColor;

});
parcelRegister("h7zk4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c76e7d7523f812d3$var$_react = $c76e7d7523f812d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c76e7d7523f812d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c76e7d7523f812d3$var$Presentation16Icon = (props)=>/*#__PURE__*/ $c76e7d7523f812d3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$c76e7d7523f812d3$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $c76e7d7523f812d3$var$_default = module.exports.default = $c76e7d7523f812d3$var$Presentation16Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("fDskX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6207aa8debd29f4$var$_react = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b6207aa8debd29f4$var$_baseNew = $b6207aa8debd29f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b6207aa8debd29f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b6207aa8debd29f4$var$ChartBarIcon = (props)=>/*#__PURE__*/ $b6207aa8debd29f4$var$_react.default.createElement($b6207aa8debd29f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$b6207aa8debd29f4$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $b6207aa8debd29f4$var$_default = module.exports.default = $b6207aa8debd29f4$var$ChartBarIcon;

});


parcelRegister("3vtQf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cb5c4b8517518bd8$export$2e2bcd8739ae039);

var $7BHMh = parcelRequire("7BHMh");

var $jGmM2 = parcelRequire("jGmM2");

var $1NlXW = parcelRequire("1NlXW");

var $50H21 = parcelRequire("50H21");
const $cb5c4b8517518bd8$var$FileIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1NlXW))), 'grayBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($7BHMh))), (0, (/*@__PURE__*/$parcel$interopDefault($jGmM2)))));
$cb5c4b8517518bd8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $cb5c4b8517518bd8$export$2e2bcd8739ae039 = $cb5c4b8517518bd8$var$FileIconWithColor;

});
parcelRegister("7BHMh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $589df26f9969902f$var$_react = $589df26f9969902f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $589df26f9969902f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $589df26f9969902f$var$Generic16Icon = (props)=>/*#__PURE__*/ $589df26f9969902f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$589df26f9969902f$var$Generic16Icon.displayName = 'Generic16Icon';
var $589df26f9969902f$var$_default = module.exports.default = $589df26f9969902f$var$Generic16Icon;

});

parcelRegister("jGmM2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e5439afabf017b97$var$_react = $e5439afabf017b97$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $e5439afabf017b97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5439afabf017b97$var$Generic24Icon = (props)=>/*#__PURE__*/ $e5439afabf017b97$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e5439afabf017b97$var$Generic24Icon.displayName = 'Generic24Icon';
var $e5439afabf017b97$var$_default = module.exports.default = $e5439afabf017b97$var$Generic24Icon;

});


parcelRegister("9bx9i", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $dad84149a00c7077$export$2e2bcd8739ae039);

var $2Bgv8 = parcelRequire("2Bgv8");

var $8SPcB = parcelRequire("8SPcB");

var $bEjt9 = parcelRequire("bEjt9");

var $50H21 = parcelRequire("50H21");
const $dad84149a00c7077$var$ListBulletedIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), 'greenBold', (0, $50H21.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($2Bgv8))), (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))));
$dad84149a00c7077$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $dad84149a00c7077$export$2e2bcd8739ae039 = $dad84149a00c7077$var$ListBulletedIconWithColor;

});
parcelRegister("2Bgv8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1e4bd645869fad1d$var$_react = $1e4bd645869fad1d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1e4bd645869fad1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e4bd645869fad1d$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $1e4bd645869fad1d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$1e4bd645869fad1d$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $1e4bd645869fad1d$var$_default = module.exports.default = $1e4bd645869fad1d$var$Spreadsheet16Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});



parcelRegister("i6XYa", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4a76bae5211e39a4$export$321256ed044e3100);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iAkpb = parcelRequire("iAkpb");

var $jnURg = parcelRequire("jnURg");

var $gAdQO = parcelRequire("gAdQO");

var $6ClRv = parcelRequire("6ClRv");

var $kQSMP = parcelRequire("kQSMP");

var $1ni2E = parcelRequire("1ni2E");

var $kvhCa = parcelRequire("kvhCa");

var $dvo9I = parcelRequire("dvo9I");

var $ercGv = parcelRequire("ercGv");

var $dvNbb = parcelRequire("dvNbb");
const $4a76bae5211e39a4$var$TaskIcon = (0, $ercGv.default);
const $4a76bae5211e39a4$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)($4a76bae5211e39a4$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $dvNbb.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $dvNbb.JIRA_TASK:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $dvNbb.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dvo9I.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $dvNbb.JIRA_STORY:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kvhCa.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $dvNbb.JIRA_BUG:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iAkpb.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $dvNbb.JIRA_EPIC:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gAdQO.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $dvNbb.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ClRv.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $dvNbb.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQSMP.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $dvNbb.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnURg.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $dvNbb.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ni2E.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $dvNbb.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("iAkpb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95722ca43be940d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f047f6f7bd48e9a2ba7394ee23b095>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $i6z47 = parcelRequire("i6z47");

var $VSDnB = parcelRequire("VSDnB");

var $dTB4u = parcelRequire("dTB4u");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95722ca43be940d9$var$Bug16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i6z47))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
        label: label,
        testId: testId
    });
};
$95722ca43be940d9$var$Bug16Icon.displayName = 'Bug16Icon';
var $95722ca43be940d9$export$2e2bcd8739ae039 = $95722ca43be940d9$var$Bug16Icon;

});
parcelRegister("i6z47", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e3fcca8ec2d82f$var$_react = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d2e3fcca8ec2d82f$var$_baseNew = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d2e3fcca8ec2d82f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e3fcca8ec2d82f$var$BugIcon = (props)=>/*#__PURE__*/ $d2e3fcca8ec2d82f$var$_react.default.createElement($d2e3fcca8ec2d82f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$d2e3fcca8ec2d82f$var$BugIcon.displayName = 'BugIcon';
var $d2e3fcca8ec2d82f$var$_default = module.exports.default = $d2e3fcca8ec2d82f$var$BugIcon;

});

parcelRegister("dTB4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35369c9d3f28a25$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d35369c9d3f28a25$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$d35369c9d3f28a25$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d35369c9d3f28a25$export$2e2bcd8739ae039 = $d35369c9d3f28a25$var$Bug16Icon;

});


parcelRegister("jnURg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3bbc99392e8686bf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee9d05b0e18fef4787b81f1748fa21a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $3Vx3e = parcelRequire("3Vx3e");

var $VSDnB = parcelRequire("VSDnB");

var $8vXv7 = parcelRequire("8vXv7");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $3bbc99392e8686bf$var$Changes16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Vx3e))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vXv7.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vXv7.default), {
        label: label,
        testId: testId
    });
};
$3bbc99392e8686bf$var$Changes16Icon.displayName = 'Changes16Icon';
var $3bbc99392e8686bf$export$2e2bcd8739ae039 = $3bbc99392e8686bf$var$Changes16Icon;

});
parcelRegister("3Vx3e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dc055420c806e0d$var$_react = $2dc055420c806e0d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2dc055420c806e0d$var$_baseNew = $2dc055420c806e0d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2dc055420c806e0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dc055420c806e0d$var$ChangesIcon = (props)=>/*#__PURE__*/ $2dc055420c806e0d$var$_react.default.createElement($2dc055420c806e0d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2dc055420c806e0d$var$ChangesIcon.displayName = 'ChangesIcon';
var $2dc055420c806e0d$var$_default = module.exports.default = $2dc055420c806e0d$var$ChangesIcon;

});

parcelRegister("8vXv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $057d039125c231f1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281636a4b7ecb1d97df53dcc5763d1a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $057d039125c231f1$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$057d039125c231f1$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$057d039125c231f1$export$2e2bcd8739ae039 = $057d039125c231f1$var$Changes16Icon;

});


parcelRegister("gAdQO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45d4358dfe9bfcd5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fec5072b15ea4111438ac6700ce61b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $5AZiN = parcelRequire("5AZiN");

var $VSDnB = parcelRequire("VSDnB");

var $37F19 = parcelRequire("37F19");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $45d4358dfe9bfcd5$var$Epic16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5AZiN))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
        label: label,
        testId: testId
    });
};
$45d4358dfe9bfcd5$var$Epic16Icon.displayName = 'Epic16Icon';
var $45d4358dfe9bfcd5$export$2e2bcd8739ae039 = $45d4358dfe9bfcd5$var$Epic16Icon;

});
parcelRegister("5AZiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $412fddddb485461d$var$_react = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $412fddddb485461d$var$_baseNew = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $412fddddb485461d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $412fddddb485461d$var$EpicIcon = (props)=>/*#__PURE__*/ $412fddddb485461d$var$_react.default.createElement($412fddddb485461d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$412fddddb485461d$var$EpicIcon.displayName = 'EpicIcon';
var $412fddddb485461d$var$_default = module.exports.default = $412fddddb485461d$var$EpicIcon;

});

parcelRegister("37F19", function(module, exports) {

$parcel$export(module.exports, "default", () => $43bfed8f132140c5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $43bfed8f132140c5$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$43bfed8f132140c5$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43bfed8f132140c5$export$2e2bcd8739ae039 = $43bfed8f132140c5$var$Epic16Icon;

});


parcelRegister("6ClRv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $03a4ac4c743fc34a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9beea2179909206f90938b1cce486fe2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $fNZB4 = parcelRequire("fNZB4");

var $VSDnB = parcelRequire("VSDnB");

var $l66Lz = parcelRequire("l66Lz");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $03a4ac4c743fc34a$var$Incident16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fNZB4))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l66Lz.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l66Lz.default), {
        label: label,
        testId: testId
    });
};
$03a4ac4c743fc34a$var$Incident16Icon.displayName = 'Incident16Icon';
var $03a4ac4c743fc34a$export$2e2bcd8739ae039 = $03a4ac4c743fc34a$var$Incident16Icon;

});
parcelRegister("fNZB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b81b36817ee75239$var$_react = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b81b36817ee75239$var$_baseNew = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b81b36817ee75239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b81b36817ee75239$var$IncidentIcon = (props)=>/*#__PURE__*/ $b81b36817ee75239$var$_react.default.createElement($b81b36817ee75239$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b81b36817ee75239$var$IncidentIcon.displayName = 'IncidentIcon';
var $b81b36817ee75239$var$_default = module.exports.default = $b81b36817ee75239$var$IncidentIcon;

});

parcelRegister("l66Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b197eb4db6e194a4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce0ac1582dc2507da5f80cdb2ca3ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $b197eb4db6e194a4$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$b197eb4db6e194a4$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b197eb4db6e194a4$export$2e2bcd8739ae039 = $b197eb4db6e194a4$var$Incident16Icon;

});


parcelRegister("kQSMP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ed36b810abfd088$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6546d4aeab39dc918bda403f727c61ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $lhPtH = parcelRequire("lhPtH");

var $VSDnB = parcelRequire("VSDnB");

var $8oSh9 = parcelRequire("8oSh9");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7ed36b810abfd088$var$Issue16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
        label: label,
        testId: testId
    });
};
$7ed36b810abfd088$var$Issue16Icon.displayName = 'Issue16Icon';
var $7ed36b810abfd088$export$2e2bcd8739ae039 = $7ed36b810abfd088$var$Issue16Icon;

});
parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26ba74a55619bd4b134c4c0c504c8b64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});

parcelRegister("8oSh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0610242619823e8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d0610242619823e8$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$d0610242619823e8$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0610242619823e8$export$2e2bcd8739ae039 = $d0610242619823e8$var$Issue16Icon;

});


parcelRegister("1ni2E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0df6901e91a4c816$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b69e4602c3c1878109c2ce1bcc3a020>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $v8u7G = parcelRequire("v8u7G");

var $VSDnB = parcelRequire("VSDnB");

var $c6n91 = parcelRequire("c6n91");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0df6901e91a4c816$var$Problem16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($v8u7G))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6n91.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6n91.default), {
        label: label,
        testId: testId
    });
};
$0df6901e91a4c816$var$Problem16Icon.displayName = 'Problem16Icon';
var $0df6901e91a4c816$export$2e2bcd8739ae039 = $0df6901e91a4c816$var$Problem16Icon;

});
parcelRegister("v8u7G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b0e283b3a840bc3b4c203e922f72a6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d97a47b15d3c35$var$_react = $05d97a47b15d3c35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05d97a47b15d3c35$var$_baseNew = $05d97a47b15d3c35$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $05d97a47b15d3c35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05d97a47b15d3c35$var$ProblemIcon = (props)=>/*#__PURE__*/ $05d97a47b15d3c35$var$_react.default.createElement($05d97a47b15d3c35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m3.964 2.904 9.132 9.132a6.501 6.501 0 0 0-9.132-9.132m8.072 10.192L2.904 3.964a6.501 6.501 0 0 0 9.132 9.132M2.343 2.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 2.343 2.343" clip-rule="evenodd"/>`
    }, props));
$05d97a47b15d3c35$var$ProblemIcon.displayName = 'ProblemIcon';
var $05d97a47b15d3c35$var$_default = module.exports.default = $05d97a47b15d3c35$var$ProblemIcon;

});

parcelRegister("c6n91", function(module, exports) {

$parcel$export(module.exports, "default", () => $9beef7a5821119de$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $9beef7a5821119de$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$9beef7a5821119de$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9beef7a5821119de$export$2e2bcd8739ae039 = $9beef7a5821119de$var$Problem16Icon;

});


parcelRegister("kvhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $58497e342f0afaee$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dc9560f1e0ba735793d18700483c5f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $7Fct1 = parcelRequire("7Fct1");

var $VSDnB = parcelRequire("VSDnB");

var $fjoZ1 = parcelRequire("fjoZ1");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $58497e342f0afaee$var$Story16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fct1))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
        label: label,
        testId: testId
    });
};
$58497e342f0afaee$var$Story16Icon.displayName = 'Story16Icon';
var $58497e342f0afaee$export$2e2bcd8739ae039 = $58497e342f0afaee$var$Story16Icon;

});
parcelRegister("7Fct1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e772f8cdb6f760a3c2951e84821a14>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $594608750eb4424e$var$_react = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $594608750eb4424e$var$_baseNew = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $594608750eb4424e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $594608750eb4424e$var$StoryIcon = (props)=>/*#__PURE__*/ $594608750eb4424e$var$_react.default.createElement($594608750eb4424e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.983 2.5a.5.5 0 0 0-.5.5v9.806L8 10.333l3.518 2.473V3a.5.5 0 0 0-.5-.5zm-2 .5a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2v11.202a.775.775 0 0 1-1.221.634L8 12.166l-3.797 2.67a.775.775 0 0 1-1.22-.634z" clip-rule="evenodd"/>`
    }, props));
$594608750eb4424e$var$StoryIcon.displayName = 'StoryIcon';
var $594608750eb4424e$var$_default = module.exports.default = $594608750eb4424e$var$StoryIcon;

});

parcelRegister("fjoZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38a9d1e30071735$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d38a9d1e30071735$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$d38a9d1e30071735$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d38a9d1e30071735$export$2e2bcd8739ae039 = $d38a9d1e30071735$var$Story16Icon;

});


parcelRegister("dvo9I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $158d2140cdc19c0f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::169a13a2ae270c089103a5ea3de6fc67>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $iRvAI = parcelRequire("iRvAI");

var $VSDnB = parcelRequire("VSDnB");

var $5WrPu = parcelRequire("5WrPu");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $158d2140cdc19c0f$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRvAI))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WrPu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WrPu.default), {
        label: label,
        testId: testId
    });
};
$158d2140cdc19c0f$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $158d2140cdc19c0f$export$2e2bcd8739ae039 = $158d2140cdc19c0f$var$Subtask16Icon;

});
parcelRegister("iRvAI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b31b4268eb35fd0d014247794d0ca202>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbb5ae8ec700c853$var$_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>/*#__PURE__*/ $dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2v4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2zm6.25 4.25V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5zm1.5 1.5V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5V9.25a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;

});

parcelRegister("5WrPu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0252c73d4b8f4e03$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cad22e1176a9874a0c269f62ca4a13d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $0252c73d4b8f4e03$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$0252c73d4b8f4e03$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0252c73d4b8f4e03$export$2e2bcd8739ae039 = $0252c73d4b8f4e03$var$Subtask16Icon;

});




parcelRegister("8Kv84", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $ae5231d890ad8c03$export$a2afc198e9dada1);


var $4DoyP = parcelRequire("4DoyP");
const $ae5231d890ad8c03$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $4DoyP.extractorPriorityMap)[b] - (0, $4DoyP.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $829f609a65d26a98$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("6tk3N", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c60268a167a69ea9$export$58d9bc37318dfb32);
const $c60268a167a69ea9$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c60268a167a69ea9$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c60268a167a69ea9$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("ir8YW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $e6bd8b33974efcaa$export$6d5912cb4b56390e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $hHEfn = parcelRequire("hHEfn");

var $6x7n6 = parcelRequire("6x7n6");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");
class $e6bd8b33974efcaa$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6x7n6.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                testId: "inline-card-resolved-view-lozenge",
                appearance: appearance,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: lozenge.style,
                isBold: (0, $VSDnB.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
                children: lozenge.text
            })
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
                        type: type
                    }
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            ...!(0, $VSDnB.fg)('platform_bandicoots-smart-card-disable-aria') ? {
                showLabel: false
            } : {},
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("6x7n6", function(module, exports) {

$parcel$export(module.exports, "default", () => $af25c54e4444d79c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");
const $af25c54e4444d79c$var$wrapperStyles = null;
const $af25c54e4444d79c$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
            ...props
        })
    });
var $af25c54e4444d79c$export$2e2bcd8739ae039 = $af25c54e4444d79c$var$InlineLozenge;

});

parcelRegister("6oaVw", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $fce424d2cf27c0bc$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $fce424d2cf27c0bc$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $fce424d2cf27c0bc$export$75180efdd3f4d9c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $bmnhy = parcelRequire("bmnhy");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $kxcRq = parcelRequire("kxcRq");

var $6P7yN = parcelRequire("6P7yN");

var $1Fo58 = parcelRequire("1Fo58");
const $fce424d2cf27c0bc$var$iconWrapperStyle = null;
const $fce424d2cf27c0bc$var$iconImageStyle = null;
const $fce424d2cf27c0bc$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko14q2"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $fce424d2cf27c0bc$var$NoLinkAppearanceOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _18u01b66",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$var$LinkAppearance = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type })=>{
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (emoji) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return emoji;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.EmojiWrapperOldVisualRefresh), {
                children: emoji
            });
        }
        if (!icon || typeof icon === 'string') return null;
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return icon;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: icon
        });
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? (0, $kxcRq.isProfileType)(type) : false;
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((errored, testId)=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $bwpsq.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $fce424d2cf27c0bc$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Shimmer), {
                testId: `${testId}-loading`
            })
        });
        const removedProps = !(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') ? {
            className: 'smart-link-icon'
        } : {};
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Icon), {
                ...removedProps,
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $bwpsq.default)([
                    profileType && $fce424d2cf27c0bc$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6P7yN.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((testId)=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return defaultIcon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
        if (defaultIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: defaultIcon
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconWrapperOldVisualRefresh), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: "link",
                LEGACY_size: "small",
                testId: `${testId}-default`,
                color: "currentColor"
            })
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $fce424d2cf27c0bc$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            as: "span",
                            xcss: $fce424d2cf27c0bc$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $bwpsq.default)([
                                "_11c81o8v _2rkoyh40 _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconPositionWrapperOldVisualRefresh), {
                "data-testid": "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.IconEmptyWrapperOldVisualRefresh), {
                            "data-testid": "icon-empty-wrapper"
                        }),
                        renderIcon(testId)
                    ]
                })
            }),
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                style: {
                    color: titleTextColor
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $1Fo58.TitleWrapperClassNameOldVisualRefresh),
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)($fce424d2cf27c0bc$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $bwpsq.default)([
                        $fce424d2cf27c0bc$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: $fce424d2cf27c0bc$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)($fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh, {
            style: {
                color: titleColor
            },
            "data-testid": testId,
            children: [
                link ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$NoLinkAppearanceOldVisualRefresh, {
                    children: rightSide
                }) : null
            ]
        })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$c73a53738ef9e3f = (props)=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $fce424d2cf27c0bc$var$styles.iconTitleWrapperStyle,
        ...props
    });
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$IconTitleWrapperOldVisualRefresh, {
        ...props
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fce424d2cf27c0bc$var$LozengeWrapperOldVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $fce424d2cf27c0bc$export$75180efdd3f4d9c2 = (props)=>{
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $2OMIu.jsx)($fce424d2cf27c0bc$var$LozengeWrapperOldVisualRefresh, {
        ...props
    });
};

});
parcelRegister("6P7yN", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $1cc6345298e1009b$export$f04a61298a47a40f);
$parcel$export(module.exports, "Shimmer", () => $1cc6345298e1009b$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3oVhZ = parcelRequire("3oVhZ");
const $1cc6345298e1009b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $1cc6345298e1009b$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3oVhZ.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("3oVhZ", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $d9c8a8c862f581db$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $d9c8a8c862f581db$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $d9c8a8c862f581db$var$placeholderShimmer = null;
const $d9c8a8c862f581db$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $d9c8a8c862f581db$var$spanSkeletonStyles = null;
const $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $d9c8a8c862f581db$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$d9c8a8c862f581db$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $bwpsq.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $d9c8a8c862f581db$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$d9c8a8c862f581db$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $bwpsq.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $d9c8a8c862f581db$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $d9c8a8c862f581db$export$2e2bcd8739ae039 = $d9c8a8c862f581db$export$8f31e4c4a37b8e9c;

});


parcelRegister("1Fo58", function(module, exports) {

$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "EmojiWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$d1387355dd734414);
$parcel$export(module.exports, "IconTitleWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$c635ccf8b1286a3a);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $13bc30456c869fbe$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$989c0529a97b612a);
$parcel$export(module.exports, "IconEmptyWrapperOldVisualRefresh", () => $13bc30456c869fbe$export$87c6f228b0cd0750);
$parcel$export(module.exports, "TitleWrapperClassNameOldVisualRefresh", () => $13bc30456c869fbe$export$65af995e438d6ba4);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // Wraps all icons represented in Inline Links. Icons have three sources/types:
// - JSON-LD: from the generator.icon property coming back from ORS.
// - @atlaskit/icon: for lock icons, unauthorized, etc.
// - @atlaskit/icon-object: for object icons, e.g. repository, branch, etc.
// NB: the first set of overrides style icons imported from @atlaskit/icon-object correctly.
// NB: the second set of overrides style icons imported from @atlaskit/icon correctly.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $13bc30456c869fbe$var$IconObjectOverrides = `
  & > span {
    height: 16px;
    width: 16px;
    position: absolute;
    top: 3px;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
// TODO: remove this override behaviour for @atlaskit/icon
const $13bc30456c869fbe$var$IconOverrides = `
  & > * > span {
    height: 16px;
    width: 16px;
    position: absolute;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $13bc30456c869fbe$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uiztglyw _17047vkz _iibf7vkz _lacastnw _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe _1f027vkz _nbgx7vkz _4d7tstnw _o5fv1l7b _3g5ridpf _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$d1387355dd734414 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw _17047vkz _iibf7vkz _lacastnw _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe _1f027vkz _nbgx7vkz _4d7tstnw _o5fv1l7b _3g5ridpf _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$c635ccf8b1286a3a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$8228f3d531b6be20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$91b164375b8037b5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$989c0529a97b612a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$87c6f228b0cd0750 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
            __cmplp.className
        ])
    });
});
const $13bc30456c869fbe$export$65af995e438d6ba4 = 'smart-link-title-wrapper';
const $13bc30456c869fbe$export$3bc08b0c31e5f53e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});

});



parcelRegister("iJqW5", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $223c5d6a864b7795$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");


var $7zaVw = parcelRequire("7zaVw");

var $7TGH2 = parcelRequire("7TGH2");
const $223c5d6a864b7795$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $223c5d6a864b7795$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7TGH2.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $223c5d6a864b7795$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).could_not_load_link
                    })
                })
            }),
            (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).try_again
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                testId: "err-view-retry",
                appearance: "link",
                spacing: "none",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("7TGH2", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $07a1a38b3dfd1707$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $07a1a38b3dfd1707$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $2OMIu.jsx)($07a1a38b3dfd1707$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($07a1a38b3dfd1707$export$7b360cd785b6c366, {
        ...props
    });
const $07a1a38b3dfd1707$var$sharedBaseFrameStyles = null;
const $07a1a38b3dfd1707$var$sharedFrameStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameHoverStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameFluidHeightTrueStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameFluidHeightFalseStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameSelectedStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameNotSelectedStyles = null;
const $07a1a38b3dfd1707$var$expandedFrameStyles = null;
const $07a1a38b3dfd1707$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $07a1a38b3dfd1707$var$compactFrameHoverStyles = null;
const $07a1a38b3dfd1707$var$compactFrameInheritDimensionsTrueStyles = null;
const $07a1a38b3dfd1707$var$compactFrameInheritDimensionsFalseStyles = null;
const $07a1a38b3dfd1707$var$compactFrameAlignStyles = null;
const $07a1a38b3dfd1707$var$compactFrameStyles = null;
const $07a1a38b3dfd1707$var$compactFrameNotSelectedStyles = null;
const $07a1a38b3dfd1707$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("39ESV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a1f0d324217dd9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $8m9FN = parcelRequire("8m9FN");

var $4ec1m = parcelRequire("4ec1m");
const $87a1f0d324217dd9$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $5uXOq.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $5uXOq.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        const ButtonComponent = (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $cL21r.toMessage)((0, $7zaVw.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ec1m.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $87a1f0d324217dd9$export$2e2bcd8739ae039 = $87a1f0d324217dd9$var$ForbiddenView;

});
parcelRegister("8m9FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be3576ed5cf1944$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $jOyH3 = parcelRequire("jOyH3");

var $HEA7j = parcelRequire("HEA7j");

var $ckWLp = parcelRequire("ckWLp");
const $6be3576ed5cf1944$var$containerStyles = null;
const $6be3576ed5cf1944$var$contentStyles = null;
const $6be3576ed5cf1944$var$descriptionStyles = null;
const $6be3576ed5cf1944$var$imageStyles = null;
const $6be3576ed5cf1944$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckWLp.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $5uXOq.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $bwpsq.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $bwpsq.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEA7j.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $bwpsq.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $bwpsq.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $6be3576ed5cf1944$export$2e2bcd8739ae039 = $6be3576ed5cf1944$var$UnresolvedView;

});
parcelRegister("HEA7j", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $4aba9fa58e630365$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $4URMI = parcelRequire("4URMI");

var $gfnFT = parcelRequire("gfnFT");

var $f8JAn = parcelRequire("f8JAn");
const $4aba9fa58e630365$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $gfnFT.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const renderHeader = ()=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return frameStyle !== 'hide' && /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            className: (0, $bwpsq.default)([
                $4aba9fa58e630365$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $4aba9fa58e630365$var$styles.headerIcon
                    ]),
                    children: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $4aba9fa58e630365$var$styles.tooltipWrapper
                    ]),
                    children: !isPlaceholder && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: text,
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                            href: href,
                            onClick: handleClick,
                            onMouseDown: handleMouseDown,
                            className: (0, $bwpsq.default)([
                                $4aba9fa58e630365$var$styles.headerAnchor
                            ]),
                            children: text
                        })
                    })
                })
            ]
        });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.HeaderOldVisualRefresh), {
            className: "embed-header",
            frameStyle: frameStyle,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.IconWrapperOldVisualRefresh), {
                    isPlaceholder: isPlaceholder,
                    children: !isPlaceholder && icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.TooltipWrapperOldVisualRefresh), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                        content: text,
                        hideTooltipOnMouseDown: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.TextWrapperOldVisualRefresh), {
                            isPlaceholder: isPlaceholder,
                            children: !isPlaceholder && /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                href: href,
                                onClick: handleClick,
                                onMouseDown: handleMouseDown,
                                children: text
                            })
                        })
                    })
                })
            ]
        }));
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $bwpsq.default)([
                $4aba9fa58e630365$var$styles.contentStyle,
                setOverflow && allowScrollBar && $4aba9fa58e630365$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $4aba9fa58e630365$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.ContentOldVisualRefresh), {
            "data-testid": "embed-content-wrapper",
            allowScrollBar: allowScrollBar,
            removeOverflow: !setOverflow,
            isInteractive: isInteractive(),
            frameStyle: frameStyle,
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: 'false',
            suppressContentEditableWarning: true,
            children: children
        });
    };
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $4aba9fa58e630365$var$styles.linkWrapper,
            inheritDimensions && $4aba9fa58e630365$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $4aba9fa58e630365$var$styles.linkWrapperSelected,
            showBackgroundAlways && $4aba9fa58e630365$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $4aba9fa58e630365$var$styles.linkWrapperInteractiveNotHidden,
            (0, $f8JAn.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
    if (!isPlaceholder && href) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.LinkWrapperOldVisualRefresh), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f8JAn.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        frameStyle: frameStyle,
        minWidth: minWidth,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        inheritDimensions: inheritDimensions,
        children: [
            renderHeader(),
            renderContent()
        ]
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f8JAn.WrapperOldVisualRefresh), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f8JAn.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        minWidth: minWidth,
        frameStyle: frameStyle,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        "data-wrapper-type": "default",
        "data-is-interactive": isInteractive(),
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $4aba9fa58e630365$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mj1crf _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _4t3igktf _1pbykb7n",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("f8JAn", function(module, exports) {

$parcel$export(module.exports, "className", () => $f426c5b6b9ce91fc$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $f426c5b6b9ce91fc$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "LinkWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$2a480844028e4ec0);
$parcel$export(module.exports, "WrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$3261c38179e5e529);
$parcel$export(module.exports, "HeaderOldVisualRefresh", () => $f426c5b6b9ce91fc$export$b23fd71055f45d1c);
$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "TextWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$6c22c892e48a7e6d);
$parcel$export(module.exports, "TooltipWrapperOldVisualRefresh", () => $f426c5b6b9ce91fc$export$63387b6a2966b8a1);
$parcel$export(module.exports, "ContentOldVisualRefresh", () => $f426c5b6b9ce91fc$export$ddc04b8b166e58de);
$parcel$export(module.exports, "Image", () => $f426c5b6b9ce91fc$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $f426c5b6b9ce91fc$export$2913c0c0b5623090 = 'media-card-frame';
const $f426c5b6b9ce91fc$export$8f5a73ba0d077b01 = 32;
const $f426c5b6b9ce91fc$export$2a480844028e4ec0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $lD23V.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di629zg",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$3261c38179e5e529 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $lD23V.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _19pk19bv _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di629zg",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7",
            __cmplp.frameStyle === 'show' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$b23fd71055f45d1c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564ojwh _4t3izwfg _kqswstnw _1pbykb7n _1bsb1osq _1e0c1txw _4cvr1h6o _syazqjbk _tzy4idpf",
            __cmplp.frameStyle === 'show' && "_vchhusvi",
            __cmplp.frameStyle === 'show' && "_1yt4h8dc",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.isPlaceholder && "_bfhkqrzy",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$6c22c892e48a7e6d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _syaz1rc1 _1bto1l2s _o5721q9c",
            __cmplp.isPlaceholder && "_2rko1sit",
            __cmplp.isPlaceholder && "_1bsb176v",
            __cmplp.isPlaceholder && "_4t3i1crf",
            __cmplp.isPlaceholder && "_bfhkqrzy",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$63387b6a2966b8a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$ddc04b8b166e58de = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeOverflow: removeOverflow, allowScrollBar: allowScrollBar, frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _19ith6cr _v56414ba _bfhkhp5a _kqswstnw _1pbykb7n _hlq8idpf _rd9b1wug _1g4jidpf _jk3p1wug",
            !__cmplp.removeOverflow && (__cmplp.allowScrollBar ? "_1reo1wug _18m91wug" : "_1reo15vq _18m915vq"),
            __cmplp.frameStyle === 'show' ? "_1bsbwgg2" : "_1bsb1osq",
            __cmplp.frameStyle === 'show' && "_18s81xf9",
            __cmplp.frameStyle === 'hide' ? "_4t3i1osq" : "_4t3i1j2a",
            __cmplp.frameStyle !== 'hide' && "_154ixy5q",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $f426c5b6b9ce91fc$export$3e431a229df88919 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $lD23V.default)($f426c5b6b9ce91fc$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $f426c5b6b9ce91fc$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ckWLp", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $e061611f1f328974$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $f8JAn = parcelRequire("f8JAn");
const $e061611f1f328974$var$styles = {
    roundedImage: "_2rko14q2"
};
const $e061611f1f328974$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square' })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    const LoadedImageComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f8JAn.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            appearance === 'round' && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && $e061611f1f328974$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("4ec1m", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $35d20558628c8f8e$export$f51768a4e7ff128);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $35d20558628c8f8e$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5VvNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f15eaaa942c697a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7zaVw = parcelRequire("7zaVw");

var $cL21r = parcelRequire("cL21r");

var $8m9FN = parcelRequire("8m9FN");

var $hEH3t = parcelRequire("hEH3t");
const $7f15eaaa942c697a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $5uXOq.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEH3t.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $cL21r.toMessage)((0, $7zaVw.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $7f15eaaa942c697a$export$2e2bcd8739ae039 = $7f15eaaa942c697a$var$NotFoundView;

});
parcelRegister("hEH3t", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $23c56cd588a55ebd$export$80542c1714a314c8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $23c56cd588a55ebd$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("d0weD", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $6626ad9154fcc56d$export$30f3c6c32b384a8b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $hxoiH = parcelRequire("hxoiH");

var $kxcRq = parcelRequire("kxcRq");

var $HEA7j = parcelRequire("HEA7j");

var $5yako = parcelRequire("5yako");

var $ckWLp = parcelRequire("ckWLp");
const $6626ad9154fcc56d$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const profileType = (0, $kxcRq.isProfileType)(type) && (0, $VSDnB.fg)('platform-linking-visual-refresh-v2');
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckWLp.ImageIcon), {
            src: src,
            default: linkGlyph,
            ...(0, $VSDnB.fg)('platform-linking-visual-refresh-v2') && {
                appearance: profileType ? 'round' : 'square'
            }
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        profileType
    ]);
    const themeState = (0, $hxoiH.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $kxcRq.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEA7j.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yako.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("5yako", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $6ecba5ca7578a7ab$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kxcRq = parcelRequire("kxcRq");

var $6WbQT = parcelRequire("6WbQT");

var $fcrey = parcelRequire("fcrey");
function $6ecba5ca7578a7ab$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $6ecba5ca7578a7ab$var$iframeStyles = null;
const $6ecba5ca7578a7ab$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gKZoD.di)((0, $6WbQT.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $5uXOq.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $5uXOq.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $5uXOq.useState)(true);
    const ref = (0, $5uXOq.useRef)();
    const mergedRef = $6ecba5ca7578a7ab$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $5uXOq.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $5uXOq.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcrey.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6WbQT.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $kxcRq.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $bwpsq.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rko1l7b _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("6WbQT", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $aafa8e6c37921cc3$export$b32b5f1ee4493319);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $aafa8e6c37921cc3$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line jsx-a11y/iframe-has-title,@atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef
    });
};

});

parcelRegister("fcrey", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $891ad2d7961cc85f$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $891ad2d7961cc85f$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $891ad2d7961cc85f$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $5uXOq.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $5uXOq.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $5uXOq.useEffect)(()=>{
        if (dwell.time > 0 && $891ad2d7961cc85f$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $5uXOq.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});



parcelRegister("4WY3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd12e79c2283e2b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $3PAn6 = parcelRequire("3PAn6");

var $8m9FN = parcelRequire("8m9FN");

var $hrgWV = parcelRequire("hrgWV");
const $cbd12e79c2283e2b$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $5uXOq.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        const ButtonComponent = (0, $VSDnB.fg)('platform-smart-card-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7zaVw.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PAn6.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $7zaVw.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8m9FN.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrgWV.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $cbd12e79c2283e2b$export$2e2bcd8739ae039 = $cbd12e79c2283e2b$var$UnauthorizedView;

});
parcelRegister("hrgWV", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $629e05cc9b210214$export$6526edaac83a8c90);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $629e05cc9b210214$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("7oGL1", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $d266b2c60f505e83$export$aff6291803939b05);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $f24gj = parcelRequire("f24gj");
var $dhQ1x = parcelRequire("dhQ1x");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $8PVtF = parcelRequire("8PVtF");

var $ctwhA = parcelRequire("ctwhA");

var $fgpl1 = parcelRequire("fgpl1");

var $aOsut = parcelRequire("aOsut");

var $bMldO = parcelRequire("bMldO");

var $anNwF = parcelRequire("anNwF");

var $4ULLF = parcelRequire("4ULLF");

var $ir8YW = parcelRequire("ir8YW");

var $eVTgG = parcelRequire("eVTgG");

var $2bexk = parcelRequire("2bexk");
const $d266b2c60f505e83$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const cardDetails = details && details.data || (0, $aOsut.getEmptyJsonLd)();
    const extensionKey = (0, $fgpl1.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $8dVIb.SmartLinkStatus).Resolved ? (0, $ctwhA.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $5uXOq.useEffect)(()=>{
        switch(status){
            case (0, $8dVIb.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $8dVIb.SmartLinkStatus).Errored:
            case (0, $8dVIb.SmartLinkStatus).Fallback:
            case (0, $8dVIb.SmartLinkStatus).Forbidden:
            case (0, $8dVIb.SmartLinkStatus).NotFound:
            case (0, $8dVIb.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eVTgG.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ir8YW.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline
            });
        case 'unauthorized':
            const provider = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2bexk.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            const cardMetadata = details?.meta ?? (0, $aOsut.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $8PVtF.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ULLF.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $VSDnB.fg)('smart_links_noun_support') ? (0, $dhQ1x.extractSmartLinkProvider)(details) : (0, $f24gj.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $anNwF.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("anNwF", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $d7fe9dbae4fd2cf4$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $059q9 = parcelRequire("059q9");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $d7fe9dbae4fd2cf4$var$styles = {
    iconWrapper: "_2hwx1i6y"
};
const $d7fe9dbae4fd2cf4$var$fallbackIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $d7fe9dbae4fd2cf4$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "error",
            LEGACY_size: "small",
            testId: "errored-view-default-icon"
        })
    });
};
const $d7fe9dbae4fd2cf4$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        return onRetry && ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).try_again
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            spacing: "none",
            component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
            onClick: handleRetry,
            role: "button",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).try_again
            })
        }));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon || $d7fe9dbae4fd2cf4$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon || $d7fe9dbae4fd2cf4$var$fallbackIcon(),
                link: url,
                title: url,
                onClick: onClick,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("7hUjd", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $d9315bd317cf09de$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3Lty3 = parcelRequire("3Lty3");
const $d9315bd317cf09de$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $d9315bd317cf09de$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $d9315bd317cf09de$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $bwpsq.default)([
                $d9315bd317cf09de$var$styles.innerContainer,
                isDisabled ? $d9315bd317cf09de$var$styles.disabled : $d9315bd317cf09de$var$styles.enabled
            ]),
            children: children
        })
    });
});

});

parcelRegister("1czVu", function(module, exports) {

$parcel$export(module.exports, "IconStyledButtonOldVisualRefresh", () => $b39da9ce412dd56b$export$c7df70607ac721c3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // By default buttons will hide overflow and ellipsis content instead of wrapping.
// This basically turns the button back into inline content
// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b39da9ce412dd56b$export$c7df70607ac721c3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_i3j7iti9 _uqpc18uv _1ilx1nu9 _18v918uv _1t1midpf _jinwidpf _1695v77o _1pns12x7 _vktqv77o _1byq12x7 _k1fv1u8q _5x9bqvcn _ju3g18uv _mt1t18uv _12rl18uv _1wge18uv _1nr3zryt _1a8r4jg8 _1xdi1nu9 _1t21zryt _1jjh4jg8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("EvUeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6c302e9fb2d38d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var /**
 * This HOC serves as a temporary workaround for controlling the style of a parent component.
 * We do not want the Frame to have a hover state when hovering over the action button.
 * TODO: When Firefox begins supporting the :has()pseudo-selector (e.g "frame:has(button:hover){...}"),
 * it should be used instead and the code should be cleaned up.
 */ $dd6c302e9fb2d38d$export$2e2bcd8739ae039 = (Button, frameRef)=>(props)=>{
        const setBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.style.borderColor = `${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`;
        };
        const removeBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.removeAttribute('style');
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            ...props,
            onMouseEnter: setBorderStyle,
            onMouseLeave: removeBorderStyle
        });
    };

});


parcelRegister("4ULLF", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $afe1b9ba417d1ecc$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $3u0c5 = parcelRequire("3u0c5");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");


var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $6x7n6 = parcelRequire("6x7n6");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $afe1b9ba417d1ecc$var$styles = {
    iconWrapper: "_2hwx1i6y _1e0cbu77",
    actionButtonLozengeStyleOld: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    actionButtonLozengeStyleNew: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $afe1b9ba417d1ecc$var$fallbackForbiddenIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $afe1b9ba417d1ecc$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
            label: "error",
            color: "var(--ds-icon-danger, #C9372C)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
            LEGACY_size: "small",
            testId: "forbidden-view-fallback-icon"
        })
    });
};
const $afe1b9ba417d1ecc$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7zaVw.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) {
                const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
                    isDisabled: isDisabled,
                    onClick: handleRetry,
                    testId: "button-connect-other-account",
                    children: renderForbiddenAccessMessage()
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                spacing: "none",
                onClick: handleRetry,
                component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
                testId: "button-connect-other-account",
                role: "button",
                isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) {
            if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) {
                if ((0, $VSDnB.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                    xcss: $afe1b9ba417d1ecc$var$styles.actionButtonLozengeStyleNew,
                    onClick: handleRetry,
                    style: {
                        font: `inherit`
                    },
                    testId: "button-connect-other-account",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6x7n6.default), {
                        appearance: "moved",
                        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                        xcss: $afe1b9ba417d1ecc$var$styles.actionButtonLozengeStyleOld,
                        onClick: handleRetry,
                        testId: "button-connect-other-account",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                            appearance: "moved",
                            ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                                isBold: true
                            } : undefined,
                            children: renderForbiddenAccessMessage()
                        })
                    })
                });
            }
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                spacing: "none",
                onClick: handleRetry,
                appearance: "subtle-link",
                testId: "button-connect-other-account",
                role: "button",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.LozengeWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                        appearance: 'moved',
                        ...(0, $VSDnB.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                })
            });
        }
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon ? icon : $afe1b9ba417d1ecc$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});


parcelRegister("eVTgG", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $0760a9bf886910dc$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1Fo58 = parcelRequire("1Fo58");

var $bIwoX = parcelRequire("bIwoX");
const $0760a9bf886910dc$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $0760a9bf886910dc$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            xcss: $0760a9bf886910dc$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: 14
            })
        }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bIwoX.SpinnerWrapperOldVisualRefresh), {
            className: "inline-resolving-spinner",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6oaVw.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Fo58.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkxZO.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
            icon: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? renderSpinner() : undefined,
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor,
            children: (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? undefined : renderSpinner()
        })
    });
};

});
parcelRegister("bIwoX", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapperOldVisualRefresh", () => $0c4a685457e69a72$export$cfcf9ebf54d3fb5c);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Fo58 = parcelRequire("1Fo58");
const $0c4a685457e69a72$export$cfcf9ebf54d3fb5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1Fo58.IconTitleWrapperOldVisualRefresh), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _s7n41ndm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2bexk", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $9c6f4165ad8dd9bb$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fVnbM = parcelRequire("fVnbM");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $hHEfn = parcelRequire("hHEfn");

var $7hUjd = parcelRequire("7hUjd");

var $kkxZO = parcelRequire("kkxZO");

var $6oaVw = parcelRequire("6oaVw");

var $1czVu = parcelRequire("1czVu");

var $EvUeI = parcelRequire("EvUeI");
const $9c6f4165ad8dd9bb$var$styles = {
    iconWrapper: "_2hwx1i6y"
};
const $9c6f4165ad8dd9bb$var$fallbackUnauthorizedIcon = ()=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $9c6f4165ad8dd9bb$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "error",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))),
            LEGACY_size: "small"
        })
    });
};
const $9c6f4165ad8dd9bb$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        const Button = (0, $EvUeI.default)((0, $fVnbM.default), frameRef);
        if ((0, $VSDnB.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hUjd.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
        return onAuthorise ? /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
            spacing: "none",
            component: (0, $1czVu.IconStyledButtonOldVisualRefresh),
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7zaVw.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        }) : undefined;
    }, [
        handleConnectAccount,
        onAuthorise,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kkxZO.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6oaVw.IconAndTitleLayout), {
                icon: icon ? icon : $9c6f4165ad8dd9bb$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hHEfn.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});



parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMldO.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';



parcelRegister("bay8L", function(module, exports) {

$parcel$export(module.exports, "SmartCardProviderMigration", () => $bfd2a295419d11d6$export$c23cd4b65d8850b8);

var $5uXOq = parcelRequire("5uXOq");

var $8dO33 = parcelRequire("8dO33");

var $4R6GH = parcelRequire("4R6GH");
const $bfd2a295419d11d6$export$c23cd4b65d8850b8 = ({ children: children, product: product, client: client, isAdminHubAIEnabled: isAdminHubAIEnabled })=>(0, $4R6GH.fg)('fun-1689_single_root_smart_card_provider') ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        client: client
    }, children);

});

parcelRegister("lTmOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed0ba85b8b165d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ed0ba85b8b165d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noRepository: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-repository",
        "defaultMessage": "No repositories"
    },
    repositories: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.repositories.popup.heading",
        "defaultMessage": "Repositories"
    }
});

});

parcelRegister("3SeWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb17fb25d067638d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $l1N8i = parcelRequire("l1N8i");

var $kVZJG = parcelRequire("kVZJG");
var $dn5wJ = parcelRequire("dn5wJ");
var $buvhv = parcelRequire("buvhv");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lTmOb = parcelRequire("lTmOb");
const $bb17fb25d067638d$export$f5bfd0a3f83b1bb1 = 99;
const $bb17fb25d067638d$var$RepositoriesPopup = ({ repositories: repositories })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (repositories.length === 0) return null;
    const list = repositories.slice(0, $bb17fb25d067638d$export$f5bfd0a3f83b1bb1);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb17fb25d067638d$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb17fb25d067638d$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "div"
        }, formatMessage((0, $lTmOb.default).repositories))), list.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb17fb25d067638d$var$Row, {
                key: `repository-link[${link.id}]`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb17fb25d067638d$var$CardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVZJG.Card), {
                testId: "project-directories.components.compass-table.cells.repository.repository-links-popup.smart-link",
                url: link.url,
                appearance: "inline",
                placeholder: link.name || link.url,
                ui: {
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    clickableContainer: true
                },
                onClick: ()=>{
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    });
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'repositoryLink');
                },
                actionOptions: {
                    hide: false,
                    exclude: [
                        (0, $dn5wJ.CardAction).ChangeStatusAction
                    ]
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buvhv.default), {
                text: link.name,
                maxLines: 1
            }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        messageId: "project-directories.components.compass-table.cells.repository.repository-links-popup.popup",
        messageType: "transactional",
        content: content,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb17fb25d067638d$var$BadgeContainer, {
                ...triggerProps,
                onClick: ()=>{
                    setIsOpen(!isOpen);
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button'
                    });
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'repositoryLinkPopup');
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
                testId: "project-directories.components.compass-table.cells.repository.repository-links-popup.badge-button",
                appearance: !isOpen ? undefined : 'primaryInverted'
            }, "+", list.length))
    });
};
var $bb17fb25d067638d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bb17fb25d067638d$var$RepositoriesPopup;
const $bb17fb25d067638d$var$BadgeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _19pk1b66 _2hwxidpf _otyr1b66 _18u01b66 _ll8p16l4 _1lgi1hek",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb17fb25d067638d$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb35xw _4t3i1osq _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb17fb25d067638d$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrutpp _ngc01fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb17fb25d067638d$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb17fb25d067638d$var$Row = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _4cvr1h6o _1bsb35xw _4t3i1ylp _otyru2gc _bfhk11bn",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kVZJG", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc8afc0c39cee453$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $fzJZi = parcelRequire("fzJZi");

var $lpxJ1 = parcelRequire("lpxJ1");
class $fc8afc0c39cee453$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lpxJ1.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: content
        });
    }
}
const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, $994MI.default)((0, $fzJZi.context))((0, $cb25w.default)()((0, $8RXs9.default)($fc8afc0c39cee453$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("lpxJ1", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $422a0598dbbdc42a$export$e00a7788e30dc998);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $kxcRq = parcelRequire("kxcRq");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $i41Ob = parcelRequire("i41Ob");

const $422a0598dbbdc42a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $kxcRq.importWithRetry)(()=>(parcelRequire("bybQQ"))));
function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $5vDFA.clearMarks)(id);
            (0, $5vDFA.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $91tw3.isFlexibleUiCard)(children, (0, $VSDnB.fg)('platform-linking-flexible-card-openness') ? ui : undefined);
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i41Ob.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($422a0598dbbdc42a$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("bybQQ", function(module, exports) {

let $868c101b2146f4f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $868c101b2146f4f5$var$load("ffQaD"),
    $868c101b2146f4f5$var$load("kvRbA"),
    $868c101b2146f4f5$var$load("kHlHw")
]).then(()=>parcelRequire('6Of57'));

});





parcelRegister("6sHQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7d8661bdac4278$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $djO4L = parcelRequire("djO4L");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $6fKa9 = parcelRequire("6fKa9");
const $5e7d8661bdac4278$var$messages = (0, $7VHMR.defineMessages)({
    noScorecards: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-scorecards",
        "defaultMessage": "No scorecards"
    }
});
function $5e7d8661bdac4278$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, scorecardScores: scorecardScores } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (scorecardScores.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $djO4L.default), {
        componentId: componentId,
        scorecardScores: scorecardScores,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'scorecardHealthLozenge');
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6fKa9.SubtleText), null, formatMessage($5e7d8661bdac4278$var$messages.noScorecards));
}

});
parcelRegister("djO4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d016f7c088596$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3u0c5 = parcelRequire("3u0c5");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $axhu5 = parcelRequire("axhu5");

var $iAW6h = parcelRequire("iAW6h");
function $865d016f7c088596$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, scorecardScores: scorecardScores, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isLozengeHovered, setIsLozengeHovered] = (0, $5uXOq.useState)(false);
    const scorecardHealthCount = (0, $5uXOq.useMemo)(()=>(0, $axhu5.getScorecardHealthCountsFromScores)(scorecardScores), [
        scorecardScores
    ]);
    const summary = (0, $5uXOq.useMemo)(()=>(0, $axhu5.getSummaryText)(scorecardHealthCount, scorecardScores.length, formatMessage), [
        scorecardHealthCount,
        scorecardScores.length,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        messageId: "compass-common.ui.scorecards-health-lozenge.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAW6h.default), {
                componentId: componentId
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "none",
                onClick: (e, analyticsEvent)=>{
                    setIsOpen(!isOpen);
                    onClick?.(e, analyticsEvent);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                onMouseOver: ()=>{
                    setIsLozengeHovered(true);
                },
                onFocus: ()=>{
                    setIsLozengeHovered(true);
                },
                onMouseLeave: ()=>{
                    setIsLozengeHovered(false);
                },
                onBlur: ()=>{
                    // React uses onFocus and onBlur instead of onFocusIn and onFocusOut.
                    setIsLozengeHovered(false);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                isBold: isLozengeHovered,
                appearance: $865d016f7c088596$var$getLozengeStyle(scorecardHealthCount)
            }, summary)))
    });
}
const $865d016f7c088596$var$getLozengeStyle = (scorecardHealthCount)=>{
    if (scorecardHealthCount.passing + scorecardHealthCount.needsAttention < scorecardHealthCount.total) return 'removed';
    if (scorecardHealthCount.needsAttention > 0) return 'moved';
    return 'success';
};

});
parcelRegister("iAW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $97eae6eb2d3849d0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $axhu5 = parcelRequire("axhu5");

var $85dCz = parcelRequire("85dCz");

var $4bVfH = parcelRequire("4bVfH");

var $dUea3 = parcelRequire("dUea3");

var $24U0c = parcelRequire("24U0c");

var $d2QuK = parcelRequire("d2QuK");

var $d9bvU = parcelRequire("d9bvU");
const $97eae6eb2d3849d0$var$NUMBER_OF_SCORECARDS_TO_DISPLAY = 5;
function $97eae6eb2d3849d0$export$2e2bcd8739ae039({ testId: testId, componentId: componentId }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { scorecards: scorecards, loading: loading, error: error } = (0, $85dCz.useGetComponentScorecards)(componentId);
    const scorecardsSortedByHealth = (0, $5uXOq.useMemo)(()=>(0, $axhu5.getScorecardsSortedByHealth)(scorecards), [
        scorecards
    ]);
    const handleViewMoreClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'scorecardsHealthInfoDetailsViewMore');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ContentWrapper, {
        "data-testid": testId
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $24U0c.default), null), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dUea3.GenericErrorGlyph), {
        "data-testid": `${testId}.generic-error-glyph`
    })), !loading && !error && scorecardsSortedByHealth.slice(0, $97eae6eb2d3849d0$var$NUMBER_OF_SCORECARDS_TO_DISPLAY).map((scorecard, i)=>{
        const totalScore = scorecard?.scorecardScore?.totalScore ?? 0;
        const { id: scorecardId } = scorecard;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: scorecardId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ScorecardWrapper, {
            "data-testid": `${testId}-scorecard-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ScorecardInfoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ScorecardName, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ScorecardButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'scorecardsHealthInfoDetailsScorecardName');
            },
            href: `/compass/scorecard/${(0, $axhu5.getIdFromAri)(scorecardId)}`,
            target: "_blank",
            rel: "noopener noreferrer",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $97eae6eb2d3849d0$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bVfH.ScorecardGlyph), null))
        }, scorecard.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$ScorecardScore, null, totalScore, "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9bvU.default), {
            progress: totalScore,
            size: "medium",
            testId: `dragonfruit-scorecards.common.ui.progress-bar-${scorecardId}`
        })));
    }), !error && scorecards.length > $97eae6eb2d3849d0$var$NUMBER_OF_SCORECARDS_TO_DISPLAY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97eae6eb2d3849d0$var$LinkWrapper, {
        href: `/compass/component/${(0, $axhu5.getIdFromAri)(componentId)}`,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handleViewMoreClick
    }, formatMessage((0, $d2QuK.default).viewMore)));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbncxg _1tke1ul9 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ScorecardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_iv8mpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ScorecardInfoWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ScorecardName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjt94y _sudp1e54",
            __cmplp.className
        ])
    });
});
const $97eae6eb2d3849d0$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ScorecardButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tjq16l4 _9n9ov77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ScorecardScore = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8140y _syaz1fxt _ca0qv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$LinkWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _19pkpxbi _k48p1wq8 _syaz1fxt _30l31fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97eae6eb2d3849d0$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("85dCz", function(module, exports) {

$parcel$export(module.exports, "useGetComponentScorecards", () => $fd6a62969d7a8c5d$export$be1e628de8d400bd);

var $5uXOq = parcelRequire("5uXOq");

var $5pk0Q = parcelRequire("5pk0Q");

var $cT6k1 = parcelRequire("cT6k1");
const $fd6a62969d7a8c5d$export$be1e628de8d400bd = (componentId)=>{
    const { data: data, loading: loading, error: error } = (0, $5pk0Q.useFetchQuery)((0, $cT6k1.GET_COMPASS_COMPONENTS_SCORECARDS_QUERY), {
        componentId: componentId
    });
    const scorecards = (0, $5uXOq.useMemo)(()=>{
        if (!loading && data?.compass?.component?.__typename === 'CompassComponent') {
            const dataFields = data.compass.component.scorecards ?? [];
            return dataFields?.map((field)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    id: field?.id ?? '',
                    name: field?.name ?? '',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    scorecardScore: {
                        totalScore: field.scorecardScore?.totalScore ?? 0,
                        maxTotalScore: field.scorecardScore?.maxTotalScore ?? 0
                    }
                }));
        }
        return [];
    }, [
        data,
        loading
    ]);
    return {
        scorecards: scorecards,
        loading: loading,
        error: error
    };
};

});
parcelRegister("cT6k1", function(module, exports) {

$parcel$export(module.exports, "GET_COMPASS_COMPONENTS_SCORECARDS_QUERY", () => $952f7605230ea2b7$export$c0ea2bb8dbfa2db2);

var $fS3SK = parcelRequire("fS3SK");
const $952f7605230ea2b7$export$c0ea2bb8dbfa2db2 = (0, $fS3SK.default);

});
parcelRegister("fS3SK", function(module, exports) {

$parcel$export(module.exports, "default", () => $24735c2a2b8e999b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b3837d707aafd2a7f012f61b4f1ee49>>
 * @relayHash f4d93a10161f753ed411c57f86bc98b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 741085e8b23798a8dea5abf455b5ad9a47688f5582ab4767b090a8458bd06bc9
const $24735c2a2b8e999b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "componentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "componentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "concreteType": "CompassScorecard",
                "kind": "LinkedField",
                "name": "scorecards",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "componentId",
                                        "variableName": "componentId"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "query"
                            }
                        ],
                        "concreteType": "CompassScorecardScore",
                        "kind": "LinkedField",
                        "name": "scorecardScore",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalScore"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "maxTotalScore"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "CompassComponent"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlGetComponentScorecardsQuery",
            "selections": [
                {
                    "concreteType": "CompassCatalogQueryApi",
                    "kind": "LinkedField",
                    "name": "compass",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlGetComponentScorecardsQuery",
            "selections": [
                {
                    "concreteType": "CompassCatalogQueryApi",
                    "kind": "LinkedField",
                    "name": "compass",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "741085e8b23798a8dea5abf455b5ad9a47688f5582ab4767b090a8458bd06bc9",
            "metadata": {},
            "name": "gqlGetComponentScorecardsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$24735c2a2b8e999b$var$node.hash = "bc264e75c2067aab1548341100b3d8c5";
var $24735c2a2b8e999b$export$2e2bcd8739ae039 = $24735c2a2b8e999b$var$node;

});



parcelRegister("4bVfH", function(module, exports) {

$parcel$export(module.exports, "ScorecardGlyph", () => $0dbee103982659b8$export$7d48f4d7960794bf);

var $5uXOq = parcelRequire("5uXOq");
function $0dbee103982659b8$export$7d48f4d7960794bf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.4188 11.9992C15.6081 14.0027 14.0093 15.603 12.0069 16.4157",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 7L8 11L6 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }));
}

});

parcelRegister("dUea3", function(module, exports) {

$parcel$export(module.exports, "GenericErrorGlyph", () => $de261f2160487685$export$1e65f4e15a4452f7);
// We are disabling the design rules because the "fill" attributes of the svg require a token that is not currently available for white

var $5uXOq = parcelRequire("5uXOq");
function $de261f2160487685$export$1e65f4e15a4452f7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "164",
        height: "212",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
}

});

parcelRegister("24U0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5fd305597b57ca$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $0c5fd305597b57ca$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c5fd305597b57ca$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), props));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c5fd305597b57ca$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("d2QuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7d2bc5f149ca3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9a7d2bc5f149ca3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewMore: {
        "id": "compass-common.scorecards-health-lozenge.popup-content.view-more",
        "defaultMessage": "View more"
    }
});

});

parcelRegister("d9bvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb9822d0b75b035$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $axhu5 = parcelRequire("axhu5");
function $fbb9822d0b75b035$export$2e2bcd8739ae039({ testId: testId, progress: progress, size: size = 'small' }) {
    const curProgress = Math.max(0, Math.min(progress, 100));
    const progressColor = (0, $axhu5.getColorForProgress)(curProgress);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fbb9822d0b75b035$var$ProgressBarWrapper, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fbb9822d0b75b035$var$Bar, {
        "data-testid": testId,
        width: curProgress,
        background: progressColor,
        size: size
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fbb9822d0b75b035$var$ProgressBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1reo15vq _18m915vq _bfhkmuej _kqswh2mm _1bsb1osq",
            __cmplp.size === 'small' ? "_4t3i1b66" : "_4t3iu2gc",
            __cmplp.className
        ])
    });
});
const $fbb9822d0b75b035$var$Bar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $lD23V.default)(__cmplp.background),
            "--_1y04s53": (0, $lD23V.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11q71i36 _v564calv _1e0c1ule _kqswstnw _1bsb1mcm",
            __cmplp.size === 'small' ? "_4t3i1b66" : "_4t3iu2gc",
            __cmplp.className
        ])
    });
});

});




parcelRegister("1yNuo", function(module, exports) {

$parcel$export(module.exports, "ComponentsTableErrorState", () => $86976273ff299a29$export$ac3671872e9d0a72);
/* components-table-error-state.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $e5H9G = parcelRequire("e5H9G");

var $jXuGw = parcelRequire("jXuGw");
function $86976273ff299a29$export$ac3671872e9d0a72({ testId: testId }) {
    (0, $gKZoD.di)(window);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const reloadButtonTestId = testId && `${testId}-reload-button`;
    const handleReloadClick = (0, $5uXOq.useCallback)((_, analyticEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'compassComponentsTableErrorStateReload');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86976273ff299a29$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.400",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $86976273ff299a29$var$errorStateImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e5H9G.ErrorStateImage), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86976273ff299a29$var$Heading, null, formatMessage((0, $jXuGw.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $86976273ff299a29$var$bodyStyles
    }, formatMessage((0, $jXuGw.default).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: reloadButtonTestId,
        appearance: "primary",
        onClick: handleReloadClick
    }, formatMessage((0, $jXuGw.default).reload)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86976273ff299a29$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1ogm",
            __cmplp.className
        ])
    });
});
const $86976273ff299a29$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $86976273ff299a29$var$bodyStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300'
});
const $86976273ff299a29$var$errorStateImageWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.500'
});

});
parcelRegister("e5H9G", function(module, exports) {

$parcel$export(module.exports, "ErrorStateImage", () => $97d5a302d981dcc7$export$69a679459027c35e);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $dJlyj = parcelRequire("dJlyj");
const $97d5a302d981dcc7$export$69a679459027c35e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dJlyj))),
        alt: "",
        width: 171.25
    });

});
parcelRegister("dJlyj", function(module, exports) {
module.exports = new URL("error-state.7a6adba2.svg", import.meta.url).toString();

});


parcelRegister("jXuGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6dd45691d4adc4e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c6dd45691d4adc4e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "compass-common.components-table-error-state.heading-non-final",
        "defaultMessage": "We're having trouble showing Compass components"
    },
    body: {
        "id": "compass-common.components-table-error-state.body-non-final",
        "defaultMessage": "Reloading the page might resolve this issue."
    },
    reload: {
        "id": "compass-common.components-table-empty-state.reload-non-final",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("b8bgB", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d09d75f1cdfa14$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $27d09d75f1cdfa14$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    componentHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.component-head",
        "defaultMessage": "Component"
    },
    ownerTeamHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.owner-team-head",
        "defaultMessage": "Owner team"
    },
    repositoryHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.repository-head",
        "defaultMessage": "Repository"
    },
    dependenciesHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.dependencies-head",
        "defaultMessage": "Dependencies"
    },
    scorecardHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.scorecard-head",
        "defaultMessage": "Scorecards"
    },
    issuesHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.issues-head",
        "defaultMessage": "Issues"
    },
    componentCount: {
        "id": "project-pages-project-directories.components.view.compass-table.component-count",
        "defaultMessage": "{componentCount, plural, one {# component} other {# components}} linked to project"
    },
    componentInfo: {
        "id": "project-pages-project-directories.components.view.compass-table.component-info",
        "defaultMessage": "Compass components appear here when they\u2019re added to an issue\u2019s <bold>Components</bold> field. <link>Learn more</link>"
    },
    issuesHeaderIssueTermRefresh: {
        "id": "project-pages-project-directories.components.view.compass-table.issues-head-issue-term-refresh",
        "defaultMessage": "Work items"
    },
    componentInfoIssueTermRefresh: {
        "id": "project-pages-project-directories.components.view.compass-table.component-info-issue-term-refresh",
        "defaultMessage": "Compass components appear here when they\u2019re added to the <bold>Components</bold> field in a work item. <link>Find out more</link>"
    }
});

});



parcelRegister("kuWs9", function(module, exports) {

$parcel$export(module.exports, "RequestAccessState", () => $33e5f46ac7a654e3$export$bc16bfb757adb731);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $kTK0a = parcelRequire("kTK0a");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $9OXo1 = parcelRequire("9OXo1");

var $iDaUl = parcelRequire("iDaUl");

var $ddcO1 = parcelRequire("ddcO1");
const $33e5f46ac7a654e3$var$COMPASS_SITE_ARI_PREFIX = 'ari:cloud:compass::site';
function $33e5f46ac7a654e3$var$compassSiteAriFor(cloudId) {
    return `${$33e5f46ac7a654e3$var$COMPASS_SITE_ARI_PREFIX}/${cloudId}`;
}
function $33e5f46ac7a654e3$var$getUserUpsellUrl(cloudId) {
    const compassResourceAri = $33e5f46ac7a654e3$var$compassSiteAriFor(cloudId);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const continueUrl = window.location.href;
    return `${(0, $kTK0a.getATLContextUrl)('id')}/join/user-access?resource=${encodeURIComponent(compassResourceAri)}&continue=${encodeURIComponent(continueUrl)}`;
}
const $33e5f46ac7a654e3$export$bc16bfb757adb731 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const upsellUrl = $33e5f46ac7a654e3$var$getUserUpsellUrl(cloudId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "componentsTableRequestAccessState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        eventName: "viewed componentsTableRequestAccessState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $33e5f46ac7a654e3$var$contentStyles,
        alignBlock: "center",
        testId: "project-directories.components.compass-table.request-access-state.request-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDaUl.RequestAccessImage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $33e5f46ac7a654e3$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $33e5f46ac7a654e3$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $ddcO1.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $33e5f46ac7a654e3$var$descriptionStyles
    }, formatMessage((0, $ddcO1.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        target: "_blank",
        href: upsellUrl,
        onClick: (_, analyticEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'compassRequestAccessUpSell');
        }
    }, formatMessage((0, $ddcO1.default).requestAccessButtonText)))));
};
const $33e5f46ac7a654e3$var$contentStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '700px',
    marginTop: 'space.1000',
    marginBottom: 'space.250',
    marginLeft: 'auto',
    marginRight: 'auto'
});
const $33e5f46ac7a654e3$var$headingStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.250'
});
const $33e5f46ac7a654e3$var$descriptionStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.250',
    paddingBottom: 'space.250'
});
const $33e5f46ac7a654e3$var$textStyles = (0, $8CUq3.xcss)({
    maxWidth: '500px',
    color: 'color.text.subtle'
});

});
parcelRegister("iDaUl", function(module, exports) {

$parcel$export(module.exports, "RequestAccessImage", () => $afd8ab629845b3dc$export$cb181e9b99786285);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $koVbs = parcelRequire("koVbs");

var $ddcO1 = parcelRequire("ddcO1");

var $dOKLC = parcelRequire("dOKLC");
const $afd8ab629845b3dc$export$cb181e9b99786285 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dOKLC))),
        alt: formatMessage((0, $ddcO1.default).requestAccessAltText)
    });
};

});
parcelRegister("ddcO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a980141adef1c1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a980141adef1c1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "project-directories.components.common.request-access.heading",
        "defaultMessage": "You don\u2019t have access to Compass components"
    },
    description: {
        "id": "project-directories.components.common.request-access.description",
        "defaultMessage": "Ask your admin to give you access to Compass, so you can track the work your team is doing on components of your software architecture."
    },
    requestAccessButtonText: {
        "id": "project-directories.components.common.request-access.button-text",
        "defaultMessage": "Request access"
    },
    requestAccessAltText: {
        "id": "project-directories.components.common.request-access.image-alt-text",
        "defaultMessage": "Request access to Compass"
    }
});

});

parcelRegister("dOKLC", function(module, exports) {
module.exports = new URL("request-access-lock.c6207860.svg", import.meta.url).toString();

});



parcelRegister("4mxqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e28458d83dedab$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $62PJu = parcelRequire("62PJu");

var $6z9Py = parcelRequire("6z9Py");

var $j4QfZ = parcelRequire("j4QfZ");

var $ilFTw = parcelRequire("ilFTw");
const $64e28458d83dedab$var$mapStateToProps = (state)=>({
        analyticsData: (0, $62PJu.get)(state),
        canAddComponent: (0, $6z9Py.isAdmin)(state)
    });
const $64e28458d83dedab$var$mapDispatchToProps = {
    onAddComponent: (0, $j4QfZ.initiate)
};
var $64e28458d83dedab$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($64e28458d83dedab$var$mapStateToProps, $64e28458d83dedab$var$mapDispatchToProps)((0, $ilFTw.default));

});
parcelRegister("ilFTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $616104c8271ea11a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $2vSU6 = parcelRequire("2vSU6");

var $5Zxxp = parcelRequire("5Zxxp");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");

var $ZiPNb = parcelRequire("ZiPNb");
const $616104c8271ea11a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1ejb _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $616104c8271ea11a$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "project-components.empty-placeholder-nothing-added-yet",
        "defaultMessage": "This project doesn't have any components, yet"
    },
    description: {
        "id": "project-components.empty-placeholder-components-are-subsections",
        "defaultMessage": "Components are subsections of a project. Use them to group issues within a project into smaller parts."
    },
    addComponent: {
        "id": "project-components.empty-placeholder-add-a-component",
        "defaultMessage": "Create component"
    },
    learnMore: {
        "id": "project-components.empty-placeholder-read-more",
        "defaultMessage": "Learn more"
    },
    learnMoreAriaLabelText: {
        "id": "project-components.empty-placeholder-read-more-aria-label-text",
        "defaultMessage": "Learn more about components"
    },
    learnMoreJiraComponentsAriaLabelText: {
        "id": "project-components.empty-placeholder-read-more-jira-components-aria-label-text",
        "defaultMessage": "Learn how to configure Jira components"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $616104c8271ea11a$var$EmptyPlaceholderView extends (0, $5uXOq.PureComponent) {
    renderAddComponentButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: this.props.onAddComponent
        }, this.props.intl.formatMessage($616104c8271ea11a$var$messages.addComponent));
    }
    renderLinkButton() {
        let articleId;
        let fallbackLink;
        let learnMoreAriaLabelText;
        if (this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT)) {
            // For JSW projects, show the newer Jira Components help articles (which contains references to Compass Components)
            articleId = 'XFBVB5cRw96Y4KvDXxiuM';
            fallbackLink = 'https://support.atlassian.com/jira-software-cloud/docs/configure-jira-components/';
            learnMoreAriaLabelText = $616104c8271ea11a$var$messages.learnMoreJiraComponentsAriaLabelText;
        } else {
            // For non-JSW projects (JSM), show the original Jira Components help articles (Compass Components are not available in JSM)
            articleId = 'kG5jarMna4VfUEbBkegtI';
            fallbackLink = 'https://confluence.atlassian.com/display/ADMINJIRACLOUD/Managing+components';
            learnMoreAriaLabelText = $616104c8271ea11a$var$messages.learnMoreAriaLabelText;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            "aria-label": this.props.intl.formatMessage(learnMoreAriaLabelText),
            articleId: articleId,
            appearance: "subtle-link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                "aria-label": this.props.intl.formatMessage(learnMoreAriaLabelText),
                appearance: "subtle-link",
                href: fallbackLink,
                target: "_blank"
            }, this.props.intl.formatMessage($616104c8271ea11a$var$messages.learnMore))
        }, this.props.intl.formatMessage($616104c8271ea11a$var$messages.learnMore));
    }
    render() {
        const { canAddComponent: canAddComponent, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($616104c8271ea11a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ZiPNb))),
            width: "narrow",
            header: formatMessage($616104c8271ea11a$var$messages.header),
            description: formatMessage($616104c8271ea11a$var$messages.description),
            primaryAction: !canAddComponent ? null : this.renderAddComponentButton(),
            tertiaryAction: this.renderLinkButton()
        }));
    }
}
var $616104c8271ea11a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($616104c8271ea11a$var$EmptyPlaceholderView);

});
parcelRegister("ZiPNb", function(module, exports) {
module.exports = new URL("components.37259031.svg", import.meta.url).toString();

});



parcelRegister("hv2Tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be6e504713d45af$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $lrD6Q = parcelRequire("lrD6Q");

var $kYnKh = parcelRequire("kYnKh");

var $d8xNe = parcelRequire("d8xNe");

var $2uzFS = parcelRequire("2uzFS");
const $0be6e504713d45af$var$mapStateToProps = (state)=>({
        isLoading: (0, $d8xNe.isLoading)(state),
        currentPage: (0, $kYnKh.getCurrentPage)(state)
    });
const $0be6e504713d45af$var$mapDispatchToProps = {
    onRetry: (0, $lrD6Q.getComponentsPageRequest)
};
var $0be6e504713d45af$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0be6e504713d45af$var$mapStateToProps, $0be6e504713d45af$var$mapDispatchToProps)((0, $2uzFS.default));

});
parcelRegister("2uzFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13373543da2b398$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $kgxuk = parcelRequire("kgxuk");
const $f13373543da2b398$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "project-components.error-header",
        "defaultMessage": "An error occurred"
    },
    description: {
        "id": "project-components.error-description",
        "defaultMessage": "There was a problem loading your components. Try again or contact your administrator for support."
    }
});
function $f13373543da2b398$var$ErrorView(props) {
    const { onRetry: onRetry, currentPage: currentPage, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage($f13373543da2b398$var$messages.header),
        description: formatMessage($f13373543da2b398$var$messages.description),
        isLoading: isLoading,
        onRetry: ()=>onRetry({
                page: currentPage,
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).VIEW
            })
    });
}
$f13373543da2b398$var$ErrorView.defaultProps = {
    isLoading: false
};
var $f13373543da2b398$export$2e2bcd8739ae039 = $f13373543da2b398$var$ErrorView;

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $az4zD = parcelRequire("az4zD");

var $97INH = parcelRequire("97INH");

var $lNvSq = parcelRequire("lNvSq");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($97INH))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNvSq)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("97INH", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("lNvSq", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});




parcelRegister("1zkys", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41da15f1d570447$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $62PJu = parcelRequire("62PJu");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");

var $hDRNF = parcelRequire("hDRNF");
const $d41da15f1d570447$var$mapStateToProps = (state)=>({
        value: (0, $kYnKh.getFilter)(state),
        analyticsData: (0, $62PJu.get)(state)
    });
const $d41da15f1d570447$var$mapDispatchToProps = (dispatch)=>({
        onChange: (value)=>{
            dispatch((0, $2G2i7.patchQuery)({
                filter: value,
                page: 1
            }));
            dispatch((0, $lrD6Q.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).FILTERING
            }));
        }
    });
var $d41da15f1d570447$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d41da15f1d570447$var$mapStateToProps, $d41da15f1d570447$var$mapDispatchToProps)((0, $hDRNF.default));

});
parcelRegister("hDRNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f994b1deb5d7e017$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $3as6V = parcelRequire("3as6V");

var $3HwlS = parcelRequire("3HwlS");
class $f994b1deb5d7e017$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: ''
        };
    }
    render() {
        const { value: value = '' } = this.props;
        return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3as6V.default), {
            value: value,
            onChange: this.onChange,
            ariaLabelText: this.props.ariaLabel,
            hasAutoFocus: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3as6V.default), {
            value: value,
            onChange: this.onChange,
            hasAutoFocus: true
        });
    }
    constructor(...args){
        super(...args), this.onChange = (value)=>{
            this.props.onChange(value);
        };
    }
}

});
parcelRegister("3as6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $466d610aa4e058b2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $2xSAL = parcelRequire("2xSAL");

var $dCm1o = parcelRequire("dCm1o");
const $466d610aa4e058b2$export$4c4c11a6ab1f5b09 = 1000;
const $466d610aa4e058b2$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((value, callback)=>callback(value), $466d610aa4e058b2$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $466d610aa4e058b2$var$Filter extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $dCm1o.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $466d610aa4e058b2$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $466d610aa4e058b2$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $466d610aa4e058b2$export$2e2bcd8739ae039 = $466d610aa4e058b2$var$Filter;

});



parcelRegister("fP6zk", function(module, exports) {

$parcel$export(module.exports, "WrappedGlobalComponentsToggleButton", () => $5cbd284460d3a081$export$3e1dcbc2cb650833);

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $c8Oei = parcelRequire("c8Oei");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $8oiVw = parcelRequire("8oiVw");

var $41vqC = parcelRequire("41vqC");

var $kPiBa = parcelRequire("kPiBa");
function $5cbd284460d3a081$export$7b6a4d9163c73b70(props) {
    const { testId: testId, loading: loading, enabled: enabled, setProperty: setProperty, isAdminContext: isAdminContext, isOpen: isOpen, toggleOpen: toggleOpen } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>toggleOpen(false),
        placement: "bottom-end",
        messageId: "project-directories.components.global-components-toggle-button.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kPiBa.PopupContent), {
                isAdminContext: isAdminContext,
                loading: loading,
                globalComponentsEnabled: !!enabled,
                setGlobalComponentsProperty: setProperty
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
                ...triggerProps,
                testId: testId,
                isLoading: loading,
                isSelected: isOpen,
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'globalComponentsToggleButton', {
                        opened: !isOpen
                    });
                    toggleOpen(!isOpen);
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    spacing: "spacious",
                    label: ""
                })
            }, formatMessage((0, $41vqC.default).productComponents, {
                product: enabled ? 'Compass' : 'Jira'
            }))
    });
}
function $5cbd284460d3a081$export$3e1dcbc2cb650833(props) {
    const { globalComponentsProperty: globalComponentsProperty, isEditable: isEditable } = props;
    const [isGlobalComponentsPopupOpen, setIsGlobalComponentsPopupOpen] = (0, $5uXOq.useState)(false);
    // https://switcheroo.atlassian.com/ui/gates/1b168ef2-2b46-4911-a34c-48247c85f7b9
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        teamName: "compass-lodestone",
        id: "wrappedGlobalComponentsToggleButton",
        sendToPrivacyUnsafeSplunk: true
    }, !(0, $4R6GH.fg)('compass-components-upsell-ad') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8oiVw.CompassComponentsSpotlight), {
        testId: "project-directories.components.global-components-toggle-button.compass-components-spotlight",
        targetRadius: 3,
        dialogPlacement: "bottom right",
        isVisible: !globalComponentsProperty?.loading && !globalComponentsProperty?.enabled,
        onDismiss: (_, analyticEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'compassComponentsSpotlightDismiss');
        },
        onLearnMore: (e, analyticEvent)=>{
            e.stopPropagation();
            setIsGlobalComponentsPopupOpen(true);
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'compassComponentSpotlightLearnMore');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5cbd284460d3a081$export$7b6a4d9163c73b70, {
        toggleOpen: setIsGlobalComponentsPopupOpen,
        isOpen: isGlobalComponentsPopupOpen,
        testId: "project-directories.components.global-components-toggle-button.compass-global-components-toggle-button",
        isAdminContext: isEditable,
        ...globalComponentsProperty
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5cbd284460d3a081$export$7b6a4d9163c73b70, {
        toggleOpen: setIsGlobalComponentsPopupOpen,
        isOpen: isGlobalComponentsPopupOpen,
        testId: "project-directories.components.global-components-toggle-button.compass-global-components-toggle-button",
        isAdminContext: isEditable,
        ...globalComponentsProperty
    }));
}

});
parcelRegister("8oiVw", function(module, exports) {

$parcel$export(module.exports, "CompassComponentsSpotlight", () => $9f65fb9d161e3a50$export$789e02269f603bf7);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $71ynZ = parcelRequire("71ynZ");

var $2RKyI = parcelRequire("2RKyI");
const $9f65fb9d161e3a50$var$TARGET = 'project-directories.components.compass-components-spotlight.target';
function $9f65fb9d161e3a50$export$789e02269f603bf7({ isVisible: isVisible = true, onDismiss: onDismiss, onLearnMore: onLearnMore, children: children, ...forwardProps }) {
    const [{ hasBeenViewed: hasBeenViewed }, { hide: hide }] = (0, $71ynZ.useCompassComponentsSpotlightViewed)();
    const handleDismiss = (e, analyticsEvent)=>{
        hide();
        onDismiss?.(e, analyticsEvent);
    };
    const handleLearnMore = (e, analyticsEvent)=>{
        hide();
        onLearnMore?.(e, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $9f65fb9d161e3a50$var$TARGET
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isVisible && !hasBeenViewed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "compassComponentsSpotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2RKyI.CompassComponentsPopup), {
        target: $9f65fb9d161e3a50$var$TARGET,
        onDismiss: handleDismiss,
        onLearnMore: handleLearnMore,
        ...forwardProps
    }))));
}

});
parcelRegister("2RKyI", function(module, exports) {

$parcel$export(module.exports, "CompassComponentsPopup", () => $2adc3a3d751c0c22$export$cc486d32c3044612);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $gNWZZ = parcelRequire("gNWZZ");

var $4drAc = parcelRequire("4drAc");
function $2adc3a3d751c0c22$export$cc486d32c3044612({ onLearnMore: onLearnMore, onDismiss: onDismiss, testId: testId, ...forwardProps }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const learnMoreTestId = testId && `${testId}-learn-more`;
    const dismissTestId = testId && `${testId}-dismiss`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        ...forwardProps,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gNWZZ))),
        dialogWidth: 320,
        actions: [
            {
                text: formatMessage((0, $4drAc.default).learnMore),
                onClick: onLearnMore,
                testId: learnMoreTestId
            },
            {
                appearance: 'subtle-link',
                text: formatMessage((0, $4drAc.default).dismiss),
                onClick: onDismiss,
                testId: dismissTestId
            }
        ],
        heading: formatMessage((0, $4drAc.default).heading),
        testId: testId,
        messageId: "project-directories.components.compass-components-spotlight.compass-components-popup.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $4drAc.default).summary));
}

});
parcelRegister("gNWZZ", function(module, exports) {
module.exports = new URL("popup-image.c1b1bf07.svg", import.meta.url).toString();

});

parcelRegister("4drAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8facc3dce5295c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd8facc3dce5295c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "project-components.compass-components-popup.heading",
        "defaultMessage": "A new way to work on software components"
    },
    summary: {
        "id": "project-components.compass-components-popup.summary",
        "defaultMessage": "Use Compass components to group and track work around pieces of your software architecture."
    },
    learnMore: {
        "id": "project-components.compass-components-popup.learn-more",
        "defaultMessage": "Show me"
    },
    dismiss: {
        "id": "project-components.compass-components-popup.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("41vqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe51bb546789498$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $afe51bb546789498$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    productComponents: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.product-components",
        "defaultMessage": "{product} components"
    }
});

});

parcelRegister("kPiBa", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $294948aecc9b30bf$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dTlW6 = parcelRequire("dTlW6");

var $3bDjY = parcelRequire("3bDjY");

var $5Zxxp = parcelRequire("5Zxxp");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $dRiKL = parcelRequire("dRiKL");

var $5eiHA = parcelRequire("5eiHA");
function $294948aecc9b30bf$export$2a2c7ba12d3231e3(props) {
    const { isAdminContext: isAdminContext, loading: loading, globalComponentsEnabled: globalComponentsEnabled, setGlobalComponentsProperty: setGlobalComponentsProperty } = props;
    const { openGlobalComponentsFeedbackCollector: openGlobalComponentsFeedbackCollector } = (0, $dRiKL.useCompassComponentsFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const adminAwareToggle = (0, $5uXOq.useMemo)(()=>{
        const toggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
            testId: "project-directories.components.global-components-toggle-button.popup-content.toggle",
            isDisabled: // Only admins can turn on Compass components.
            !isAdminContext || loading,
            isChecked: globalComponentsEnabled,
            onChange: (_, analyticEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'globalComponentsProperty', {
                    value: !globalComponentsEnabled
                });
                setGlobalComponentsProperty(!globalComponentsEnabled); // Request feedback when global components are disabled (i.e. was enabled, becoming disabled).
                if (globalComponentsEnabled) openGlobalComponentsFeedbackCollector({
                    cancelButtonLabel: formatMessage((0, $5eiHA.default).skipButtonLabel)
                });
            }
        });
        if (isAdminContext) return toggle;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            testId: "project-directories.components.global-components-toggle-button.popup-content.tooltip",
            content: formatMessage((0, $5eiHA.default).askAdmin)
        }, toggle);
    }, [
        formatMessage,
        loading,
        isAdminContext,
        globalComponentsEnabled,
        setGlobalComponentsProperty,
        openGlobalComponentsFeedbackCollector
    ]);
    const actionHint = (0, $5uXOq.useMemo)(()=>{
        if (globalComponentsEnabled) {
            if (isAdminContext) return (0, $5eiHA.default).jiraAdminActionHint;
            return (0, $5eiHA.default).jiraActionHint;
        }
        if (isAdminContext) return (0, $5eiHA.default).compassAdminActionHint;
        return (0, $5eiHA.default).compassActionHint;
    }, [
        globalComponentsEnabled,
        isAdminContext
    ]); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, globalComponentsEnabled ? 'learnMoreAboutJiraLink' : 'learnMoreAboutCompassLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "globalComponentsTogglePopup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($294948aecc9b30bf$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($294948aecc9b30bf$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage(globalComponentsEnabled ? (0, $5eiHA.default).switchToJiraCta : (0, $5eiHA.default).switchToCompassCta)), adminAwareToggle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($294948aecc9b30bf$var$Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($294948aecc9b30bf$var$ComponentsDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...globalComponentsEnabled ? (0, $5eiHA.default).jiraDescription : (0, $5eiHA.default).compassDescription,
        values: {
            // @ts-expect-error - Type '(learnMore: string) => JSX.Element' is not assignable to type 'ReactNode'.
            link: (learnMore)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                    articleId: globalComponentsEnabled ? (0, $60dc2b49c1cc2b8c$export$d519c2877b8b5078) : (0, $60dc2b49c1cc2b8c$export$46b2089262397762),
                    appearance: "link",
                    spacing: "none",
                    onClick: onClickLearnMore,
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        href: globalComponentsEnabled ? (0, $60dc2b49c1cc2b8c$export$c0a683dd07e215fe) : (0, $60dc2b49c1cc2b8c$export$6b933388fae9d233),
                        onClick: onClickLearnMore,
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, learnMore)
                }, learnMore)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($294948aecc9b30bf$var$SwitchInfo, null, formatMessage(actionHint))))), globalComponentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'compassFeedbackCollector');
            openGlobalComponentsFeedbackCollector();
        }
    }, formatMessage((0, $5eiHA.default).giveFeedback)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $294948aecc9b30bf$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1a2h _ca0qpxbi _u5f3v47k _n3tdpxbi _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $294948aecc9b30bf$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _otyrpxbi _tqeh1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $294948aecc9b30bf$var$Body = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $294948aecc9b30bf$var$ComponentsDetails = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $294948aecc9b30bf$var$SwitchInfo = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


const $60dc2b49c1cc2b8c$export$6b933388fae9d233 = 'https://support.atlassian.com/jira-software-cloud/docs/what-are-compass-components/';
const $60dc2b49c1cc2b8c$export$c0a683dd07e215fe = 'https://support.atlassian.com/jira-software-cloud/docs/what-are-jira-components/';
const $60dc2b49c1cc2b8c$export$46b2089262397762 = 'vnkvMTEMH9pGdm5r9sTtl';
const $60dc2b49c1cc2b8c$export$d519c2877b8b5078 = '6PbqxN3PWhkG7F5OE18WqX';

parcelRegister("dRiKL", function(module, exports) {

$parcel$export(module.exports, "useCompassComponentsFeedbackCollectorActions", () => $b1fa103ec10cdcee$export$f2628ebb122d157e);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $547Vd = parcelRequire("547Vd");

var $5eiHA = parcelRequire("5eiHA");
const $b1fa103ec10cdcee$export$f2628ebb122d157e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const openGlobalComponentsFeedbackCollector = (0, $5uXOq.useCallback)((props)=>{
        openFeedbackCollector({
            feedbackGroupId: (0, $547Vd.feedback).GLOBAL_COMPONENTS,
            entrypointId: (0, $7iULw.ENTRY_POINT_ID_COMPASS),
            feedbackTitle: formatMessage((0, $5eiHA.default).feedbackTitle),
            showTypeField: true,
            showDefaultTextFields: true,
            submitButtonLabel: formatMessage((0, $5eiHA.default).submitButtonLabel),
            feedbackContext: [
                {
                    id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                    value: (0, $547Vd.feedback).LOCATION
                }
            ],
            ...props
        });
    }, [
        formatMessage,
        openFeedbackCollector
    ]);
    return {
        openGlobalComponentsFeedbackCollector: openGlobalComponentsFeedbackCollector
    };
};

});
parcelRegister("547Vd", function(module, exports) {

$parcel$export(module.exports, "feedback", () => $e6fbfb705b84dd0a$export$2696717cee565f14);
const $e6fbfb705b84dd0a$export$2696717cee565f14 = {
    LOCATION: 'Project Components',
    GLOBAL_COMPONENTS: 'jsw.components.global-components'
};

});

parcelRegister("5eiHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $81c4ddadce324fc2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81c4ddadce324fc2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    switchToCompassCta: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-compass-cta",
        "defaultMessage": "Switch to Compass components"
    },
    compassDescription: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-description",
        "defaultMessage": "Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more</link>"
    },
    compassAdminActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-admin-action-hint",
        "defaultMessage": "If you switch, you\u2019ll still see read-only Jira components. You can switch back at any time."
    },
    compassActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-action-hint",
        "defaultMessage": "If your admin switches, you\u2019ll still see read-only Jira components."
    },
    switchToJiraCta: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-jira-cta",
        "defaultMessage": "Switch to Jira components"
    },
    jiraDescription: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-description",
        "defaultMessage": "Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more</link>"
    },
    jiraAdminActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-admin-action-hint",
        "defaultMessage": "If you switch, you\u2019ll still see read-only Compass components. You can switch back at any time."
    },
    jiraActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-action-hint",
        "defaultMessage": "If your admin switches, you\u2019ll still see read-only Compass components."
    },
    newLozenge: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.new-lozenge",
        "defaultMessage": "New"
    },
    giveFeedback: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.give-feedback",
        "defaultMessage": "Give feedback"
    },
    askAdmin: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.ask-admin",
        "defaultMessage": "Ask your admin to switch to Compass components."
    },
    feedbackTitle: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.title",
        "defaultMessage": "Give feedback"
    },
    feedbackPlaceholder: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.placeholder",
        "defaultMessage": "Write feedback"
    },
    submitButtonLabel: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.submit-button",
        "defaultMessage": "Submit"
    },
    skipButtonLabel: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.skip-button",
        "defaultMessage": "Skip"
    }
});

});




parcelRegister("e5SJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e95e6e448ad6b5$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $62PJu = parcelRequire("62PJu");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");

var $fump8 = parcelRequire("fump8");

var $lcF0M = parcelRequire("lcF0M");
const $02e95e6e448ad6b5$var$mapStateToProps = (state)=>({
        currentPage: (0, $kYnKh.getCurrentPage)(state),
        totalPages: (0, $fump8.getTotalPages)(state),
        analyticsData: (0, $62PJu.get)(state)
    });
const $02e95e6e448ad6b5$var$mapDispatchToProps = (dispatch)=>({
        onPageChange: (number)=>{
            dispatch((0, $2G2i7.patchQuery)({
                page: number
            }));
            return dispatch((0, $lrD6Q.getComponentsPageRequest)({
                page: number,
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).VIEW
            }));
        }
    });
var $02e95e6e448ad6b5$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($02e95e6e448ad6b5$var$mapStateToProps, $02e95e6e448ad6b5$var$mapDispatchToProps)((0, $lcF0M.default));

});
parcelRegister("fump8", function(module, exports) {

$parcel$export(module.exports, "getTotalPages", () => $4889fa8d864f00fa$export$652b307566494a6);
$parcel$export(module.exports, "getIssuesUrl", () => $4889fa8d864f00fa$export$390b5477b70c6392);

var $cIy4l = parcelRequire("cIy4l");

var $k15gu = parcelRequire("k15gu");

var $3kGkY = parcelRequire("3kGkY");

var $golPT = parcelRequire("golPT");

var $d8xNe = parcelRequire("d8xNe");
const $4889fa8d864f00fa$export$652b307566494a6 = (state)=>(0, $k15gu.calculateTotalPages)((0, $3kGkY.getTotalItems)(state), (0, $d8xNe.getItemsOnPage)(state));
const $4889fa8d864f00fa$export$390b5477b70c6392 = (state, componentId)=>{
    if (!(0, $3kGkY.getComponent)(state, componentId)) return '';
    const projectKey = (0, $golPT.getProjectKey)(state);
    const componentName = (0, $3kGkY.getName)(state, componentId);
    const jql = `project = ${(0, $cIy4l.toQuotedString)(projectKey)} AND component = ${(0, $cIy4l.toQuotedString)(componentName)}`;
    return (0, $cIy4l.createIssuesUrl)(jql);
};

});

parcelRegister("lcF0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $33729ab3fef0502f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $iASWI = parcelRequire("iASWI");

var $xBgAj = parcelRequire("xBgAj");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");
const $33729ab3fef0502f$var$messages = (0, $7VHMR.defineMessages)({
    previousButton: {
        "id": "project-components.paginator.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "project-components.paginator.next-button",
        "defaultMessage": "Next"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33729ab3fef0502f$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1syuewr-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        marginTop: "var(--ds-space-300, 24px)",
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-negative-200, -16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.totalPages <= 1 ? 'none' : 'block'
    }));
// eslint-disable-next-line jira/react/no-class-components
class $33729ab3fef0502f$var$PaginatorView extends (0, $5uXOq.PureComponent) {
    render() {
        const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33729ab3fef0502f$var$Container, {
            totalPages: totalPages,
            "data-test-id": "project-directories.components.paginator.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
            testId: "project-directories.components.paginator.pagination",
            selectedIndex: currentPage - 1,
            onChange: this.onPageChange,
            pages: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(1, totalPages + 1),
            previousLabel: formatMessage($33729ab3fef0502f$var$messages.previousButton),
            nextLabel: formatMessage($33729ab3fef0502f$var$messages.nextButton)
        }));
    }
    constructor(...args){
        super(...args), this.onPageChange = (event, page)=>{
            this.props.onPageChange(page);
        };
    }
}
var $33729ab3fef0502f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($33729ab3fef0502f$var$PaginatorView);

});


parcelRegister("84sfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8108f9eab0413e$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $kgxuk = parcelRequire("kgxuk");

var $lrD6Q = parcelRequire("lrD6Q");

var $3kGkY = parcelRequire("3kGkY");

var $6z9Py = parcelRequire("6z9Py");

var $2G2i7 = parcelRequire("2G2i7");

var $kYnKh = parcelRequire("kYnKh");

var $d8xNe = parcelRequire("d8xNe");

var $7eh6H = parcelRequire("7eh6H");
const $3a8108f9eab0413e$var$mapStateToProps = (state)=>({
        componentIds: (0, $3kGkY.getIds)(state),
        isLoading: (0, $d8xNe.isLoading)(state),
        editable: (0, $6z9Py.isAdmin)(state),
        orderField: (0, $kYnKh.getOrderField)(state),
        orderDirection: (0, $kYnKh.getOrderDirection)(state),
        query: (0, $kYnKh.getFilter)(state)
    });
const $3a8108f9eab0413e$var$mapDispatchToProps = (dispatch)=>({
        onSort: ({ key: key, sortOrder: sortOrder })=>{
            dispatch((0, $2G2i7.patchQuery)({
                orderDirection: sortOrder,
                orderField: key,
                page: 1
            }));
            dispatch((0, $lrD6Q.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $kgxuk.FETCH_COMPONENTS_REASON).SORTING
            }));
        }
    });
var $3a8108f9eab0413e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($3a8108f9eab0413e$var$mapStateToProps, $3a8108f9eab0413e$var$mapDispatchToProps)((0, $7eh6H.default));

});
parcelRegister("7eh6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e05a1b1e5e82532$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dHbUn = parcelRequire("dHbUn");

var $luBm6 = parcelRequire("luBm6");

var $4R6GH = parcelRequire("4R6GH");

var $fraBZ = parcelRequire("fraBZ");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $az4zD = parcelRequire("az4zD");

var $cSD7y = parcelRequire("cSD7y");


var $fFsPq = parcelRequire("fFsPq");

var $azwD6 = parcelRequire("azwD6");

var $3Q5XI = parcelRequire("3Q5XI");

var $lyMKV = parcelRequire("lyMKV");

var $38Tn1 = parcelRequire("38Tn1");

var $kn1U6 = parcelRequire("kn1U6");

var $9lqtm = parcelRequire("9lqtm");

var $dpVwy = parcelRequire("dpVwy");
const $8e05a1b1e5e82532$var$messages = (0, $7VHMR.defineMessages)({
    component: {
        "id": "project-components.table-header-component",
        "defaultMessage": "Component"
    },
    issues: {
        "id": "project-components.table-header-issues",
        "defaultMessage": "Issues"
    },
    lead: {
        "id": "project-components.table-header-lead",
        "defaultMessage": "Component lead"
    },
    description: {
        "id": "project-components.table-header-description",
        "defaultMessage": "Description"
    },
    defaultAssignee: {
        "id": "project-components.table-header-default-assignee",
        "defaultMessage": "Default assignee"
    },
    moreActions: {
        "id": "project-components.table-header-more-actions",
        "defaultMessage": "More actions"
    },
    componentsTableLabel: {
        "id": "project-components.table-components-label",
        "defaultMessage": "Table of components"
    },
    searchResults: {
        "id": "project-components.table-search-results",
        "defaultMessage": "{total, plural, =0 {No suggestions available for typed text} one {# suggestion available for typed text} other {# suggestions available for typed text}}"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $8e05a1b1e5e82532$var$TableViewOld extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            editable: false,
            isLoading: false,
            orderField: (0, $fFsPq.NAME),
            orderDirection: (0, $772ff6a70df2b999$export$1dee026a19752d6b)
        };
    }
    render() {
        const { isLoading: isLoading, componentIds: componentIds, editable: editable, onSort: onSort, orderField: orderField, orderDirection: orderDirection, intl: intl } = this.props;
        const { formatMessage: formatMessage } = intl;
        const actionCellHeader = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-test-id": "project-directories.components.table.action-cell-header-container"
        }, formatMessage($8e05a1b1e5e82532$var$messages.moreActions));
        const headCells = [
            {
                key: (0, $fFsPq.NAME),
                content: formatMessage($8e05a1b1e5e82532$var$messages.component),
                width: 20,
                isSortable: true
            },
            {
                key: (0, $fFsPq.DESCRIPTION),
                content: formatMessage($8e05a1b1e5e82532$var$messages.description),
                width: 30,
                isSortable: true
            },
            {
                key: (0, $fFsPq.LEAD),
                content: formatMessage($8e05a1b1e5e82532$var$messages.lead),
                width: 20,
                isSortable: true
            },
            {
                content: formatMessage($8e05a1b1e5e82532$var$messages.defaultAssignee),
                width: 15
            },
            {
                key: (0, $fFsPq.ISSUES),
                content: formatMessage($8e05a1b1e5e82532$var$messages.issues),
                width: 10,
                isSortable: true
            },
            {
                content: actionCellHeader,
                width: 6
            }
        ];
        const head = {
            cells: editable ? headCells : headCells.slice(0, headCells.length - 1)
        };
        const rowCells = componentIds.map((componentId, index)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = orderDirection === 'DESC' ? -(index + 1) : index + 1;
            const cells = [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e05a1b1e5e82532$var$ComponentCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Q5XI.default), {
                        componentId: componentId
                    })),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Tn1.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9lqtm.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lyMKV.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn1U6.default), {
                        componentId: componentId
                    }),
                    key: key
                }
            ];
            if (editable) // @ts-expect-error - TS2345 - Argument of type '{ content: JSX.Element; }' is not assignable to parameter of type '{ content: JSX.Element; key: number; }'.
            cells.push({
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azwD6.default), {
                    componentId: componentId
                })
            });
            return {
                cells: cells
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e05a1b1e5e82532$var$TableContainer, {
            "data-test-id": "project-directories.components.table.table-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
            isFixedSize: true,
            head: head,
            rows: rowCells,
            onSort: onSort,
            sortKey: orderField,
            sortOrder: orderDirection,
            isLoading: isLoading,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e05a1b1e5e82532$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpVwy.default), null),
            label: formatMessage($8e05a1b1e5e82532$var$messages.componentsTableLabel)
        }));
    }
}
const $8e05a1b1e5e82532$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $8e05a1b1e5e82532$var$defaultProps = {
    editable: false,
    isLoading: false,
    orderField: (0, $fFsPq.NAME),
    orderDirection: (0, $772ff6a70df2b999$export$1dee026a19752d6b),
    query: ''
};
const $8e05a1b1e5e82532$var$TableViewNew = ({ isLoading: isLoading = $8e05a1b1e5e82532$var$defaultProps.isLoading, componentIds: componentIds, editable: editable = $8e05a1b1e5e82532$var$defaultProps.editable, onSort: onSort, orderField: orderField = $8e05a1b1e5e82532$var$defaultProps.orderField, orderDirection: orderDirection = $8e05a1b1e5e82532$var$defaultProps.orderDirection, query: query = $8e05a1b1e5e82532$var$defaultProps.query })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const prevQuery = $8e05a1b1e5e82532$var$usePrevious(query);
    const shouldAnnounce = !isLoading && Boolean(query) && prevQuery !== query;
    const actionCellHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        as: "span",
        testId: "project-directories.components.table.action-cell-header-container"
    }, formatMessage($8e05a1b1e5e82532$var$messages.moreActions));
    const headCells = [
        {
            key: (0, $fFsPq.NAME),
            content: formatMessage($8e05a1b1e5e82532$var$messages.component),
            width: 20,
            isSortable: true
        },
        {
            key: (0, $fFsPq.DESCRIPTION),
            content: formatMessage($8e05a1b1e5e82532$var$messages.description),
            width: 30,
            isSortable: true
        },
        {
            key: (0, $fFsPq.LEAD),
            content: formatMessage($8e05a1b1e5e82532$var$messages.lead),
            width: 20,
            isSortable: true
        },
        {
            content: formatMessage($8e05a1b1e5e82532$var$messages.defaultAssignee),
            width: 15
        },
        {
            key: (0, $fFsPq.ISSUES),
            content: formatMessage($8e05a1b1e5e82532$var$messages.issues),
            width: 10,
            isSortable: true
        },
        {
            content: actionCellHeader,
            width: 6
        }
    ];
    const head = {
        cells: editable ? headCells : headCells.slice(0, headCells.length - 1)
    };
    const rowCells = componentIds.map((componentId, index)=>{
        // the page is already sorted (by the API), so fake key,
        // so that DynamicTable won't destroy it
        const key = orderDirection === 'DESC' ? -(index + 1) : index + 1;
        const cells = [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e05a1b1e5e82532$var$ComponentCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Q5XI.default), {
                    componentId: componentId
                })),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Tn1.default), {
                    componentId: componentId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9lqtm.default), {
                    componentId: componentId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lyMKV.default), {
                    componentId: componentId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn1U6.default), {
                    componentId: componentId
                }),
                key: key
            }
        ];
        if (editable) // @ts-expect-error - TS2345 - Argument of type '{ content: JSX.Element; }' is not assignable to parameter of type '{ content: JSX.Element; key: number; }'.
        cells.push({
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azwD6.default), {
                componentId: componentId
            })
        });
        return {
            cells: cells
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e05a1b1e5e82532$var$TableContainer, {
        "data-testid": "project-directories.components.table.table-container"
    }, (0, $4R6GH.fg)('mc-devops-proj-components-a11y') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: formatMessage($8e05a1b1e5e82532$var$messages.searchResults, {
            total: rowCells.length
        }),
        shouldAnnounce: shouldAnnounce
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
        isFixedSize: true,
        head: head,
        rows: rowCells,
        onSort: onSort,
        sortKey: orderField,
        sortOrder: orderDirection,
        isLoading: isLoading,
        emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e05a1b1e5e82532$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpVwy.default), null),
        label: formatMessage($8e05a1b1e5e82532$var$messages.componentsTableLabel)
    }));
};
var $8e05a1b1e5e82532$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $cSD7y.componentWithFG)('mc-devops-proj-components-a11y', $8e05a1b1e5e82532$var$TableViewNew, (0, $az4zD.injectIntlV2)($8e05a1b1e5e82532$var$TableViewOld));
const $8e05a1b1e5e82532$var$TableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2ws7jp4b _p4liutpp _6aututpp _jrvj1hna _fdle1hna _1vd212x7 _10uc12x7 _v8u71b66 _1gnfze3t _1prjusic _10wbnkob _y4k2usic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e05a1b1e5e82532$var$ComponentCellContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91l8a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e05a1b1e5e82532$var$EmptyLoadingView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
});

});
const $772ff6a70df2b999$export$1dee026a19752d6b = 'ASC';
const $772ff6a70df2b999$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("azwD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d07f098fa56dfa73$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $lrD6Q = parcelRequire("lrD6Q");

var $3kGkY = parcelRequire("3kGkY");

var $314fd = parcelRequire("314fd");

var $8qjql = parcelRequire("8qjql");

var $ejeD6 = parcelRequire("ejeD6");
const $d07f098fa56dfa73$var$mapStateToProps = (state, ownProps)=>({
        showSpinner: (0, $8qjql.showSpinner)(state, ownProps.componentId),
        name: (0, $3kGkY.getName)(state, ownProps.componentId)
    });
const $d07f098fa56dfa73$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onEdit: ()=>dispatch((0, $lrD6Q.initiateUpdateComponent)({
                id: ownProps.componentId
            })),
        onDelete: ()=>dispatch((0, $314fd.deleteComponentStarted)({
                id: ownProps.componentId
            }))
    });
var $d07f098fa56dfa73$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d07f098fa56dfa73$var$mapStateToProps, $d07f098fa56dfa73$var$mapDispatchToProps)((0, $ejeD6.default));

});
parcelRegister("8qjql", function(module, exports) {

$parcel$export(module.exports, "showSpinner", () => $245d96373579fd17$export$2a7a135fa1ec651f);

var $eZYjc = parcelRequire("eZYjc");

var $aN3Lz = parcelRequire("aN3Lz");
const $245d96373579fd17$export$2a7a135fa1ec651f = (state, id)=>{
    if ((0, $aN3Lz.isInitialising)(state, id)) return true;
    return (0, $eZYjc.isSpinnerVisible)(state, id);
};

});
parcelRegister("eZYjc", function(module, exports) {

$parcel$export(module.exports, "isSpinnerVisible", () => $211c7d6e9f2dd943$export$b0b0e195937a1a6f);
$parcel$export(module.exports, "componentsBeingDeleted", () => $211c7d6e9f2dd943$export$fac926d1ed969680);
const $211c7d6e9f2dd943$export$b0b0e195937a1a6f = (state, id)=>state.ui.delete.spinner[id];
const $211c7d6e9f2dd943$export$fac926d1ed969680 = (state)=>state.ui.delete.componentsBeingDeleted;

});


parcelRegister("ejeD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f65782d287262b8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $eZJjh = parcelRequire("eZJjh");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7f65782d287262b8$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $7f65782d287262b8$var$messages = (0, $7VHMR.defineMessages)({
    editAction: {
        "id": "project-components.table-actions-cell-edit",
        "defaultMessage": "Edit"
    },
    deleteAction: {
        "id": "project-components.table-actions-cell-delete",
        "defaultMessage": "Delete"
    },
    moreActions: {
        "id": "project-components.table-header-more-actions",
        "defaultMessage": "More actions for {componentName}"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $7f65782d287262b8$var$ActionsView extends (0, $5uXOq.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, name: name } = this.props;
        const IconBefore = this.props.showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f65782d287262b8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
            spacing: "spacious",
            label: formatMessage($7f65782d287262b8$var$messages.moreActions, {
                componentName: name
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            shouldRenderToParent: true,
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    iconBefore: IconBefore
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: this.onEditClicked
        }, formatMessage($7f65782d287262b8$var$messages.editAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: this.onDeleteClicked
        }, formatMessage($7f65782d287262b8$var$messages.deleteAction))));
    }
    constructor(...args){
        super(...args), this.onEditClicked = ()=>this.props.onEdit(), this.onDeleteClicked = ()=>this.props.onDelete();
    }
}
var $7f65782d287262b8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($7f65782d287262b8$var$ActionsView);

});


parcelRegister("3Q5XI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aeb0e9620d50d04$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3kGkY = parcelRequire("3kGkY");

var $fump8 = parcelRequire("fump8");

var $do0Xa = parcelRequire("do0Xa");
const $5aeb0e9620d50d04$var$mapStateToProps = (state, ownProps)=>({
        name: (0, $3kGkY.getName)(state, ownProps.componentId),
        issuesUrl: (0, $fump8.getIssuesUrl)(state, ownProps.componentId)
    });
var $5aeb0e9620d50d04$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($5aeb0e9620d50d04$var$mapStateToProps, {})((0, $do0Xa.default));

});
parcelRegister("do0Xa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23df76a6ab8c703$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");
function $d23df76a6ab8c703$export$2e2bcd8739ae039(props) {
    const { name: name, issuesUrl: issuesUrl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        href: issuesUrl,
        "data-testid": "project-directories.components.table.cell.component.link"
    }, name);
}

});


parcelRegister("lyMKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f60d9f993b56b659$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3kGkY = parcelRequire("3kGkY");

var $j4UX2 = parcelRequire("j4UX2");
const $f60d9f993b56b659$var$mapStateToProps = (state, ownProps)=>({
        defaultAssignee: (0, $3kGkY.getDefaultAssignee)(state, ownProps.componentId)
    });
var $f60d9f993b56b659$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f60d9f993b56b659$var$mapStateToProps, {})((0, $j4UX2.default));

});
parcelRegister("j4UX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ed2bce0e088fba$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");
const $f3ed2bce0e088fba$var$messages = (0, $7VHMR.defineMessages)({
    componentLead: {
        "id": "project-components.table-default-assignee-cell-component-lead",
        "defaultMessage": "Component lead"
    },
    projectDefault: {
        "id": "project-components.table-default-assignee-cell-project-default",
        "defaultMessage": "Project default"
    },
    projectLead: {
        "id": "project-components.table-default-assignee-cell-project-lead",
        "defaultMessage": "Project lead"
    },
    unassigned: {
        "id": "project-components.table-default-assignee-cell-unassigned",
        "defaultMessage": "Unassigned"
    }
});
function $f3ed2bce0e088fba$var$DefaultAssigneeView(props) {
    const { defaultAssignee: defaultAssignee, intl: { formatMessage: formatMessage } } = props;
    if (!defaultAssignee) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": "project-directories.components.table.cell.default-assignee"
    }, formatMessage($f3ed2bce0e088fba$var$messages[(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(defaultAssignee)]));
}
var $f3ed2bce0e088fba$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($f3ed2bce0e088fba$var$DefaultAssigneeView);

});


parcelRegister("38Tn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c749b8b4c1c03c5f$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3kGkY = parcelRequire("3kGkY");

var $8vYVf = parcelRequire("8vYVf");
const $c749b8b4c1c03c5f$var$mapStateToProps = (state, ownProps)=>({
        description: (0, $3kGkY.getDescription)(state, ownProps.componentId)
    });
var $c749b8b4c1c03c5f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($c749b8b4c1c03c5f$var$mapStateToProps, {})((0, $8vYVf.default));

});
parcelRegister("8vYVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f4246a776064fc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $91f4246a776064fc$export$2e2bcd8739ae039(props) {
    const { description: description } = props;
    if (!description) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": "project-directories.components.table.cell.description"
    }, description);
}

});


parcelRegister("kn1U6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbeef0d9f78cf857$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3kGkY = parcelRequire("3kGkY");

var $fump8 = parcelRequire("fump8");

var $cZK8k = parcelRequire("cZK8k");
const $fbeef0d9f78cf857$var$mapStateToProps = (state, ownProps)=>({
        name: (0, $3kGkY.getName)(state, ownProps.componentId),
        number: (0, $3kGkY.getIssueCount)(state, ownProps.componentId),
        issuesUrl: (0, $fump8.getIssuesUrl)(state, ownProps.componentId)
    });
var $fbeef0d9f78cf857$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($fbeef0d9f78cf857$var$mapStateToProps, {})((0, $cZK8k.default));

});
parcelRegister("cZK8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72a7e2bfff1f7f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");
const $c72a7e2bfff1f7f5$var$messages = (0, $7VHMR.defineMessages)({
    issueCount: {
        "id": "project-components.table-issues-cell-content",
        "defaultMessage": "{number} {number, plural, one {issue} other {issues}}"
    },
    ariaLabel: {
        "id": "project-components.table-issues-cell-content-aria-label",
        "defaultMessage": "{number} {number, plural, one {issue} other {issues}} for {name}"
    }
});
function $c72a7e2bfff1f7f5$var$IssuesView(props) {
    const { number: number, issuesUrl: issuesUrl, name: name, intl: { formatMessage: formatMessage } } = props;
    const content = formatMessage($c72a7e2bfff1f7f5$var$messages.issueCount, {
        number: number.toString()
    });
    const ariaLabel = formatMessage($c72a7e2bfff1f7f5$var$messages.ariaLabel, {
        number: number.toString(),
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        href: issuesUrl,
        "aria-label": ariaLabel
    }, content);
}
var $c72a7e2bfff1f7f5$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($c72a7e2bfff1f7f5$var$IssuesView);

});


parcelRegister("9lqtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6a1040fda77c5b$export$2e2bcd8739ae039);

var $8RXs9 = parcelRequire("8RXs9");

var $bC2fB = parcelRequire("bC2fB");

var $3kGkY = parcelRequire("3kGkY");

var $6z9Py = parcelRequire("6z9Py");

var $e4Xnb = parcelRequire("e4Xnb");
const $2f6a1040fda77c5b$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: (0, $6z9Py.getBaseUrl)(state),
        user: (0, $3kGkY.getLead)(state, ownProps.componentId)
    });
var $2f6a1040fda77c5b$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($2f6a1040fda77c5b$var$mapStateToProps, {})((0, $8RXs9.default)((0, $e4Xnb.default)));

});
parcelRegister("e4Xnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3114a599c3e562$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $7ACmi = parcelRequire("7ACmi");
function $0e3114a599c3e562$export$2e2bcd8739ae039(props) {
    const { formatMessage: formatMessage } = props.intl;
    if (!props.user) return null;
    const { avatarUrl: avatarUrl, displayName: displayName, profileUrl: profileUrl, active: active } = props.user;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: profileUrl,
        "data-testid": "project-directories.components.table.cell.lead.link",
        className: (0, $bwpsq.default)([
            "_1e0c1o8l"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_u5f3u2gc _1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: avatarUrl,
        size: "small",
        key: "avatar"
    })), active === true ? displayName : // @ts-expect-error - TS2769: No overload matches this call.
    formatMessage((0, $7ACmi.default).deactivated, {
        userName: displayName,
        status: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                className: (0, $bwpsq.default)([
                    "_syaz131l"
                ])
            }, text[0])
    })));
}
const $0e3114a599c3e562$var$WrapperStyles = null;
const $0e3114a599c3e562$var$LinkStyles = null;
const $0e3114a599c3e562$var$AvatarContainerStyles = null;
const $0e3114a599c3e562$var$UserStatusStyles = null;

});
parcelRegister("7ACmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4dc98960ba096a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4dc98960ba096a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deactivated: {
        "id": "project-components.lead.deactivated-status",
        "defaultMessage": "{userName} <status>(Deactivated)</status>"
    }
});

});



parcelRegister("dpVwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0889696b5880d6fd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");

var $fQUA9 = parcelRequire("fQUA9");
const $0889696b5880d6fd$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "project-components.filter-no-results-nothing-matched-your-search",
        "defaultMessage": "We didn't find any components that matched your search"
    },
    emptyStateMessageDescription: {
        "id": "project-components.filter-no-results-nothing-matched-your-search-description",
        "defaultMessage": "Try using specific component names or terms."
    }
});
function $0889696b5880d6fd$var$EmptyView(props) {
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fQUA9))),
        header: formatMessage($0889696b5880d6fd$var$messages.header),
        description: formatMessage($0889696b5880d6fd$var$messages.emptyStateMessageDescription),
        headingLevel: 2,
        width: "narrow"
    });
}
var $0889696b5880d6fd$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($0889696b5880d6fd$var$EmptyView);

});
parcelRegister("fQUA9", function(module, exports) {
module.exports = new URL("empty.565fbc78.svg", import.meta.url).toString();

});




parcelRegister("eBSZq", function(module, exports) {

$parcel$export(module.exports, "HeaderBottombarContent", () => $618faab91d92980b$export$503cbcd19e8ae377);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");


var $f3rkO = parcelRequire("f3rkO");
const $618faab91d92980b$export$503cbcd19e8ae377 = (props)=>{
    const { isGlobalComponentsEnabled: isGlobalComponentsEnabled, searchBar: searchBar, formatMessage: formatMessage } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const learnMoreOnClick = (_, analyticEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, isGlobalComponentsEnabled ? 'learnMoreAboutCompassComponentsLink' : 'learnMoreAboutJiraComponentsLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: isGlobalComponentsEnabled ? 'project-directories.components.content.compass-header-content' : 'project-directories.components.content.jira-header-content',
        xcss: $618faab91d92980b$var$compassHeaderTextStyles,
        paddingBlockEnd: "space.300"
    }, formatMessage(isGlobalComponentsEnabled ? (0, $f3rkO.default).headerCompass : (0, $f3rkO.default).headerJira, {
        link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                articleId: isGlobalComponentsEnabled ? (0, $60dc2b49c1cc2b8c$export$46b2089262397762) : (0, $60dc2b49c1cc2b8c$export$d519c2877b8b5078),
                appearance: "link",
                onClick: learnMoreOnClick,
                spacing: "none",
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    href: isGlobalComponentsEnabled ? (0, $60dc2b49c1cc2b8c$export$6b933388fae9d233) : (0, $60dc2b49c1cc2b8c$export$c0a683dd07e215fe),
                    target: "_blank",
                    onClick: learnMoreOnClick,
                    appearance: "link",
                    spacing: "none"
                }, text)
            }, text)
    })), !isGlobalComponentsEnabled && searchBar);
};
const $618faab91d92980b$var$compassHeaderTextStyles = (0, $8CUq3.xcss)({
    width: '611px'
});

});
parcelRegister("f3rkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2f1cef782d39df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5d2f1cef782d39df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    headerCompass: {
        "id": "project-components.compass-header",
        "defaultMessage": "Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more about Compass components</link>"
    },
    headerJira: {
        "id": "project-components.jira-header",
        "defaultMessage": "Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more about Jira Components</link>"
    }
});

});


parcelRegister("7h5i5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b0d898b082c0f742$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b0d898b082c0f742$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    filterInputLabel: {
        "id": "project.directories.components.header.filterInputLabel",
        "defaultMessage": "Filter components"
    },
    addComponent: {
        "id": "project-components.add-component.trigger",
        "defaultMessage": "Create component"
    },
    caption: {
        "id": "project-components.header-caption",
        "defaultMessage": "Components"
    },
    successFlagTitle: {
        "id": "project-components.add-component.success-flag-title",
        "defaultMessage": "Success"
    },
    successFlagDescription: {
        "id": "project-components.add-component.success-flag-description",
        "defaultMessage": "New component was created successfully"
    }
});

});



parcelRegister("vOSKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d44b75838535c8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dpzha = parcelRequire("dpzha");

var $1JC75 = parcelRequire("1JC75");

var $garrt = parcelRequire("garrt");
function $7d44b75838535c8a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JC75.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $garrt.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpzha.default), null));
}

});
parcelRegister("dpzha", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d92f8435a4dfcbd$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eZYjc = parcelRequire("eZYjc");

var $gONeo = parcelRequire("gONeo");
const $5d92f8435a4dfcbd$var$mapStateToProps = (state)=>({
        componentsBeingDeleted: (0, $eZYjc.componentsBeingDeleted)(state)
    });
var $5d92f8435a4dfcbd$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($5d92f8435a4dfcbd$var$mapStateToProps, {})((0, $gONeo.default));

});
parcelRegister("gONeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b04490ddf7d454$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5RbJX = parcelRequire("5RbJX");
function $53b04490ddf7d454$var$ViewComponent(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, props.componentsBeingDeleted.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5RbJX.default), {
            id: id,
            key: id
        })));
}
var $53b04490ddf7d454$export$2e2bcd8739ae039 = $53b04490ddf7d454$var$ViewComponent;

});
parcelRegister("5RbJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $199b09125ce4481a$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $lrD6Q = parcelRequire("lrD6Q");

var $62PJu = parcelRequire("62PJu");

var $3kGkY = parcelRequire("3kGkY");

var $6z9Py = parcelRequire("6z9Py");

var $golPT = parcelRequire("golPT");

var $fump8 = parcelRequire("fump8");

var $314fd = parcelRequire("314fd");

var $i7HOc = parcelRequire("i7HOc");
const $199b09125ce4481a$var$mapStateToProps = (state, { id: id })=>({
        component: (0, $3kGkY.getComponent)(state, id),
        projectKey: (0, $golPT.getProjectKey)(state),
        baseUrl: (0, $6z9Py.getBaseUrl)(state),
        locale: (0, $6z9Py.getLocale)(state),
        analyticsData: (0, $62PJu.get)(state),
        relatedIssueUrl: (0, $fump8.getIssuesUrl)(state, id)
    });
const $199b09125ce4481a$var$mapDispatchToProps = (dispatch, { id: id })=>({
        onPatchComponentIssueCount: (issueCount)=>{
            dispatch((0, $lrD6Q.patchComponent)({
                id: id,
                component: {
                    issueCount: issueCount
                }
            }));
        },
        onDeleteComponentSuccessful: (component)=>{
            dispatch((0, $lrD6Q.deleteComponentSuccess)({
                id: id,
                component: component
            }));
        },
        onDeleteComponentFailure: (error, isDialogOpen)=>{
            dispatch((0, $lrD6Q.deleteComponentFailure)({
                id: id,
                error: error,
                isDialogOpen: isDialogOpen
            }));
        },
        onDeleteDialogDisplay: ()=>{
            dispatch((0, $314fd.deleteComponentDialogDisplayed)({
                id: id
            }));
        },
        onDeleteDialogCancel: ()=>{
            dispatch((0, $314fd.deleteComponentCancel)({
                id: id
            }));
        }
    });
var $199b09125ce4481a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($199b09125ce4481a$var$mapStateToProps, $199b09125ce4481a$var$mapDispatchToProps)((0, $i7HOc.default));

});
parcelRegister("i7HOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2509eb96b16f9aa$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $7zswL = parcelRequire("7zswL");
// component name is handled via state because we want to show component name when dialog fades out
// eslint-disable-next-line jira/react/no-class-components
class $f2509eb96b16f9aa$var$ViewComponent extends (0, $5uXOq.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { component: component, relatedIssueUrl: relatedIssueUrl } = nextProps;
        if (component && this.state.component !== component) this.setState({
            component: component
        });
        if (relatedIssueUrl && this.state.url !== relatedIssueUrl) this.setState({
            url: relatedIssueUrl
        });
    }
    render() {
        const { component: { name: name, issueCount: issueCount }, url: url } = this.state;
        const { id: id, locale: locale, projectKey: projectKey, analyticsData: analyticsData, baseUrl: baseUrl, onDeleteComponentFailure: onDeleteComponentFailure, onDeleteDialogDisplay: onDeleteDialogDisplay, onDeleteDialogCancel: onDeleteDialogCancel, onPatchComponentIssueCount: onPatchComponentIssueCount } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7zswL.default), {
            onFail: onDeleteComponentFailure,
            onSuccessful: this.onDeleteComponentSuccessful,
            onDialogDisplay: onDeleteDialogDisplay,
            onIssueCountFetched: onPatchComponentIssueCount,
            onDialogCancel: onDeleteDialogCancel,
            id: id,
            locale: locale,
            analyticsData: analyticsData,
            relatedIssueCount: issueCount,
            relatedIssueUrl: url,
            name: name,
            projectKey: projectKey,
            baseUrl: baseUrl
        });
    }
    constructor(...args){
        super(...args), this.state = {
            component: this.props.component,
            url: this.props.relatedIssueUrl
        }, this.onDeleteComponentSuccessful = ()=>{
            this.props.onDeleteComponentSuccessful(this.state.component);
        };
    }
}
var $f2509eb96b16f9aa$export$2e2bcd8739ae039 = $f2509eb96b16f9aa$var$ViewComponent;

});
parcelRegister("7zswL", function(module, exports) {

$parcel$export(module.exports, "default", () => $47bfc8b78d8094b0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $3NMrl = parcelRequire("3NMrl");

var $jD5no = parcelRequire("jD5no");

var $7iJwP = parcelRequire("7iJwP");

var $dligG = parcelRequire("dligG");

var $cbyQZ = parcelRequire("cbyQZ");

var $9FHxz = parcelRequire("9FHxz");

var $7TSpH = parcelRequire("7TSpH");

var $hzmWk = parcelRequire("hzmWk");
const $47bfc8b78d8094b0$var$pickContextFromProps = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(props, [
        'id',
        'name',
        'baseUrl',
        'projectKey',
        'locale',
        'analyticsData',
        'relatedIssueCount',
        'relatedIssueUrl'
    ]);
const $47bfc8b78d8094b0$var$pickCallbackFromProps = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(props, [
        'onIssueCountFetched',
        'onSuccessful',
        'onFail',
        'onDialogDisplay',
        'onDialogCancel'
    ]);
class $47bfc8b78d8094b0$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.store = (0, $7TSpH.default)((0, $dligG.default), this.props.name);
        this.setAppProps(this.props);
    }
    componentDidMount() {
        this.store.dispatch((0, $9FHxz.deleteComponentRequest)());
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(this.props, nextProps)) this.setAppProps(nextProps);
    }
    setAppProps(props) {
        this.store.dispatch((0, $cbyQZ.setAppProps)({
            context: $47bfc8b78d8094b0$var$pickContextFromProps(props),
            callbacks: $47bfc8b78d8094b0$var$pickCallbackFromProps(props)
        }));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzmWk.default), null)));
    }
}

});
parcelRegister("dligG", function(module, exports) {

$parcel$export(module.exports, "default", () => $847d2c89e6e19aa0$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $hhGSn = parcelRequire("hhGSn");

var $95zPH = parcelRequire("95zPH");
const $847d2c89e6e19aa0$var$rootEpic = (0, $e1AU2.combineEpics)((0, $95zPH.deleteComponentRequest), (0, $95zPH.deleteComponentSafe), (0, $95zPH.deleteComponentConfirmed), (0, $hhGSn.dialogDisplayed), (0, $hhGSn.componentDeleted), (0, $hhGSn.failure), (0, $hhGSn.cancel));
var $847d2c89e6e19aa0$export$2e2bcd8739ae039 = $847d2c89e6e19aa0$var$rootEpic;

});
parcelRegister("hhGSn", function(module, exports) {

$parcel$export(module.exports, "dialogDisplayed", () => $43b3ee3ccf74e1d2$export$c57e151085f519af);
$parcel$export(module.exports, "componentDeleted", () => $43b3ee3ccf74e1d2$export$b986928a2f340a61);
$parcel$export(module.exports, "failure", () => $43b3ee3ccf74e1d2$export$af2dba6db4e9e1f0);
$parcel$export(module.exports, "cancel", () => $43b3ee3ccf74e1d2$export$70b61ad426ddbe54);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $9FHxz = parcelRequire("9FHxz");

var $a4Fmb = parcelRequire("a4Fmb");

var $a9TNq = parcelRequire("a9TNq");
const $43b3ee3ccf74e1d2$export$c57e151085f519af = (action$, store)=>action$.ofType((0, $9FHxz.DELETE_COMPONENT_CONFIRMATION)).mergeMap(()=>{
        (0, $a4Fmb.onDialogDisplay)(store.getState())();
        return (0, $kVLXA.Observable).empty();
    });
const $43b3ee3ccf74e1d2$export$b986928a2f340a61 = (action$, store)=>action$.ofType((0, $9FHxz.DELETE_COMPONENT_SUCCESS)).mergeMap(()=>{
        (0, $a4Fmb.onSuccessful)(store.getState())();
        return (0, $kVLXA.Observable).empty();
    });
const $43b3ee3ccf74e1d2$export$af2dba6db4e9e1f0 = (action$, store)=>action$.ofType((0, $9FHxz.DELETE_COMPONENT_FAIL)).mergeMap((action)=>{
        const { payload: { error: error } } = action;
        const state = store.getState();
        (0, $a4Fmb.onFail)(state)(error, (0, $a9TNq.isDialogOpen)(state));
        return (0, $kVLXA.Observable).empty();
    });
const $43b3ee3ccf74e1d2$export$70b61ad426ddbe54 = (action$, store)=>action$.ofType((0, $9FHxz.CANCEL)).mergeMap(()=>{
        (0, $a4Fmb.onDialogCancel)(store.getState())();
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("9FHxz", function(module, exports) {

$parcel$export(module.exports, "DELETE_COMPONENT_REQUEST", () => $cceb1e50a4863d85$export$24e2bdb9f02e5fb4);
$parcel$export(module.exports, "deleteComponentRequest", () => $cceb1e50a4863d85$export$e4a1f64fe436caf8);
$parcel$export(module.exports, "DELETE_COMPONENT_SAFE", () => $cceb1e50a4863d85$export$38c2b9f6b042ef0f);
$parcel$export(module.exports, "deleteComponentSafe", () => $cceb1e50a4863d85$export$624d4d9a2c81f4fc);
$parcel$export(module.exports, "DELETE_COMPONENT_CONFIRMATION", () => $cceb1e50a4863d85$export$b831980d93222685);
$parcel$export(module.exports, "deleteComponentConfirmation", () => $cceb1e50a4863d85$export$ad2794195cfdcdd1);
$parcel$export(module.exports, "DELETE_COMPONENT_CONFIRMED", () => $cceb1e50a4863d85$export$ee9d0d88840ce8bd);
$parcel$export(module.exports, "deleteComponentConfirmed", () => $cceb1e50a4863d85$export$45e8f2bd48b3a662);
$parcel$export(module.exports, "DELETE_COMPONENT_SUCCESS", () => $cceb1e50a4863d85$export$da077ae08c543bd0);
$parcel$export(module.exports, "deleteComponentSuccess", () => $cceb1e50a4863d85$export$8d34c79dac47f8f3);
$parcel$export(module.exports, "DELETE_COMPONENT_FAIL", () => $cceb1e50a4863d85$export$4520c4bcba87d72a);
$parcel$export(module.exports, "deleteComponentFail", () => $cceb1e50a4863d85$export$5698fe655dd4ff82);
$parcel$export(module.exports, "CANCEL", () => $cceb1e50a4863d85$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $cceb1e50a4863d85$export$70b61ad426ddbe54);
const $cceb1e50a4863d85$export$24e2bdb9f02e5fb4 = 'state.actions.DELETE_COMPONENT_REQUEST';
const $cceb1e50a4863d85$export$e4a1f64fe436caf8 = ()=>({
        type: $cceb1e50a4863d85$export$24e2bdb9f02e5fb4
    });
const $cceb1e50a4863d85$export$38c2b9f6b042ef0f = 'state.actions.DELETE_COMPONENT_SAFE';
const $cceb1e50a4863d85$export$624d4d9a2c81f4fc = ()=>({
        type: $cceb1e50a4863d85$export$38c2b9f6b042ef0f
    });
const $cceb1e50a4863d85$export$b831980d93222685 = 'state.actions.DELETE_COMPONENT_CONFIRMATION';
const $cceb1e50a4863d85$export$ad2794195cfdcdd1 = ()=>({
        type: $cceb1e50a4863d85$export$b831980d93222685
    });
const $cceb1e50a4863d85$export$ee9d0d88840ce8bd = 'state.actions.DELETE_COMPONENT_CONFIRMED';
const $cceb1e50a4863d85$export$45e8f2bd48b3a662 = (payload)=>({
        type: $cceb1e50a4863d85$export$ee9d0d88840ce8bd,
        payload: payload
    });
const $cceb1e50a4863d85$export$da077ae08c543bd0 = 'state.actions.DELETE_COMPONENT_SUCCESS';
const $cceb1e50a4863d85$export$8d34c79dac47f8f3 = ()=>({
        type: $cceb1e50a4863d85$export$da077ae08c543bd0
    });
const $cceb1e50a4863d85$export$4520c4bcba87d72a = 'state.actions.DELETE_COMPONENT_FAIL';
const $cceb1e50a4863d85$export$5698fe655dd4ff82 = (payload)=>({
        type: $cceb1e50a4863d85$export$4520c4bcba87d72a,
        payload: payload
    });
const $cceb1e50a4863d85$export$2b10f4b30fb65583 = 'state.actions.CANCEL';
const $cceb1e50a4863d85$export$70b61ad426ddbe54 = ()=>({
        type: $cceb1e50a4863d85$export$2b10f4b30fb65583
    });

});

parcelRegister("a4Fmb", function(module, exports) {

$parcel$export(module.exports, "onIssueCountFetched", () => $3300eaf56b432b9f$export$363d6ea633d615fc);
$parcel$export(module.exports, "onSuccessful", () => $3300eaf56b432b9f$export$d5d6a762d03166fa);
$parcel$export(module.exports, "onFail", () => $3300eaf56b432b9f$export$5d3242f81f2f2d43);
$parcel$export(module.exports, "onDialogDisplay", () => $3300eaf56b432b9f$export$4a76bd015b2d4167);
$parcel$export(module.exports, "onDialogCancel", () => $3300eaf56b432b9f$export$ac3df3705c165fdc);
const $3300eaf56b432b9f$export$363d6ea633d615fc = (state)=>state.callbacks.onIssueCountFetched;
const $3300eaf56b432b9f$export$d5d6a762d03166fa = (state)=>state.callbacks.onSuccessful;
const $3300eaf56b432b9f$export$5d3242f81f2f2d43 = (state)=>state.callbacks.onFail;
const $3300eaf56b432b9f$export$4a76bd015b2d4167 = (state)=>state.callbacks.onDialogDisplay;
const $3300eaf56b432b9f$export$ac3df3705c165fdc = (state)=>state.callbacks.onDialogCancel;

});

parcelRegister("a9TNq", function(module, exports) {

$parcel$export(module.exports, "isDialogOpen", () => $ae9b2395664d1151$export$61d407d1c7ec6926);
$parcel$export(module.exports, "isInProgress", () => $ae9b2395664d1151$export$350bfa81fecdb6f3);
const $ae9b2395664d1151$export$61d407d1c7ec6926 = (state)=>state.ui.requiresConfirmation;
const $ae9b2395664d1151$export$350bfa81fecdb6f3 = (state)=>state.ui.deleteInProgress;

});


parcelRegister("95zPH", function(module, exports) {

$parcel$export(module.exports, "deleteComponentRequest", () => $24b268a3b648f295$export$e4a1f64fe436caf8);
$parcel$export(module.exports, "deleteComponentSafe", () => $24b268a3b648f295$export$624d4d9a2c81f4fc);
$parcel$export(module.exports, "deleteComponentConfirmed", () => $24b268a3b648f295$export$45e8f2bd48b3a662);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $6n1vy = parcelRequire("6n1vy");

var $9FHxz = parcelRequire("9FHxz");

var $a4Fmb = parcelRequire("a4Fmb");

var $hB7OU = parcelRequire("hB7OU");
const $24b268a3b648f295$var$LOG_LOCATION = 'project-components.state.epics.delete';
const $24b268a3b648f295$var$deleteComponentPerform = (moveIssuesTo, store)=>{
    const state = store.getState();
    const baseUrl = (0, $hB7OU.getBaseUrl)(state);
    const id = (0, $hB7OU.getComponentId)(state);
    return (0, $kVLXA.Observable).fromPromise((0, $6n1vy.deleteComponent)(baseUrl, id, moveIssuesTo)).flatMap(()=>(0, $kVLXA.Observable).of((0, $9FHxz.deleteComponentSuccess)())).catch((error)=>{
        (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, $24b268a3b648f295$var$LOG_LOCATION, (0, $9f04abe75161e860$export$1089831196ae0f84));
        return (0, $kVLXA.Observable).of((0, $9FHxz.deleteComponentFail)({
            error: error
        }));
    });
};
const $24b268a3b648f295$export$e4a1f64fe436caf8 = (action$, store)=>action$.ofType((0, $9FHxz.DELETE_COMPONENT_REQUEST)).mergeMap(()=>{
        const id = (0, $hB7OU.getComponentId)(store.getState());
        return (0, $kVLXA.Observable).fromPromise((0, $6n1vy.getComponentRelatedIssueCount)((0, $hB7OU.getBaseUrl)(store.getState()), id)).mergeMap((result)=>{
            const state = store.getState();
            (0, $a4Fmb.onIssueCountFetched)(state)(result.issueCount);
            if (result.issueCount === 0) return (0, $kVLXA.Observable).of((0, $9FHxz.deleteComponentSafe)());
            return (0, $kVLXA.Observable).of((0, $9FHxz.deleteComponentConfirmation)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, $24b268a3b648f295$var$LOG_LOCATION, (0, $9f04abe75161e860$export$1089831196ae0f84));
            return (0, $kVLXA.Observable).of((0, $9FHxz.deleteComponentFail)({
                error: error
            }));
        });
    });
const $24b268a3b648f295$export$624d4d9a2c81f4fc = (action$, store)=>action$.ofType((0, $9FHxz.DELETE_COMPONENT_SAFE)).mergeMap(()=>$24b268a3b648f295$var$deleteComponentPerform(undefined, store));
const $24b268a3b648f295$export$45e8f2bd48b3a662 = (action$, store)=>action$.ofType((0, $9FHxz.DELETE_COMPONENT_CONFIRMED)).mergeMap((action)=>$24b268a3b648f295$var$deleteComponentPerform(action.payload, store));

});
parcelRegister("6n1vy", function(module, exports) {

$parcel$export(module.exports, "deleteComponent", () => $1c7c8d29c79ae45e$export$b131bf5b3493873b);
$parcel$export(module.exports, "getComponentRelatedIssueCount", () => $1c7c8d29c79ae45e$export$4adab71254d91864);

var $do78Z = parcelRequire("do78Z");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $81N2K = parcelRequire("81N2K");

var $jJu0w = parcelRequire("jJu0w");
const $1c7c8d29c79ae45e$export$b131bf5b3493873b = async (baseUrl, componentId, moveIssuesTo)=>{
    const result = await (0, $jJu0w.deleteComponent)(baseUrl, componentId, moveIssuesTo);
    if (result.ok) {
        try {
            componentId && (0, $do78Z.default).remove(componentId.toString());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('project-directories.components.cache.remove', error.message);
        }
        return {
            id: componentId
        };
    }
    const error = await (0, $81N2K.getErrorMessage)(result);
    throw new (0, $jJZqs.default)(result.status, error);
};
const $1c7c8d29c79ae45e$export$4adab71254d91864 = async (baseUrl, componentId)=>{
    const result = await (0, $jJu0w.getComponentRelatedIssueCount)(baseUrl, componentId);
    if (result.ok) {
        const json = await result.json();
        return {
            id: componentId,
            issueCount: json.issueCount
        };
    }
    const error = await (0, $81N2K.getErrorMessage)(result);
    throw new (0, $jJZqs.default)(result.status, error);
};

});
parcelRegister("81N2K", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $b9b19ebc5bf9c7a6$export$82f46aa4e6535a45);
const $b9b19ebc5bf9c7a6$export$82f46aa4e6535a45 = async (response)=>{
    try {
        const json = await response.json();
        return json.errorMessages[0] || '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return '';
    }
};

});

parcelRegister("jJu0w", function(module, exports) {

$parcel$export(module.exports, "deleteComponent", () => $12a309d84c666e95$export$b131bf5b3493873b);
$parcel$export(module.exports, "getComponentRelatedIssueCount", () => $12a309d84c666e95$export$4adab71254d91864);

var $lEFJO = parcelRequire("lEFJO");
const $12a309d84c666e95$var$getUrl = (baseUrl, componentId)=>`${baseUrl}/rest/api/2/component/${componentId}`;
const $12a309d84c666e95$export$b131bf5b3493873b = async (baseUrl, componentId, moveIssuesTo)=>{
    const queryString = moveIssuesTo ? `?moveIssuesTo=${moveIssuesTo}` : '';
    const fullUrl = `${$12a309d84c666e95$var$getUrl(baseUrl, componentId)}${queryString}`;
    return fetch(fullUrl, (0, $lEFJO.createOptions)('DELETE'));
};
const $12a309d84c666e95$export$4adab71254d91864 = async (baseUrl, componentId)=>{
    const fullUrl = `${$12a309d84c666e95$var$getUrl(baseUrl, componentId)}/relatedIssueCounts`;
    return fetch(fullUrl, (0, $lEFJO.createOptions)('GET'));
};

});


parcelRegister("hB7OU", function(module, exports) {

$parcel$export(module.exports, "getContext", () => $6f85f9a9ad27a456$export$31553aaa555c1514);
$parcel$export(module.exports, "getComponentId", () => $6f85f9a9ad27a456$export$19f56ea1d359a013);
$parcel$export(module.exports, "getBaseUrl", () => $6f85f9a9ad27a456$export$f654b28f82155665);
const $6f85f9a9ad27a456$export$31553aaa555c1514 = (state)=>state.context;
const $6f85f9a9ad27a456$export$19f56ea1d359a013 = (state)=>$6f85f9a9ad27a456$export$31553aaa555c1514(state).id;
const $6f85f9a9ad27a456$export$f654b28f82155665 = (state)=>$6f85f9a9ad27a456$export$31553aaa555c1514(state).baseUrl;
const $6f85f9a9ad27a456$export$128e6d32dd8f7139 = (state)=>$6f85f9a9ad27a456$export$31553aaa555c1514(state).analyticsData;

});



parcelRegister("cbyQZ", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $2c3bad3c03660780$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $2c3bad3c03660780$export$cfda7627848a58cd);
const $2c3bad3c03660780$export$8aefe701a6f431e0 = 'state.actions.SET_APP_PROPS';
const $2c3bad3c03660780$export$cfda7627848a58cd = (payload)=>({
        type: $2c3bad3c03660780$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("7TSpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4424ce10be43b73$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $aiRJY = parcelRequire("aiRJY");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4424ce10be43b73$export$2e2bcd8739ae039 = (rootOperation, name)=>{
    const middlewares = [];
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    return (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)((0, $aiRJY.default)), undefined, (0, $hkadP.default)({
        name: `Delete component '${name}'`
    })((0, $3f2cs.applyMiddleware)(...middlewares, (0, $e1AU2.createEpicMiddleware)(rootOperation))));
};

});
parcelRegister("aiRJY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aaf685c79044697$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $9H2c0 = parcelRequire("9H2c0");

var $3RKUx = parcelRequire("3RKUx");

var $fDIHs = parcelRequire("fDIHs");
const $6aaf685c79044697$var$combinedReducer = (0, $3f2cs.combineReducers)({
    ui: $fDIHs.default,
    callbacks: $9H2c0.default,
    context: $3RKUx.default
});
var $6aaf685c79044697$export$2e2bcd8739ae039 = $6aaf685c79044697$var$combinedReducer;

});
parcelRegister("9H2c0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c4d1811cf6b84b8$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $8Rkzz = parcelRequire("8Rkzz");

var $cbyQZ = parcelRequire("cbyQZ");
const $8c4d1811cf6b84b8$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    onIssueCountFetched: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onSuccessful: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onFail: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDialogDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c4d1811cf6b84b8$export$2e2bcd8739ae039 = (state = $8c4d1811cf6b84b8$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $cbyQZ.SET_APP_PROPS:
            return (0, $7uUwQ.assign)(state, action.payload.callbacks);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("3RKUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83fb013aa3d0d21$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $lzeFL = parcelRequire("lzeFL");

var $cbyQZ = parcelRequire("cbyQZ");
const $a83fb013aa3d0d21$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    id: '',
    name: '',
    locale: (0, $lzeFL.defaultLocale),
    baseUrl: '',
    projectKey: '',
    analyticsData: {
        projectType: ''
    },
    relatedIssueCount: 0,
    relatedIssueUrl: ''
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a83fb013aa3d0d21$export$2e2bcd8739ae039 = (state = $a83fb013aa3d0d21$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $cbyQZ.SET_APP_PROPS:
            return (0, $7uUwQ.assign)(state, action.payload.context);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("fDIHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b90f61efc674643$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9FHxz = parcelRequire("9FHxz");
const $7b90f61efc674643$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    requiresConfirmation: false,
    deleteInProgress: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b90f61efc674643$export$2e2bcd8739ae039 = (state = $7b90f61efc674643$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9FHxz.CANCEL:
            return (0, $7uUwQ.assign)(state, {
                requiresConfirmation: false,
                deleteInProgress: false
            });
        case 0, $9FHxz.DELETE_COMPONENT_FAIL:
            return (0, $7uUwQ.assign)(state, {
                deleteInProgress: false
            });
        case 0, $9FHxz.DELETE_COMPONENT_SAFE:
        case 0, $9FHxz.DELETE_COMPONENT_CONFIRMED:
            return (0, $7uUwQ.assign)(state, {
                deleteInProgress: true
            });
        case 0, $9FHxz.DELETE_COMPONENT_CONFIRMATION:
            return (0, $7uUwQ.assign)(state, {
                requiresConfirmation: true
            });
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("hzmWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $df456b0beaf533f7$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $9FHxz = parcelRequire("9FHxz");

var $hB7OU = parcelRequire("hB7OU");

var $a9TNq = parcelRequire("a9TNq");

var $1cU95 = parcelRequire("1cU95");
const $df456b0beaf533f7$var$mapStateToProps = (state)=>({
        context: (0, $hB7OU.getContext)(state),
        isDialogOpen: (0, $a9TNq.isDialogOpen)(state),
        isInProgress: (0, $a9TNq.isInProgress)(state)
    });
const $df456b0beaf533f7$var$mapDispatchToProps = (dispatch)=>({
        onCancel: ()=>{
            dispatch((0, $9FHxz.cancel)());
        },
        onConfirm: (moveIssuesTo)=>{
            dispatch((0, $9FHxz.deleteComponentConfirmed)(moveIssuesTo));
        }
    });
var $df456b0beaf533f7$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($df456b0beaf533f7$var$mapStateToProps, $df456b0beaf533f7$var$mapDispatchToProps)((0, $1cU95.default));

});
parcelRegister("1cU95", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19660dab3577820$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $eZJjh = parcelRequire("eZJjh");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $1BOpI = parcelRequire("1BOpI");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $gj945 = parcelRequire("gj945");
// eslint-disable-next-line jira/react/no-class-components
class $d19660dab3577820$var$ViewComponent extends (0, $5uXOq.Component) {
    getMoveIssuesTo() {
        const { shouldSwap: shouldSwap, swapComponent: swapComponent } = this.state;
        if (shouldSwap && swapComponent) return swapComponent.id;
        return undefined;
    }
    isDeleteDisabled() {
        if (this.state.shouldSwap) return !this.state.swapComponent;
        return this.props.isInProgress;
    }
    render() {
        const { context: { baseUrl: baseUrl, projectKey: projectKey, id: componentId, relatedIssueCount: relatedIssueCount, relatedIssueUrl: relatedIssueUrl, name: name }, onCancel: onCancel, isDialogOpen: isDialogOpen, intl: { formatMessage: formatMessage } } = this.props;
        const { shouldSwap: shouldSwap } = this.state;
        const dialogDescription = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, (0, $4R6GH.fg)('replace-anchor-with-link__morphinecake') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: relatedIssueUrl
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gj945.default).deleteComponentWarningLinkIssueTermRefresh : (0, $gj945.default).deleteComponentWarningLink, {
            relatedIssueCount: relatedIssueCount
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: relatedIssueUrl
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gj945.default).deleteComponentWarningLinkIssueTermRefresh : (0, $gj945.default).deleteComponentWarningLink, {
            relatedIssueCount: relatedIssueCount
        })), ' ', formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gj945.default).deleteComponentWillAffectIssuesIssueTermRefresh : (0, $gj945.default).deleteComponentWillAffectIssues, {
            relatedIssueCount: relatedIssueCount
        }), ' ', formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gj945.default).deleteComponentYouCanChangeIssuesIssueTermRefresh : (0, $gj945.default).deleteComponentYouCanChangeIssues, {
            relatedIssueCount: relatedIssueCount
        }));
        if (!isDialogOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
            messageId: "project-directories.components.delete.modal-dialog",
            messageType: "transactional",
            width: "medium",
            onClose: onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
            appearance: "danger",
            isMultiline: false
        }, formatMessage((0, $gj945.default).headerNew, {
            component: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, dialogDescription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d19660dab3577820$var$deleteOptionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
            name: "swap-option-swap",
            isChecked: shouldSwap,
            onChange: this.onSwapComponentsSelected,
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gj945.default).changeComponentRadioIssueTermRefresh : (0, $gj945.default).changeComponentRadio)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d19660dab3577820$var$ComponentPickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BOpI.default), {
            baseUrl: baseUrl,
            projectKeyOrId: projectKey,
            ignore: [
                componentId
            ],
            placeholder: formatMessage((0, $gj945.default).componentPickerPlaceholder),
            onSelected: this.onSwapComponentChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
            name: "swap-option-remove",
            isChecked: !shouldSwap,
            onChange: this.onRemoveComponentFromIssuesSelected,
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gj945.default).removeComponentRadioIssueTermRefresh : (0, $gj945.default).removeComponentRadio)
        }))), this.renderFooter())));
    }
    constructor(...args){
        super(...args), this.state = {
            shouldSwap: true,
            swapComponent: undefined
        }, this.onPrimaryClick = ()=>{
            const moveIssuesTo = this.getMoveIssuesTo();
            this.props.onConfirm(moveIssuesTo);
        }, this.onSwapComponentsSelected = ()=>{
            this.setState({
                shouldSwap: true
            });
        }, this.onRemoveComponentFromIssuesSelected = ()=>{
            this.setState({
                shouldSwap: false
            });
        }, this.onSwapComponentChange = (components)=>{
            this.setState({
                swapComponent: components && components[0]
            });
        }, this.renderFooter = ()=>{
            const { isInProgress: isInProgress, onCancel: onCancel, intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d19660dab3577820$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d19660dab3577820$var$ButtonsContainer, null, isInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $d19660dab3577820$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle-link",
                isDisabled: isInProgress,
                onClick: onCancel
            }, formatMessage((0, $gj945.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "danger",
                type: "submit",
                isDisabled: this.isDeleteDisabled(),
                onClick: this.onPrimaryClick
            }, formatMessage((0, $gj945.default).deleteButton)))));
        };
    }
}
var $d19660dab3577820$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($d19660dab3577820$var$ViewComponent);
const $d19660dab3577820$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d19660dab3577820$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
});
const $d19660dab3577820$var$deleteOptionsContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d19660dab3577820$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d19660dab3577820$var$ComponentPickerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mjv _19pk1b66 _2hwxidpf _otyrpxbi _18u01ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});

parcelRegister("1BOpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88c1102936575b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aLwja = parcelRequire("aLwja");

var $4U4qk = parcelRequire("4U4qk");

var $az4zD = parcelRequire("az4zD");

var $4hsxn = parcelRequire("4hsxn");

var $jaFn2 = parcelRequire("jaFn2");
const $f88c1102936575b2$var$optionFromComponent = (component)=>({
        value: component.id,
        label: component.name
    });
const $f88c1102936575b2$var$componentFromOption = (option)=>({
        id: option.value,
        name: option.label
    });
const $f88c1102936575b2$var$hasSameComponentIds = (newComponents, oldComponents)=>{
    if (newComponents === undefined || oldComponents === undefined) return newComponents === oldComponents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aLwja)))(newComponents, oldComponents, 'id').length === 0;
};
class $f88c1102936575b2$export$893706da3f9272af extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isMulti: false,
            isClearableWithCrossIcon: false,
            selectedComponents: undefined,
            label: '',
            placeholder: '',
            ignore: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!$f88c1102936575b2$var$hasSameComponentIds(props.selectedComponents, state.prevSelectedComponents)) return {
            ...state,
            selectedComponents: props.selectedComponents,
            prevSelectedComponentIds: props.selectedComponents
        };
        return null;
    }
    componentDidMount() {
        const { selectedComponents: selectedComponents } = this.state;
        if (selectedComponents && selectedComponents.some((x)=>!x.name)) this.fetchAndUpdateComponents(selectedComponents);
    }
    componentDidUpdate() {
        const { selectedComponents: selectedComponents } = this.state;
        if (selectedComponents && selectedComponents.some((x)=>!x.name)) this.fetchAndUpdateComponents(selectedComponents);
    }
    fetchAndUpdateComponents(selectedComponents) {
        const fillInSelectedComponents = (filledInComponents)=>{
            // Update the state only in case the component list wasn't changed
            if ($f88c1102936575b2$var$hasSameComponentIds(this.state.selectedComponents, selectedComponents)) {
                this.setState({
                    selectedComponents: filledInComponents
                });
                this.props.onSelected(filledInComponents);
            }
        };
        (0, $4hsxn.requestComponentObjects)(selectedComponents.map((x)=>x.id)).then(fillInSelectedComponents).catch(()=>fillInSelectedComponents(selectedComponents.filter((x)=>x.name)));
    }
    render() {
        const { label: label, placeholder: placeholder, isRequired: isRequired, isDisabled: isDisabled, isClearableWithCrossIcon: isClearableWithCrossIcon, isMulti: isMulti, intl: intl } = this.props;
        const selectedComponents = this.state.selectedComponents?.filter((x)=>x.name);
        const pickerProps = {
            label: label,
            placeholder: placeholder,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $jaFn2.default).error),
            options: this.renderOptions,
            ...isMulti ? {
                value: selectedComponents?.map($f88c1102936575b2$var$optionFromComponent),
                isMulti: true,
                onMultiSelected: this.onMultiSelected
            } : {
                value: selectedComponents && selectedComponents[0] && $f88c1102936575b2$var$optionFromComponent(selectedComponents[0]),
                isMulti: false,
                onSelected: this.onSelected
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.Picker), {
            intl: intl,
            ...pickerProps
        });
    }
    constructor(...args){
        super(...args), this.state = {
            selectedComponents: this.props.selectedComponents,
            prevSelectedComponents: this.props.selectedComponents
        }, this.onMultiSelected = (selectedOptions)=>{
            if (selectedOptions) {
                this.setState({
                    selectedComponents: selectedOptions.map($f88c1102936575b2$var$componentFromOption)
                });
                this.props.onSelected(selectedOptions.map($f88c1102936575b2$var$componentFromOption));
            } else {
                this.setState({
                    selectedComponents: undefined
                });
                this.props.onSelected(undefined);
            }
        }, this.onSelected = (selectedOption)=>{
            this.onMultiSelected(selectedOption && [
                selectedOption
            ]);
        }, this.renderOptions = (filter)=>// @ts-expect-error - TS2349 - This expression is not callable.
            (0, $4hsxn.requestComponentOptions)(this.props.projectKeyOrId, this.props.isMulti ? this.props.ignore.concat(this.state.selectedComponents?.map((x)=>x.id) || []) : this.props.ignore, filter);
    }
}
var $f88c1102936575b2$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($f88c1102936575b2$export$893706da3f9272af);

});
parcelRegister("aLwja", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */ var $7d675ae8c4878703$var$xorBy = $g7i7g(function(arrays) {
    var iteratee = $hYfgW(arrays);
    if ($f3SOL(iteratee)) iteratee = undefined;
    return $7txx8($2GdQn(arrays, $f3SOL), $bxDef(iteratee, 2));
});
module.exports = $7d675ae8c4878703$var$xorBy;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("4U4qk", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $0d1a93ba35d548ba$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $0d1a93ba35d548ba$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $0d1a93ba35d548ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");
var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $VgvL1 = parcelRequire("VgvL1");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $e239o = parcelRequire("e239o");
const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $e239o.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $0d1a93ba35d548ba$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZftP.default) : (0, $iOwNT.default);
        if (isAsync) return 0, $VgvL1.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $94bNw.default) : (0, $7K5PP.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $e239o.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>(0, $4R6GH.fg)('enable-project-picker-require-edit-permission') ? this.props.noOptionsMessage ?? formatMessage((0, $e239o.default).noOptions) : formatMessage((0, $e239o.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $e239o.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...(0, $4R6GH.fg)('jira_apply_prop_stylings_to_base_picker') ? this.props.styles : undefined,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $0d1a93ba35d548ba$var$PickerWithIntl = (0, $az4zD.injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
};
$0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
var $0d1a93ba35d548ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0d1a93ba35d548ba$var$DefaultPicker;
const $0d1a93ba35d548ba$var$StyledValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, $8CUq3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});


parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $itpgN = parcelRequire("itpgN");

var $7K5PP = parcelRequire("7K5PP");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});

parcelRegister("VgvL1", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $462c399840da3e1c$export$ee664e5add893f9);

var $d7FF4 = parcelRequire("d7FF4");

var $8oe80 = parcelRequire("8oe80");
const $462c399840da3e1c$export$ee664e5add893f9 = (0, $8oe80.default)('select', {
    onChange: 'changed'
})((0, $d7FF4.default));

});

parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("e239o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6849afedcc0fa8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("4hsxn", function(module, exports) {

$parcel$export(module.exports, "requestComponentOptions", () => $d947808212725a09$export$b17a6324e2e1c7f7);
$parcel$export(module.exports, "requestComponentObjects", () => $d947808212725a09$export$57acaec04cc6f107);

var $5voxU = parcelRequire("5voxU");

var $6WB7s = parcelRequire("6WB7s");
const $d947808212725a09$export$b17a6324e2e1c7f7 = (projectKeyOrId, ignore, filter)=>(0, $5voxU.getComponents)(projectKeyOrId, filter, ignore).then((data)=>(0, $6WB7s.transformToOptions)(data, ignore));
const $d947808212725a09$export$57acaec04cc6f107 = (componentIds)=>Promise.allSettled(componentIds.map((0, $5voxU.getComponent))).then((results)=>results.flatMap((x)=>x.status === 'fulfilled' ? [
                (0, $6WB7s.transformToComponent)(x.value)
            ] : []));

});
parcelRegister("5voxU", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $c3088710755bf287$export$f6b2881bc1090cea);
$parcel$export(module.exports, "getComponents", () => $c3088710755bf287$export$4e811121b221213b);
$parcel$export(module.exports, "getComponent", () => $c3088710755bf287$export$21a8719ce41a1de2);

var $7f4tk = parcelRequire("7f4tk");
const $c3088710755bf287$export$f6b2881bc1090cea = 5;
const $c3088710755bf287$export$4aa7fe68c5163f3d = (baseUrl, projectKeyOrId)=>`${baseUrl}/rest/api/2/project/${projectKeyOrId}/component`;
const $c3088710755bf287$export$7b8ce8b3873e394d = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/component`;
const $c3088710755bf287$export$5f0555d9912ed84 = (filter, ignore)=>`startAt=0&maxResults=${$c3088710755bf287$export$f6b2881bc1090cea + ignore.length}&query=${encodeURIComponent(filter)}`;
const $c3088710755bf287$export$1adc93310c566826 = (baseUrl, projectKeyOrId, filter, ignore)=>`${$c3088710755bf287$export$4aa7fe68c5163f3d(baseUrl, projectKeyOrId)}?${$c3088710755bf287$export$5f0555d9912ed84(filter, ignore)}`;
const $c3088710755bf287$export$379bde45c66d6bf3 = (projectKeyOrId, filter, ignore)=>`${$c3088710755bf287$export$7b8ce8b3873e394d(projectKeyOrId)}?${$c3088710755bf287$export$5f0555d9912ed84(filter, ignore)}`;
const $c3088710755bf287$export$e1462d7e65c4432f = (baseUrl, projectKeyOrId, filter, ignore)=>(0, $7f4tk.default)($c3088710755bf287$export$1adc93310c566826(baseUrl, projectKeyOrId, filter, ignore));
const $c3088710755bf287$export$4e811121b221213b = (projectKeyOrId, filter, ignore)=>(0, $7f4tk.default)($c3088710755bf287$export$379bde45c66d6bf3(projectKeyOrId, filter, ignore));
const $c3088710755bf287$export$2b0e03bdc48b0fb8 = (componentId)=>`/rest/api/3/component/${componentId}`;
const $c3088710755bf287$export$21a8719ce41a1de2 = (componentId)=>(0, $7f4tk.default)($c3088710755bf287$export$2b0e03bdc48b0fb8(componentId));

});

parcelRegister("6WB7s", function(module, exports) {

$parcel$export(module.exports, "transformToComponent", () => $415835f85689b4f3$export$4db7477f39e92dcc);
$parcel$export(module.exports, "transformToOptions", () => $415835f85689b4f3$export$899758961952c638);

var $5voxU = parcelRequire("5voxU");
const $415835f85689b4f3$var$transformOption = (component)=>({
        value: component.id,
        label: component.name
    });
const $415835f85689b4f3$export$4db7477f39e92dcc = ({ id: id, name: name })=>({
        id: id,
        name: name
    });
const $415835f85689b4f3$export$899758961952c638 = (data, ignore)=>{
    const { values: values } = data;
    return values.filter((value)=>!ignore.includes(value.id)).map($415835f85689b4f3$var$transformOption).slice(0, (0, $5voxU.MAX_RESULTS));
};

});


parcelRegister("jaFn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8794180f1ba05d01$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8794180f1ba05d01$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "component-picker.error",
        "defaultMessage": "We couldn't retrieve components"
    }
});

});


parcelRegister("gj945", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f101421073c163a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var // eslint-disable-next-line formatjs/no-multiple-plurals
$2f101421073c163a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    headerNew: {
        "id": "project-directories.components.delete.header-new",
        "defaultMessage": "Delete {component} component"
    },
    deleteButton: {
        "id": "project-directories.components.delete.delete-button",
        "defaultMessage": "Delete"
    },
    cancelButton: {
        "id": "project-directories.components.delete.cancel-button",
        "defaultMessage": "Cancel"
    },
    deleteComponentCount: {
        "id": "project-directories.components.delete.delete-component-count",
        "defaultMessage": "{count} {count, plural, one {issue} other {issues}}"
    },
    deleteComponentRestMessage: {
        "id": "project-directories.components.delete.delete-component-rest-message",
        "defaultMessage": " use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this issue} other {these issues}}."
    },
    deleteComponentWarningLink: {
        "id": "project-directories.components.delete.delete-component-warning-link",
        "defaultMessage": "{relatedIssueCount, plural, one {There is 1 issue} other {There are {relatedIssueCount} issues}} using this component."
    },
    deleteComponentWillAffectIssues: {
        "id": "project-directories.components.delete.delete-component-will-affect-issues",
        "defaultMessage": "Deleting this component will affect {relatedIssueCount, plural, one {this issue} other {these issues}}."
    },
    deleteComponentYouCanChangeIssues: {
        "id": "project-directories.components.delete.delete-component-you-can-change-issues",
        "defaultMessage": "You can change the component or remove the component {relatedIssueCount, plural, one {from this issue} other {from these issues}}."
    },
    changeComponentRadio: {
        "id": "project-directories.components.delete.change-component-radio",
        "defaultMessage": "Change current issues to component"
    },
    removeComponentRadio: {
        "id": "project-directories.components.delete.remove-component-radio",
        "defaultMessage": "Remove component from all issues."
    },
    componentPickerPlaceholder: {
        "id": "project-directories.components.delete.component-picker-placeholder",
        "defaultMessage": "Select component"
    },
    deleteComponentCountIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-count-issue-term-refresh",
        "defaultMessage": "{count} {count, plural, one {work item} other {work items}}"
    },
    deleteComponentRestMessageIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-rest-message-issue-term-refresh",
        "defaultMessage": " use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this work item} other {these work items}}."
    },
    deleteComponentWarningLinkIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-warning-link-issue-term-refresh",
        "defaultMessage": "{relatedIssueCount, plural, one {There is 1 work item} other {There are {relatedIssueCount} work items}} using this component."
    },
    deleteComponentWillAffectIssuesIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-will-affect-issues-issue-term-refresh",
        "defaultMessage": "Deleting this component will affect {relatedIssueCount, plural, one {this work item} other {these work items}}."
    },
    deleteComponentYouCanChangeIssuesIssueTermRefresh: {
        "id": "project-directories.components.delete.delete-component-you-can-change-issues-issue-term-refresh",
        "defaultMessage": "You can change the component or remove the component {relatedIssueCount, plural, one {from this work item} other {from these work items}}."
    },
    changeComponentRadioIssueTermRefresh: {
        "id": "project-directories.components.delete.change-component-radio-issue-term-refresh",
        "defaultMessage": "Change current work items to component"
    },
    removeComponentRadioIssueTermRefresh: {
        "id": "project-directories.components.delete.remove-component-radio-issue-term-refresh",
        "defaultMessage": "Remove component from all work items."
    }
});

});








parcelRegister("1JC75", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db0d8e6d6274bc7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bC2fB = parcelRequire("bC2fB");

var $hYyP7 = parcelRequire("hYyP7");

var $lrD6Q = parcelRequire("lrD6Q");

var $6z9Py = parcelRequire("6z9Py");

var $golPT = parcelRequire("golPT");

var $j4QfZ = parcelRequire("j4QfZ");

var $8Y4HQ = parcelRequire("8Y4HQ");
function $9db0d8e6d6274bc7$var$AddModal(props) {
    const { locale: locale, baseUrl: baseUrl, projectId: projectId, projectKey: projectKey, projectDefaultAssignee: projectDefaultAssignee, projectLead: projectLead, onClose: onClose, onComplete: onComplete, onError: onError, isDialogOpen: isDialogOpen } = props;
    if (!isDialogOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYyP7.default), {
        locale: locale,
        baseUrl: baseUrl,
        projectId: projectId,
        projectKey: projectKey,
        projectDefaultAssignee: projectDefaultAssignee,
        projectLead: projectLead,
        onClose: onClose,
        onComplete: onComplete,
        onError: onError
    });
}
const $9db0d8e6d6274bc7$var$mapStateToProps = (state)=>({
        locale: (0, $6z9Py.getLocale)(state),
        baseUrl: (0, $6z9Py.getBaseUrl)(state),
        isDialogOpen: (0, $8Y4HQ.isOpen)(state),
        projectId: (0, $golPT.getProjectId)(state),
        projectKey: (0, $golPT.getProjectKey)(state),
        projectDefaultAssignee: (0, $golPT.getProjectDefaultAssignee)(state),
        projectLead: (0, $golPT.getProjectLead)(state)
    });
const $9db0d8e6d6274bc7$var$mapDispatchToProps = {
    onClose: (0, $j4QfZ.cancel),
    onComplete: (0, $lrD6Q.addComponentSuccess),
    onError: (0, $lrD6Q.addComponentFail)
};
var $9db0d8e6d6274bc7$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($9db0d8e6d6274bc7$var$mapStateToProps, $9db0d8e6d6274bc7$var$mapDispatchToProps)($9db0d8e6d6274bc7$var$AddModal);

});
parcelRegister("hYyP7", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb58d65fe4ad21b8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $7iJwP = parcelRequire("7iJwP");

var $iRwiU = parcelRequire("iRwiU");

var $kNwfy = parcelRequire("kNwfy");

var $fcGTa = parcelRequire("fcGTa");

var $eT3xV = parcelRequire("eT3xV");

var $8037W = parcelRequire("8037W");
class $eb58d65fe4ad21b8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            projectDefaultAssignee: undefined,
            projectLead: undefined
        };
    }
    constructor(props){
        super(props);
        // @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
        this.store = (0, $eT3xV.default)((0, $iRwiU.default));
        this.initializeProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.initializeProps(nextProps);
    }
    initializeProps(props) {
        this.store.dispatch((0, $fcGTa.setAppProps)(props));
        (0, $kNwfy.setBaseUrl)(props.baseUrl);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8037W.default), null))));
    }
}

});
parcelRegister("iRwiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90207b63e9c3247$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $jknN4 = parcelRequire("jknN4");
var $a90207b63e9c3247$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $jknN4.onSave), (0, $jknN4.onClose), (0, $jknN4.onComplete), (0, $jknN4.onError));

});
parcelRegister("jknN4", function(module, exports) {

$parcel$export(module.exports, "onClose", () => $b154c2fc6bcd7c90$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "onComplete", () => $b154c2fc6bcd7c90$export$e82b76dc89ff0f64);
$parcel$export(module.exports, "onError", () => $b154c2fc6bcd7c90$export$2288787135a8f66e);
$parcel$export(module.exports, "onSave", () => $b154c2fc6bcd7c90$export$87b124fe38894ca4);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("6hSeW");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");

var $jJZqs = parcelRequire("jJZqs");


var $2rKcu = parcelRequire("2rKcu");

var $fcGTa = parcelRequire("fcGTa");

var $cEpBz = parcelRequire("cEpBz");
const $b154c2fc6bcd7c90$var$LOG_LOCATION = 'project-components.state.epics.create';
const $b154c2fc6bcd7c90$var$epicOf = (type, handler)=>(action$, store)=>action$.ofType(type).mergeMap((action)=>handler(action, store.getState()));
const $b154c2fc6bcd7c90$export$f312d3bc7ef841a8 = $b154c2fc6bcd7c90$var$epicOf((0, $fcGTa.CANCEL), (action, state)=>{
    (0, $cEpBz.getOnClose)(state)();
    return (0, $kVLXA.Observable).empty();
});
const $b154c2fc6bcd7c90$export$e82b76dc89ff0f64 = $b154c2fc6bcd7c90$var$epicOf((0, $fcGTa.SUCCESS), ({ payload: payload }, state)=>{
    (0, $cEpBz.getOnComplete)(state)(payload);
    return (0, $kVLXA.Observable).empty();
});
const $b154c2fc6bcd7c90$export$2288787135a8f66e = $b154c2fc6bcd7c90$var$epicOf((0, $fcGTa.FAILURE), (action, state)=>{
    (0, $cEpBz.getOnError)(state)();
    return (0, $kVLXA.Observable).empty();
});
const $b154c2fc6bcd7c90$export$87b124fe38894ca4 = $b154c2fc6bcd7c90$var$epicOf((0, $fcGTa.SAVE), (action, state)=>{
    const projectId = (0, $cEpBz.getProjectId)(state);
    const projectKey = (0, $cEpBz.getProjectKey)(state);
    const component = (0, $cEpBz.getComponent)(state);
    return (0, $kVLXA.Observable).fromPromise((0, $2rKcu.create)(projectId, projectKey, component)).mergeMap((createdComponent)=>(0, $kVLXA.Observable).of((0, $fcGTa.success)(createdComponent)))// @ts-expect-error - TS2345 - Argument of type '(error: any) => Observable<ValidationFailureAction> | Observable<FailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<SuccessAction>) => ObservableInput<ValidationFailureAction>'.
    .catch((error)=>{
        (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, $b154c2fc6bcd7c90$var$LOG_LOCATION, (0, $9f04abe75161e860$export$1089831196ae0f84));
        if (error instanceof (0, $jJZqs.ValidationError)) return (0, $kVLXA.Observable).of((0, $fcGTa.validationFailure)(error.errors));
        return (0, $kVLXA.Observable).of((0, $fcGTa.failure)());
    });
});

});
parcelRegister("2rKcu", function(module, exports) {

$parcel$export(module.exports, "create", () => $8c7e87dac4b88d55$export$185802fd694ee1f5);

var $2wfmR = parcelRequire("2wfmR");

var $5OBPr = parcelRequire("5OBPr");

var $kNwfy = parcelRequire("kNwfy");

var $9Xvzj = parcelRequire("9Xvzj");
const $8c7e87dac4b88d55$export$185802fd694ee1f5 = (projectId, projectKey, component)=>{
    const { name: name, description: description, lead: lead, defaultAssignee: defaultAssignee } = component;
    const componentLeadField = lead && {
        leadAccountId: lead.accountId
    };
    const payload = {
        name: name,
        description: description,
        assigneeType: defaultAssignee,
        project: projectKey,
        projectId: projectId,
        ...componentLeadField
    };
    return (0, $2wfmR.default)((0, $5OBPr.create)((0, $kNwfy.getBaseUrl)(), payload), (0, $9Xvzj.transformComponent), projectKey);
};

});
parcelRegister("2wfmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d0a149c2cf3e515$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $3NMrl = parcelRequire("3NMrl");

var $jSYEh = parcelRequire("jSYEh");

var $do78Z = parcelRequire("do78Z");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d0a149c2cf3e515$export$2e2bcd8739ae039 = (promise, transformer, projectKey)=>promise.then((response)=>Promise.all([
            response.ok,
            response.json()
        ])) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .then(([ok, json])=>{
        if (ok) {
            const component = transformer(json);
            if (component.id !== undefined) {
                const newComponent = {
                    ...component,
                    projectKey: projectKey
                };
                try {
                    (0, $do78Z.default).set(component.id.toString(), newComponent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('project-directories.components.cache.set', error.message);
                }
            }
            return component;
        }
        const errors = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(json.errors, [
            'name',
            'componentLead'
        ]);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errors)) {
            const fieldErrors = (0, (/*@__PURE__*/$parcel$interopDefault($jSYEh)))(errors).map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            ([field, error])=>({
                    field: field,
                    error: error
                }));
            throw new (0, $jJZqs.ValidationError)('Validation error', fieldErrors);
        }
        throw new Error(`Request failed with a json response but cannot extract validation errors: ${JSON.stringify(json)}`);
    }).catch((e)=>{
        throw e instanceof Error ? e : new Error(e);
    });

});
parcelRegister("jSYEh", function(module, exports) {

var $i8saS = parcelRequire("i8saS");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */ var $e7a21b07870b5d21$var$toPairs = $i8saS($66FNL);
module.exports = $e7a21b07870b5d21$var$toPairs;

});
parcelRegister("i8saS", function(module, exports) {

var $ePDPz = parcelRequire("ePDPz");

var $jtBGw = parcelRequire("jtBGw");

var $f1B3k = parcelRequire("f1B3k");

var $cir7h = parcelRequire("cir7h");
/** `Object#toString` result references. */ var $d33ed43950bf1011$var$mapTag = '[object Map]', $d33ed43950bf1011$var$setTag = '[object Set]';
/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */ function $d33ed43950bf1011$var$createToPairs(keysFunc) {
    return function(object) {
        var tag = $jtBGw(object);
        if (tag == $d33ed43950bf1011$var$mapTag) return $f1B3k(object);
        if (tag == $d33ed43950bf1011$var$setTag) return $cir7h(object);
        return $ePDPz(object, keysFunc(object));
    };
}
module.exports = $d33ed43950bf1011$var$createToPairs;

});
parcelRegister("ePDPz", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");
/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */ function $acc4b9adaa827983$var$baseToPairs(object, props) {
    return $1nIHN(props, function(key) {
        return [
            key,
            object[key]
        ];
    });
}
module.exports = $acc4b9adaa827983$var$baseToPairs;

});

parcelRegister("cir7h", function(module, exports) {
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */ function $8f3c33364ffffb3b$var$setToPairs(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = [
            value,
            value
        ];
    });
    return result;
}
module.exports = $8f3c33364ffffb3b$var$setToPairs;

});




parcelRegister("5OBPr", function(module, exports) {

$parcel$export(module.exports, "create", () => $ea47f344f49fe04c$export$185802fd694ee1f5);

var $lEFJO = parcelRequire("lEFJO");
const $ea47f344f49fe04c$export$94df0e59ebebf4a7 = (baseUrl)=>`${baseUrl}/rest/api/2/component`;
const $ea47f344f49fe04c$export$185802fd694ee1f5 = (baseUrl, payload)=>fetch($ea47f344f49fe04c$export$94df0e59ebebf4a7(baseUrl), (0, $lEFJO.createOptions)('POST', payload));

});

parcelRegister("kNwfy", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $6aa8e84b0e436932$export$f654b28f82155665);
$parcel$export(module.exports, "setBaseUrl", () => $6aa8e84b0e436932$export$9c999f676138fa5b);
let $6aa8e84b0e436932$var$baseUrl = '';
const $6aa8e84b0e436932$export$f654b28f82155665 = ()=>$6aa8e84b0e436932$var$baseUrl;
const $6aa8e84b0e436932$export$9c999f676138fa5b = (url)=>{
    $6aa8e84b0e436932$var$baseUrl = url;
};

});

parcelRegister("9Xvzj", function(module, exports) {

$parcel$export(module.exports, "transformComponent", () => $37aaa84f4076f24a$export$79ccea7e11af4b35);
const $37aaa84f4076f24a$export$79ccea7e11af4b35 = (component)=>{
    const { id: id, name: name, self: self } = component;
    return {
        id: id,
        name: name,
        self: self
    };
};

});


parcelRegister("fcGTa", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $afb3c7491f18279a$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $afb3c7491f18279a$export$cfda7627848a58cd);
$parcel$export(module.exports, "SAVE", () => $afb3c7491f18279a$export$f9ec4afc4535638b);
$parcel$export(module.exports, "save", () => $afb3c7491f18279a$export$a1544dad697b423d);
$parcel$export(module.exports, "CANCEL", () => $afb3c7491f18279a$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $afb3c7491f18279a$export$70b61ad426ddbe54);
$parcel$export(module.exports, "UPDATE", () => $afb3c7491f18279a$export$e271b26eefe41db8);
$parcel$export(module.exports, "update", () => $afb3c7491f18279a$export$722fbec263ad908a);
$parcel$export(module.exports, "SUCCESS", () => $afb3c7491f18279a$export$638cc6e36b2a737a);
$parcel$export(module.exports, "success", () => $afb3c7491f18279a$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "VALIDATION_FAILURE", () => $afb3c7491f18279a$export$f73e519c8b2ca03a);
$parcel$export(module.exports, "validationFailure", () => $afb3c7491f18279a$export$ad2c1d94a94ea0c1);
$parcel$export(module.exports, "FAILURE", () => $afb3c7491f18279a$export$5b1e245d5eac107);
$parcel$export(module.exports, "failure", () => $afb3c7491f18279a$export$af2dba6db4e9e1f0);
const $afb3c7491f18279a$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $afb3c7491f18279a$export$cfda7627848a58cd = (payload)=>({
        type: $afb3c7491f18279a$export$8aefe701a6f431e0,
        payload: payload
    });
const $afb3c7491f18279a$export$f9ec4afc4535638b = 'state.SAVE';
const $afb3c7491f18279a$export$a1544dad697b423d = ()=>({
        type: $afb3c7491f18279a$export$f9ec4afc4535638b
    });
const $afb3c7491f18279a$export$2b10f4b30fb65583 = 'state.CANCEL';
const $afb3c7491f18279a$export$70b61ad426ddbe54 = ()=>({
        type: $afb3c7491f18279a$export$2b10f4b30fb65583
    });
const $afb3c7491f18279a$export$e271b26eefe41db8 = 'state.UPDATE';
const $afb3c7491f18279a$export$722fbec263ad908a = (payload)=>({
        type: $afb3c7491f18279a$export$e271b26eefe41db8,
        payload: payload
    });
const $afb3c7491f18279a$export$638cc6e36b2a737a = 'state.SUCCESS';
const $afb3c7491f18279a$export$fe7c49d056ea1d88 = (payload)=>({
        type: $afb3c7491f18279a$export$638cc6e36b2a737a,
        payload: payload
    });
const $afb3c7491f18279a$export$f73e519c8b2ca03a = 'state.VALIDATION_FAILURE';
const $afb3c7491f18279a$export$ad2c1d94a94ea0c1 = (payload)=>({
        type: $afb3c7491f18279a$export$f73e519c8b2ca03a,
        payload: payload
    });
const $afb3c7491f18279a$export$5b1e245d5eac107 = 'state.FAILURE';
const $afb3c7491f18279a$export$af2dba6db4e9e1f0 = ()=>({
        type: $afb3c7491f18279a$export$5b1e245d5eac107
    });

});

parcelRegister("cEpBz", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $124334f8ad752270$export$f654b28f82155665);
$parcel$export(module.exports, "getProjectKey", () => $124334f8ad752270$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $124334f8ad752270$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectDefaultAssignee", () => $124334f8ad752270$export$be28a82d4e8d697f);
$parcel$export(module.exports, "getProjectLeadName", () => $124334f8ad752270$export$c5b979a08b55628c);
$parcel$export(module.exports, "getOnClose", () => $124334f8ad752270$export$87f3187c49e686c);
$parcel$export(module.exports, "getOnComplete", () => $124334f8ad752270$export$a92edfca0b454563);
$parcel$export(module.exports, "getOnError", () => $124334f8ad752270$export$60888e2ed0df5dfd);
$parcel$export(module.exports, "getComponent", () => $124334f8ad752270$export$21a8719ce41a1de2);
$parcel$export(module.exports, "getName", () => $124334f8ad752270$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getDescription", () => $124334f8ad752270$export$67580b1c13935958);
$parcel$export(module.exports, "getDefaultAssignee", () => $124334f8ad752270$export$725da8bee1e71eb0);
$parcel$export(module.exports, "getLead", () => $124334f8ad752270$export$97850e2d25587c0d);
$parcel$export(module.exports, "getNameErrorMessage", () => $124334f8ad752270$export$6222164b63cc3ae9);
$parcel$export(module.exports, "isSaving", () => $124334f8ad752270$export$3b51d1dcee070cea);
$parcel$export(module.exports, "canSubmit", () => $124334f8ad752270$export$f5bccce225aa614b);
const $124334f8ad752270$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $124334f8ad752270$export$667f2a0f99c75faa = (state)=>state.appProps.projectKey;
const $124334f8ad752270$export$89040d072f281f85 = (state)=>state.appProps.projectId;
const $124334f8ad752270$export$be28a82d4e8d697f = (state)=>state.appProps.projectDefaultAssignee;
const $124334f8ad752270$export$c5b979a08b55628c = (state)=>state.appProps.projectLead ? state.appProps.projectLead.displayName : '';
const $124334f8ad752270$export$87f3187c49e686c = (state)=>state.appProps.onClose;
const $124334f8ad752270$export$a92edfca0b454563 = (state)=>state.appProps.onComplete;
const $124334f8ad752270$export$60888e2ed0df5dfd = (state)=>state.appProps.onError;
const $124334f8ad752270$export$21a8719ce41a1de2 = (state)=>state.component;
const $124334f8ad752270$export$7d9f7e9c1c02b41e = (state)=>state.component.name;
const $124334f8ad752270$export$67580b1c13935958 = (state)=>state.component.description;
const $124334f8ad752270$export$725da8bee1e71eb0 = (state)=>state.component.defaultAssignee;
const $124334f8ad752270$export$97850e2d25587c0d = (state)=>state.component.lead;
const $124334f8ad752270$export$6222164b63cc3ae9 = (state)=>state.errors.name;
const $124334f8ad752270$export$8802ac508ab8d49a = (state)=>state.errors.componentLead;
const $124334f8ad752270$export$3b51d1dcee070cea = (state)=>state.isSaving;
const $124334f8ad752270$export$f5bccce225aa614b = (state)=>!$124334f8ad752270$export$3b51d1dcee070cea(state) && !!$124334f8ad752270$export$7d9f7e9c1c02b41e(state).trim();

});



parcelRegister("eT3xV", function(module, exports) {

$parcel$export(module.exports, "default", () => $240fa1e7f92e5c2d$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $hkadP = parcelRequire("hkadP");

var $cGSrN = parcelRequire("cGSrN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$240fa1e7f92e5c2d$export$2e2bcd8739ae039 = (rootEpic, initialState, middlewares = [])=>(0, $3f2cs.createStore)((0, $cGSrN.default), initialState, (0, $hkadP.default)({
        name: 'Create component modal'
    })((0, $3f2cs.applyMiddleware)(...middlewares, (0, $e1AU2.createEpicMiddleware)(rootEpic))));

});
parcelRegister("cGSrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade61a984e44dcee$export$2e2bcd8739ae039);

var $1sWm7 = parcelRequire("1sWm7");

var $8Rkzz = parcelRequire("8Rkzz");

var $lzeFL = parcelRequire("lzeFL");

var $g5X3G = parcelRequire("g5X3G");


var $fcGTa = parcelRequire("fcGTa");
const $ade61a984e44dcee$var$defaultState = {
    appProps: {
        baseUrl: '',
        locale: (0, $lzeFL.defaultLocale),
        projectId: NaN,
        projectKey: (0, $g5X3G.toProjectKey)(''),
        projectDefaultAssignee: undefined,
        projectLead: undefined,
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    isSaving: false,
    component: {
        name: '',
        description: '',
        defaultAssignee: (0, $67451e0b83279376$export$dfc4824370fdf2e8),
        lead: undefined
    },
    errors: {
        name: '',
        componentLead: ''
    }
};
const $ade61a984e44dcee$var$getFieldError = (payload, field)=>{
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(payload, {
        field: field
    }) || {};
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type '{}'.
    return result.error || '';
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ade61a984e44dcee$export$2e2bcd8739ae039 = (state = $ade61a984e44dcee$var$defaultState, action)=>{
    switch(action.type){
        case 0, $fcGTa.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $fcGTa.UPDATE:
            return {
                ...state,
                component: action.payload
            };
        case 0, $fcGTa.SAVE:
            return {
                ...state,
                isSaving: true,
                errors: {
                    name: '',
                    componentLead: ''
                }
            };
        case 0, $fcGTa.VALIDATION_FAILURE:
            return {
                ...state,
                isSaving: false,
                errors: {
                    name: $ade61a984e44dcee$var$getFieldError(action.payload, 'name'),
                    componentLead: $ade61a984e44dcee$var$getFieldError(action.payload, 'componentLead')
                }
            };
        case 0, $fcGTa.FAILURE:
        case 0, $fcGTa.CANCEL:
        case 0, $fcGTa.SUCCESS:
            return {
                ...state,
                isSaving: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});


const $67451e0b83279376$export$e141a3d44fafd179 = 'COMPONENT_LEAD';
const $67451e0b83279376$export$dfc4824370fdf2e8 = 'PROJECT_DEFAULT';
const $67451e0b83279376$export$3c83461db52a5dd6 = 'PROJECT_LEAD';
const $67451e0b83279376$export$3f4d79509888a8a1 = 'UNASSIGNED';



parcelRegister("8037W", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a11a03060ab8e2d$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $fcGTa = parcelRequire("fcGTa");

var $cEpBz = parcelRequire("cEpBz");

var $9MjQX = parcelRequire("9MjQX");
const $6a11a03060ab8e2d$var$mapStateToProps = (state)=>({
        baseUrl: (0, $cEpBz.getBaseUrl)(state),
        isSaving: (0, $cEpBz.isSaving)(state),
        canSubmit: (0, $cEpBz.canSubmit)(state),
        projectDefaultAssignee: (0, $cEpBz.getProjectDefaultAssignee)(state),
        projectLeadName: (0, $cEpBz.getProjectLeadName)(state),
        name: (0, $cEpBz.getName)(state),
        description: (0, $cEpBz.getDescription)(state),
        lead: (0, $cEpBz.getLead)(state),
        defaultAssignee: (0, $cEpBz.getDefaultAssignee)(state),
        nameErrorMessage: (0, $cEpBz.getNameErrorMessage)(state)
    });
const $6a11a03060ab8e2d$var$mapDispatchToProps = {
    onCancel: (0, $fcGTa.cancel),
    onConfirm: (0, $fcGTa.save),
    onUpdateComponent: (0, $fcGTa.update)
};
var $6a11a03060ab8e2d$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6a11a03060ab8e2d$var$mapStateToProps, $6a11a03060ab8e2d$var$mapDispatchToProps)((0, $9MjQX.default));

});
parcelRegister("9MjQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b096de3f718753ca$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $az4zD = parcelRequire("az4zD");

var $kZuyZ = parcelRequire("kZuyZ");

var $kbby2 = parcelRequire("kbby2");
const $b096de3f718753ca$var$Header = ({ intl: { formatMessage: formatMessage } })=>// eslint-disable-next-line @atlaskit/design-system/use-heading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h2", null, formatMessage((0, $kbby2.default).globalComponentsHeader));
const $b096de3f718753ca$var$Footer = ({ intl: { formatMessage: formatMessage }, isSaving: isSaving, canSubmit: canSubmit, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b096de3f718753ca$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b096de3f718753ca$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        type: "submit",
        onClick: onConfirm,
        isDisabled: !canSubmit,
        externalId: "project-components.item.add"
    }, formatMessage((0, $kbby2.default).saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onCancel,
        isDisabled: isSaving
    }, formatMessage((0, $kbby2.default).cancelButton))));
function $b096de3f718753ca$var$CreateModal(props) {
    const { baseUrl: baseUrl, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName, isSaving: isSaving, canSubmit: canSubmit, name: name, description: description, lead: lead, defaultAssignee: defaultAssignee, intl: intl, onConfirm: onConfirm, onCancel: onCancel, onUpdateComponent: onUpdateComponent, nameErrorMessage: nameErrorMessage } = props;
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const HeaderComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b096de3f718753ca$var$Header, {
            intl: intl
        }); // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const FooterComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b096de3f718753ca$var$Footer, {
            intl: intl,
            isSaving: isSaving,
            canSubmit: canSubmit,
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        autoFocus: true,
        onClose: onCancel,
        width: "medium",
        messageId: "project-directories.components.create-modal.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZuyZ.default), {
        baseUrl: baseUrl,
        onUpdateComponent: onUpdateComponent,
        projectDefaultAssignee: projectDefaultAssignee,
        projectLeadName: projectLeadName,
        name: name,
        description: description,
        lead: lead,
        defaultAssignee: defaultAssignee,
        nameErrorMessage: nameErrorMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FooterComponent, null)));
}
var $b096de3f718753ca$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($b096de3f718753ca$var$CreateModal);
const $b096de3f718753ca$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b096de3f718753ca$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kZuyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $19656a6f23a8067f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $cV5hj = parcelRequire("cV5hj");
var $kxqHl = parcelRequire("kxqHl");

var $kY99m = parcelRequire("kY99m");

var $az4zD = parcelRequire("az4zD");

var $imOJb = parcelRequire("imOJb");

var $4R6GH = parcelRequire("4R6GH");

var $eRV8v = parcelRequire("eRV8v");

var $h1wWv = parcelRequire("h1wWv");
// eslint-disable-next-line jira/react/no-class-components
class $19656a6f23a8067f$var$ModalCommonContent extends (0, $5uXOq.PureComponent) {
    componentDidUpdate(prevProps) {
        if (this.props.nameErrorMessage && !prevProps.nameErrorMessage) // do it a little bit later to avoid animation clipping
        setTimeout(()=>{
            if (this.nameFieldInstance) this.nameFieldInstance.focus();
        });
    }
    inputChange(update) {
        const { name: name, description: description, lead: lead, defaultAssignee: defaultAssignee, onUpdateComponent: onUpdateComponent } = this.props;
        const oldComponent = {
            name: name,
            description: description,
            lead: lead,
            defaultAssignee: defaultAssignee
        };
        const newComponent = {
            ...oldComponent,
            ...update
        };
        onUpdateComponent(newComponent);
    }
    generateLeadWithStatus(lead) {
        const { formatMessage: formatMessage } = this.props.intl;
        if (lead && lead.active === false) return {
            ...lead,
            displayName: formatMessage((0, $h1wWv.default).deactivated, {
                userName: lead.displayName
            })
        };
        return lead;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, nameErrorMessage: nameErrorMessage, baseUrl: baseUrl, projectLeadName: projectLeadName, projectDefaultAssignee: projectDefaultAssignee, name: name, description: description, lead: lead, defaultAssignee: defaultAssignee } = this.props;
        const isInvalid = !!nameErrorMessage;
        const selectedLead = this.generateLeadWithStatus(lead);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "project-directories.components.common.components.configuration"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cV5hj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            "aria-hidden": "true"
        }, formatMessage((0, $h1wWv.default).requiredFieldsInformMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxqHl.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "component-name",
            isRequired: true,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19656a6f23a8067f$var$FieldLabelWrapper, null, formatMessage((0, $h1wWv.default).componentName))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                ...isInvalid ? {
                    'aria-describedby': `${fieldProps.id}-error ${fieldProps['aria-describedby']}`
                } : {},
                autoFocus: true,
                onChange: this.onChangeComponentName,
                value: name,
                isInvalid: isInvalid,
                "aria-invalid": isInvalid,
                maxLength: 255,
                ref: (instance)=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    this.nameFieldInstance = instance;
                }
            }), nameErrorMessage !== undefined && nameErrorMessage !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, nameErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "component-description",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19656a6f23a8067f$var$FieldLabelWrapper, null, formatMessage((0, $h1wWv.default).description))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                onChange: this.onChangeComponentDescription,
                value: description
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imOJb.default), {
            label: formatMessage((0, $h1wWv.default).componentLead),
            placeholder: formatMessage((0, $h1wWv.default).componentLeadPlaceholder),
            selectedUser: selectedLead,
            baseUrl: baseUrl,
            onChange: this.onLeadSelected,
            shouldFitContainer: true,
            isClearable: (0, $4R6GH.fg)('jracloud-93602-can-unassign-lead-from-proj-comp'),
            isClearableWithCrossIcon: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRV8v.default), {
            label: formatMessage((0, $h1wWv.default).defaultAssignee),
            projectDefaultAssignee: projectDefaultAssignee,
            projectLeadName: projectLeadName,
            componentLeadName: lead && lead.displayName,
            onSelected: this.onAssigneeChange,
            value: defaultAssignee
        }));
    }
    constructor(...args){
        super(...args), this.onChangeComponentName = (e)=>{
            this.inputChange({
                name: e.target.value
            });
        }, this.onChangeComponentDescription = (e)=>{
            this.inputChange({
                description: e.target.value
            });
        }, this.onLeadSelected = (user)=>{
            this.inputChange({
                lead: user ? {
                    accountId: user.accountId,
                    displayName: user.displayName,
                    avatarUrl: user.avatarUrl,
                    /*
                        This is hardcoded to true as user from the user picker does not return its status.
                        Since user picker is always returning the active user, it should be safe to hard code to be active user.
                         */ active: true
                } : undefined
            });
        }, this.onAssigneeChange = (assignee)=>{
            this.inputChange({
                defaultAssignee: assignee
            });
        };
    }
}
var $19656a6f23a8067f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($19656a6f23a8067f$var$ModalCommonContent);
const $19656a6f23a8067f$var$FieldLabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cV5hj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0caf51f4b6a6db$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $3b0caf51f4b6a6db$var$formHeaderContentStyles = null;
const $3b0caf51f4b6a6db$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $3b0caf51f4b6a6db$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
var $3b0caf51f4b6a6db$export$2e2bcd8739ae039 = $3b0caf51f4b6a6db$var$FormHeader;

});

parcelRegister("imOJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ffec577315758c$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $7ffSD = parcelRequire("7ffSD");
var $66ffec577315758c$export$2e2bcd8739ae039 = (0, $8oe80.default)('UserPicker', {
    onChange: 'changed'
})((0, $7ffSD.default));

});
parcelRegister("7ffSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ea91f281eaff85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $4USKh = parcelRequire("4USKh");

var $2YZCu = parcelRequire("2YZCu");

var $az4zD = parcelRequire("az4zD");

var $6GCo0 = parcelRequire("6GCo0");

var $8jpCj = parcelRequire("8jpCj");
class $63ea91f281eaff85$export$83e0c73b09b3a9cd extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { baseUrl: baseUrl, suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $6GCo0.requestUsers)(baseUrl, query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $6GCo0.requestUser)(baseUrl, suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $7Jxgt.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $2YZCu.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $6GCo0.requestUser)(this.props.baseUrl, accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $8jpCj.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4USKh.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $8jpCj.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $8jpCj.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $63ea91f281eaff85$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($63ea91f281eaff85$export$83e0c73b09b3a9cd);

});
parcelRegister("4USKh", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $63c33924209c0872$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $63c33924209c0872$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $8oe80 = parcelRequire("8oe80");

var $4U4qk = parcelRequire("4U4qk");

var $9M5Oz = parcelRequire("9M5Oz");
const $63c33924209c0872$export$e6b8a87858f7afd1 = (0, $9M5Oz.default);
const $63c33924209c0872$export$3d409af828769e2e = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $9M5Oz.default));
const $63c33924209c0872$export$d8d9f25d80d89b16 = (0, $8oe80.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $4U4qk.default));

});
parcelRegister("9M5Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2cb265c5b0a53f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $kgoHi = parcelRequire("kgoHi");

var $4U4qk = parcelRequire("4U4qk");
class $ae2cb265c5b0a53f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ae2cb265c5b0a53f$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae2cb265c5b0a53f$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ae2cb265c5b0a53f$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6GCo0", function(module, exports) {

$parcel$export(module.exports, "requestUser", () => $c396037537d957cc$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $c396037537d957cc$export$55b721778f931cc1);

var $i4N0u = parcelRequire("i4N0u");

var $bQgxR = parcelRequire("bQgxR");
const $c396037537d957cc$export$949646a1c1731536 = (baseUrl, accountId)=>(0, $i4N0u.getUser)(baseUrl, accountId).then((0, $bQgxR.transformUser));
const $c396037537d957cc$export$55b721778f931cc1 = (baseUrl, query)=>(0, $i4N0u.getUsers)(baseUrl, query).then((0, $bQgxR.transformUsers));

});
parcelRegister("i4N0u", function(module, exports) {

$parcel$export(module.exports, "getUser", () => $de20a383ad0b74fc$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $de20a383ad0b74fc$export$925a4945a6cd0f3e);

var $7f4tk = parcelRequire("7f4tk");
const $de20a383ad0b74fc$export$e45b57f6c6c40475 = 5;
const $de20a383ad0b74fc$export$7eaa662f51e316ae = (baseUrl)=>`${baseUrl}/rest/api/2/user`;
const $de20a383ad0b74fc$export$8df721f926f55c9a = (baseUrl, accountId = '')=>`${$de20a383ad0b74fc$export$7eaa662f51e316ae(baseUrl)}?accountId=${encodeURIComponent(accountId)}`;
const $de20a383ad0b74fc$export$715964ba85b11e2b = (baseUrl)=>`${baseUrl}/rest/api/2/user/picker`;
const $de20a383ad0b74fc$export$977bdbd87001f83 = (baseUrl, query = '')=>`${$de20a383ad0b74fc$export$715964ba85b11e2b(baseUrl)}?showAvatar=true&maxResults=${$de20a383ad0b74fc$export$e45b57f6c6c40475}&query=${query}`;
const $de20a383ad0b74fc$export$7cbf767827cd68ba = (baseUrl, accountId = '')=>(0, $7f4tk.default)($de20a383ad0b74fc$export$8df721f926f55c9a(baseUrl, accountId));
const $de20a383ad0b74fc$export$925a4945a6cd0f3e = (baseUrl, query = '')=>(0, $7f4tk.default)($de20a383ad0b74fc$export$977bdbd87001f83(baseUrl, query));

});

parcelRegister("bQgxR", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $c04a8a4571b1f523$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $c04a8a4571b1f523$export$fb8c90bfc4beaa59);
const $c04a8a4571b1f523$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $c04a8a4571b1f523$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("8jpCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a1beea71a0796f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2a1beea71a0796f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});

});



parcelRegister("eRV8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dfafbb94d152b9a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1sWm7 = parcelRequire("1sWm7");

var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $az4zD = parcelRequire("az4zD");


var $7zzD8 = parcelRequire("7zzD8");
const $6dfafbb94d152b9a$var$getAssigneeItems = (props)=>{
    const { intl: { formatMessage: formatMessage }, componentLeadName: componentLeadName, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName } = props;
    const unassignedMessage = formatMessage((0, $7zzD8.default).assigneeUnassigned);
    const projectLeadMessage = formatMessage((0, $7zzD8.default).assigneeProjectLead);
    const projectDefaultMessage = formatMessage((0, $7zzD8.default).assigneeProjectDefault);
    return [
        {
            value: (0, $67451e0b83279376$export$e141a3d44fafd179),
            label: formatMessage((0, $7zzD8.default).assigneeTypeWithDetails, {
                assigneeType: formatMessage((0, $7zzD8.default).assigneeComponentLead),
                displayName: componentLeadName || unassignedMessage
            })
        },
        {
            value: (0, $67451e0b83279376$export$dfc4824370fdf2e8),
            label: projectDefaultAssignee ? formatMessage((0, $7zzD8.default).assigneeTypeWithDetails, {
                assigneeType: projectDefaultMessage,
                displayName: projectDefaultAssignee === (0, $67451e0b83279376$export$3f4d79509888a8a1) ? unassignedMessage : projectLeadMessage
            }) : projectDefaultMessage
        },
        {
            value: (0, $67451e0b83279376$export$3c83461db52a5dd6),
            label: projectLeadName ? formatMessage((0, $7zzD8.default).assigneeTypeWithDetails, {
                assigneeType: projectLeadMessage,
                displayName: projectLeadName
            }) : projectLeadMessage
        },
        {
            value: (0, $67451e0b83279376$export$3f4d79509888a8a1),
            label: unassignedMessage
        }
    ];
};
const $6dfafbb94d152b9a$var$getAssigneeItemByValue = (props, value)=>{
    const futureAssigneeItems = $6dfafbb94d152b9a$var$getAssigneeItems(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(futureAssigneeItems, (i)=>i.value === value);
}; // eslint-disable-next-line jira/react/no-class-components
class $6dfafbb94d152b9a$export$935c4082cfb74cb6 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            label: ''
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const selectedItem = prevState.selectedItem;
        const nextState = {
            value: nextProps.value,
            componentLeadName: nextProps.componentLeadName
        };
        if (prevState.value !== nextProps.value) {
            if (!selectedItem || nextProps.value !== selectedItem.value) nextState.selectedItem = $6dfafbb94d152b9a$var$getAssigneeItemByValue(nextProps, nextProps.value);
        } else if (selectedItem && prevState.componentLeadName !== nextProps.componentLeadName) {
            const updatedCurrentSelection = $6dfafbb94d152b9a$var$getAssigneeItemByValue(nextProps, selectedItem.value);
            if (updatedCurrentSelection && updatedCurrentSelection.label !== selectedItem.label) nextState.selectedItem = updatedCurrentSelection;
        }
        return nextState;
    }
    constructor(props){
        super(props), this.onSelected = (selected)=>{
            this.setState({
                selectedItem: selected,
                isOpen: false
            });
            this.props.onSelected(selected.value);
        }, this.onMenuOpenHandler = ()=>this.setState({
                isOpen: true
            }), this.onMenuCloseHandler = ()=>this.setState({
                isOpen: false
            });
        this.state = {
            selectedItem: props.value ? $6dfafbb94d152b9a$var$getAssigneeItemByValue(props, props.value) : undefined,
            isOpen: false
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, label: label } = this.props;
        const { selectedItem: selectedItem, isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "component-assignee",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6dfafbb94d152b9a$var$FieldLabelWrapper, null, label)
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                inputId: fieldProps.id,
                noOptionsMessage: ()=>formatMessage((0, $7zzD8.default).noMatches),
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, $gwIPs.layers).modal
                        })
                },
                placeholder: formatMessage((0, $7zzD8.default).placeholder),
                options: $6dfafbb94d152b9a$var$getAssigneeItems(this.props),
                onChange: this.onSelected,
                value: selectedItem,
                menuIsOpen: isOpen,
                onMenuOpen: this.onMenuOpenHandler,
                onMenuClose: this.onMenuCloseHandler
            }));
    }
}
var $6dfafbb94d152b9a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($6dfafbb94d152b9a$export$935c4082cfb74cb6);
const $6dfafbb94d152b9a$var$FieldLabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7zzD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a425bddf48b8fe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $05a425bddf48b8fe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "project-components.component-assignee-placeholder",
        "defaultMessage": "Default assignee"
    },
    noMatches: {
        "id": "project-components.component-assignee-no-matches",
        "defaultMessage": "No Matches"
    },
    assigneeTypeWithDetails: {
        "id": "project-components.component-assignee-type-with-details",
        "defaultMessage": "{assigneeType} ({displayName})"
    },
    assigneeComponentLead: {
        "id": "project-components.assignee-component-lead",
        "defaultMessage": "Component lead"
    },
    assigneeProjectDefault: {
        "id": "project-components.assignee-project-default",
        "defaultMessage": "Project default"
    },
    assigneeProjectLead: {
        "id": "project-components.assignee-project-lead",
        "defaultMessage": "Project lead"
    },
    assigneeUnassigned: {
        "id": "project-components.assignee-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("h1wWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f46191127b3fec39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f46191127b3fec39$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    componentName: {
        "id": "project-components.edit-modal-dialog-component-name-label",
        "defaultMessage": "Name"
    },
    componentLead: {
        "id": "project-components.edit-modal-dialog-component-lead-label",
        "defaultMessage": "Component lead"
    },
    componentLeadPlaceholder: {
        "id": "project-components.edit-modal-dialog-component-lead-placeholder",
        "defaultMessage": "Select person"
    },
    description: {
        "id": "project-components.edit-modal-dialog-description-label",
        "defaultMessage": "Description"
    },
    defaultAssignee: {
        "id": "project-components.edit-modal-dialog-default-assignee-label",
        "defaultMessage": "Default assignee"
    },
    deactivated: {
        "id": "project-components.edit-modal-dialog-deactivated-status-label",
        "defaultMessage": "{userName} (Deactivated)"
    },
    requiredFieldsInformMessage: {
        "id": "project-components.edit-modal-dialog-required-field-inform-text-message",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});


parcelRegister("kbby2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6dba1f19f9b0d65$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6dba1f19f9b0d65$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    globalComponentsHeader: {
        "id": "project-directories.components.create-modal.global-components-header",
        "defaultMessage": "Create Jira component"
    },
    header: {
        "id": "project-directories.components.create-modal.header",
        "defaultMessage": "Create component"
    },
    saveButton: {
        "id": "project-directories.components.create-modal.save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "project-directories.components.create-modal.cancel-button",
        "defaultMessage": "Cancel"
    }
});

});




parcelRegister("8Y4HQ", function(module, exports) {

$parcel$export(module.exports, "isOpen", () => $ec7f7e782ba50773$export$ea0830439c7fc698);
const $ec7f7e782ba50773$export$ea0830439c7fc698 = (state)=>state.ui.add.isOpen;

});


parcelRegister("garrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de6ec07aeddc0c4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $9fuVs = parcelRequire("9fuVs");

var $7VHMR = parcelRequire("7VHMR");

var $az4zD = parcelRequire("az4zD");

var $7NYq5 = parcelRequire("7NYq5");

var $bC2fB = parcelRequire("bC2fB");

var $kZuyZ = parcelRequire("kZuyZ");

var $lrD6Q = parcelRequire("lrD6Q");

var $6z9Py = parcelRequire("6z9Py");

var $golPT = parcelRequire("golPT");

var $aSIZh = parcelRequire("aSIZh");

var $aN3Lz = parcelRequire("aN3Lz");
const $4de6ec07aeddc0c4$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4de6ec07aeddc0c4$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4de6ec07aeddc0c4$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "project-components.dialogs-edit-header",
        "defaultMessage": "Edit component"
    },
    saveButton: {
        "id": "project-components.dialogs-edit-save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "project-components.dialogs-edit-cancel-button",
        "defaultMessage": "Cancel"
    }
});
class $4de6ec07aeddc0c4$export$97b20acb2862c69e extends (0, $5uXOq.Component) {
    render() {
        const { baseUrl: baseUrl, component: component, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName, onCancel: onCancel, nameErrorMessage: nameErrorMessage, isDialogOpen: isDialogOpen } = this.props;
        if (!isDialogOpen || !component) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
            onClose: onCancel,
            width: "medium",
            messageId: "project-directories.components.modals.edit.modal-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, this.renderHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZuyZ.default), {
            baseUrl: baseUrl,
            name: component.name,
            description: component.description,
            lead: component.lead,
            defaultAssignee: component.defaultAssignee,
            onUpdateComponent: this.onUpdateComponent,
            projectDefaultAssignee: projectDefaultAssignee,
            projectLeadName: projectLeadName,
            nameErrorMessage: nameErrorMessage
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, this.renderFooter()))));
    }
    constructor(...args){
        super(...args), this.state = {
            isSaveDisabled: false
        }, this.onUpdateComponent = (component)=>{
            const isSaveDisabled = !component.name || !component.name.trim();
            this.setState({
                isSaveDisabled: isSaveDisabled
            });
            this.props.onUpdateComponent(component);
        }, // eslint-disable-next-line @atlaskit/design-system/use-heading
        this.renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h2", null, this.props.intl.formatMessage($4de6ec07aeddc0c4$var$messages.header)), this.renderFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4de6ec07aeddc0c4$var$ButtonsContainer, null, this.props.isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4de6ec07aeddc0c4$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "primary",
                type: "submit",
                onClick: this.props.onConfirm,
                isDisabled: this.props.isSaving || this.state.isSaveDisabled
            }, this.props.intl.formatMessage($4de6ec07aeddc0c4$var$messages.saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle-link",
                onClick: this.props.onCancel,
                isDisabled: this.props.isSaving
            }, this.props.intl.formatMessage($4de6ec07aeddc0c4$var$messages.cancelButton)));
    }
}
const $4de6ec07aeddc0c4$var$mapStateToProps = (state)=>({
        baseUrl: (0, $6z9Py.getBaseUrl)(state),
        isDialogOpen: (0, $aN3Lz.isEditing)(state),
        isSaving: (0, $aN3Lz.saveIsInProgress)(state),
        projectDefaultAssignee: (0, $golPT.getProjectDefaultAssignee)(state),
        projectLeadName: (0, $golPT.getProjectLeadName)(state),
        component: (0, $aN3Lz.getEditedComponent)(state),
        nameErrorMessage: (0, $aN3Lz.getNameErrorMessage)(state)
    });
const $4de6ec07aeddc0c4$var$mapDispatchToProps = {
    onCancel: (0, $aSIZh.cancel),
    onConfirm: (0, $lrD6Q.updateComponentRequest),
    onUpdateComponent: (0, $aSIZh.updateEditedComponent)
};
const $4de6ec07aeddc0c4$var$Connected = (0, $bC2fB.connect)($4de6ec07aeddc0c4$var$mapStateToProps, $4de6ec07aeddc0c4$var$mapDispatchToProps)((0, $az4zD.injectIntlV2)($4de6ec07aeddc0c4$export$97b20acb2862c69e));
var $4de6ec07aeddc0c4$export$2e2bcd8739ae039 = $4de6ec07aeddc0c4$var$Connected;

});




parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("62oVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $996fb369610c4d3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $i2Rm5 = parcelRequire("i2Rm5");

var $7iJwP = parcelRequire("7iJwP");


var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $7DbgJ = parcelRequire("7DbgJ");

var $fhVq7 = parcelRequire("fhVq7");

var $dZw8H = parcelRequire("dZw8H");

var $l8ruj = parcelRequire("l8ruj");

var $9JNcq = parcelRequire("9JNcq");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $996fb369610c4d3d$var$noop = ()=>{};
function $996fb369610c4d3d$var$ProjectComponents({ Updater: Updater, ProjectDirectoriesApp: ProjectDirectoriesApp, tenantContext: tenantContext, projectContext: projectContext, prefetchResult: prefetchResult, query: query, onQueryChanged: onQueryChanged }) {
    const { error: prefetchError, data: data } = prefetchResult;
    const { data: project } = projectContext;
    if (prefetchError) // @ts-expect-error - react-resource-router types return Record<string,any> but ErrorFlagRenderer only accepts Errors
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "project-components",
        error: prefetchError
    });
    if (!data || !(project && project.projectKey)) return null;
    const { isAdmin: isAdmin, baseUrl: baseUrl, locale: locale } = tenantContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhVq7.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "project-components-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectComponents",
        teamName: "morphinecake",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectDirectoriesApp, {
        baseUrl: baseUrl,
        locale: locale,
        projectKey: project.projectKey,
        projectId: project.projectId,
        projectName: project.projectName,
        projectType: project.projectType,
        isAdmin: isAdmin || project.isProjectAdmin === true || false,
        prefetchedData: data,
        onUnmount: $996fb369610c4d3d$var$noop,
        query: query,
        onQueryChanged: onQueryChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        metricKey: "jira.project.components",
        metric: (0, $9JNcq.projectComponentsPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DbgJ.default), {
        baseUrl: baseUrl,
        projectKey: project.projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null))));
}
var $996fb369610c4d3d$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('project-components', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($996fb369610c4d3d$var$ProjectComponents);

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("7DbgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $709f870a3eb06979$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $01Rn4 = parcelRequire("01Rn4");

var $eusud = parcelRequire("eusud");
const $709f870a3eb06979$export$fa156a01818e3239 = (baseUrl, projectKey)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
    });
const $709f870a3eb06979$var$AddProjectToHistory = ({ baseUrl: baseUrl, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: ()=>$709f870a3eb06979$export$fa156a01818e3239(baseUrl, projectKey)
    });
var $709f870a3eb06979$export$2e2bcd8739ae039 = $709f870a3eb06979$var$AddProjectToHistory;

});

parcelRegister("fhVq7", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $501f0ba909d41168$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $501f0ba909d41168$export$6d1402fb58384e4f);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");
const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $501f0ba909d41168$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, children);
const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $501f0ba909d41168$var$scrollablePageStyles = (0, $8CUq3.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.0'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("9JNcq", function(module, exports) {

$parcel$export(module.exports, "projectComponentsPageLoad", () => $c217b53aad57be6b$export$4b4575b030c402bb);

var $dGrdR = parcelRequire("dGrdR");
const $c217b53aad57be6b$export$4b4575b030c402bb = (0, $dGrdR.metrics).pageLoad({
    key: 'project-components',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-project-components.093f96c3.js.map
